/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 488);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(319)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(46);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(16);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectToGetParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable prefer-template */
function objectToGetParams(object) {
  return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var DOMProperty = __webpack_require__(41);
var ReactDOMComponentFlags = __webpack_require__(170);

var invariant = __webpack_require__(2);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ieDetection__ = __webpack_require__(202);














var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

function windowOpen(url, _ref, onShareWindowClose) {
  var name = _ref.name,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width;

  /* eslint-disable no-mixed-operators */
  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  /* eslint-enable no-mixed-operators */

  var config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  };

  var shareDialog = window.open(url, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__ieDetection__["a" /* default */])(10) ? '' : name, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onShareWindowClose) {
    var interval = window.setInterval(function () {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval);
          onShareWindowClose(shareDialog);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        /* eslint-enable no-console */
      }
    }, 1000);
  }

  return shareDialog;
}

var ShareButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShareButton, _PureComponent);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ShareButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow,
          beforeOnClick = _this$props.beforeOnClick;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      var clickHandler = openWindow ? function () {
        return _this.openWindow(link);
      } : function () {
        return onClick(link);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if (isPromise(returnVal)) {
          returnVal.then(clickHandler);
        } else {
          clickHandler();
        }
      } else {
        clickHandler();
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13 || e.key === ' ' || e.key === 32) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowOptions = {
        height: windowHeight,
        width: windowWidth
      };

      windowOpen(link, windowOptions, onShareWindowClose);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          networkLink = _props.networkLink;

      return networkLink(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          additionalProps = _props2.additionalProps,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          name = _props2.name,
          network = _props2.network,
          role = _props2.role,
          style = _props2.style,
          tabIndex = _props2.tabIndex;


      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          name: name
        }, additionalProps, {
          role: role,
          tabIndex: tabIndex,
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, disabled ? disabledStyle : {}) }),
        children
      );
    }
  }]);

  return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

ShareButton.propTypes = {
  additionalProps: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  disabledStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  network: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  networkLink: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  opts: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  openWindow: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  url: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  windowWidth: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  windowHeight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  beforeOnClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onShareWindowClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true,
  role: 'button',
  tabIndex: '0'
};


function createShareButton(network, link) {
  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var propTypes = arguments[3];
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var CreatedButton = function CreatedButton(props) {
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ShareButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      network: network,
      networkLink: link,
      opts: optsMap(props) }));
  };

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

/* harmony default export */ __webpack_exports__["a"] = (createShareButton);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(317);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iconFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function iconFactory(network, iconConfig) {
  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: baseStyle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          width: size,
          height: size,
          className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          !round ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
            width: '64',
            height: '64',
            fill: iconConfig.color,
            style: iconBgStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: iconBgStyle })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
        )
      )
    );
  };

  Icon.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    iconBgStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    logoFillColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    round: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  Icon.defaultProps = {
    className: '',
    iconBgStyle: {},
    logoFillColor: 'white',
    size: 64
  };

  return Icon;
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=bem;function bem(baseClass){var _modifiers=[];var _otherClasses=[];var _bem={modifier:function modifier(){for(var _len=arguments.length,modifiers=Array(_len),_key=0;_key<_len;_key++){modifiers[_key]=arguments[_key];}_modifiers=_modifiers.concat(modifiers.reduce(function(flat,modifier){return flat.concat(modifier);},[]).filter(function(modifier){return!!modifier;}));return _bem;},element:function element(name){if(baseClass.indexOf('__')>-1){throw new Error('Element nesting too deep, create a new component.');}return bem(baseClass+'__'+name);},withClass:function withClass(){for(var _len2=arguments.length,classes=Array(_len2),_key2=0;_key2<_len2;_key2++){classes[_key2]=arguments[_key2];}_otherClasses=_otherClasses.concat(classes.filter(function(className){return className;}));return _bem;},toString:function toString(){return[baseClass].concat(_modifiers.map(function(modifier){return baseClass+'--'+modifier;})).concat(_otherClasses).join(' ');}};return _bem;}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var CallbackQueue = __webpack_require__(168);
var PooledClass = __webpack_require__(32);
var ReactFeatureFlags = __webpack_require__(173);
var ReactReconciler = __webpack_require__(42);
var Transaction = __webpack_require__(65);

var invariant = __webpack_require__(2);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(161);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var PooledClass = __webpack_require__(32);

var emptyFunction = __webpack_require__(16);
var warning = __webpack_require__(4);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _HtmlHead=__webpack_require__(223);Object.defineProperty(exports,'HtmlHead',{enumerable:true,get:function get(){return _interopRequireDefault(_HtmlHead).default;}});var _Page=__webpack_require__(225);Object.defineProperty(exports,'Page',{enumerable:true,get:function get(){return _interopRequireDefault(_Page).default;}});var _PageWrapper=__webpack_require__(228);Object.defineProperty(exports,'PageWrapper',{enumerable:true,get:function get(){return _interopRequireDefault(_PageWrapper).default;}});var _PageContent=__webpack_require__(226);Object.defineProperty(exports,'PageContent',{enumerable:true,get:function get(){return _interopRequireDefault(_PageContent).default;}});var _PageSection=__webpack_require__(227);Object.defineProperty(exports,'PageSection',{enumerable:true,get:function get(){return _interopRequireDefault(_PageSection).default;}});var _SidePanel=__webpack_require__(231);Object.defineProperty(exports,'SidePanel',{enumerable:true,get:function get(){return _interopRequireDefault(_SidePanel).default;}});var _Sidebar=__webpack_require__(232);Object.defineProperty(exports,'Sidebar',{enumerable:true,get:function get(){return _interopRequireDefault(_Sidebar).default;}});var _Footer=__webpack_require__(222);Object.defineProperty(exports,'Footer',{enumerable:true,get:function get(){return _interopRequireDefault(_Footer).default;}});var _Searchbar=__webpack_require__(229);Object.defineProperty(exports,'Searchbar',{enumerable:true,get:function get(){return _interopRequireDefault(_Searchbar).default;}});var _Button=__webpack_require__(221);Object.defineProperty(exports,'Button',{enumerable:true,get:function get(){return _interopRequireDefault(_Button).default;}});var _BurgerMenu=__webpack_require__(220);Object.defineProperty(exports,'BurgerMenu',{enumerable:true,get:function get(){return _interopRequireDefault(_BurgerMenu).default;}});var _InputText=__webpack_require__(224);Object.defineProperty(exports,'InputText',{enumerable:true,get:function get(){return _interopRequireDefault(_InputText).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareCountFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var SocialMediaShareCount = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialMediaShareCount);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialMediaShareCount.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.updateCount(nextProps.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);

  return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SocialMediaShareCount.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  getCount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SocialMediaShareCount, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getCount: getCount }, props));
  };
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(35)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(14);
var ctx = __webpack_require__(150);
var hide = __webpack_require__(36);
var has = __webpack_require__(29);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(48);
var IE8_DOM_DEFINE = __webpack_require__(152);
var toPrimitive = __webpack_require__(87);
var dP = Object.defineProperty;

exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(279)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.isUrlExternal=isUrlExternal;exports.checkIsError=checkIsError;exports.routeStructBuilder=routeStructBuilder;exports.urlFormatter=urlFormatter;function isUrlExternal(url){var host=window.location.hostname;var linkHost=function(url){if(/^https?:\/\//.test(url)){// Absolute URL.
// The easy way to parse an URL, is to create <a> element.
// @see: https://gist.github.com/jlong/2428561
var parser=document.createElement('a');parser.href=url;return parser.hostname;}else{// Relative URL.
return window.location.hostname;}}(url);return host!==linkHost;}var CONTENT_TYPES=['info','pages','pageList','main'];function checkIsError(props,typesToCheck){typesToCheck=!typesToCheck?CONTENT_TYPES:typesToCheck;return typesToCheck.reduce(function(prev,val){return prev||!!props[val]&&!!props[val].status&&props[val].status==='error';},false);}function routeStructBuilder(_ref){var routes=_ref.routes,_ref$type=_ref.type,type=_ref$type===undefined?'pages':_ref$type,_ref$depth=_ref.depth,depth=_ref$depth===undefined?Infinity:_ref$depth;if(!routes&&routes.constructor!==Object)return;var transformedRoutes=childRouteStruct({routes:routes[0].childRoutes,depth:depth});return transformedRoutes&&transformedRoutes.children[type]?transformedRoutes.children[type].children:[];}function childRouteStruct(_ref2){var routes=_ref2.routes,depth=_ref2.depth;if(!routes)return;var checkCreatePathObj=function checkCreatePathObj(obj,arr){var data=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var curDepth=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;if(arr.length>0&&curDepth<depth){var name=arr.shift();curDepth++;var attributes=data.attributes;if(name!=='index'){if(!obj.children[name]){obj.children[name]={};}if(arr.length!==0&&curDepth<depth&&(!attributes||!attributes.hidden)){if(!obj.children[name].children){obj.children[name].children={};}obj.children[name]=checkCreatePathObj(obj.children[name],arr,data,curDepth);}else{obj.children[name]=Object.assign(obj.children[name],attributes,{url:urlFormatter(data.path,data.suffix)||undefined});}}else{obj=Object.assign(obj,attributes,{url:urlFormatter(data.path,data.suffix)||undefined});}}return obj;};return routes.reduce(function(pre,cur){cur.path=cur.path.charAt(0)==='/'?cur.path.slice(1):cur.path;var pathArr=cur.path.split('/').filter(function(p){return!!p;});return checkCreatePathObj(pre,pathArr,cur);},{children:{}});}function urlFormatter(url,suffix){return url!=='/'?suffix?'/'+url+'.'+suffix:'/'+url:url;}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var createDesc = __webpack_require__(58);
module.exports = __webpack_require__(27) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(153);
var defined = __webpack_require__(78);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(85)('wks');
var uid = __webpack_require__(60);
var Symbol = __webpack_require__(22).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(92);
var setInnerHTML = __webpack_require__(67);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);
var setTextContent = __webpack_require__(186);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(360);
var ReactInstrumentation = __webpack_require__(15);

var warning = __webpack_require__(4);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(24);

var _Actions = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var ReactBaseClasses = __webpack_require__(203);
var ReactChildren = __webpack_require__(473);
var ReactDOMFactories = __webpack_require__(474);
var ReactElement = __webpack_require__(47);
var ReactPropTypes = __webpack_require__(475);
var ReactVersion = __webpack_require__(476);

var createReactClass = __webpack_require__(477);
var onlyChild = __webpack_require__(481);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(20);

var warning = __webpack_require__(4);
var canDefineProperty = __webpack_require__(207);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(205);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(158);
var enumBugKeys = __webpack_require__(79);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(93);
var EventPluginUtils = __webpack_require__(94);
var ReactErrorUtils = __webpack_require__(98);

var accumulateInto = __webpack_require__(179);
var forEachAccumulated = __webpack_require__(180);
var invariant = __webpack_require__(2);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(50);
var EventPluginUtils = __webpack_require__(94);

var accumulateInto = __webpack_require__(179);
var forEachAccumulated = __webpack_require__(180);
var warning = __webpack_require__(4);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

var getEventTarget = __webpack_require__(103);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(78);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var EventPluginRegistry = __webpack_require__(93);
var ReactEventEmitterMixin = __webpack_require__(352);
var ViewportMetrics = __webpack_require__(178);

var getVendorPrefixedEventName = __webpack_require__(384);
var isEventSupported = __webpack_require__(104);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(53);
var ViewportMetrics = __webpack_require__(178);

var getEventModifierState = __webpack_require__(102);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var DOMNamespaces = __webpack_require__(92);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = exports.Col = exports.getRowProps = exports.Row = exports.Grid = undefined;

var _Row2 = __webpack_require__(389);

Object.defineProperty(exports, 'getRowProps', {
  enumerable: true,
  get: function get() {
    return _Row2.getRowProps;
  }
});

var _Col2 = __webpack_require__(387);

Object.defineProperty(exports, 'getColumnProps', {
  enumerable: true,
  get: function get() {
    return _Col2.getColumnProps;
  }
});

var _Grid2 = __webpack_require__(388);

var _Grid3 = _interopRequireDefault(_Grid2);

var _Row3 = _interopRequireDefault(_Row2);

var _Col3 = _interopRequireDefault(_Col2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Grid = _Grid3.default;
exports.Row = _Row3.default;
exports.Col = _Col3.default;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(245), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(236);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(237);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(235);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(239);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(238);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(48);
var dPs = __webpack_require__(260);
var enumBugKeys = __webpack_require__(79);
var IE_PROTO = __webpack_require__(84)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(151)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(254).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(30).f;
var has = __webpack_require__(29);
var TAG = __webpack_require__(39)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(85)('keys');
var uid = __webpack_require__(60);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(14);
var global = __webpack_require__(22);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(56) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(37);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(14);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(89);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(39);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(40);
var Danger = __webpack_require__(329);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstrumentation = __webpack_require__(15);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(100);
var setInnerHTML = __webpack_require__(67);
var setTextContent = __webpack_require__(186);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactErrorUtils = __webpack_require__(98);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactPropTypesSecret = __webpack_require__(358);
var propTypesFactory = __webpack_require__(165);

var React = __webpack_require__(46);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(20);
var ReactInstanceMap = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(15);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var emptyFunction = __webpack_require__(16);
var warning = __webpack_require__(4);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClass;

var _flexboxgrid = __webpack_require__(299);

var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClass(className) {
  return _flexboxgrid2.default && _flexboxgrid2.default[className] ? _flexboxgrid2.default[className] : className;
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createProps;
function createProps(propTypes, props, classNames) {
  var newProps = {};

  Object.keys(props).filter(function (key) {
    return key === 'children' || !propTypes[key];
  }).forEach(function (key) {
    return newProps[key] = props[key];
  });

  var className = classNames.filter(function (cn) {
    return cn;
  }).join(' ');
  return Object.assign({}, newProps, { className: className });
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["b" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(45);

var _DOMUtils = __webpack_require__(70);

var _DOMStateStorage = __webpack_require__(199);

var _PathUtils = __webpack_require__(24);

var _ExecutionEnvironment = __webpack_require__(115);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(419);

var _PathUtils = __webpack_require__(24);

var _runTransitionHook = __webpack_require__(117);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(69);

var _LocationUtils = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvYnVpbGQvZHVtcHRydWNrLm1k","filename":"/content/pages/build/dumptruck.md","suffix":"","attributes":{"title":"Dumptruck","sort":2,"featured":true,"description":"A Node CLI Helper to fetch Lambda logs from CloudWatch.","tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Dumptruck\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 2","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'A Node CLI Helper to fetch Lambda logs from CloudWatch.'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/dumptruck"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/dumptruck"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-npm-small.png"],["alt",""],["title","npm"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"A Node CLI Helper to fetch Lambda logs from CloudWatch.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To get started, ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"npm install dumptruck -g","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To view logs, simply run ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"dumptruck","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". If you are in a Serverless project,","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"it will try to pull config from a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yaml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" in the current working directory.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once dumptruck has launched, it will guide you through prompts to select","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"the correct log group, these selections are made with your keyboard and are","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"remembered locally, for ease of access on future launches.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"1. Select AWS profile","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"2. Select AWS Region","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"3. Filter from local YAML file (if ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yaml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is present in current folder)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"4. Select your Lambda (Ordered by most recently updated)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once a Lambda has been selected, this will poll AWS for the latest events,","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There is still some slight lag as events go from your Lamdba to CloudWatch.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you close a log stream (","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ctrl+c","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":") you are presented with a direct invocation command incase you wish to skip the option selection when targeting the same lambda again.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash dumptruck -p \"default\" -r \"eu-west-1\" -l \"your-lambda-name-here\"","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Dumptruck\"\nsort: 2\nfeatured: true\ndescription: 'A Node CLI Helper to fetch Lambda logs from CloudWatch.'\ntags:\n  - new\n---\n::: icons\n# Dumptruck\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/dumptruck)\n[![alt text](/images/logo-npm-small.png \"npm\")](https://www.npmjs.com/package/dumptruck)\n:::\n\nA Node CLI Helper to fetch Lambda logs from CloudWatch.\n\n&nbsp;\n\nTo get started, `npm install dumptruck -g`.\n\nTo view logs, simply run `dumptruck`. If you are in a Serverless project,\nit will try to pull config from a `serverless.yaml` in the current working directory.\n\n&nbsp;\n\nOnce dumptruck has launched, it will guide you through prompts to select\nthe correct log group, these selections are made with your keyboard and are\nremembered locally, for ease of access on future launches.\n\n1. Select AWS profile\n2. Select AWS Region\n3. Filter from local YAML file (if `serverless.yaml` is present in current folder)\n4. Select your Lambda (Ordered by most recently updated)\n\nOnce a Lambda has been selected, this will poll AWS for the latest events,\nThere is still some slight lag as events go from your Lamdba to CloudWatch.\n\n&nbsp;\n\nOnce you close a log stream (`ctrl+c`) you are presented with a direct invocation command incase you wish to skip the option selection when targeting the same lambda again.\n\n```bash\ndumptruck -p  \"default\"  -r \"eu-west-1\" -l \"your-lambda-name-here\"\n```\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"Dumptruck\"><a name=\"Dumptruck\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Dumptruck</h1>\n<p><a href=\"https://github.com/withreason/dumptruck\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a>\n<a href=\"https://www.npmjs.com/package/dumptruck\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-npm-small.png\" alt=\"alt text\" title=\"npm\"></a></p>\n</div>\n<p>A Node CLI Helper to fetch Lambda logs from CloudWatch.</p>\n<p> </p>\n<p>To get started, <code>npm install dumptruck -g</code>.</p>\n<p>To view logs, simply run <code>dumptruck</code>. If you are in a Serverless project,\nit will try to pull config from a <code>serverless.yaml</code> in the current working directory.</p>\n<p> </p>\n<p>Once dumptruck has launched, it will guide you through prompts to select\nthe correct log group, these selections are made with your keyboard and are\nremembered locally, for ease of access on future launches.</p>\n<ol>\n<li>Select AWS profile</li>\n<li>Select AWS Region</li>\n<li>Filter from local YAML file (if <code>serverless.yaml</code> is present in current folder)</li>\n<li>Select your Lambda (Ordered by most recently updated)</li>\n</ol>\n<p>Once a Lambda has been selected, this will poll AWS for the latest events,\nThere is still some slight lag as events go from your Lamdba to CloudWatch.</p>\n<p> </p>\n<p>Once you close a log stream (<code>ctrl+c</code>) you are presented with a direct invocation command incase you wish to skip the option selection when targeting the same lambda again.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">dumptruck -p  <span class=\"token string\">\"default\"</span>  -r <span class=\"token string\">\"eu-west-1\"</span> -l <span class=\"token string\">\"your-lambda-name-here\"</span>\n</code></pre>\n"}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvYnVpbGQvaW5kZXgubWQ","filename":"/content/pages/build/index.md","suffix":"","attributes":{"title":"Build","sort":2},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Build'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 2","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Build'\nsort: 2\n---\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":""}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvYnVpbGQvc2xzcHJlc3MtYXV0aGVudGljYXRpb24td2l0aC1hdXRoMC5tZA","filename":"/content/pages/build/slspress-authentication-with-auth0.md","suffix":"","attributes":{"title":"Slspress - rapidly create complex API's on serverless","sort":6,"hidden":true},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Slspress - rapidly create complex API's on serverless\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 6","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Slspress w/ Auth0","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/slspress"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/slspress"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-npm-small.png"],["alt",""],["title","npm"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Coming Soon.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Slspress - rapidly create complex API's on serverless\"\nsort: 6\nhidden: true\n---\n::: icons\n\n# Slspress w/ Auth0\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/slspress)\n[![alt text](/images/logo-npm-small.png \"npm\")](https://www.npmjs.com/package/slspress)\n:::\n\nComing Soon.\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"Slspressw%2FAuth0\"><a name=\"Slspressw%2FAuth0\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Slspress w/ Auth0</h1>\n<p><a href=\"https://github.com/withreason/slspress\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a>\n<a href=\"https://www.npmjs.com/package/slspress\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-npm-small.png\" alt=\"alt text\" title=\"npm\"></a></p>\n</div>\n<p>Coming Soon.</p>\n"}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvYnVpbGQvc2xzcHJlc3MtaW1hZ2UtY2RuLm1k","filename":"/content/pages/build/slspress-image-cdn.md","suffix":"","attributes":{"title":"Slspress CDN","sort":3,"hidden":true,"tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Slspress CDN\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 3","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Slspress Image CDN","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-cdn"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/sls-cdn"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-npm-small.png"],["alt",""],["title","npm"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# sls-image-cdn","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This allows you to deploy a serverless image CDN with image resizing, processing and caching on AWS in a couple of easy steps.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It uses s3, s3 website hosting, api gateway, lambda and optionally cloud front.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## To deploy a simple s3 hosted non caching instance","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 1. prerequisits","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- A working and running local docker deamon","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- a cpp compiler. npm install will fail to compile the native image processor if you dont have this.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It will however tell you what it needs to install. On a Mac you will need to have xcode installed.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 1. Clone this repo and add your own config.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Config can be either added to a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".env","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file, as system properties or a combination of both.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The following settings need to be provided:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWS_ACCESS_KEY_ID=YOURAWSAKID AWS_SECRET_ACCESS_KEY=YOURAWSSAK AWS_REGION='eu-west-1' # your aws region SOURCE_S3_BUCKET_NAME=the-s3-dns-compat-bucket-name","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## 2. install and deploy","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"npm install && npm run deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## 3. upload an image and test your CDN","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"TODO","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## To deploy an s3 hosted cloud front cached instance (recommended)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 1. prerequisits","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- A working and running local docker deamon","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- a cpp compiler. npm install will fail to compile the native image processor if you dont have this.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It will however tell you what it needs to install. On a Mac you will need to have xcode installed.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- A hosted zone configured in AWS to add your cdn url to.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- A certificate in AWS certificate manager (MUST BE in us-east-1 region) to use for the cdn domain you wish to create.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 1. Clone this repo and add your own config.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Config can be either added to a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".env","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file, as system properties or a combination of both.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The following settings need to be provided:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWS_ACCESS_KEY_ID=YOURAWSAKID AWS_SECRET_ACCESS_KEY=YOURAWSSAK AWS_REGION='eu-west-1' # your aws region CLOUD_FRONT_DOMAIN=your.cdn.dot.your.domain.name.com CLOUD_FRONT_HOSTED_ZONE=your.domain.name.com. (NOTE trailing dot is important as its part of the hosted zone name) CLOUD_FRONT_CERT_ARN=yourCertArn","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## 2. install and deploy","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Just a warning, its takes ages to initialize a cloudfront instance so this step takes a while...","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"npm install && npm run deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Slspress CDN\"\nsort: 3\nhidden: true\ntags:\n    - new\n---\n::: icons\n\n# Slspress Image CDN\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-cdn)\n[![alt text](/images/logo-npm-small.png \"npm\")](https://www.npmjs.com/package/sls-cdn)\n:::\n\n# sls-image-cdn\n\nThis allows you to deploy a serverless image CDN with image resizing, processing and caching on AWS in a couple of easy steps.\n\nIt uses s3, s3 website hosting, api gateway, lambda and optionally cloud front.\n\n## To deploy a simple s3 hosted non caching instance\n\n### 1. prerequisits\n\n- A working and running local docker deamon\n- a cpp compiler. npm install will fail to compile the native image processor if you dont have this. \nIt will however tell you what it needs to install. On a Mac you will need to have xcode installed.\n\n### 1. Clone this repo and add your own config.\n\nConfig can be either added to a `.env` file, as system properties or a combination of both. \nThe following settings need to be provided:\n\n```\nAWS_ACCESS_KEY_ID=YOURAWSAKID\nAWS_SECRET_ACCESS_KEY=YOURAWSSAK\nAWS_REGION='eu-west-1' # your aws region\nSOURCE_S3_BUCKET_NAME=the-s3-dns-compat-bucket-name\n```\n\n## 2. install and deploy\n```\nnpm install && npm run deploy\n```\n\n## 3. upload an image and test your CDN\nTODO\n\n## To deploy an s3 hosted cloud front cached instance (recommended)\n\n### 1. prerequisits\n\n- A working and running local docker deamon\n- a cpp compiler. npm install will fail to compile the native image processor if you dont have this. \nIt will however tell you what it needs to install. On a Mac you will need to have xcode installed.\n- A hosted zone configured in AWS to add your cdn url to.\n- A certificate in AWS certificate manager (MUST BE in us-east-1 region) to use for the cdn domain you wish to create.\n\n### 1. Clone this repo and add your own config.\n\nConfig can be either added to a `.env` file, as system properties or a combination of both. \nThe following settings need to be provided:\n\n```\nAWS_ACCESS_KEY_ID=YOURAWSAKID\nAWS_SECRET_ACCESS_KEY=YOURAWSSAK\nAWS_REGION='eu-west-1' # your aws region\nCLOUD_FRONT_DOMAIN=your.cdn.dot.your.domain.name.com\nCLOUD_FRONT_HOSTED_ZONE=your.domain.name.com. (NOTE trailing dot is important as its part of the hosted zone name)\nCLOUD_FRONT_CERT_ARN=yourCertArn\n```\n\n## 2. install and deploy\n\nJust a warning, its takes ages to initialize a cloudfront instance so this step takes a while...\n\n```\nnpm install && npm run deploy\n```\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"SlspressImageCDN\"><a name=\"SlspressImageCDN\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Slspress Image CDN</h1>\n<p><a href=\"https://github.com/withreason/sls-cdn\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a>\n<a href=\"https://www.npmjs.com/package/sls-cdn\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-npm-small.png\" alt=\"alt text\" title=\"npm\"></a></p>\n</div>\n<h1 id=\"sls-image-cdn\"><a name=\"sls-image-cdn\" class=\"markdown-it-headinganchor\" href=\"#\"></a>sls-image-cdn</h1>\n<p>This allows you to deploy a serverless image CDN with image resizing, processing and caching on AWS in a couple of easy steps.</p>\n<p>It uses s3, s3 website hosting, api gateway, lambda and optionally cloud front.</p>\n<h2 id=\"Todeployasimples3hostednoncachinginstance\"><a name=\"Todeployasimples3hostednoncachinginstance\" class=\"markdown-it-headinganchor\" href=\"#\"></a>To deploy a simple s3 hosted non caching instance</h2>\n<h3 id=\"1.prerequisits\"><a name=\"1.prerequisits\" class=\"markdown-it-headinganchor\" href=\"#\"></a>1. prerequisits</h3>\n<ul>\n<li>A working and running local docker deamon</li>\n<li>a cpp compiler. npm install will fail to compile the native image processor if you dont have this.\nIt will however tell you what it needs to install. On a Mac you will need to have xcode installed.</li>\n</ul>\n<h3 id=\"1.Clonethisrepoandaddyourownconfig.\"><a name=\"1.Clonethisrepoandaddyourownconfig.\" class=\"markdown-it-headinganchor\" href=\"#\"></a>1. Clone this repo and add your own config.</h3>\n<p>Config can be either added to a <code>.env</code> file, as system properties or a combination of both.\nThe following settings need to be provided:</p>\n<pre><code>AWS_ACCESS_KEY_ID=YOURAWSAKID\nAWS_SECRET_ACCESS_KEY=YOURAWSSAK\nAWS_REGION='eu-west-1' # your aws region\nSOURCE_S3_BUCKET_NAME=the-s3-dns-compat-bucket-name\n</code></pre>\n<h2 id=\"2.installanddeploy\"><a name=\"2.installanddeploy\" class=\"markdown-it-headinganchor\" href=\"#\"></a>2. install and deploy</h2>\n<pre><code>npm install &amp;&amp; npm run deploy\n</code></pre>\n<h2 id=\"3.uploadanimageandtestyourCDN\"><a name=\"3.uploadanimageandtestyourCDN\" class=\"markdown-it-headinganchor\" href=\"#\"></a>3. upload an image and test your CDN</h2>\n<p>TODO</p>\n<h2 id=\"Todeployans3hostedcloudfrontcachedinstance(recommended)\"><a name=\"Todeployans3hostedcloudfrontcachedinstance(recommended)\" class=\"markdown-it-headinganchor\" href=\"#\"></a>To deploy an s3 hosted cloud front cached instance (recommended)</h2>\n<h3 id=\"1.prerequisits\"><a name=\"1.prerequisits\" class=\"markdown-it-headinganchor\" href=\"#\"></a>1. prerequisits</h3>\n<ul>\n<li>A working and running local docker deamon</li>\n<li>a cpp compiler. npm install will fail to compile the native image processor if you dont have this.\nIt will however tell you what it needs to install. On a Mac you will need to have xcode installed.</li>\n<li>A hosted zone configured in AWS to add your cdn url to.</li>\n<li>A certificate in AWS certificate manager (MUST BE in us-east-1 region) to use for the cdn domain you wish to create.</li>\n</ul>\n<h3 id=\"1.Clonethisrepoandaddyourownconfig.\"><a name=\"1.Clonethisrepoandaddyourownconfig.\" class=\"markdown-it-headinganchor\" href=\"#\"></a>1. Clone this repo and add your own config.</h3>\n<p>Config can be either added to a <code>.env</code> file, as system properties or a combination of both.\nThe following settings need to be provided:</p>\n<pre><code>AWS_ACCESS_KEY_ID=YOURAWSAKID\nAWS_SECRET_ACCESS_KEY=YOURAWSSAK\nAWS_REGION='eu-west-1' # your aws region\nCLOUD_FRONT_DOMAIN=your.cdn.dot.your.domain.name.com\nCLOUD_FRONT_HOSTED_ZONE=your.domain.name.com. (NOTE trailing dot is important as its part of the hosted zone name)\nCLOUD_FRONT_CERT_ARN=yourCertArn\n</code></pre>\n<h2 id=\"2.installanddeploy\"><a name=\"2.installanddeploy\" class=\"markdown-it-headinganchor\" href=\"#\"></a>2. install and deploy</h2>\n<p>Just a warning, its takes ages to initialize a cloudfront instance so this step takes a while...</p>\n<pre><code>npm install &amp;&amp; npm run deploy\n</code></pre>\n"}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvYnVpbGQvc2xzcHJlc3Mtc2ltcGxlLWV4YW1wbGUubWQ","filename":"/content/pages/build/slspress-simple-example.md","suffix":"","attributes":{"title":"Slspress","sort":1,"featured":true,"description":"SLSPress helps you builds serverless APIs fast"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Slspress\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 1","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'SLSPress helps you builds serverless APIs fast'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Slspress","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/slspress"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/slspress"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-npm-small.png"],["alt",""],["title","npm"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Slspress is a library that was designed to abstract some of the boilerplate away from Serverless application creation to allow you just to focus on the API's that you want to build. Given the popularity and ease of use of the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://expressjs.com/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Express framework","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" we wanted to build something that allowed one to build Serverless applications in a similar way. Slspress does not aim to emulate the express APIs but to use a similar approach when wiring up endpoints and middleware etc. This article will show you how to create a simple CRUD api backed by dynamoDB using slspress.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Simple CRUD example","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/simple-crud-example"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following additional AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"dynamodb:CreateTable","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note there is no security in the example. In the real world you would need to add a security layer.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/slspress-authentication-with-auth0/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"See this guide on to how to do this with slspress and auth0","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To start, let's create a collection table ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"SlspressTestItem","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on DynamoDB:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws dynamodb create-table --table-name SlspressTestItem --attribute-definitions AttributeName=Id,AttributeType=S --key-schema AttributeName=Id,KeyType=HASH --provisioned-throughput ReadCapacityUnits=5,WriteCapacityUnits=5","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Initiate npm and install slspress.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm init npm install --save slspress","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Lets create a function to write to the table. Add the following config and code to your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and a file called ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"app.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There is no need to add a dependency on the aws-sdk, it is provided by default.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: itemApi: handler: app.handle events: - http: path: items/{id} method: post cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript const { create, jsonMiddleware } = require('slspress'); const AWS = require(\"aws-sdk\"); const docClient = new AWS.DynamoDB.DocumentClient(); const app = create(); app.on('handle') .middleware(jsonMiddleware) .post('/items', (req, res) => { const params = { TableName: 'SlspressTestItem', Item: { Id: req.event.body.id, Name: req.event.body.name } } return docClient.put(params, err => err ? res.handleError(err) : res.created()); }); module.exports = app.export();","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Deploy your application","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Before your lambda can connect to DynamoDb you will need to grant it access. Create the following policy file","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"for your lambda as policy.json","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Version\": \"2012-10-17\", \"Statement\": [ { \"Action\": [ \"dynamodb:GetItem\", \"dynamodb:DeleteItem\", \"dynamodb:PutItem\", \"dynamodb:UpdateItem\", \"dynamodb:Query\" ], \"Effect\": \"Allow\", \"Resource\": [ \"arn:aws:dynamodb:*:*:table/SlspressTestItem\" ] } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Locate the role that the Serverless framework automatically created for your lambda","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"function and grant it read/write access to the new table by running the following aws commands:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws iam list-roles | grep lambdaRole aws iam put-role-policy --role-name ROLE_FROM_ABOVE_COMMAND --policy-name LambdaDynamoPolicy --policy-document file://policy.json","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Test the endpoint using curl (or your favorite rest client) and then get the row back out via the DynamoDB CLI.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash curl -H \"Content-Type: application/json\" -X POST -v -d '{\"Id\": \"1234\", \"name\":\"New Item!\"}' https://{your-api-url}.execute-api.us-east-1.amazonaws.com/dev/items/1234 aws dynamodb scan --table-name SlspressTestItem","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You should be be able to see the object in DynamoDB.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There are a couple of things to note with the above code.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"1. The middleware call is adding some built in middleware that ensures that requests are parsed as json and responses returned as json.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"2. In this example we are adding all of the code inline in the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"app.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file but with a bigger application it usually makes sense to split it out into separate files that ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"app.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" requires. Then ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"app.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" becomes a list of all of your routes.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Add the following config and code to flesh out the other CRUD operations","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: itemApi: handler: app.handle events: - http: path: items method: post cors: true - http: path: items/{id} method: put cors: true - http: path: items/{id} method: get cors: true - http: path: items/{id} method: delete cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript .put('/items/{id}', (req, res) => { const params = { TableName: 'SlspressTestItem', Item: { Id: req.event.pathParameters.id, Name: req.event.body.name } } return docClient.put(params, err => err ? res.handleError(err) : res.noContent()); }) .get('/items/{id}', (req, res) => { const params = { TableName: 'SlspressTestItem', Key: { Id: req.event.pathParameters.id } }; return docClient.get(params, (err, data) => err ? res.handleError(err) : res.ok(data)); }) .delete('/items/{id}', (req, res) => { const params = { TableName: 'SlspressTestItem', Key: { Id: req.event.pathParameters.id } }; return docClient.delete(params, err => err ? res.handleError(err) : res.noContent()); })","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can deploy your serverless app again and check the new endpoints. e.g.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash curl -H \"Content-Type: application/json\" -X PUT -d '{\"name\":\"New Item3!\"}' https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 - curl -H \"Content-Type: application/json\" -X GET https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v curl -H \"Content-Type: application/json\" -X DELETE https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/serverless/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Slspress readme","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Introduction.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS DynamoDB","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: steps","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Next step","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/developing-locally-with-serverless-offline/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Develop Serverless applications locally","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/hosting-for-a-serverless-project-on-s3/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Add some static HTML/JavaScript to use your new API","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/where-are-my-logs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Find out where logs from your functions go","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Slspress\"\nsort: 1\nfeatured: true\ndescription: 'SLSPress helps you builds serverless APIs fast'\n---\n::: icons\n\n# Slspress\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/slspress)\n[![alt text](/images/logo-npm-small.png \"npm\")](https://www.npmjs.com/package/slspress)\n:::\n\nSlspress is a library that was designed to abstract some of the boilerplate away from Serverless application creation to allow you just to focus on the API's that you want to build. Given the popularity and ease of use of the [Express framework](https://expressjs.com/) we wanted to build something that allowed one to build Serverless applications in a similar way. Slspress does not aim to emulate the express APIs but to use a similar approach when wiring up endpoints and middleware etc. This article will show you how to create a simple CRUD api backed by dynamoDB using slspress.\n\n&nbsp;\n\n::: icons\n\n## Simple CRUD example\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/simple-crud-example)\n:::\n\n::: info\n You will require the following additional AWS permissions: \n * `dynamodb:CreateTable`\n * `lambda:CreateEventSourceMapping`\n:::\n\n&nbsp;\n\n::: info\n Note there is no security in the example. In the real world you would need to add a security layer.\n [See this guide on to how to do this with slspress and auth0](/pages/build/slspress-authentication-with-auth0/)\n:::\n\nTo start, let's create a collection table `SlspressTestItem` on DynamoDB:\n\n```bash\naws dynamodb create-table --table-name SlspressTestItem --attribute-definitions AttributeName=Id,AttributeType=S --key-schema AttributeName=Id,KeyType=HASH --provisioned-throughput ReadCapacityUnits=5,WriteCapacityUnits=5\n```\n\nInitiate npm and install slspress.\n\n```bash\n  npm init\n  npm install --save slspress\n```\n\n&nbsp;\n\nLets create a function to write to the table. Add the following config and code to your `serverless.yml` and a file called `app.js`.\n\n::: info\nThere is no need to add a dependency on the aws-sdk, it is provided by default.\n:::\n\n```yaml\n  functions:\n    itemApi:\n      handler: app.handle\n      events:\n        - http:\n            path: items/{id}\n            method: post\n            cors: true\n```\n\n```javascript\nconst { create, jsonMiddleware } = require('slspress');\nconst AWS = require(\"aws-sdk\");\nconst docClient = new AWS.DynamoDB.DocumentClient();\n\nconst app = create();\n\napp.on('handle')\n    .middleware(jsonMiddleware)\n    .post('/items', (req, res) => {\n        const params = {\n          TableName: 'SlspressTestItem',\n          Item: {\n              Id: req.event.body.id,\n              Name: req.event.body.name\n          }\n        }\n        return docClient.put(params, err => err ? res.handleError(err) : res.created());\n    });\n\nmodule.exports = app.export();\n```\n\nDeploy your application\n\n```bash\n  serverless deploy\n``` \n\n&nbsp;\n\nBefore your lambda can connect to DynamoDb you will need to grant it access. Create the following policy file \nfor your lambda as policy.json\n\n```json\n{\n    \"Version\": \"2012-10-17\",\n    \"Statement\": [\n        {\n            \"Action\": [\n              \"dynamodb:GetItem\", \n              \"dynamodb:DeleteItem\", \n              \"dynamodb:PutItem\", \n              \"dynamodb:UpdateItem\", \n              \"dynamodb:Query\"\n            ],\n            \"Effect\": \"Allow\", \n            \"Resource\": [\n              \"arn:aws:dynamodb:*:*:table/SlspressTestItem\"\n            ]\n        }\n    ]\n}\n```\n\n&nbsp;\n\nLocate the role that the Serverless framework automatically created for your lambda\nfunction and grant it read/write access to the new table by running the following aws commands:\n\n```bash\naws iam list-roles | grep lambdaRole\naws iam put-role-policy --role-name ROLE_FROM_ABOVE_COMMAND --policy-name LambdaDynamoPolicy --policy-document file://policy.json\n```\n\n&nbsp;\n\nTest the endpoint using curl (or your favorite rest client) and then get the row back out via the DynamoDB CLI.\n\n```bash\ncurl -H \"Content-Type: application/json\" -X POST -v -d '{\"Id\": \"1234\", \"name\":\"New Item!\"}' https://{your-api-url}.execute-api.us-east-1.amazonaws.com/dev/items/1234\naws dynamodb scan --table-name SlspressTestItem\n```\n\n&nbsp;\n\nYou should be be able to see the object in DynamoDB.\n\nThere are a couple of things to note with the above code.\n\n1. The middleware call is adding some built in middleware that ensures that requests are parsed as json and responses returned as json.\n2. In this example we are adding all of the code inline in the `app.js` file but with a bigger application it usually makes sense to split it out into separate files that `app.js` requires. Then `app.js` becomes a list of all of your routes.\n\nAdd the following config and code to flesh out the other CRUD operations\n\n```yaml\n  functions:\n    itemApi:\n        handler: app.handle\n        events:\n          - http:\n              path: items\n              method: post\n              cors: true\n          - http:\n              path: items/{id}\n              method: put\n              cors: true\n          - http:\n              path: items/{id}\n              method: get\n              cors: true\n          - http:\n              path: items/{id}\n              method: delete\n              cors: true\n```\n\n```javascript\n\n        .put('/items/{id}', (req, res) => {\n            const params = {\n                TableName: 'SlspressTestItem',\n                Item: {\n                    Id: req.event.pathParameters.id,\n                    Name: req.event.body.name\n                }\n            }\n            return docClient.put(params, err => err ? res.handleError(err) : res.noContent());\n        })\n        .get('/items/{id}', (req, res) => {\n            const params = {\n                TableName: 'SlspressTestItem',\n                Key: {\n                    Id: req.event.pathParameters.id\n                }\n            };\n            return docClient.get(params, (err, data) => err ? res.handleError(err) : res.ok(data));\n        })\n        .delete('/items/{id}', (req, res) => {\n            const params = {\n                TableName: 'SlspressTestItem',\n                Key: {\n                    Id: req.event.pathParameters.id\n                }\n            };\n            return docClient.delete(params, err => err ? res.handleError(err) : res.noContent());\n        })\n```\n\nYou can deploy your serverless app again and check the new endpoints. e.g. \n\n```bash\ncurl -H \"Content-Type: application/json\" -X PUT -d '{\"name\":\"New Item3!\"}' https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -\ncurl -H \"Content-Type: application/json\" -X GET https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v\ncurl -H \"Content-Type: application/json\" -X DELETE https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v\n```\n\n::: links\nFurther reading:\n\n* [Slspress readme](https://aws.amazon.com/serverless/)\n* [AWS DynamoDB](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Introduction.html)\n\n:::\n\n::: steps\nNext step\n\n* [Develop Serverless applications locally](/pages/learn/developing-locally-with-serverless-offline/)\n* [Add some static HTML/JavaScript to use your new API](/pages/learn/hosting-for-a-serverless-project-on-s3/)\n* [Find out where logs from your functions go](/pages/learn/where-are-my-logs/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"Slspress\"><a name=\"Slspress\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Slspress</h1>\n<p><a href=\"https://github.com/withreason/slspress\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a>\n<a href=\"https://www.npmjs.com/package/slspress\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-npm-small.png\" alt=\"alt text\" title=\"npm\"></a></p>\n</div>\n<p>Slspress is a library that was designed to abstract some of the boilerplate away from Serverless application creation to allow you just to focus on the API's that you want to build. Given the popularity and ease of use of the <a href=\"https://expressjs.com/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Express framework</a> we wanted to build something that allowed one to build Serverless applications in a similar way. Slspress does not aim to emulate the express APIs but to use a similar approach when wiring up endpoints and middleware etc. This article will show you how to create a simple CRUD api backed by dynamoDB using slspress.</p>\n<p> </p>\n<div class=\"icons\">\n<h2 id=\"SimpleCRUDexample\"><a name=\"SimpleCRUDexample\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Simple CRUD example</h2>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/simple-crud-example\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<div class=\"info\">\n<p>You will require the following additional AWS permissions:</p>\n<ul>\n<li><code>dynamodb:CreateTable</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p> </p>\n<div class=\"info\">\n<p>Note there is no security in the example. In the real world you would need to add a security layer.\n<a href=\"/pages/build/slspress-authentication-with-auth0/\" class=\"absolute-link\">See this guide on to how to do this with slspress and auth0</a></p>\n</div>\n<p>To start, let's create a collection table <code>SlspressTestItem</code> on DynamoDB:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">aws dynamodb create-table --table-name SlspressTestItem --attribute-definitions AttributeName<span class=\"token operator\">=</span>Id,AttributeType<span class=\"token operator\">=</span>S --key-schema AttributeName<span class=\"token operator\">=</span>Id,KeyType<span class=\"token operator\">=</span>HASH --provisioned-throughput ReadCapacityUnits<span class=\"token operator\">=</span>5,WriteCapacityUnits<span class=\"token operator\">=</span>5\n</code></pre>\n<p>Initiate npm and install slspress.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">  <span class=\"token function\">npm</span> init\n  <span class=\"token function\">npm</span> <span class=\"token function\">install</span> --save slspress\n</code></pre>\n<p> </p>\n<p>Lets create a function to write to the table. Add the following config and code to your <code>serverless.yml</code> and a file called <code>app.js</code>.</p>\n<div class=\"info\">\n<p>There is no need to add a dependency on the aws-sdk, it is provided by default.</p>\n</div>\n<pre class=\"language-yaml\"><code class=\"language-yaml\">  <span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">itemApi</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> app.handle\n      <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n            <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> items/<span class=\"token punctuation\">{</span>id<span class=\"token punctuation\">}</span>\n            <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> post\n            <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> create<span class=\"token punctuation\">,</span> jsonMiddleware <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'slspress'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">const</span> <span class=\"token constant\">AWS</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"aws-sdk\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">const</span> docClient <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">AWS<span class=\"token punctuation\">.</span>DynamoDB<span class=\"token punctuation\">.</span>DocumentClient</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> app <span class=\"token operator\">=</span> <span class=\"token function\">create</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\napp<span class=\"token punctuation\">.</span><span class=\"token function\">on</span><span class=\"token punctuation\">(</span><span class=\"token string\">'handle'</span><span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">middleware</span><span class=\"token punctuation\">(</span>jsonMiddleware<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">post</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/items'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">const</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n          TableName<span class=\"token punctuation\">:</span> <span class=\"token string\">'SlspressTestItem'</span><span class=\"token punctuation\">,</span>\n          Item<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n              Id<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">,</span>\n              Name<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">.</span>name\n          <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">}</span>\n        <span class=\"token keyword\">return</span> docClient<span class=\"token punctuation\">.</span><span class=\"token function\">put</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> err <span class=\"token operator\">=></span> err <span class=\"token operator\">?</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">:</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">created</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports <span class=\"token operator\">=</span> app<span class=\"token punctuation\">.</span><span class=\"token keyword\">export</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>Deploy your application</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">  serverless deploy\n</code></pre>\n<p> </p>\n<p>Before your lambda can connect to DynamoDb you will need to grant it access. Create the following policy file\nfor your lambda as policy.json</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"Version\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2012-10-17\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"Statement\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"Action\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n              <span class=\"token string\">\"dynamodb:GetItem\"</span><span class=\"token punctuation\">,</span> \n              <span class=\"token string\">\"dynamodb:DeleteItem\"</span><span class=\"token punctuation\">,</span> \n              <span class=\"token string\">\"dynamodb:PutItem\"</span><span class=\"token punctuation\">,</span> \n              <span class=\"token string\">\"dynamodb:UpdateItem\"</span><span class=\"token punctuation\">,</span> \n              <span class=\"token string\">\"dynamodb:Query\"</span>\n            <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"Effect\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Allow\"</span><span class=\"token punctuation\">,</span> \n            <span class=\"token property\">\"Resource\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n              <span class=\"token string\">\"arn:aws:dynamodb:*:*:table/SlspressTestItem\"</span>\n            <span class=\"token punctuation\">]</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>Locate the role that the Serverless framework automatically created for your lambda\nfunction and grant it read/write access to the new table by running the following aws commands:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">aws iam list-roles <span class=\"token operator\">|</span> <span class=\"token function\">grep</span> lambdaRole\naws iam put-role-policy --role-name ROLE_FROM_ABOVE_COMMAND --policy-name LambdaDynamoPolicy --policy-document file://policy.json\n</code></pre>\n<p> </p>\n<p>Test the endpoint using curl (or your favorite rest client) and then get the row back out via the DynamoDB CLI.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">curl</span> -H <span class=\"token string\">\"Content-Type: application/json\"</span> -X POST -v -d <span class=\"token string\">'{\"Id\": \"1234\", \"name\":\"New Item!\"}'</span> https://<span class=\"token punctuation\">{</span>your-api-url<span class=\"token punctuation\">}</span>.execute-api.us-east-1.amazonaws.com/dev/items/1234\naws dynamodb scan --table-name SlspressTestItem\n</code></pre>\n<p> </p>\n<p>You should be be able to see the object in DynamoDB.</p>\n<p>There are a couple of things to note with the above code.</p>\n<ol>\n<li>The middleware call is adding some built in middleware that ensures that requests are parsed as json and responses returned as json.</li>\n<li>In this example we are adding all of the code inline in the <code>app.js</code> file but with a bigger application it usually makes sense to split it out into separate files that <code>app.js</code> requires. Then <code>app.js</code> becomes a list of all of your routes.</li>\n</ol>\n<p>Add the following config and code to flesh out the other CRUD operations</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\">  <span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">itemApi</span><span class=\"token punctuation\">:</span>\n        <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> app.handle\n        <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n          <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n              <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> items\n              <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> post\n              <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n          <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n              <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> items/<span class=\"token punctuation\">{</span>id<span class=\"token punctuation\">}</span>\n              <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> put\n              <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n          <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n              <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> items/<span class=\"token punctuation\">{</span>id<span class=\"token punctuation\">}</span>\n              <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n              <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n          <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n              <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> items/<span class=\"token punctuation\">{</span>id<span class=\"token punctuation\">}</span>\n              <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> delete\n              <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">\n        <span class=\"token punctuation\">.</span><span class=\"token function\">put</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/items/{id}'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">const</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n                TableName<span class=\"token punctuation\">:</span> <span class=\"token string\">'SlspressTestItem'</span><span class=\"token punctuation\">,</span>\n                Item<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n                    Id<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>pathParameters<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">,</span>\n                    Name<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">.</span>name\n                <span class=\"token punctuation\">}</span>\n            <span class=\"token punctuation\">}</span>\n            <span class=\"token keyword\">return</span> docClient<span class=\"token punctuation\">.</span><span class=\"token function\">put</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> err <span class=\"token operator\">=></span> err <span class=\"token operator\">?</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">:</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">noContent</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">.</span><span class=\"token keyword\">get</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/items/{id}'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">const</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n                TableName<span class=\"token punctuation\">:</span> <span class=\"token string\">'SlspressTestItem'</span><span class=\"token punctuation\">,</span>\n                Key<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n                    Id<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>pathParameters<span class=\"token punctuation\">.</span>id\n                <span class=\"token punctuation\">}</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n            <span class=\"token keyword\">return</span> docClient<span class=\"token punctuation\">.</span><span class=\"token keyword\">get</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> data<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> err <span class=\"token operator\">?</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">:</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">ok</span><span class=\"token punctuation\">(</span>data<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">.</span><span class=\"token keyword\">delete</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/items/{id}'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">const</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n                TableName<span class=\"token punctuation\">:</span> <span class=\"token string\">'SlspressTestItem'</span><span class=\"token punctuation\">,</span>\n                Key<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n                    Id<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>pathParameters<span class=\"token punctuation\">.</span>id\n                <span class=\"token punctuation\">}</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n            <span class=\"token keyword\">return</span> docClient<span class=\"token punctuation\">.</span><span class=\"token keyword\">delete</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> err <span class=\"token operator\">=></span> err <span class=\"token operator\">?</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">:</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">noContent</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n</code></pre>\n<p>You can deploy your serverless app again and check the new endpoints. e.g.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">curl</span> -H <span class=\"token string\">\"Content-Type: application/json\"</span> -X PUT -d <span class=\"token string\">'{\"name\":\"New Item3!\"}'</span> https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -\n<span class=\"token function\">curl</span> -H <span class=\"token string\">\"Content-Type: application/json\"</span> -X GET https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v\n<span class=\"token function\">curl</span> -H <span class=\"token string\">\"Content-Type: application/json\"</span> -X DELETE https://your-api-url.execute-api.us-east-1.amazonaws.com/dev/items/1234 -v\n</code></pre>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://aws.amazon.com/serverless/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Slspress readme</a></li>\n<li><a href=\"http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Introduction.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS DynamoDB</a></li>\n</ul>\n</div>\n<div class=\"steps\">\n<p>Next step</p>\n<ul>\n<li><a href=\"/pages/learn/developing-locally-with-serverless-offline/\" class=\"absolute-link\">Develop Serverless applications locally</a></li>\n<li><a href=\"/pages/learn/hosting-for-a-serverless-project-on-s3/\" class=\"absolute-link\">Add some static HTML/JavaScript to use your new API</a></li>\n<li><a href=\"/pages/learn/where-are-my-logs/\" class=\"absolute-link\">Find out where logs from your functions go</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvY29tbXVuaXR5LXN1cHBvcnQubWQ","filename":"/content/pages/community-support.md","suffix":"","attributes":{"title":"Community & Support","sort":4,"description":"Groups and forums you will find useful in your Serverless journey"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Community & Support'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 4","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Groups and forums you will find useful in your Serverless journey'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"DO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Community & Support'\nsort: 4\ndescription: 'Groups and forums you will find useful in your Serverless journey'\n---\nDO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<p>DO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class</p>\n"}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvZ2V0dGluZy1zdGFydGVkLm1k","filename":"/content/pages/getting-started.md","suffix":"","attributes":{"title":"Getting Started","sort":0,"description":"SLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Getting Started'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 0","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'SLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Getting started","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"strong_open","tag":"strong","attrs":null,"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"**","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"TLDR:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"strong_close","tag":"strong","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"**","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you’re after a guide on Getting started by creating your first Serverless project. Dive straight in to create your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/first-serverless-project/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"first serverless project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" here. Or if you want to learn ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/learn"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"what is Serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". Otherwise, read on about getting started with SLS Zone, what it is, and how you can use it.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Introduction","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We have made some assumptions if you are on this website.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"1. You are a developer looking to learn about Serverless and develop Serverless apps.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"2. You are familiar with what Serverless is. (If not, read ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/learn"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"what is serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to get up to speed)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"SLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment. There are multiple approaches and tools to work with Serverless, so we should make it very clear that:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- SLS Zone tutorials currently focus on Serverless apps within the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://www.aws.com"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" infrastructure (Not Azure, Google Cloud Functions, or IBM Bluemix).","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- SLS Zone tutorials and practices largely use the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://www.serverless.com"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless framework","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to deliver applications, and help manage application structure.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- There are other approaches and tools which can be used, but nearly all our work exists in the AWS Environment and uses the Serverless framework. These are also the most mature tools in the serverless delivery world.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In the future, SLS Zone aims to write guides for other Cloud infrastructure including Azure, and Google Cloud.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Learn","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Learn content is the best place to start if you’re new to the Serverless world. It will teach you about developing Serverless apps, and how to handle different concepts including debugging, configuration, testing, and the basics of setting up your development environment.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Run","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Run content is more focussed on how you run your application in a production environment. This looks at a sustainable deployment model, handling monitoring, etc.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Build","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Projects and content within Build are open source projects which are available for you to use as part of a larger project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will find tools in here to help you structure your Serverless apps in a sustainable, logical way using slspress, but also tools which you might need for your project, but don’t necessarily need to build them from scratch. Have a look at the file-CDN, which is a self contained Serverless project that can provide similar functionality to the fully featured ‘Cloudinary’ service. Or sls-notify, which is useful for managing all notifications including APNS, SMS, GCM, MPNS and Email.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Community","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The Community section of the site will point you to the right direction for online groups and forums you find useful in your Serverless journey. These are external communities from SLS Zone but if you have questions for the developers who are making the SLS Zone content, you are free to join our Slack group, and you can speak to any one of us.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_open","tag":"em","attrs":null,"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"strong_open","tag":"strong","attrs":null,"map":null,"nesting":1,"level":2,"children":null,"content":"","markup":"**","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":2,"children":null,"content":"Have fun!","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"strong_close","tag":"strong","attrs":null,"map":null,"nesting":-1,"level":1,"children":null,"content":"","markup":"**","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_close","tag":"em","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Getting Started'\nsort: 0\ndescription: 'SLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment'\n---\n# Getting started\n\n::: info\n**TLDR:**\nIf you’re after a guide on Getting started by creating your first Serverless project. Dive straight in to create your [first serverless project](/pages/learn/first-serverless-project/) here. Or if you want to learn [what is Serverless](https://serverless.com/learn). Otherwise, read on about getting started with SLS Zone, what it is, and how you can use it.\n:::\n\n## Introduction\n\nWe have made some assumptions if you are on this website.\n\n1. You are a developer looking to learn about Serverless and develop Serverless apps.\n2. You are familiar with what Serverless is. (If not, read [what is serverless](https://serverless.com/learn) to get up to speed)\n\n&nbsp;\n\nSLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment. There are multiple approaches and tools to work with Serverless, so we should make it very clear that:\n\n- SLS Zone tutorials currently focus on Serverless apps within the [AWS](http://www.aws.com) infrastructure (Not Azure, Google Cloud Functions, or IBM Bluemix).\n\n- SLS Zone tutorials and practices largely use the [Serverless framework](http://www.serverless.com) to deliver applications, and help manage application structure.\n\n- There are other approaches and tools which can be used, but nearly all our work exists in the AWS Environment and uses the Serverless framework. These are also the most mature tools in the serverless delivery world.\n\n&nbsp;\n\n::: info\nIn the future, SLS Zone aims to write guides for other Cloud infrastructure including Azure, and Google Cloud.\n:::\n\n## Learn\n\nLearn content is the best place to start if you’re new to the Serverless world. It will teach you about developing Serverless apps, and how to handle different concepts including debugging, configuration, testing, and the basics of setting up your development environment.\n\n## Run\n\nRun content is more focussed on how you run your application in a production environment. This looks at a sustainable deployment model, handling monitoring, etc.\n\n## Build\n\nProjects and content within Build are open source projects which are available for you to use as part of a larger project.\n\nYou will find tools in here to help you structure your Serverless apps in a sustainable, logical way using slspress, but also tools which you might need for your project, but don’t necessarily need to build them from scratch. Have a look at the file-CDN, which is a self contained Serverless project that can provide similar functionality to the fully featured ‘Cloudinary’ service. Or sls-notify, which is useful for managing all notifications including APNS, SMS, GCM, MPNS and Email.\n\n## Community\n\nThe Community section of the site will point you to the right direction for online groups and forums you find useful in your Serverless journey. These are external communities from SLS Zone but if you have questions for the developers who are making the SLS Zone content, you are free to join our Slack group, and you can speak to any one of us.\n\n***Have fun!***\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Gettingstarted\"><a name=\"Gettingstarted\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Getting started</h1>\n<div class=\"info\">\n<p><strong>TLDR:</strong>\nIf you’re after a guide on Getting started by creating your first Serverless project. Dive straight in to create your <a href=\"/pages/learn/first-serverless-project/\" class=\"absolute-link\">first serverless project</a> here. Or if you want to learn <a href=\"https://serverless.com/learn\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">what is Serverless</a>. Otherwise, read on about getting started with SLS Zone, what it is, and how you can use it.</p>\n</div>\n<h2 id=\"Introduction\"><a name=\"Introduction\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Introduction</h2>\n<p>We have made some assumptions if you are on this website.</p>\n<ol>\n<li>You are a developer looking to learn about Serverless and develop Serverless apps.</li>\n<li>You are familiar with what Serverless is. (If not, read <a href=\"https://serverless.com/learn\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">what is serverless</a> to get up to speed)</li>\n</ol>\n<p> </p>\n<p>SLS Zone is a collection of tutorials and tools to help you develop and run Serverless applications in a production environment. There are multiple approaches and tools to work with Serverless, so we should make it very clear that:</p>\n<ul>\n<li>\n<p>SLS Zone tutorials currently focus on Serverless apps within the <a href=\"http://www.aws.com\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS</a> infrastructure (Not Azure, Google Cloud Functions, or IBM Bluemix).</p>\n</li>\n<li>\n<p>SLS Zone tutorials and practices largely use the <a href=\"http://www.serverless.com\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless framework</a> to deliver applications, and help manage application structure.</p>\n</li>\n<li>\n<p>There are other approaches and tools which can be used, but nearly all our work exists in the AWS Environment and uses the Serverless framework. These are also the most mature tools in the serverless delivery world.</p>\n</li>\n</ul>\n<p> </p>\n<div class=\"info\">\n<p>In the future, SLS Zone aims to write guides for other Cloud infrastructure including Azure, and Google Cloud.</p>\n</div>\n<h2 id=\"Learn\"><a name=\"Learn\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Learn</h2>\n<p>Learn content is the best place to start if you’re new to the Serverless world. It will teach you about developing Serverless apps, and how to handle different concepts including debugging, configuration, testing, and the basics of setting up your development environment.</p>\n<h2 id=\"Run\"><a name=\"Run\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Run</h2>\n<p>Run content is more focussed on how you run your application in a production environment. This looks at a sustainable deployment model, handling monitoring, etc.</p>\n<h2 id=\"Build\"><a name=\"Build\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Build</h2>\n<p>Projects and content within Build are open source projects which are available for you to use as part of a larger project.</p>\n<p>You will find tools in here to help you structure your Serverless apps in a sustainable, logical way using slspress, but also tools which you might need for your project, but don’t necessarily need to build them from scratch. Have a look at the file-CDN, which is a self contained Serverless project that can provide similar functionality to the fully featured ‘Cloudinary’ service. Or sls-notify, which is useful for managing all notifications including APNS, SMS, GCM, MPNS and Email.</p>\n<h2 id=\"Community\"><a name=\"Community\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Community</h2>\n<p>The Community section of the site will point you to the right direction for online groups and forums you find useful in your Serverless journey. These are external communities from SLS Zone but if you have questions for the developers who are making the SLS Zone content, you are free to join our Slack group, and you can speak to any one of us.</p>\n<p><em><strong>Have fun!</strong></em></p>\n"}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vYWRkaW5nLWEtY3VzdG9tLXVybC1mb3IteW91ci1hcGkubWQ","filename":"/content/pages/learn/adding-a-custom-url-for-your-api.md","suffix":"","attributes":{"title":"Adding a custom url for your API","sort":9,"description":"We are going to set-up a custom URL for our AWS lambda functions.","tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Adding a custom url for your API\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 9","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'We are going to set-up a custom URL for our AWS lambda functions.'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Custom domains for lambda functions","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We are going to set-up a custom URL for our AWS lambda functions.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Prerequisites","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Familiarity with AWS and Serverless.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Let's do this!","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 1. Make sure you have the domain in Route 53.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"A few options if you don't:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-transfer-to-route-53.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Transfer the domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" (if you already have it with another registrar)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-register.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Buy a new domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/custom-url_1.png"],["alt",""],["title","registered domains"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"registered domains","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"registered domains","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 2. API Gateway requests are served over HTTPS, so we need an SSL certificate.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Again, we have a few options to get this working with the Certificate Manager from AWS.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://console.aws.amazon.com/acm/home?region=us-east-1#/wizard/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Request a certificate.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" (Let AWS handle it! - recommended)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://docs.aws.amazon.com/acm/latest/userguide/import-certificate.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Import a certificate.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/custom-url_2.png"],["alt",""],["title","manage certificates"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"manage certificates","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"manage certificates","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"After going through the review and validation process, you will have a your certificate in \"Issued\" status.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/custom-url_3.png"],["alt",""],["title","issued certificate"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"issued certificate","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"issued certificate","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### 3. Configure your Serverless function to use your new custom domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First, install a new serverless plugin.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install serverless-domain-manager --save-dev","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Second, Add the following to your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". Replace '<registered_domain_name>' with your domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml plugins: - serverless-domain-manager custom: customDomain: domainName: <registered_domain_name> basePath: '' stage: ${self:provider.stage} createRoute53Record: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Third, create the custom domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash sls create_domain Serverless: Domain was created, may take up to 40 mins to be initialized","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Finally, deploy the function again.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash sls deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"At the end of the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Service Information","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" block, you'll also get a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless Domain Manager Summary","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" that shows the domain name associated with your domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you need to remove the domain, simply run:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless delete_domain","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/serverless-domain-manager"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless domain manager plugin","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/blog/api-gateway-multiple-services/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Deploying multiple services on same domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/blog/serverless-api-gateway-domain/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Custom domains for Serverless functions on AWS","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Adding a custom url for your API\"\nsort: 9\ndescription: 'We are going to set-up a custom URL for our AWS lambda functions.'\ntags:\n    - new\n---\n# Custom domains for lambda functions\n\nWe are going to set-up a custom URL for our AWS lambda functions.\n\n&nbsp;\n\n## Prerequisites\n\nFamiliarity with AWS and Serverless.\n\n&nbsp;\n\n## Let's do this!\n\n### 1. Make sure you have the domain in Route 53.\nA few options if you don't:\n* [Transfer the domain.](http://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-transfer-to-route-53.html) (if you already have it with another registrar)\n* [Buy a new domain.](https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-register.html)\n![registered domains](/assets/custom-url_1.png \"registered domains\")\n\n### 2. API Gateway requests are served over HTTPS, so we need an SSL certificate.\nAgain, we have a few options to get this working with the Certificate Manager from AWS.\n* [Request a certificate.](https://console.aws.amazon.com/acm/home?region=us-east-1#/wizard/) (Let AWS handle it! - recommended)\n* [Import a certificate.](https://docs.aws.amazon.com/acm/latest/userguide/import-certificate.html)\n![manage certificates](/assets/custom-url_2.png \"manage certificates\")\n\nAfter going through the review and validation process, you will have a your certificate in \"Issued\" status.\n![issued certificate](/assets/custom-url_3.png \"issued certificate\")\n&nbsp;\n\n### 3. Configure your Serverless function to use your new custom domain.\n\nFirst, install a new serverless plugin.\n```bash\nnpm install serverless-domain-manager --save-dev\n```\n\n&nbsp;\n\nSecond, Add the following to your `serverless.yml`. Replace '<registered_domain_name>' with your domain.\n```yaml\nplugins:\n  - serverless-domain-manager\n\ncustom:\n  customDomain:\n    domainName: <registered_domain_name>\n    basePath: ''\n    stage: ${self:provider.stage}\n    createRoute53Record: true\n```\n\n&nbsp;\n\nThird, create the custom domain.\n```bash\nsls create_domain\nServerless: Domain was created, may take up to 40 mins to be initialized\n```\n\n&nbsp;\n\nFinally, deploy the function again.\n```bash\nsls deploy\n```\n\nAt the end of the `Service Information` block, you'll also get a `Serverless Domain Manager Summary` that shows the domain name associated with your domain.\n\n&nbsp;\n\nIf you need to remove the domain, simply run:\n```bash\nserverless delete_domain\n```\n\n::: links\nFurther reading:\n\n* [Serverless domain manager plugin](https://www.npmjs.com/package/serverless-domain-manager)\n* [Deploying multiple services on same domain.](https://serverless.com/blog/api-gateway-multiple-services/)\n* [Custom domains for Serverless functions on AWS](https://serverless.com/blog/serverless-api-gateway-domain/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Customdomainsforlambdafunctions\"><a name=\"Customdomainsforlambdafunctions\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Custom domains for lambda functions</h1>\n<p>We are going to set-up a custom URL for our AWS lambda functions.</p>\n<p> </p>\n<h2 id=\"Prerequisites\"><a name=\"Prerequisites\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Prerequisites</h2>\n<p>Familiarity with AWS and Serverless.</p>\n<p> </p>\n<h2 id=\"Let'sdothis!\"><a name=\"Let'sdothis!\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Let's do this!</h2>\n<h3 id=\"1.MakesureyouhavethedomaininRoute53.\"><a name=\"1.MakesureyouhavethedomaininRoute53.\" class=\"markdown-it-headinganchor\" href=\"#\"></a>1. Make sure you have the domain in Route 53.</h3>\n<p>A few options if you don't:</p>\n<ul>\n<li><a href=\"http://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-transfer-to-route-53.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Transfer the domain.</a> (if you already have it with another registrar)</li>\n<li><a href=\"https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/domain-register.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Buy a new domain.</a>\n<img src=\"/assets/custom-url_1.png\" alt=\"registered domains\" title=\"registered domains\"></li>\n</ul>\n<h3 id=\"2.APIGatewayrequestsareservedoverHTTPS%2CsoweneedanSSLcertificate.\"><a name=\"2.APIGatewayrequestsareservedoverHTTPS%2CsoweneedanSSLcertificate.\" class=\"markdown-it-headinganchor\" href=\"#\"></a>2. API Gateway requests are served over HTTPS, so we need an SSL certificate.</h3>\n<p>Again, we have a few options to get this working with the Certificate Manager from AWS.</p>\n<ul>\n<li><a href=\"https://console.aws.amazon.com/acm/home?region=us-east-1#/wizard/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Request a certificate.</a> (Let AWS handle it! - recommended)</li>\n<li><a href=\"https://docs.aws.amazon.com/acm/latest/userguide/import-certificate.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Import a certificate.</a>\n<img src=\"/assets/custom-url_2.png\" alt=\"manage certificates\" title=\"manage certificates\"></li>\n</ul>\n<p>After going through the review and validation process, you will have a your certificate in &quot;Issued&quot; status.\n<img src=\"/assets/custom-url_3.png\" alt=\"issued certificate\" title=\"issued certificate\">\n </p>\n<h3 id=\"3.ConfigureyourServerlessfunctiontouseyournewcustomdomain.\"><a name=\"3.ConfigureyourServerlessfunctiontouseyournewcustomdomain.\" class=\"markdown-it-headinganchor\" href=\"#\"></a>3. Configure your Serverless function to use your new custom domain.</h3>\n<p>First, install a new serverless plugin.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> serverless-domain-manager --save-dev\n</code></pre>\n<p> </p>\n<p>Second, Add the following to your <code>serverless.yml</code>. Replace '&lt;registered_domain_name&gt;' with your domain.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">plugins</span><span class=\"token punctuation\">:</span>\n  <span class=\"token punctuation\">-</span> serverless<span class=\"token punctuation\">-</span>domain<span class=\"token punctuation\">-</span>manager\n\n<span class=\"token key atrule\">custom</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">customDomain</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">domainName</span><span class=\"token punctuation\">:</span> &lt;registered_domain_name<span class=\"token punctuation\">></span>\n    <span class=\"token key atrule\">basePath</span><span class=\"token punctuation\">:</span> <span class=\"token string\">''</span>\n    <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span>\n    <span class=\"token key atrule\">createRoute53Record</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p> </p>\n<p>Third, create the custom domain.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">sls create_domain\nServerless: Domain was created, may take up to 40 mins to be initialized\n</code></pre>\n<p> </p>\n<p>Finally, deploy the function again.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">sls deploy\n</code></pre>\n<p>At the end of the <code>Service Information</code> block, you'll also get a <code>Serverless Domain Manager Summary</code> that shows the domain name associated with your domain.</p>\n<p> </p>\n<p>If you need to remove the domain, simply run:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless delete_domain\n</code></pre>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://www.npmjs.com/package/serverless-domain-manager\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless domain manager plugin</a></li>\n<li><a href=\"https://serverless.com/blog/api-gateway-multiple-services/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Deploying multiple services on same domain.</a></li>\n<li><a href=\"https://serverless.com/blog/serverless-api-gateway-domain/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Custom domains for Serverless functions on AWS</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vY2FsbGluZy1vdGhlci1sYW1iZGFzLm1k","filename":"/content/pages/learn/calling-other-lambdas.md","suffix":"","attributes":{"title":"Calling other lambdas","sort":4,"featured":true,"description":"Calling other lambdas using SLSPress"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Calling other lambdas'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 4","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Calling other lambdas using SLSPress'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Calling other lambdas","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We assume that you've already created your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/first-serverless-project/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"First Serverless project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Prerequisites","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/dumptruck"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is here to help you monitoring what happens with your lambda functions on AWS in real time.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## When would you call other lambdas?","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The typical Lambda function would take some input, provide some small modular functionality and produce some output. Usually, any complex project would require multiple lambda functions, some of which might depend on each other. Whenever the output of one lambda is required as an input for another lambda function, it is necessary to have multiple options to call one lambda function from another.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Two approaches to the problem: Calling other λs","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| ___ | Through SNS Queue | Directly via AWS API (HTTP) |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| --- | -----------------------  | ---------------------------------  |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| Cost efficient | Yes | No |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| Immediate response | No | Yes |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| Can pass limited data to other λ | Yes* | No |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| Longer execution time of first lambda | No | Yes |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"| Fire and Forget | Yes | Yes |","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* - If you need to pass a lot of data, you can save it to S3 or any other storage and pass the link to it, although, it requires more hassle.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First and correct approach is is to use SNS queue. It follows the event-driven architecture and is more cost efficient. Once you send and event to the queue your origin λ can forget about it and successfully exit thus saving you execution time and money.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Second approach can be used if the result of the second λ is absolutely required in the first λ. In that case you can directly call second λ from first λ. This approach also allows you to send more data between λs as ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://forum.serverless.com/t/simple-method-to-trigger-other-serverless-functions-inside-one-function/747"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"SNS doesn't allow you to pass much data","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". The disadvantage of this approach is that you essentially make first λ to wait while the second is executing, essentially doubling the execution time you are charged for. Also, if second λ also calls some other λs it might increase your costs even more. On more negative scenario is when the second λ is not warmed up, you will be charged for the warm up of the second λ in the first λ.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note that you can also use Fire and Forget in case of the second approach. In that case the first lambda is not gonna wait for the execution of the second lambda.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Call through SNS Queue","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas-sns"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/sns/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Detailed instructions","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on how to specify SNS topic to invoke λ when something is posted there.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless framework supports the creation of SNS topic for you, you just have to have the following yaml for your function:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml multiply-number-sns: handler: handler.multiplyNumberSNS description: \"slspress calling other lambdas using sns example\" events: - sns: topicName: multiply-number-dispatch displayName: Multiply Number Dispatch","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"On first deploy, Serverless will automatically create the topic and make subscribe ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumberSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function on it. Unfortunately, at the moment of writing the documentation there was no good way of relatively referencing the topic ARN resource from other functions, therefore usually you would take a different approach. You can define the ARN as a variable and pass it all functions that need it as well as to functions that need to listen to the topic.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Example yaml:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: serverless-hello-world custom: multiplyNumberDispatchTopic: Fn::Join: - \"\" - - \"arn:aws:sns:\" - Ref: \"AWS::Region\" - \":\" - Ref: \"AWS::AccountId\" - \":multiply-number-dispatch\" provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 stage: dev environment: SERVERLESS_SERVICE_NAME: ${self:service} SERVERLESS_SERVICE_STAGE: ${opt:stage, self:provider.stage} iamRoleStatements: - Effect: Allow Action: - sns:Publish - sns:CreateTopic Resource: \"${self:custom.multiplyNumberDispatchTopic}\" package: individually: true functions: post-to-sns: handler: handler.handle name: \"${self:service}-${self:provider.stage}-post-to-sns\" description: \"slspress calling other lambdas using sns example\" environment: MULTIPLY_NUMBER_SNS_TOPIC: \"${self:custom.multiplyNumberDispatchTopic}\" events: - http: path: post-to-sns method: get cors: true multiply-number-sns: handler: handler.multiplyNumberSNS description: \"slspress calling other lambdas using sns example\" events: - sns: topicName: multiply-number-dispatch displayName: Multiply Number Dispatch","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In the code, ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"postToSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function will have access to the topic where to post.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript const { create, jsonMiddleware } = require('slspress'); const AWS = require('aws-sdk'); const handler = create(); const sns = new AWS.SNS(); handler.on('handle') .middleware(jsonMiddleware) .get('/post-to-sns', (req, res) => { var params = { Message: JSON.stringify({ x: 345, y: 543 }), Subject: 'post-to-sns', TopicArn: process.env.MULTIPLY_NUMBER_SNS_TOPIC }; sns.publish(params, (err, data) => { if (err) return res.handleError(err); else return res.ok(data); }); }); module.exports = handler.export();","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"and simplest version of ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumberSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" that will listen to events:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.multiplyNumberSNS = (event, context) => { console.log('EVENT: ', JSON.stringify(event)) const vars = JSON.parse(event.Records[0].Sns.Message); console.log(vars.x * vars.y); };","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can use our internal tool ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/dumptruck"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to monitor both ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"postToSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumberSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" logs in a fast way.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash dumptruck","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you try to go to your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"postToSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function API Gateway URL, you should see in terminal window logs that function failed to post to SNS because it doesn't have permissions to SNS. That's correct, λ function should be given permissions to post to SNS queue.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Login to AWS Console -> Lambda -> Functions -> serverless-hello-world-dev-postToSNS -> Configuration.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_1.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/calling-other-lambdas-4_1.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"enter image description here","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"enter image description here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Here you should press Role -> Create Custom Role","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_2.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/calling-other-lambdas-4_2.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"enter image description here","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"enter image description here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Name the role ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda-post-to-sns-allow","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and set it to policy:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Version\": \"2012-10-17\", \"Statement\": [ { \"Effect\": \"Allow\", \"Action\": [ \"sns:Publish\" ], \"Resource\": \"arn:aws:sns:us-east-1:xxxxxxxxxxxx:multiplyNumberDispatch\" } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"where ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"xxxxxxxxxxxx","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is you AWS Account ID.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will make sure this λ can do ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sns:Publish","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on our newly created SNS Topic.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"After saving role and λ configuration (make sure you press Save on both), you can retry invoking ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"postToSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" API Gateway URL. Now, you'll see in dumptruck of ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumberSNS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" that it received data from the queue.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Call Directly via AWS API (HTTP)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's just create a simple JS handler for our both our functions in ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript const { create, jsonMiddleware } = require('slspress'); const AWS = require('aws-sdk'); const handler = create(); const lambda = new AWS.Lambda( { region: 'eu-west-1' } ); const fPrepend = [ process.env.SERVERLESS_SERVICE_NAME, process.env.SERVERLESS_SERVICE_STAGE, '' ].join('-'); handler.on('handle') .middleware(jsonMiddleware) .get('/calling-other-lambdas', (req, res) => { const params = { FunctionName: fPrepend + 'multiply-number', InvocationType: \"RequestResponse\", LogType: \"Tail\", Payload: JSON.stringify({x: 5, y: 100}), }; lambda.invoke(params, (err, data) => { if (err) return res.handleError(err); else return res.ok(data); }); }) .post('/multiply-number', (req, res) => { const vars = req.event.body; const response = { statusCode: 200, headers: { 'Access-Control-Allow-Origin': '*', // Required for CORS support to work }, body: JSON.stringify({ result: vars.x * vars.y || 0, input: req.event, }) }; return res.ok(response); }); module.exports = handler.export();","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/Lambda.html#invoke-property"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"lambda.invoke","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function will do the call from one lambda function to another. Keep in mind that better approach of calling one lambda function from another would be to use SNS queue described previously.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Our ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" looks like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: calling-other-lambdas provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 stage: dev environment: SERVERLESS_SERVICE_NAME: ${self:service} SERVERLESS_SERVICE_STAGE: ${opt:stage, self:provider.stage} iamRoleStatements: - Effect: Allow Action: - lambda:InvokeFunction Resource: \"arn:aws:lambda:${opt:region, self:provider.region}:*:function:${self:service}-${opt:stage, self:provider.stage}-multiply-number\" package: individually: true functions: calling-other-lambdas: handler: handler.handle name: \"${self:service}-${self:provider.stage}-calling-other-lambdas\" events: - http: path: calling-other-lambdas method: get cors: true multiply-number: handler: handler.handle name: \"${self:service}-${self:provider.stage}-multiply-number\" events: - http: path: multiply-number method: post cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now if you created ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" you can deploy function with:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"and just open the API Gateway URL of multiply-number function. You should see the result looking like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"{\"message\":\"//////helloWorld called multiplyNumber and second function responded with: 500\",\"responseBody\":{\"result\":500,\"input\":{\"x\":5,\"y\":100}}}","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note, that you can also use fire and forget. In that case, you just have to specify","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript var params = { FunctionName: fPrepend + 'multiplyNumber', InvocationType: \"Event\", LogType: \"Tail\", Payload: JSON.stringify({x: 5, y: 100}), };","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The callback will succeed when the other lambda was invoked but it'll not wait for it to be finished.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Calling other lambdas'\nsort: 4\nfeatured: true\ndescription: 'Calling other lambdas using SLSPress'\n---\n# Calling other lambdas\n\nWe assume that you've already created your [First Serverless project](/pages/learn/first-serverless-project/)\n\n## Prerequisites\n\n[Dumptruck](https://github.com/withreason/dumptruck) is here to help you monitoring what happens with your lambda functions on AWS in real time.\n\n## When would you call other lambdas?\n\nThe typical Lambda function would take some input, provide some small modular functionality and produce some output. Usually, any complex project would require multiple lambda functions, some of which might depend on each other. Whenever the output of one lambda is required as an input for another lambda function, it is necessary to have multiple options to call one lambda function from another.\n\n## Two approaches to the problem: Calling other λs\n\n| ___ | Through SNS Queue | Directly via AWS API (HTTP) |\n| --- | -----------------------  | ---------------------------------  |\n| Cost efficient | Yes | No |\n| Immediate response | No | Yes |\n| Can pass limited data to other λ | Yes* | No |\n| Longer execution time of first lambda | No | Yes |\n| Fire and Forget | Yes | Yes |\n\n\\* - If you need to pass a lot of data, you can save it to S3 or any other storage and pass the link to it, although, it requires more hassle.\n\nFirst and correct approach is is to use SNS queue. It follows the event-driven architecture and is more cost efficient. Once you send and event to the queue your origin λ can forget about it and successfully exit thus saving you execution time and money.\n\nSecond approach can be used if the result of the second λ is absolutely required in the first λ. In that case you can directly call second λ from first λ. This approach also allows you to send more data between λs as [SNS doesn't allow you to pass much data](http://forum.serverless.com/t/simple-method-to-trigger-other-serverless-functions-inside-one-function/747). The disadvantage of this approach is that you essentially make first λ to wait while the second is executing, essentially doubling the execution time you are charged for. Also, if second λ also calls some other λs it might increase your costs even more. On more negative scenario is when the second λ is not warmed up, you will be charged for the warm up of the second λ in the first λ.\n\nNote that you can also use Fire and Forget in case of the second approach. In that case the first lambda is not gonna wait for the execution of the second lambda.\n\n::: icons\n\n### Call through SNS Queue\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas-sns)\n:::\n\n[Detailed instructions](https://serverless.com/framework/docs/providers/aws/events/sns/) on how to specify SNS topic to invoke λ when something is posted there.\n\nServerless framework supports the creation of SNS topic for you, you just have to have the following yaml for your function:\n\n```yaml\n  multiply-number-sns:\n    handler: handler.multiplyNumberSNS\n    description: \"slspress calling other lambdas using sns example\"\n    events:\n      - sns: \n          topicName: multiply-number-dispatch\n          displayName: Multiply Number Dispatch\n```\n\nOn first deploy, Serverless will automatically create the topic and make subscribe `multiplyNumberSNS` function on it. Unfortunately, at the moment of writing the documentation there was no good way of relatively referencing the topic ARN resource from other functions, therefore usually you would take a different approach. You can define the ARN as a variable and pass it all functions that need it as well as to functions that need to listen to the topic.\nExample yaml:\n\n```yaml\nservice: serverless-hello-world\ncustom:\n  multiplyNumberDispatchTopic: \n    Fn::Join:\n      - \"\"\n      - - \"arn:aws:sns:\"\n        - Ref: \"AWS::Region\"\n        - \":\"\n        - Ref: \"AWS::AccountId\"\n        - \":multiply-number-dispatch\"\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256\n  stage: dev\n  environment:\n    SERVERLESS_SERVICE_NAME: ${self:service}\n    SERVERLESS_SERVICE_STAGE: ${opt:stage, self:provider.stage}\n  iamRoleStatements:\n    - Effect: Allow\n      Action:\n        - sns:Publish\n        - sns:CreateTopic\n      Resource: \"${self:custom.multiplyNumberDispatchTopic}\"\n\npackage:\n  individually: true\n\nfunctions:\n\n  post-to-sns:\n    handler: handler.handle\n    name: \"${self:service}-${self:provider.stage}-post-to-sns\"\n    description: \"slspress calling other lambdas using sns example\"\n    environment:\n      MULTIPLY_NUMBER_SNS_TOPIC: \"${self:custom.multiplyNumberDispatchTopic}\"\n    events:\n      - http:\n          path: post-to-sns\n          method: get\n          cors: true\n\n  multiply-number-sns:\n    handler: handler.multiplyNumberSNS\n    description: \"slspress calling other lambdas using sns example\"\n    events:\n      - sns: \n          topicName: multiply-number-dispatch\n          displayName: Multiply Number Dispatch\n```\n\nIn the code, `postToSNS` function will have access to the topic where to post.\n\n```javascript\nconst { create, jsonMiddleware } = require('slspress');\nconst AWS = require('aws-sdk');\n\nconst handler = create();\n\nconst sns = new AWS.SNS();\n\nhandler.on('handle')\n    .middleware(jsonMiddleware)\n    .get('/post-to-sns', (req, res) => {\n\n        var params = {\n            Message: JSON.stringify({ x: 345, y: 543 }),\n            Subject: 'post-to-sns',\n            TopicArn: process.env.MULTIPLY_NUMBER_SNS_TOPIC\n          };\n    \n        sns.publish(params, (err, data) => {\n            if (err) return res.handleError(err);\n            else return res.ok(data);\n        });\n    });\n\nmodule.exports = handler.export();\n```\n\nand simplest version of `multiplyNumberSNS` that will listen to events:\n\n```javascript\nmodule.exports.multiplyNumberSNS = (event, context) => {\n  console.log('EVENT: ', JSON.stringify(event))\n  const vars = JSON.parse(event.Records[0].Sns.Message);\n  console.log(vars.x * vars.y);\n};\n```\n\nYou can use our internal tool [Dumptruck](https://github.com/withreason/dumptruck) to monitor both `postToSNS` and `multiplyNumberSNS` logs in a fast way.\n\n```bash\ndumptruck\n```\n\nIf you try to go to your `postToSNS` function API Gateway URL, you should see in terminal window logs that function failed to post to SNS because it doesn't have permissions to SNS. That's correct, λ function should be given permissions to post to SNS queue.\n\nLogin to AWS Console -> Lambda -> Functions -> serverless-hello-world-dev-postToSNS -> Configuration.\n[![enter image description here](/assets/calling-other-lambdas-4_1.png)](https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_1.png)\nHere you should press Role -> Create Custom Role\n[![enter image description here](/assets/calling-other-lambdas-4_2.png)](https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_2.png)\nName the role `lambda-post-to-sns-allow` and set it to policy:\n\n```json\n{\n  \"Version\": \"2012-10-17\",\n  \"Statement\": [\n    {\n      \"Effect\": \"Allow\",\n      \"Action\": [\n        \"sns:Publish\"\n      ],\n      \"Resource\": \"arn:aws:sns:us-east-1:xxxxxxxxxxxx:multiplyNumberDispatch\"\n    }\n  ]\n}\n```\n\nwhere `xxxxxxxxxxxx` is you AWS Account ID.\nThis will make sure this λ can do `sns:Publish` on our newly created SNS Topic.\nAfter saving role and λ configuration (make sure you press Save on both), you can retry invoking `postToSNS` API Gateway URL. Now, you'll see in dumptruck of `multiplyNumberSNS` that it received data from the queue.\n\n::: icons\n\n### Call Directly via AWS API (HTTP)\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas)\n:::\n\nLet's just create a simple JS handler for our both our functions in `handler.js`\n\n```javascript\nconst { create, jsonMiddleware } = require('slspress');\nconst AWS = require('aws-sdk');\n\nconst handler = create();\n\nconst lambda = new AWS.Lambda( { region: 'eu-west-1' } );\n\nconst fPrepend = [\n    process.env.SERVERLESS_SERVICE_NAME,\n    process.env.SERVERLESS_SERVICE_STAGE, ''\n    ].join('-');\n\nhandler.on('handle')\n    .middleware(jsonMiddleware)\n    .get('/calling-other-lambdas', (req, res) => {\n\n        const params = {\n            FunctionName: fPrepend + 'multiply-number', \n            InvocationType: \"RequestResponse\", \n            LogType: \"Tail\", \n            Payload: JSON.stringify({x: 5, y: 100}),\n          };\n\n        lambda.invoke(params, (err, data) => {\n            if (err) return res.handleError(err);\n            else return res.ok(data);\n        });\n    })\n    .post('/multiply-number', (req, res) => {\n        const vars = req.event.body;\n        const response = {\n            statusCode: 200,\n            headers: {\n              'Access-Control-Allow-Origin': '*', // Required for CORS support to work\n            },\n            body: JSON.stringify({\n              result: vars.x * vars.y || 0,\n              input: req.event,\n            })\n        };\n        return res.ok(response);\n    });\n\nmodule.exports = handler.export();\n```\n\n[lambda.invoke](http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/Lambda.html#invoke-property) function will do the call from one lambda function to another. Keep in mind that better approach of calling one lambda function from another would be to use SNS queue described previously.\n\nOur `serverless.yml` looks like this:\n\n```yaml\nservice: calling-other-lambdas\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256\n  stage: dev\n  environment:\n    SERVERLESS_SERVICE_NAME: ${self:service}\n    SERVERLESS_SERVICE_STAGE: ${opt:stage, self:provider.stage}\n  iamRoleStatements:\n    - Effect: Allow\n      Action:\n        - lambda:InvokeFunction\n      Resource: \"arn:aws:lambda:${opt:region, self:provider.region}:*:function:${self:service}-${opt:stage, self:provider.stage}-multiply-number\"\n\npackage:\n  individually: true\n\nfunctions:\n  calling-other-lambdas:\n      handler: handler.handle\n      name: \"${self:service}-${self:provider.stage}-calling-other-lambdas\"\n      events:\n        - http:\n            path: calling-other-lambdas\n            method: get\n            cors: true\n\n  multiply-number:\n      handler: handler.handle\n      name: \"${self:service}-${self:provider.stage}-multiply-number\"\n      events:\n        - http:\n            path: multiply-number\n            method: post\n            cors: true\n```\n\nNow if you created `handler.js` and `serverless.yml` you can deploy function with:\n```bash\nserverless deploy\n```\n\nand just open the API Gateway URL of multiply-number function. You should see the result looking like this:\n\n```\n{\"message\":\"//////helloWorld called multiplyNumber and second function responded with: 500\",\"responseBody\":{\"result\":500,\"input\":{\"x\":5,\"y\":100}}}\n\n```\n\nNote, that you can also use fire and forget. In that case, you just have to specify\n\n```javascript\nvar params = {\n  FunctionName: fPrepend + 'multiplyNumber',\n  InvocationType: \"Event\",\n  LogType: \"Tail\",\n  Payload: JSON.stringify({x: 5, y: 100}),\n};\n```\n\nThe callback will succeed when the other lambda was invoked but it'll not wait for it to be finished.\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Callingotherlambdas\"><a name=\"Callingotherlambdas\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Calling other lambdas</h1>\n<p>We assume that you've already created your <a href=\"/pages/learn/first-serverless-project/\" class=\"absolute-link\">First Serverless project</a></p>\n<h2 id=\"Prerequisites\"><a name=\"Prerequisites\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Prerequisites</h2>\n<p><a href=\"https://github.com/withreason/dumptruck\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Dumptruck</a> is here to help you monitoring what happens with your lambda functions on AWS in real time.</p>\n<h2 id=\"Whenwouldyoucallotherlambdas%3F\"><a name=\"Whenwouldyoucallotherlambdas%3F\" class=\"markdown-it-headinganchor\" href=\"#\"></a>When would you call other lambdas?</h2>\n<p>The typical Lambda function would take some input, provide some small modular functionality and produce some output. Usually, any complex project would require multiple lambda functions, some of which might depend on each other. Whenever the output of one lambda is required as an input for another lambda function, it is necessary to have multiple options to call one lambda function from another.</p>\n<h2 id=\"Twoapproachestotheproblem%3ACallingother%CE%BBs\"><a name=\"Twoapproachestotheproblem%3ACallingother%CE%BBs\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Two approaches to the problem: Calling other λs</h2>\n<table>\n<thead>\n<tr>\n<th>___</th>\n<th>Through SNS Queue</th>\n<th>Directly via AWS API (HTTP)</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Cost efficient</td>\n<td>Yes</td>\n<td>No</td>\n</tr>\n<tr>\n<td>Immediate response</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr>\n<td>Can pass limited data to other λ</td>\n<td>Yes*</td>\n<td>No</td>\n</tr>\n<tr>\n<td>Longer execution time of first lambda</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr>\n<td>Fire and Forget</td>\n<td>Yes</td>\n<td>Yes</td>\n</tr>\n</tbody>\n</table>\n<p>* - If you need to pass a lot of data, you can save it to S3 or any other storage and pass the link to it, although, it requires more hassle.</p>\n<p>First and correct approach is is to use SNS queue. It follows the event-driven architecture and is more cost efficient. Once you send and event to the queue your origin λ can forget about it and successfully exit thus saving you execution time and money.</p>\n<p>Second approach can be used if the result of the second λ is absolutely required in the first λ. In that case you can directly call second λ from first λ. This approach also allows you to send more data between λs as <a href=\"http://forum.serverless.com/t/simple-method-to-trigger-other-serverless-functions-inside-one-function/747\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">SNS doesn't allow you to pass much data</a>. The disadvantage of this approach is that you essentially make first λ to wait while the second is executing, essentially doubling the execution time you are charged for. Also, if second λ also calls some other λs it might increase your costs even more. On more negative scenario is when the second λ is not warmed up, you will be charged for the warm up of the second λ in the first λ.</p>\n<p>Note that you can also use Fire and Forget in case of the second approach. In that case the first lambda is not gonna wait for the execution of the second lambda.</p>\n<div class=\"icons\">\n<h3 id=\"CallthroughSNSQueue\"><a name=\"CallthroughSNSQueue\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Call through SNS Queue</h3>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas-sns\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p><a href=\"https://serverless.com/framework/docs/providers/aws/events/sns/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Detailed instructions</a> on how to specify SNS topic to invoke λ when something is posted there.</p>\n<p>Serverless framework supports the creation of SNS topic for you, you just have to have the following yaml for your function:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\">  <span class=\"token key atrule\">multiply-number-sns</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.multiplyNumberSNS\n    <span class=\"token key atrule\">description</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"slspress calling other lambdas using sns example\"</span>\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">sns</span><span class=\"token punctuation\">:</span> \n          <span class=\"token key atrule\">topicName</span><span class=\"token punctuation\">:</span> multiply<span class=\"token punctuation\">-</span>number<span class=\"token punctuation\">-</span>dispatch\n          <span class=\"token key atrule\">displayName</span><span class=\"token punctuation\">:</span> Multiply Number Dispatch\n</code></pre>\n<p>On first deploy, Serverless will automatically create the topic and make subscribe <code>multiplyNumberSNS</code> function on it. Unfortunately, at the moment of writing the documentation there was no good way of relatively referencing the topic ARN resource from other functions, therefore usually you would take a different approach. You can define the ARN as a variable and pass it all functions that need it as well as to functions that need to listen to the topic.\nExample yaml:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> serverless<span class=\"token punctuation\">-</span>hello<span class=\"token punctuation\">-</span>world\n<span class=\"token key atrule\">custom</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">multiplyNumberDispatchTopic</span><span class=\"token punctuation\">:</span> \n    <span class=\"token key atrule\">Fn::Join</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token string\">\"\"</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token punctuation\">-</span> <span class=\"token string\">\"arn:aws:sns:\"</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Ref</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"AWS::Region\"</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token string\">\":\"</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Ref</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"AWS::AccountId\"</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token string\">\":multiply-number-dispatch\"</span>\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n  <span class=\"token key atrule\">environment</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">SERVERLESS_SERVICE_NAME</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span>\n    <span class=\"token key atrule\">SERVERLESS_SERVICE_STAGE</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>opt<span class=\"token punctuation\">:</span>stage<span class=\"token punctuation\">,</span> self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span>\n  <span class=\"token key atrule\">iamRoleStatements</span><span class=\"token punctuation\">:</span>\n    <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Effect</span><span class=\"token punctuation\">:</span> Allow\n      <span class=\"token key atrule\">Action</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> sns<span class=\"token punctuation\">:</span>Publish\n        <span class=\"token punctuation\">-</span> sns<span class=\"token punctuation\">:</span>CreateTopic\n      <span class=\"token key atrule\">Resource</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"${self:custom.multiplyNumberDispatchTopic}\"</span>\n\n<span class=\"token key atrule\">package</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">individually</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n\n  <span class=\"token key atrule\">post-to-sns</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.handle\n    <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"${self:service}-${self:provider.stage}-post-to-sns\"</span>\n    <span class=\"token key atrule\">description</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"slspress calling other lambdas using sns example\"</span>\n    <span class=\"token key atrule\">environment</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">MULTIPLY_NUMBER_SNS_TOPIC</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"${self:custom.multiplyNumberDispatchTopic}\"</span>\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> post<span class=\"token punctuation\">-</span>to<span class=\"token punctuation\">-</span>sns\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n\n  <span class=\"token key atrule\">multiply-number-sns</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.multiplyNumberSNS\n    <span class=\"token key atrule\">description</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"slspress calling other lambdas using sns example\"</span>\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">sns</span><span class=\"token punctuation\">:</span> \n          <span class=\"token key atrule\">topicName</span><span class=\"token punctuation\">:</span> multiply<span class=\"token punctuation\">-</span>number<span class=\"token punctuation\">-</span>dispatch\n          <span class=\"token key atrule\">displayName</span><span class=\"token punctuation\">:</span> Multiply Number Dispatch\n</code></pre>\n<p>In the code, <code>postToSNS</code> function will have access to the topic where to post.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> create<span class=\"token punctuation\">,</span> jsonMiddleware <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'slspress'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">const</span> <span class=\"token constant\">AWS</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'aws-sdk'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> handler <span class=\"token operator\">=</span> <span class=\"token function\">create</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> sns <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">AWS<span class=\"token punctuation\">.</span>SNS</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nhandler<span class=\"token punctuation\">.</span><span class=\"token function\">on</span><span class=\"token punctuation\">(</span><span class=\"token string\">'handle'</span><span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">middleware</span><span class=\"token punctuation\">(</span>jsonMiddleware<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token keyword\">get</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/post-to-sns'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n\n        <span class=\"token keyword\">var</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n            Message<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> x<span class=\"token punctuation\">:</span> <span class=\"token number\">345</span><span class=\"token punctuation\">,</span> y<span class=\"token punctuation\">:</span> <span class=\"token number\">543</span> <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n            Subject<span class=\"token punctuation\">:</span> <span class=\"token string\">'post-to-sns'</span><span class=\"token punctuation\">,</span>\n            TopicArn<span class=\"token punctuation\">:</span> process<span class=\"token punctuation\">.</span>env<span class=\"token punctuation\">.</span><span class=\"token constant\">MULTIPLY_NUMBER_SNS_TOPIC</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n    \n        sns<span class=\"token punctuation\">.</span><span class=\"token function\">publish</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> data<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n            <span class=\"token keyword\">else</span> <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">ok</span><span class=\"token punctuation\">(</span>data<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports <span class=\"token operator\">=</span> handler<span class=\"token punctuation\">.</span><span class=\"token keyword\">export</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>and simplest version of <code>multiplyNumberSNS</code> that will listen to events:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">multiplyNumberSNS</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT: '</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">const</span> vars <span class=\"token operator\">=</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">parse</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">.</span>Records<span class=\"token punctuation\">[</span><span class=\"token number\">0</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">.</span>Sns<span class=\"token punctuation\">.</span>Message<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span>vars<span class=\"token punctuation\">.</span>x <span class=\"token operator\">*</span> vars<span class=\"token punctuation\">.</span>y<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>You can use our internal tool <a href=\"https://github.com/withreason/dumptruck\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Dumptruck</a> to monitor both <code>postToSNS</code> and <code>multiplyNumberSNS</code> logs in a fast way.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">dumptruck\n</code></pre>\n<p>If you try to go to your <code>postToSNS</code> function API Gateway URL, you should see in terminal window logs that function failed to post to SNS because it doesn't have permissions to SNS. That's correct, λ function should be given permissions to post to SNS queue.</p>\n<p>Login to AWS Console -&gt; Lambda -&gt; Functions -&gt; serverless-hello-world-dev-postToSNS -&gt; Configuration.\n<a href=\"https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_1.png\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/assets/calling-other-lambdas-4_1.png\" alt=\"enter image description here\"></a>\nHere you should press Role -&gt; Create Custom Role\n<a href=\"https://bitbucket.org/reason/sls-zone-examples/src/8c48c4728edbb996220b76a29645d5aa2953f83b/assets/calling-other-lambdas-4_2.png\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/assets/calling-other-lambdas-4_2.png\" alt=\"enter image description here\"></a>\nName the role <code>lambda-post-to-sns-allow</code> and set it to policy:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"Version\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2012-10-17\"</span><span class=\"token punctuation\">,</span>\n  <span class=\"token property\">\"Statement\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n    <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"Effect\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Allow\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"Action\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token string\">\"sns:Publish\"</span>\n      <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"Resource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:sns:us-east-1:xxxxxxxxxxxx:multiplyNumberDispatch\"</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>where <code>xxxxxxxxxxxx</code> is you AWS Account ID.\nThis will make sure this λ can do <code>sns:Publish</code> on our newly created SNS Topic.\nAfter saving role and λ configuration (make sure you press Save on both), you can retry invoking <code>postToSNS</code> API Gateway URL. Now, you'll see in dumptruck of <code>multiplyNumberSNS</code> that it received data from the queue.</p>\n<div class=\"icons\">\n<h3 id=\"CallDirectlyviaAWSAPI(HTTP)\"><a name=\"CallDirectlyviaAWSAPI(HTTP)\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Call Directly via AWS API (HTTP)</h3>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/calling-other-lambdas\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>Let's just create a simple JS handler for our both our functions in <code>handler.js</code></p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> create<span class=\"token punctuation\">,</span> jsonMiddleware <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'slspress'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">const</span> <span class=\"token constant\">AWS</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'aws-sdk'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> handler <span class=\"token operator\">=</span> <span class=\"token function\">create</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> lambda <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">AWS<span class=\"token punctuation\">.</span>Lambda</span><span class=\"token punctuation\">(</span> <span class=\"token punctuation\">{</span> region<span class=\"token punctuation\">:</span> <span class=\"token string\">'eu-west-1'</span> <span class=\"token punctuation\">}</span> <span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> fPrepend <span class=\"token operator\">=</span> <span class=\"token punctuation\">[</span>\n    process<span class=\"token punctuation\">.</span>env<span class=\"token punctuation\">.</span><span class=\"token constant\">SERVERLESS_SERVICE_NAME</span><span class=\"token punctuation\">,</span>\n    process<span class=\"token punctuation\">.</span>env<span class=\"token punctuation\">.</span><span class=\"token constant\">SERVERLESS_SERVICE_STAGE</span><span class=\"token punctuation\">,</span> <span class=\"token string\">''</span>\n    <span class=\"token punctuation\">]</span><span class=\"token punctuation\">.</span><span class=\"token function\">join</span><span class=\"token punctuation\">(</span><span class=\"token string\">'-'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nhandler<span class=\"token punctuation\">.</span><span class=\"token function\">on</span><span class=\"token punctuation\">(</span><span class=\"token string\">'handle'</span><span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">middleware</span><span class=\"token punctuation\">(</span>jsonMiddleware<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token keyword\">get</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/calling-other-lambdas'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n\n        <span class=\"token keyword\">const</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n            FunctionName<span class=\"token punctuation\">:</span> fPrepend <span class=\"token operator\">+</span> <span class=\"token string\">'multiply-number'</span><span class=\"token punctuation\">,</span> \n            InvocationType<span class=\"token punctuation\">:</span> <span class=\"token string\">\"RequestResponse\"</span><span class=\"token punctuation\">,</span> \n            LogType<span class=\"token punctuation\">:</span> <span class=\"token string\">\"Tail\"</span><span class=\"token punctuation\">,</span> \n            Payload<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>x<span class=\"token punctuation\">:</span> <span class=\"token number\">5</span><span class=\"token punctuation\">,</span> y<span class=\"token punctuation\">:</span> <span class=\"token number\">100</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n\n        lambda<span class=\"token punctuation\">.</span><span class=\"token function\">invoke</span><span class=\"token punctuation\">(</span>params<span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> data<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">handleError</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n            <span class=\"token keyword\">else</span> <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">ok</span><span class=\"token punctuation\">(</span>data<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">post</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/multiply-number'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">const</span> vars <span class=\"token operator\">=</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">;</span>\n        <span class=\"token keyword\">const</span> response <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n            statusCode<span class=\"token punctuation\">:</span> <span class=\"token number\">200</span><span class=\"token punctuation\">,</span>\n            headers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n              <span class=\"token string\">'Access-Control-Allow-Origin'</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'*'</span><span class=\"token punctuation\">,</span> <span class=\"token comment\">// Required for CORS support to work</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n            body<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n              result<span class=\"token punctuation\">:</span> vars<span class=\"token punctuation\">.</span>x <span class=\"token operator\">*</span> vars<span class=\"token punctuation\">.</span>y <span class=\"token operator\">||</span> <span class=\"token number\">0</span><span class=\"token punctuation\">,</span>\n              input<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>event<span class=\"token punctuation\">,</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n        <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">ok</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports <span class=\"token operator\">=</span> handler<span class=\"token punctuation\">.</span><span class=\"token keyword\">export</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p><a href=\"http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/Lambda.html#invoke-property\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">lambda.invoke</a> function will do the call from one lambda function to another. Keep in mind that better approach of calling one lambda function from another would be to use SNS queue described previously.</p>\n<p>Our <code>serverless.yml</code> looks like this:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> calling<span class=\"token punctuation\">-</span>other<span class=\"token punctuation\">-</span>lambdas\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n  <span class=\"token key atrule\">environment</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">SERVERLESS_SERVICE_NAME</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span>\n    <span class=\"token key atrule\">SERVERLESS_SERVICE_STAGE</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>opt<span class=\"token punctuation\">:</span>stage<span class=\"token punctuation\">,</span> self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span>\n  <span class=\"token key atrule\">iamRoleStatements</span><span class=\"token punctuation\">:</span>\n    <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Effect</span><span class=\"token punctuation\">:</span> Allow\n      <span class=\"token key atrule\">Action</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> lambda<span class=\"token punctuation\">:</span>InvokeFunction\n      <span class=\"token key atrule\">Resource</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"arn:aws:lambda:${opt:region, self:provider.region}:*:function:${self:service}-${opt:stage, self:provider.stage}-multiply-number\"</span>\n\n<span class=\"token key atrule\">package</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">individually</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">calling-other-lambdas</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.handle\n      <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"${self:service}-${self:provider.stage}-calling-other-lambdas\"</span>\n      <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n            <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> calling<span class=\"token punctuation\">-</span>other<span class=\"token punctuation\">-</span>lambdas\n            <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n            <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n\n  <span class=\"token key atrule\">multiply-number</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.handle\n      <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"${self:service}-${self:provider.stage}-multiply-number\"</span>\n      <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n            <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> multiply<span class=\"token punctuation\">-</span>number\n            <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> post\n            <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p>Now if you created <code>handler.js</code> and <code>serverless.yml</code> you can deploy function with:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless deploy\n</code></pre>\n<p>and just open the API Gateway URL of multiply-number function. You should see the result looking like this:</p>\n<pre><code>{&quot;message&quot;:&quot;//////helloWorld called multiplyNumber and second function responded with: 500&quot;,&quot;responseBody&quot;:{&quot;result&quot;:500,&quot;input&quot;:{&quot;x&quot;:5,&quot;y&quot;:100}}}\n\n</code></pre>\n<p>Note, that you can also use fire and forget. In that case, you just have to specify</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">var</span> params <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n  FunctionName<span class=\"token punctuation\">:</span> fPrepend <span class=\"token operator\">+</span> <span class=\"token string\">'multiplyNumber'</span><span class=\"token punctuation\">,</span>\n  InvocationType<span class=\"token punctuation\">:</span> <span class=\"token string\">\"Event\"</span><span class=\"token punctuation\">,</span>\n  LogType<span class=\"token punctuation\">:</span> <span class=\"token string\">\"Tail\"</span><span class=\"token punctuation\">,</span>\n  Payload<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>x<span class=\"token punctuation\">:</span> <span class=\"token number\">5</span><span class=\"token punctuation\">,</span> y<span class=\"token punctuation\">:</span> <span class=\"token number\">100</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>The callback will succeed when the other lambda was invoked but it'll not wait for it to be finished.</p>\n"}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vZGV2ZWxvcGluZy1mb3ItYWxleGEubWQ","filename":"/content/pages/learn/developing-for-alexa.md","suffix":"","attributes":{"title":"Developing for Alexa","sort":6,"description":"Developing for Alexa using serverless","tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Developing for Alexa'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 6","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Developing for Alexa using serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Developing for Alexa","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/alexa-event-handler"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless makes it easy to develop Alexa skills.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Alexa Skill","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To create a new Alexa skill, you have to go to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://developer.amazon.com/home.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Amazon Developer Website","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and create an ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://developer.amazon.com/edw/home.html#/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Alexa Skill.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/assets/listening-to-other-events-4_1.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events-4_1.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"create a new skill","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"create a new skill","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you should add a new skill.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/assets/listening-to-other-events-4_2.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events-4_2.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"create a new skill","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"create a new skill","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It's important to give your Alexa Skill a unique invocation name. It has to be two words at least unless you have a copyright for a fancy brand name like (c) Apple.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/assets/listening-to-other-events-4_3.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events-4_3.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alexa invocation name","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alexa invocation name","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Our Alexa app has quite simple interaction model. When you say 'Alexa, reason test one hello', it'll respond with greeting. You can use Interaction Builder to build a model:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/assets/listening-to-other-events-4_4.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events-4_4.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alexa model","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alexa model","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Press ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Build model","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and wait for 2-3 minutes while Amazon is building your interaction model.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, we are ready to create a Lambda function that will process requests from Alexa.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" will look like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: alexa-event-handler provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev functions: skillReasonTestOne: handler: handler.skillReasonTestOne events: - alexaSkill","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" will look like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.skillReasonTestOne = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)) const response = { version: '1.0', response: { outputSpeech: { type: 'PlainText', text: `Hello from Reason Serverless!`, }, shouldEndSession: false, }, }; callback(null, response); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The last step for our skill to work is to get our Lambda ARN and save it to our Amazon Alexa skill.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless deploy -v","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"you'll get the Stack Output:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Stack Outputs SkillReasonTestOneLambdaFunctionQualifiedArn: arn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:alexa-event-handler-dev-skillReasonTestOne:1","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Here ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":1","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is our Lambda version number. With each deployment, it'll increase. If you would like to fix your Alexa to use specific Lambda version number and not use Latest deployment, just include it as part of ARN. To save Lambda ARN to our Alexa skill, go to Configuration tab:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/assets/listening-to-other-events-4_5.png"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events-4_5.png"],["alt",""]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda configuration","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"lambda configuration","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, Alexa Skill is ready to be tested. If you have Alexa connected to your account, you can just say ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Alexa reason test one hello","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and you should receive a response ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Hello from Reason Serverless","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". Otherwise, you can head to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Test","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" tab and provide the utterance ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hello","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" in Service Simulator section. You should receive a response from your lambda:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"version\": \"1.0\", \"response\": { \"outputSpeech\": { \"type\": \"PlainText\", \"text\": \"Hello from Reason Serverless!\" }, \"speechletResponse\": { \"outputSpeech\": { \"text\": \"Hello from Reason Serverless!\" }, \"shouldEndSession\": false } }, \"sessionAttributes\": {} }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Developing for Alexa'\nsort: 6\ndescription: 'Developing for Alexa using serverless'\ntags:\n  - new\n---\n::: icons\n\n# Developing for Alexa\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/alexa-event-handler)\n:::\n\nServerless makes it easy to develop Alexa skills. \n\n## Alexa Skill\n\nTo create a new Alexa skill, you have to go to [Amazon Developer Website](https://developer.amazon.com/home.html) and create an [Alexa Skill.](https://developer.amazon.com/edw/home.html#/)\n[![create a new skill](/assets/listening-to-other-events-4_1.png)](/assets/listening-to-other-events-4_1.png)\n\nNow, you should add a new skill.\n\n[![create a new skill](/assets/listening-to-other-events-4_2.png)](/assets/listening-to-other-events-4_2.png)\n\nIt's important to give your Alexa Skill a unique invocation name. It has to be two words at least unless you have a copyright for a fancy brand name like (c) Apple.\n[![alexa invocation name](/assets/listening-to-other-events-4_3.png)](/assets/listening-to-other-events-4_3.png)\n\nOur Alexa app has quite simple interaction model. When you say 'Alexa, reason test one hello', it'll respond with greeting. You can use Interaction Builder to build a model:\n\n[![alexa model](/assets/listening-to-other-events-4_4.png)](/assets/listening-to-other-events-4_4.png)\nPress `Build model` and wait for 2-3 minutes while Amazon is building your interaction model.\n\n&nbsp;\n\nNow, we are ready to create a Lambda function that will process requests from Alexa. \n\n&nbsp;\n\nThe `serverless.yml` will look like this:\n\n```yaml\nservice: alexa-event-handler\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n\nfunctions:  \n  skillReasonTestOne:\n    handler: handler.skillReasonTestOne\n    events:\n      - alexaSkill\n```\n\nThe `handler.js` will look like this:\n\n```javascript\nmodule.exports.skillReasonTestOne = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event))\n  const response = {\n    version: '1.0',\n    response: {\n      outputSpeech: {\n        type: 'PlainText',\n        text: `Hello from Reason Serverless!`,\n      },\n      shouldEndSession: false,\n    },\n  };\n\n  callback(null, response);\n}\n```\n\nThe last step for our skill to work is to get our Lambda ARN and save it to our Amazon Alexa skill.\n```\nserverless deploy -v\n```\nyou'll get the Stack Output:\n```\nStack Outputs\nSkillReasonTestOneLambdaFunctionQualifiedArn:\narn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:alexa-event-handler-dev-skillReasonTestOne:1\n```\nHere `:1` is our Lambda version number. With each deployment, it'll increase. If you would like to fix your Alexa to use specific Lambda version number and not use Latest deployment, just include it as part of ARN. To save Lambda ARN to our Alexa skill, go to Configuration tab:\n[![lambda configuration](/assets/listening-to-other-events-4_5.png)](/assets/listening-to-other-events-4_5.png)\n\nNow, Alexa Skill is ready to be tested. If you have Alexa connected to your account, you can just say `Alexa reason test one hello` and you should receive a response `Hello from Reason Serverless`. Otherwise, you can head to `Test` tab and provide the utterance `hello` in Service Simulator section. You should receive a response from your lambda:\n```json\n{\n  \"version\": \"1.0\",\n  \"response\": {\n    \"outputSpeech\": {\n      \"type\": \"PlainText\",\n      \"text\": \"Hello from Reason Serverless!\"\n    },\n    \"speechletResponse\": {\n      \"outputSpeech\": {\n        \"text\": \"Hello from Reason Serverless!\"\n      },\n      \"shouldEndSession\": false\n    }\n  },\n  \"sessionAttributes\": {}\n}\n```\n\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"DevelopingforAlexa\"><a name=\"DevelopingforAlexa\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Developing for Alexa</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/alexa-event-handler\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>Serverless makes it easy to develop Alexa skills.</p>\n<h2 id=\"AlexaSkill\"><a name=\"AlexaSkill\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Alexa Skill</h2>\n<p>To create a new Alexa skill, you have to go to <a href=\"https://developer.amazon.com/home.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Amazon Developer Website</a> and create an <a href=\"https://developer.amazon.com/edw/home.html#/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Alexa Skill.</a>\n<a href=\"/assets/listening-to-other-events-4_1.png\" class=\"absolute-link\"><img src=\"/assets/listening-to-other-events-4_1.png\" alt=\"create a new skill\"></a></p>\n<p>Now, you should add a new skill.</p>\n<p><a href=\"/assets/listening-to-other-events-4_2.png\" class=\"absolute-link\"><img src=\"/assets/listening-to-other-events-4_2.png\" alt=\"create a new skill\"></a></p>\n<p>It's important to give your Alexa Skill a unique invocation name. It has to be two words at least unless you have a copyright for a fancy brand name like (c) Apple.\n<a href=\"/assets/listening-to-other-events-4_3.png\" class=\"absolute-link\"><img src=\"/assets/listening-to-other-events-4_3.png\" alt=\"alexa invocation name\"></a></p>\n<p>Our Alexa app has quite simple interaction model. When you say 'Alexa, reason test one hello', it'll respond with greeting. You can use Interaction Builder to build a model:</p>\n<p><a href=\"/assets/listening-to-other-events-4_4.png\" class=\"absolute-link\"><img src=\"/assets/listening-to-other-events-4_4.png\" alt=\"alexa model\"></a>\nPress <code>Build model</code> and wait for 2-3 minutes while Amazon is building your interaction model.</p>\n<p> </p>\n<p>Now, we are ready to create a Lambda function that will process requests from Alexa.</p>\n<p> </p>\n<p>The <code>serverless.yml</code> will look like this:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> alexa<span class=\"token punctuation\">-</span>event<span class=\"token punctuation\">-</span>handler\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>  \n  <span class=\"token key atrule\">skillReasonTestOne</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.skillReasonTestOne\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> alexaSkill\n</code></pre>\n<p>The <code>handler.js</code> will look like this:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">skillReasonTestOne</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">const</span> response <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    version<span class=\"token punctuation\">:</span> <span class=\"token string\">'1.0'</span><span class=\"token punctuation\">,</span>\n    response<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n      outputSpeech<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n        type<span class=\"token punctuation\">:</span> <span class=\"token string\">'PlainText'</span><span class=\"token punctuation\">,</span>\n        text<span class=\"token punctuation\">:</span> <span class=\"token template-string\"><span class=\"token string\">`Hello from Reason Serverless!`</span></span><span class=\"token punctuation\">,</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      shouldEndSession<span class=\"token punctuation\">:</span> <span class=\"token boolean\">false</span><span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">,</span> response<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>The last step for our skill to work is to get our Lambda ARN and save it to our Amazon Alexa skill.</p>\n<pre><code>serverless deploy -v\n</code></pre>\n<p>you'll get the Stack Output:</p>\n<pre><code>Stack Outputs\nSkillReasonTestOneLambdaFunctionQualifiedArn:\narn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:alexa-event-handler-dev-skillReasonTestOne:1\n</code></pre>\n<p>Here <code>:1</code> is our Lambda version number. With each deployment, it'll increase. If you would like to fix your Alexa to use specific Lambda version number and not use Latest deployment, just include it as part of ARN. To save Lambda ARN to our Alexa skill, go to Configuration tab:\n<a href=\"/assets/listening-to-other-events-4_5.png\" class=\"absolute-link\"><img src=\"/assets/listening-to-other-events-4_5.png\" alt=\"lambda configuration\"></a></p>\n<p>Now, Alexa Skill is ready to be tested. If you have Alexa connected to your account, you can just say <code>Alexa reason test one hello</code> and you should receive a response <code>Hello from Reason Serverless</code>. Otherwise, you can head to <code>Test</code> tab and provide the utterance <code>hello</code> in Service Simulator section. You should receive a response from your lambda:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"version\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.0\"</span><span class=\"token punctuation\">,</span>\n  <span class=\"token property\">\"response\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"outputSpeech\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"PlainText\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"text\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Hello from Reason Serverless!\"</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"speechletResponse\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"outputSpeech\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"text\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Hello from Reason Serverless!\"</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"shouldEndSession\"</span><span class=\"token operator\">:</span> <span class=\"token boolean\">false</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n  <span class=\"token property\">\"sessionAttributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n"}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vZGV2ZWxvcGluZy1sb2NhbGx5LXdpdGgtc2VydmVybGVzcy1vZmZsaW5lLm1k","filename":"/content/pages/learn/developing-locally-with-serverless-offline.md","suffix":"","attributes":{"title":"Developing locally with Serverless Offline","sort":1,"description":"Run and debug Serverless functions offline using slspress.","tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Developing locally with Serverless Offline\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 1","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Run and debug Serverless functions offline using slspress.'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Running locally","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/hello-world-offline"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Create a Serverless function using slspress.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In this tutorial, we are gonna use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless-offline","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to create and run Serverless offline.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Sample","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First, create a new project and generate a new ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"package.json","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file for it, running the following commands:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash mkdir hello-world-offline cd hello-world-offline npm init","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Install the dependencies needed for the project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install -S slspress npm install -D serverless-offline","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's create a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript const { create, jsonMiddleware } = require('slspress'); const handler = create(); handler.on('handle') .middleware(jsonMiddleware) .get('/hello-world', (req, res) => { return res.ok('hello-world'); }); module.exports = handler.export();","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's create a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: hello-world-offline provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev plugins: - serverless-offline functions: hello-world: handler: handler.handle # required, handler set in AWS Lambda name: \"${self:service}-${self:provider.stage}\" # optional, Deployed Lambda name description: \"slspress offline example\" events: - http: path: hello-world method: get cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Run a local version of the 'hello-world' Serverless function.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash sls offline start","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To stop the local debugging, just hit (","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ctrl+c","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":").","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you are happy with the local debugging, you can deploy your code to AWS.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash sls deploy -v","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Debugging","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless offline plugin will respond to the overall framework settings and output additional information to the console in debug mode. In order to do this you will have to set the SLS_DEBUG environmental variable.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash SLS_DEBUG=* sls offline start","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/dherault/serverless-offline#debug-process"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless Debugging","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/cli-reference/invoke-local/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS Invoke Function","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://code.visualstudio.com/docs/nodejs/nodejs-debugging"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"VSCode Debugging","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Developing locally with Serverless Offline\"\nsort: 1\ndescription: 'Run and debug Serverless functions offline using slspress.'\ntags:\n  - new\n---\n::: icons\n\n# Running locally\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/hello-world-offline)\n:::\n\nCreate a Serverless function using slspress.\nIn this tutorial, we are gonna use `serverless-offline` to create and run Serverless offline.\n\n&nbsp;\n\n## Sample\n\nFirst, create a new project and generate a new `package.json` file for it, running the following commands:\n\n```bash\nmkdir hello-world-offline\ncd hello-world-offline\nnpm init\n```\n\n&nbsp;\n\nInstall the dependencies needed for the project.\n\n```bash\nnpm install -S slspress\nnpm install -D serverless-offline\n```\n\n&nbsp;\n\nLet's create a `handler.js` file.\n\n```javascript\nconst { create, jsonMiddleware } = require('slspress');\n\nconst handler = create();\n\nhandler.on('handle')\n    .middleware(jsonMiddleware)\n    .get('/hello-world', (req, res) => {\n        return res.ok('hello-world');\n    });\n\nmodule.exports = handler.export();\n```\n\n&nbsp;\n\nLet's create a `serverless.yml` file.\n\n```yaml\nservice: hello-world-offline\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n\nplugins:\n  - serverless-offline\n\nfunctions:\n  hello-world:\n    handler: handler.handle # required, handler set in AWS Lambda\n    name: \"${self:service}-${self:provider.stage}\" # optional, Deployed Lambda name\n    description: \"slspress offline example\"\n    events:\n      - http:\n          path: hello-world\n          method: get\n          cors: true\n```\n\n&nbsp;\n\nRun a local version of the 'hello-world' Serverless function.\n\n```bash\nsls offline start\n```\n\nTo stop the local debugging, just hit (`ctrl+c`).\n\n&nbsp;\n\nOnce you are happy with the local debugging, you can deploy your code to AWS.\n\n```bash\nsls deploy -v\n```\n\n&nbsp;\n\n## Debugging\n\nServerless offline plugin will respond to the overall framework settings and output additional information to the console in debug mode. In order to do this you will have to set the SLS_DEBUG environmental variable.\n\n```bash\nSLS_DEBUG=* sls offline start\n```\n\n::: links\nFurther reading:\n\n* [Serverless Debugging](https://github.com/dherault/serverless-offline#debug-process)\n* [AWS Invoke Function](https://serverless.com/framework/docs/providers/aws/cli-reference/invoke-local/)\n* [VSCode Debugging](https://code.visualstudio.com/docs/nodejs/nodejs-debugging)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"Runninglocally\"><a name=\"Runninglocally\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Running locally</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/hello-world-offline\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>Create a Serverless function using slspress.\nIn this tutorial, we are gonna use <code>serverless-offline</code> to create and run Serverless offline.</p>\n<p> </p>\n<h2 id=\"Sample\"><a name=\"Sample\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Sample</h2>\n<p>First, create a new project and generate a new <code>package.json</code> file for it, running the following commands:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">mkdir</span> hello-world-offline\n<span class=\"token function\">cd</span> hello-world-offline\n<span class=\"token function\">npm</span> init\n</code></pre>\n<p> </p>\n<p>Install the dependencies needed for the project.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> -S slspress\n<span class=\"token function\">npm</span> <span class=\"token function\">install</span> -D serverless-offline\n</code></pre>\n<p> </p>\n<p>Let's create a <code>handler.js</code> file.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">const</span> <span class=\"token punctuation\">{</span> create<span class=\"token punctuation\">,</span> jsonMiddleware <span class=\"token punctuation\">}</span> <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'slspress'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">const</span> handler <span class=\"token operator\">=</span> <span class=\"token function\">create</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nhandler<span class=\"token punctuation\">.</span><span class=\"token function\">on</span><span class=\"token punctuation\">(</span><span class=\"token string\">'handle'</span><span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token function\">middleware</span><span class=\"token punctuation\">(</span>jsonMiddleware<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">.</span><span class=\"token keyword\">get</span><span class=\"token punctuation\">(</span><span class=\"token string\">'/hello-world'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span>req<span class=\"token punctuation\">,</span> res<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">return</span> res<span class=\"token punctuation\">.</span><span class=\"token function\">ok</span><span class=\"token punctuation\">(</span><span class=\"token string\">'hello-world'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports <span class=\"token operator\">=</span> handler<span class=\"token punctuation\">.</span><span class=\"token keyword\">export</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p> </p>\n<p>Let's create a <code>serverless.yml</code> file.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> hello<span class=\"token punctuation\">-</span>world<span class=\"token punctuation\">-</span>offline\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n\n<span class=\"token key atrule\">plugins</span><span class=\"token punctuation\">:</span>\n  <span class=\"token punctuation\">-</span> serverless<span class=\"token punctuation\">-</span>offline\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">hello-world</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.handle <span class=\"token comment\"># required, handler set in AWS Lambda</span>\n    <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> \"$<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>$<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span>\" <span class=\"token comment\"># optional, Deployed Lambda name</span>\n    <span class=\"token key atrule\">description</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"slspress offline example\"</span>\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> hello<span class=\"token punctuation\">-</span>world\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p> </p>\n<p>Run a local version of the 'hello-world' Serverless function.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">sls offline start\n</code></pre>\n<p>To stop the local debugging, just hit (<code>ctrl+c</code>).</p>\n<p> </p>\n<p>Once you are happy with the local debugging, you can deploy your code to AWS.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">sls deploy -v\n</code></pre>\n<p> </p>\n<h2 id=\"Debugging\"><a name=\"Debugging\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Debugging</h2>\n<p>Serverless offline plugin will respond to the overall framework settings and output additional information to the console in debug mode. In order to do this you will have to set the SLS_DEBUG environmental variable.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">SLS_DEBUG<span class=\"token operator\">=</span>* sls offline start\n</code></pre>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://github.com/dherault/serverless-offline#debug-process\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless Debugging</a></li>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/cli-reference/invoke-local/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS Invoke Function</a></li>\n<li><a href=\"https://code.visualstudio.com/docs/nodejs/nodejs-debugging\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">VSCode Debugging</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vZmluZGluZy1hcGktZ2F0ZXdheS11cmxzLm1k","filename":"/content/pages/learn/finding-api-gateway-urls.md","suffix":"","attributes":{"title":"Finding API gateway URL's","sort":7,"description":"How to find your serverless AWS API gateway urls"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Finding API gateway URL's\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 7","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'How to find your serverless AWS API gateway urls'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# How to find your API gateway urls","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you have deployed your Serverless project and you start hiding deployments in CI pipelines etc, it is easy to forget the URL's to your API's (after all they are not very memorable!).","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Added to that if you need to completely re-deploy your stack your API urls will change.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This article describes how to find out what your urls are. It is also possible to use a custom url for your API, but this does add the complexity of managing SSL certificates. For more info on this see ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/adding-a-custom-url-for-your-api/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"this article on how to add a custom url.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Getting endpoints from Serverless deploy","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you are ready to deploy the function, you can simply run:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy -v","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will give you an output with ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Service information","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", which will contain ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"endpoints","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" list. Example:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash Service Information service: serverless-hello-world stage: dev region: us-east-1 api keys: None endpoints: GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world2 functions: helloWorld: serverless-hello-world-dev-helloWorld helloWorld2: serverless-hello-world-dev-helloWorld2","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## How to find endpoints in AWS console","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless uses CloudFormation to manage your stack.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Go to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"CloudFormation","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" in the region where you deployed your function or functions.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Find the recently deployed stack. In our case it's ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless-hello-world-dev","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* In Outputs Tab you will find the url of the stack called ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ServiceEndpoint","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". In our case it's ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"https://qewroweire.execute-api.us-east-1.amazonaws.com/dev","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/finding-api-gateways-2_1.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"CloudFormation Image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"CloudFormation Image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can also see information on your api from the API gateway service dashboard page:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"e.g.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/finding-api-gateways-2_2.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"API gateway Image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"API gateway Image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Breakdown of url (what each part means)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The Serverless will use CloudFormation stack url and append the function name to generate the url for each lambda function. For example, ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hello-world","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function will reside at ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"https://xwynzpjjlc.execute-api.us-east-1.amazonaws.com/dev/hello-world","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"xwynzpjjlc","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" in our case is a AWS generated ID of our stack.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"us-east-1","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" AWS region where the function is hosted.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"dev","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is a stage (or you can call it environment). For example it could be ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"production","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" or ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"staging","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hello-world","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" endpoint url.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/cloudformation/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS Cloudformation","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/api-gateway/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS API Gateway","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: steps","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Next step","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/slspress-simple-example/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Create more complicated API's quickly with slspress","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/hosting-for-a-serverless-project-on-s3/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Add some static HTML/JavaScript to use your new API","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Finding API gateway URL's\"\nsort: 7\ndescription: 'How to find your serverless AWS API gateway urls'\n---\n# How to find your API gateway urls\n\nOnce you have deployed your Serverless project and you start hiding deployments in CI pipelines etc, it is easy to forget the URL's to your API's (after all they are not very memorable!).\n\n&nbsp;\n\nAdded to that if you need to completely re-deploy your stack your API urls will change.\nThis article describes how to find out what your urls are. It is also possible to use a custom url for your API, but this does add the complexity of managing SSL certificates. For more info on this see [this article on how to add a custom url.](/pages/learn/adding-a-custom-url-for-your-api/)\n\n&nbsp;\n\n## Getting endpoints from Serverless deploy\n\nOnce you are ready to deploy the function, you can simply run:\n\n```bash\nserverless deploy -v\n```\n\n&nbsp;\n\nThis will give you an output with `Service information`, which will contain `endpoints` list. Example:\n\n```bash\nService Information\nservice: serverless-hello-world\nstage: dev\nregion: us-east-1\napi keys:\n  None\nendpoints:\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world2\nfunctions:\n  helloWorld: serverless-hello-world-dev-helloWorld\n  helloWorld2: serverless-hello-world-dev-helloWorld2\n```\n\n&nbsp;\n\n## How to find endpoints in AWS console\n\nServerless uses CloudFormation to manage your stack.\n\n* Go to `CloudFormation` in the region where you deployed your function or functions.\n* Find the recently deployed stack. In our case it's `serverless-hello-world-dev`.\n* In Outputs Tab you will find the url of the stack called `ServiceEndpoint`. In our case it's `https://qewroweire.execute-api.us-east-1.amazonaws.com/dev`\n\n![CloudFormation Image](/assets/finding-api-gateways-2_1.png)\n\nYou can also see information on your api from the API gateway service dashboard page:\n\ne.g.\n\n![API gateway Image](/assets/finding-api-gateways-2_2.png)\n\n&nbsp;\n\n## Breakdown of url (what each part means)\n\nThe Serverless will use CloudFormation stack url and append the function name to generate the url for each lambda function. For example, `hello-world` function will reside at `https://xwynzpjjlc.execute-api.us-east-1.amazonaws.com/dev/hello-world`\n\n* `xwynzpjjlc` in our case is a AWS generated ID of our stack.\n* `us-east-1` AWS region where the function is hosted.\n* `dev` is a stage (or you can call it environment). For example it could be `production` or `staging`\n* `hello-world` endpoint url.\n\n::: links\nFurther reading:\n\n* [AWS Cloudformation](https://aws.amazon.com/cloudformation/)\n* [AWS API Gateway](https://aws.amazon.com/api-gateway/)\n\n:::\n\n::: steps\nNext step\n\n* [Create more complicated API's quickly with slspress](/pages/build/slspress-simple-example/)\n* [Add some static HTML/JavaScript to use your new API](/pages/learn/hosting-for-a-serverless-project-on-s3/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"HowtofindyourAPIgatewayurls\"><a name=\"HowtofindyourAPIgatewayurls\" class=\"markdown-it-headinganchor\" href=\"#\"></a>How to find your API gateway urls</h1>\n<p>Once you have deployed your Serverless project and you start hiding deployments in CI pipelines etc, it is easy to forget the URL's to your API's (after all they are not very memorable!).</p>\n<p> </p>\n<p>Added to that if you need to completely re-deploy your stack your API urls will change.\nThis article describes how to find out what your urls are. It is also possible to use a custom url for your API, but this does add the complexity of managing SSL certificates. For more info on this see <a href=\"/pages/learn/adding-a-custom-url-for-your-api/\" class=\"absolute-link\">this article on how to add a custom url.</a></p>\n<p> </p>\n<h2 id=\"GettingendpointsfromServerlessdeploy\"><a name=\"GettingendpointsfromServerlessdeploy\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Getting endpoints from Serverless deploy</h2>\n<p>Once you are ready to deploy the function, you can simply run:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless deploy -v\n</code></pre>\n<p> </p>\n<p>This will give you an output with <code>Service information</code>, which will contain <code>endpoints</code> list. Example:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">Service Information\nservice: serverless-hello-world\nstage: dev\nregion: us-east-1\napi keys:\n  None\nendpoints:\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world2\nfunctions:\n  helloWorld: serverless-hello-world-dev-helloWorld\n  helloWorld2: serverless-hello-world-dev-helloWorld2\n</code></pre>\n<p> </p>\n<h2 id=\"HowtofindendpointsinAWSconsole\"><a name=\"HowtofindendpointsinAWSconsole\" class=\"markdown-it-headinganchor\" href=\"#\"></a>How to find endpoints in AWS console</h2>\n<p>Serverless uses CloudFormation to manage your stack.</p>\n<ul>\n<li>Go to <code>CloudFormation</code> in the region where you deployed your function or functions.</li>\n<li>Find the recently deployed stack. In our case it's <code>serverless-hello-world-dev</code>.</li>\n<li>In Outputs Tab you will find the url of the stack called <code>ServiceEndpoint</code>. In our case it's <code>https://qewroweire.execute-api.us-east-1.amazonaws.com/dev</code></li>\n</ul>\n<p><img src=\"/assets/finding-api-gateways-2_1.png\" alt=\"CloudFormation Image\"></p>\n<p>You can also see information on your api from the API gateway service dashboard page:</p>\n<p>e.g.</p>\n<p><img src=\"/assets/finding-api-gateways-2_2.png\" alt=\"API gateway Image\"></p>\n<p> </p>\n<h2 id=\"Breakdownofurl(whateachpartmeans)\"><a name=\"Breakdownofurl(whateachpartmeans)\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Breakdown of url (what each part means)</h2>\n<p>The Serverless will use CloudFormation stack url and append the function name to generate the url for each lambda function. For example, <code>hello-world</code> function will reside at <code>https://xwynzpjjlc.execute-api.us-east-1.amazonaws.com/dev/hello-world</code></p>\n<ul>\n<li><code>xwynzpjjlc</code> in our case is a AWS generated ID of our stack.</li>\n<li><code>us-east-1</code> AWS region where the function is hosted.</li>\n<li><code>dev</code> is a stage (or you can call it environment). For example it could be <code>production</code> or <code>staging</code></li>\n<li><code>hello-world</code> endpoint url.</li>\n</ul>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://aws.amazon.com/cloudformation/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS Cloudformation</a></li>\n<li><a href=\"https://aws.amazon.com/api-gateway/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS API Gateway</a></li>\n</ul>\n</div>\n<div class=\"steps\">\n<p>Next step</p>\n<ul>\n<li><a href=\"/pages/build/slspress-simple-example/\" class=\"absolute-link\">Create more complicated API's quickly with slspress</a></li>\n<li><a href=\"/pages/learn/hosting-for-a-serverless-project-on-s3/\" class=\"absolute-link\">Add some static HTML/JavaScript to use your new API</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vZmlyc3Qtc2VydmVybGVzcy1wcm9qZWN0Lm1k","filename":"/content/pages/learn/first-serverless-project.md","suffix":"","attributes":{"title":"First Serverless project","sort":0,"featured":true,"description":"Tutorial to deploy a very simple Serverless application on AWS"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'First Serverless project'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 0","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Tutorial to deploy a very simple Serverless application on AWS'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# First Serverless project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/first-serverless"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Introduction","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will take you through the steps required to set up and deploy a very simple Serverless application on AWS.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This assumes you have some familiarity with AWS and its command line interface.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"For more information see the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/cli/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS CLI docs","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Prerequisites","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Please make sure you have an AWS account, have ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/cli/latest/userguide/installing.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"aws-cli","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" installed and at least node version 6.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can check this by running ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"node --version && aws --version","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" from a command line","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Installation","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Step 1 - Serverless installation","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Install the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" framework on your machine via npm by running this command:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install serverless -g","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We have used a global install here for convenience however ideally you would use a local install for a real project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"so that the version of the Serverless framework remains consistent for that particular project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Step 2 - Create project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Create a simple hello-world project using a template built into the Serverless command line tool.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash mkdir first-serverless cd first-serverless serverless create --template hello-world","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will create you two files.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" - this is used to configure lambda endpoints and/or events for lambdas invocation. Most of the configuration is done there. The list of available properties and settings can be found in the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/guide/serverless.yml/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless documentation.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml # Welcome to serverless. Read the docs # https://serverless.com/framework/docs/ # Serverless.yml is the configuration the CLI # uses to deploy your code to your provider of choice # The `service` block is the name of the service service: serverless-hello-world # The `provider` block defines where your service will be deployed provider: name: aws runtime: nodejs6.10 # The `functions` block defines what code to deploy functions: helloWorld: handler: handler.helloWorld # The `events` block defines how to trigger the handler.helloWorld code events: - http: path: hello-world method: get cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handlers.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" - this contains the hello-world endpoint.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript 'use strict'; module.exports.helloWorld = (event, context, callback) => { const response = { statusCode: 200, headers: { 'Access-Control-Allow-Origin': '*', // Required for CORS support to work }, body: JSON.stringify({ message: 'Go Serverless v1.0! Your function executed successfully!', input: event, }), }; callback(null, response); };","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Step 3 - Create AWS credentials","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you have not used aws-cli before you will need to create credentials for it so that the","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless framework is able to connect to your AWS environment.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Detailed instructions on how to do this is available from the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/guide/credentials/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless website.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you have done that you will need to allow your AWS user permissions to deploy a Serverless application.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* In the AWS console go to the IAM service -> Users -> ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_open","tag":"em","attrs":null,"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"IAM Manage User Access and Encryption Keys","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_close","tag":"em","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/first-serverless-project-3_1.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"IAM Service Image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"IAM Service Image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Choose your existing user or create a new user.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Ensure the user has the following permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWSLambdaExecute","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWSLambdaRole","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWSLambdaFullAccess","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWSLambdaRole","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"AWSCloudFormationReadOnlyAccess","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"(You can open up more permissions but remember it is best practice to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/IAM/latest/UserGuide/best-practices.html#grant-least-privilege"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"grant least privilege","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" principle)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/first-serverless-project-3_2.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Add User Image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"Add User Image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/first-serverless-project-3_3.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Add permissions image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"Add permissions image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Generate new Access Key for the user in Security Credentials.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/first-serverless-project-3_4.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"New access key image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"New access key image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Save the credentials somewhere safe.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/first-serverless-project-3_5.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Save credentials image","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"Save credentials image","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Step 4 - Configure serverless with your AWS credentials","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now you can use Serverless Framework to save the credentials in a way that the aws-cli can understand them by running the following command.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless config credentials --provider aws --key YOUR_ACCESS_KEY --secret YOUR_ACCESS_SECRET","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Step 5 - Deploy your lambda function","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Deploy your Lambda function to AWS using the following command. (the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"--verbose","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" flag will output full logs of your deployment)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy --verbose","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"As you may be able to see in the output this creates quite a few AWS resources.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Behind the scenes it creates a code bundle and new CloudFormation stack that does the following:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Uploads your code to S3.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Creates a lambda function from your code","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Creates an API gateway api and endpoint that points to your new function.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* Creates a CloudWatch log group for your function","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can view the files uploaded to s3 in the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".serverless","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" folder that the deploy command creates.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"For more detail see the explanation from Serverless ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/guide/deploying/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Try it out","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The output from the above deployment command will print the endpoint API Gateway of the deployed function similar to the example below.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Just open it in a browser to test the Lambda function works.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"endpoints: GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"For more information on API gateway urls see ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/finding-api-gateway-urls/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"this page","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on how to find out what yours is after deployment.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### What now","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Check out some of the links below to learn more and get building your apps with serverless now.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/serverless/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS Serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless Framework docs","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: steps","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Next step","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/developing-locally-with-serverless-offline/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Develop Serverless applications locally","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/slspress-simple-example/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Create more complicated API's quickly with slspress","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/hosting-for-a-serverless-project-on-s3/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Add some static HTML/JavaScript to use your new API","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/where-are-my-logs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Find out where logs from your functions go","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'First Serverless project'\nsort: 0\nfeatured: true\ndescription: 'Tutorial to deploy a very simple Serverless application on AWS'\n---\n::: icons\n\n# First Serverless project\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/first-serverless)\n:::\n\n## Introduction\n\nThis will take you through the steps required to set up and deploy a very simple Serverless application on AWS.\nThis assumes you have some familiarity with AWS and its command line interface.\nFor more information see the [AWS CLI docs](https://aws.amazon.com/cli/)\n\n## Prerequisites\n\nPlease make sure you have an AWS account, have [aws-cli](http://docs.aws.amazon.com/cli/latest/userguide/installing.html) installed and at least node version 6.\nYou can check this by running `node --version && aws --version` from a command line\n\n## Installation\n\n### Step 1 - Serverless installation\n\nInstall the [Serverless](https://serverless.com/) framework on your machine via npm by running this command:\n\n```bash\nnpm install serverless -g\n```\n\n::: info\nWe have used a global install here for convenience however ideally you would use a local install for a real project\nso that the version of the Serverless framework remains consistent for that particular project.\n:::\n\n### Step 2 - Create project\n\nCreate a simple hello-world project using a template built into the Serverless command line tool.\n\n```bash\nmkdir first-serverless\ncd first-serverless\nserverless create --template hello-world\n```\n\n&nbsp;\n\nThis will create you two files.\n\n* `serverless.yml` - this is used to configure lambda endpoints and/or events for lambdas invocation. Most of the configuration is done there. The list of available properties and settings can be found in the [Serverless documentation.](https://serverless.com/framework/docs/providers/aws/guide/serverless.yml/)\n\n```yaml\n# Welcome to serverless. Read the docs\n# https://serverless.com/framework/docs/\n\n# Serverless.yml is the configuration the CLI\n# uses to deploy your code to your provider of choice\n\n# The `service` block is the name of the service\nservice: serverless-hello-world\n\n# The `provider` block defines where your service will be deployed\nprovider:\n  name: aws\n  runtime: nodejs6.10\n\n# The `functions` block defines what code to deploy\nfunctions:\n  helloWorld:\n    handler: handler.helloWorld\n    # The `events` block defines how to trigger the handler.helloWorld code\n    events:\n      - http:\n          path: hello-world\n          method: get\n          cors: true\n```\n\n&nbsp;\n\n* `handlers.js` - this contains the hello-world endpoint.\n\n```javascript\n'use strict';\n\nmodule.exports.helloWorld = (event, context, callback) => {\n  const response = {\n    statusCode: 200,\n    headers: {\n      'Access-Control-Allow-Origin': '*', // Required for CORS support to work\n    },\n    body: JSON.stringify({\n      message: 'Go Serverless v1.0! Your function executed successfully!',\n      input: event,\n    }),\n  };\n\n  callback(null, response);\n};\n\n```\n\n### Step 3 - Create AWS credentials\n\nIf you have not used aws-cli before you will need to create credentials for it so that the\nserverless framework is able to connect to your AWS environment. \nDetailed instructions on how to do this is available from the [Serverless website.](https://serverless.com/framework/docs/providers/aws/guide/credentials/)\n\nOnce you have done that you will need to allow your AWS user permissions to deploy a Serverless application.\n\n* In the AWS console go to the IAM service -> Users -> *IAM Manage User Access and Encryption Keys*\n![IAM Service Image](/assets/first-serverless-project-3_1.png)\n\n* Choose your existing user or create a new user.\n\nEnsure the user has the following permissions:\n\n* `AWSLambdaExecute`\n* `AWSLambdaRole`\n* `AWSLambdaFullAccess`\n* `AWSLambdaRole`\n* `AWSCloudFormationReadOnlyAccess`\n\n(You can open up more permissions but remember it is best practice to [grant least privilege](http://docs.aws.amazon.com/IAM/latest/UserGuide/best-practices.html#grant-least-privilege) principle)\n![Add User Image](/assets/first-serverless-project-3_2.png)\n![Add permissions image](/assets/first-serverless-project-3_3.png)\n\n* Generate new Access Key for the user in Security Credentials.\n![New access key image](/assets/first-serverless-project-3_4.png)\n\n* Save the credentials somewhere safe.\n![Save credentials image](/assets/first-serverless-project-3_5.png)\n\n### Step 4 - Configure serverless with your AWS credentials\n\nNow you can use Serverless Framework to save the credentials in a way that the aws-cli can understand them by running the following command.\n\n```bash\nserverless config credentials --provider aws --key YOUR_ACCESS_KEY --secret YOUR_ACCESS_SECRET\n```\n\n### Step 5 - Deploy your lambda function\n\nDeploy your Lambda function to AWS using the following command. (the ` --verbose` flag will output full logs of your deployment)\n\n```bash\nserverless deploy --verbose\n```\n\nAs you may be able to see in the output this creates quite a few AWS resources.\nBehind the scenes it creates a code bundle and new CloudFormation stack that does the following:\n\n* Uploads your code to S3.\n* Creates a lambda function from your code\n* Creates an API gateway api and endpoint that points to your new function.\n* Creates a CloudWatch log group for your function\n\nYou can view the files uploaded to s3 in the `.serverless` folder that the deploy command creates.\n\n::: info\nFor more detail see the explanation from Serverless [here](https://serverless.com/framework/docs/providers/aws/guide/deploying/)\n:::\n\n### Try it out\n\nThe output from the above deployment command will print the endpoint API Gateway of the deployed function similar to the example below.\nJust open it in a browser to test the Lambda function works.\n\n```\nendpoints:\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world\n```\n\nFor more information on API gateway urls see [this page](/pages/learn/finding-api-gateway-urls/) on how to find out what yours is after deployment.\n\n### What now\n\nCheck out some of the links below to learn more and get building your apps with serverless now.\n\n::: links\nFurther reading:\n\n* [AWS Serverless](https://aws.amazon.com/serverless/)\n* [Serverless Framework docs](https://serverless.com/framework/docs/)\n\n:::\n\n::: steps\nNext step\n\n* [Develop Serverless applications locally](/pages/learn/developing-locally-with-serverless-offline/)\n* [Create more complicated API's quickly with slspress](/pages/build/slspress-simple-example/)\n* [Add some static HTML/JavaScript to use your new API](/pages/learn/hosting-for-a-serverless-project-on-s3/)\n* [Find out where logs from your functions go](/pages/learn/where-are-my-logs/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"FirstServerlessproject\"><a name=\"FirstServerlessproject\" class=\"markdown-it-headinganchor\" href=\"#\"></a>First Serverless project</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/first-serverless\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<h2 id=\"Introduction\"><a name=\"Introduction\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Introduction</h2>\n<p>This will take you through the steps required to set up and deploy a very simple Serverless application on AWS.\nThis assumes you have some familiarity with AWS and its command line interface.\nFor more information see the <a href=\"https://aws.amazon.com/cli/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS CLI docs</a></p>\n<h2 id=\"Prerequisites\"><a name=\"Prerequisites\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Prerequisites</h2>\n<p>Please make sure you have an AWS account, have <a href=\"http://docs.aws.amazon.com/cli/latest/userguide/installing.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">aws-cli</a> installed and at least node version 6.\nYou can check this by running <code>node --version &amp;&amp; aws --version</code> from a command line</p>\n<h2 id=\"Installation\"><a name=\"Installation\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Installation</h2>\n<h3 id=\"Step1-Serverlessinstallation\"><a name=\"Step1-Serverlessinstallation\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 1 - Serverless installation</h3>\n<p>Install the <a href=\"https://serverless.com/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless</a> framework on your machine via npm by running this command:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> serverless -g\n</code></pre>\n<div class=\"info\">\n<p>We have used a global install here for convenience however ideally you would use a local install for a real project\nso that the version of the Serverless framework remains consistent for that particular project.</p>\n</div>\n<h3 id=\"Step2-Createproject\"><a name=\"Step2-Createproject\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 2 - Create project</h3>\n<p>Create a simple hello-world project using a template built into the Serverless command line tool.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">mkdir</span> first-serverless\n<span class=\"token function\">cd</span> first-serverless\nserverless create --template hello-world\n</code></pre>\n<p> </p>\n<p>This will create you two files.</p>\n<ul>\n<li><code>serverless.yml</code> - this is used to configure lambda endpoints and/or events for lambdas invocation. Most of the configuration is done there. The list of available properties and settings can be found in the <a href=\"https://serverless.com/framework/docs/providers/aws/guide/serverless.yml/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless documentation.</a></li>\n</ul>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token comment\"># Welcome to serverless. Read the docs</span>\n<span class=\"token comment\"># https://serverless.com/framework/docs/</span>\n\n<span class=\"token comment\"># Serverless.yml is the configuration the CLI</span>\n<span class=\"token comment\"># uses to deploy your code to your provider of choice</span>\n\n<span class=\"token comment\"># The `service` block is the name of the service</span>\n<span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> serverless<span class=\"token punctuation\">-</span>hello<span class=\"token punctuation\">-</span>world\n\n<span class=\"token comment\"># The `provider` block defines where your service will be deployed</span>\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs6.10\n\n<span class=\"token comment\"># The `functions` block defines what code to deploy</span>\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">helloWorld</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.helloWorld\n    <span class=\"token comment\"># The `events` block defines how to trigger the handler.helloWorld code</span>\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> hello<span class=\"token punctuation\">-</span>world\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p> </p>\n<ul>\n<li><code>handlers.js</code> - this contains the hello-world endpoint.</li>\n</ul>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token string\">'use strict'</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">helloWorld</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> response <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    statusCode<span class=\"token punctuation\">:</span> <span class=\"token number\">200</span><span class=\"token punctuation\">,</span>\n    headers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token string\">'Access-Control-Allow-Origin'</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'*'</span><span class=\"token punctuation\">,</span> <span class=\"token comment\">// Required for CORS support to work</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    body<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n      message<span class=\"token punctuation\">:</span> <span class=\"token string\">'Go Serverless v1.0! Your function executed successfully!'</span><span class=\"token punctuation\">,</span>\n      input<span class=\"token punctuation\">:</span> event<span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">,</span> response<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n\n</code></pre>\n<h3 id=\"Step3-CreateAWScredentials\"><a name=\"Step3-CreateAWScredentials\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 3 - Create AWS credentials</h3>\n<p>If you have not used aws-cli before you will need to create credentials for it so that the\nserverless framework is able to connect to your AWS environment.\nDetailed instructions on how to do this is available from the <a href=\"https://serverless.com/framework/docs/providers/aws/guide/credentials/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless website.</a></p>\n<p>Once you have done that you will need to allow your AWS user permissions to deploy a Serverless application.</p>\n<ul>\n<li>\n<p>In the AWS console go to the IAM service -&gt; Users -&gt; <em>IAM Manage User Access and Encryption Keys</em>\n<img src=\"/assets/first-serverless-project-3_1.png\" alt=\"IAM Service Image\"></p>\n</li>\n<li>\n<p>Choose your existing user or create a new user.</p>\n</li>\n</ul>\n<p>Ensure the user has the following permissions:</p>\n<ul>\n<li><code>AWSLambdaExecute</code></li>\n<li><code>AWSLambdaRole</code></li>\n<li><code>AWSLambdaFullAccess</code></li>\n<li><code>AWSLambdaRole</code></li>\n<li><code>AWSCloudFormationReadOnlyAccess</code></li>\n</ul>\n<p>(You can open up more permissions but remember it is best practice to <a href=\"http://docs.aws.amazon.com/IAM/latest/UserGuide/best-practices.html#grant-least-privilege\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">grant least privilege</a> principle)\n<img src=\"/assets/first-serverless-project-3_2.png\" alt=\"Add User Image\">\n<img src=\"/assets/first-serverless-project-3_3.png\" alt=\"Add permissions image\"></p>\n<ul>\n<li>\n<p>Generate new Access Key for the user in Security Credentials.\n<img src=\"/assets/first-serverless-project-3_4.png\" alt=\"New access key image\"></p>\n</li>\n<li>\n<p>Save the credentials somewhere safe.\n<img src=\"/assets/first-serverless-project-3_5.png\" alt=\"Save credentials image\"></p>\n</li>\n</ul>\n<h3 id=\"Step4-ConfigureserverlesswithyourAWScredentials\"><a name=\"Step4-ConfigureserverlesswithyourAWScredentials\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 4 - Configure serverless with your AWS credentials</h3>\n<p>Now you can use Serverless Framework to save the credentials in a way that the aws-cli can understand them by running the following command.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless config credentials --provider aws --key YOUR_ACCESS_KEY --secret YOUR_ACCESS_SECRET\n</code></pre>\n<h3 id=\"Step5-Deployyourlambdafunction\"><a name=\"Step5-Deployyourlambdafunction\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 5 - Deploy your lambda function</h3>\n<p>Deploy your Lambda function to AWS using the following command. (the <code>--verbose</code> flag will output full logs of your deployment)</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless deploy --verbose\n</code></pre>\n<p>As you may be able to see in the output this creates quite a few AWS resources.\nBehind the scenes it creates a code bundle and new CloudFormation stack that does the following:</p>\n<ul>\n<li>Uploads your code to S3.</li>\n<li>Creates a lambda function from your code</li>\n<li>Creates an API gateway api and endpoint that points to your new function.</li>\n<li>Creates a CloudWatch log group for your function</li>\n</ul>\n<p>You can view the files uploaded to s3 in the <code>.serverless</code> folder that the deploy command creates.</p>\n<div class=\"info\">\n<p>For more detail see the explanation from Serverless <a href=\"https://serverless.com/framework/docs/providers/aws/guide/deploying/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">here</a></p>\n</div>\n<h3 id=\"Tryitout\"><a name=\"Tryitout\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Try it out</h3>\n<p>The output from the above deployment command will print the endpoint API Gateway of the deployed function similar to the example below.\nJust open it in a browser to test the Lambda function works.</p>\n<pre><code>endpoints:\n  GET - https://qewroweire.execute-api.us-east-1.amazonaws.com/dev/hello-world\n</code></pre>\n<p>For more information on API gateway urls see <a href=\"/pages/learn/finding-api-gateway-urls/\" class=\"absolute-link\">this page</a> on how to find out what yours is after deployment.</p>\n<h3 id=\"Whatnow\"><a name=\"Whatnow\" class=\"markdown-it-headinganchor\" href=\"#\"></a>What now</h3>\n<p>Check out some of the links below to learn more and get building your apps with serverless now.</p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://aws.amazon.com/serverless/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS Serverless</a></li>\n<li><a href=\"https://serverless.com/framework/docs/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless Framework docs</a></li>\n</ul>\n</div>\n<div class=\"steps\">\n<p>Next step</p>\n<ul>\n<li><a href=\"/pages/learn/developing-locally-with-serverless-offline/\" class=\"absolute-link\">Develop Serverless applications locally</a></li>\n<li><a href=\"/pages/build/slspress-simple-example/\" class=\"absolute-link\">Create more complicated API's quickly with slspress</a></li>\n<li><a href=\"/pages/learn/hosting-for-a-serverless-project-on-s3/\" class=\"absolute-link\">Add some static HTML/JavaScript to use your new API</a></li>\n<li><a href=\"/pages/learn/where-are-my-logs/\" class=\"absolute-link\">Find out where logs from your functions go</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vaG93LXRvLXVzZS1wcml2YXRlLWRlcGVuZGVuY2llcy5tZA","filename":"/content/pages/learn/how-to-use-private-dependencies.md","suffix":"","attributes":{"title":"How to use private dependencies","sort":8,"featured":true,"description":"How to use your own private dependencies in serverless functions"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'How to use private dependencies'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 8","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'How to use your own private dependencies in serverless functions'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# How to use private dependencies","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Sometimes you need to add more functionality than Serverless has by default. You can create a private plugin for it (Consider making it public after testing, help the community :) ). Just create a new folder with the name of the plugin.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"how-to-use-private-dependencies","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" as an example name.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash git init git remote add origin YOU_PRIVATE_REPO_ADDRESS npm init","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"npm will walk you through a bunch of questions. Make sure you specify ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"index.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" as an entry point. After that we need to use Serverless to create a template for our plugin.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless create --template plugin","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can check out newly created ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"index.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". More details about the structure of the file can be found ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/blog/writing-serverless-plugins/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Then, just push the changes to the repo.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash git add . git commit -m \"first\" git tag -a v1.0 -m \"version 1.0\" git push origin v1.0","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It is very important to add a tag to your repository and keep tagging new releases. In case you don't do it, any changes to the repository master branch can potentially break all the projects that depend on the project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Then, you can open any Serverless project and add newly created plugin to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"plugins","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" list.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml plugins: - how-to-use-private-dependencies","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In order for that to work, you have to do the npm install from the private repo.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install --save-dev git+ssh://git@git-host.com:user/serverless_how-to-use-private-dependencies.git#v1.0","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you can check if the plugin exists by running:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"New command ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"welcome","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" should appear in the list of commands. Try running:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless welcome -m \"hello world\"","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"to test if the plugin works.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/guide/plugins/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless Plugins","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/serverless/plugins"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Community Plugins","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'How to use private dependencies'\nsort: 8\nfeatured: true\ndescription: 'How to use your own private dependencies in serverless functions'\n---\n# How to use private dependencies\n\nSometimes you need to add more functionality than Serverless has by default. You can create a private plugin for it (Consider making it public after testing, help the community :) ). Just create a new folder with the name of the plugin.\nWe use `how-to-use-private-dependencies` as an example name.\n\n&nbsp;\n\n```bash\ngit init\ngit remote add origin YOU_PRIVATE_REPO_ADDRESS\nnpm init\n```\n\n&nbsp;\n\nnpm will walk you through a bunch of questions. Make sure you specify `index.js` as an entry point. After that we need to use Serverless to create a template for our plugin.\n\n```bash\nserverless create --template plugin\n```\n\nYou can check out newly created `index.js`. More details about the structure of the file can be found [here](https://serverless.com/blog/writing-serverless-plugins/)\n\n&nbsp;\n\nThen, just push the changes to the repo.\n\n```bash\ngit add .\ngit commit -m \"first\"\ngit tag -a v1.0 -m \"version 1.0\"\ngit push origin v1.0\n```\n\nIt is very important to add a tag to your repository and keep tagging new releases. In case you don't do it, any changes to the repository master branch can potentially break all the projects that depend on the project.\n\nThen, you can open any Serverless project and add newly created plugin to `plugins` list.\n\n```yaml\nplugins:\n  - how-to-use-private-dependencies\n```\n\n&nbsp;\n\nIn order for that to work, you have to do the npm install from the private repo.\n\n```bash\nnpm install --save-dev git+ssh://git@git-host.com:user/serverless_how-to-use-private-dependencies.git#v1.0\n```\n\nNow, you can check if the plugin exists by running:\n\n```bash\nserverless\n```\n\nNew command `welcome` should appear in the list of commands. Try running:\n\n```bash\nserverless welcome -m \"hello world\"\n```\n\nto test if the plugin works.\n\n::: links\nFurther reading:\n\n* [Serverless Plugins](https://serverless.com/framework/docs/providers/aws/guide/plugins/)\n* [Community Plugins](https://github.com/serverless/plugins)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Howtouseprivatedependencies\"><a name=\"Howtouseprivatedependencies\" class=\"markdown-it-headinganchor\" href=\"#\"></a>How to use private dependencies</h1>\n<p>Sometimes you need to add more functionality than Serverless has by default. You can create a private plugin for it (Consider making it public after testing, help the community :) ). Just create a new folder with the name of the plugin.\nWe use <code>how-to-use-private-dependencies</code> as an example name.</p>\n<p> </p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">git</span> init\n<span class=\"token function\">git</span> remote add origin YOU_PRIVATE_REPO_ADDRESS\n<span class=\"token function\">npm</span> init\n</code></pre>\n<p> </p>\n<p>npm will walk you through a bunch of questions. Make sure you specify <code>index.js</code> as an entry point. After that we need to use Serverless to create a template for our plugin.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless create --template plugin\n</code></pre>\n<p>You can check out newly created <code>index.js</code>. More details about the structure of the file can be found <a href=\"https://serverless.com/blog/writing-serverless-plugins/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">here</a></p>\n<p> </p>\n<p>Then, just push the changes to the repo.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">git</span> add <span class=\"token keyword\">.</span>\n<span class=\"token function\">git</span> commit -m <span class=\"token string\">\"first\"</span>\n<span class=\"token function\">git</span> tag -a v1.0 -m <span class=\"token string\">\"version 1.0\"</span>\n<span class=\"token function\">git</span> push origin v1.0\n</code></pre>\n<p>It is very important to add a tag to your repository and keep tagging new releases. In case you don't do it, any changes to the repository master branch can potentially break all the projects that depend on the project.</p>\n<p>Then, you can open any Serverless project and add newly created plugin to <code>plugins</code> list.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">plugins</span><span class=\"token punctuation\">:</span>\n  <span class=\"token punctuation\">-</span> how<span class=\"token punctuation\">-</span>to<span class=\"token punctuation\">-</span>use<span class=\"token punctuation\">-</span>private<span class=\"token punctuation\">-</span>dependencies\n</code></pre>\n<p> </p>\n<p>In order for that to work, you have to do the npm install from the private repo.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> --save-dev git+ssh://git@git-host.com:user/serverless_how-to-use-private-dependencies.git<span class=\"token comment\">#v1.0</span>\n</code></pre>\n<p>Now, you can check if the plugin exists by running:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless\n</code></pre>\n<p>New command <code>welcome</code> should appear in the list of commands. Try running:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless welcome -m <span class=\"token string\">\"hello world\"</span>\n</code></pre>\n<p>to test if the plugin works.</p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/guide/plugins/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless Plugins</a></li>\n<li><a href=\"https://github.com/serverless/plugins\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Community Plugins</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vaW5kZXgubWQ","filename":"/content/pages/learn/index.md","suffix":"","attributes":{"title":"Learn","sort":1},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Learn'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 1","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Learn'\nsort: 1\n---","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":""}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLWNsb3Vkd2F0Y2gtZXZlbnRzLm1k","filename":"/content/pages/learn/listening-to-cloudwatch-events.md","suffix":"","attributes":{"title":"Listening to cloudwatch events","sort":7,"description":"Listening to AWS CloudWatch events using serverless","hidden":true},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to cloudwatch events'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 7","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Listening to AWS CloudWatch events using serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to CloudWatch events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/cloudwatch-event-handler"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"events:PutRule","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Lambda can listen to various types of CloudWatch events. One of the simplest types of events is CloudWatch Scheduled Event (similar to Cron job).","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Just create a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" with","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: cloudwatch-event-handler provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev functions: signInCloudWatchEvent: handler: handler.signInCloudWatchEvent events: - cloudwatchEvent: event: source: - aws.events","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" with","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"js module.exports.signInCloudWatchEvent = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)), callback(null); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"After deploying this stack, you can attach this lambda to CloudWatch Event. For example, you can create a new Rule with Schedule of a fixed rate 1 minute in AWS Console. In Targets section set ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"cloudwatch-event-handler-dev-signInCloudWatchEvent","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" as listening lambda function. After that you should start receiving events on this lambda:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"version\": \"0\", \"id\": \"397c14ce-20b1-cc14-dbca-9deca327fca9\", \"detail-type\": \"Scheduled Event\", \"source\": \"aws.events\", \"account\": \"189075651281\", \"time\": \"2018-06-05T10:48:38Z\", \"region\": \"eu-west-1\", \"resources\": [ \"arn:aws:events:eu-west-1:189075651281:rule/test_rule\" ], \"detail\": {} }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you can listen to a Scheduler Event from using cron-like CloudWatch functionality. Every time the event is fired, your lambda will be invoked.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-cloudwatch_1.png"],["alt",""]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"CloudWatch rules","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"CloudWatch rules","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://docs.aws.amazon.com/AmazonCloudWatch/latest/events/Create-CloudWatch-Events-Rule.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Create CloudWatch Event Rules","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/cloudwatch-event/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless CloudWatch","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to cloudwatch events'\nsort: 7\ndescription: 'Listening to AWS CloudWatch events using serverless'\nhidden: true\n---\n::: icons\n\n# Listening to CloudWatch events\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/cloudwatch-event-handler)\n:::\n\n::: info\nYou will require the following AWS permissions: \n - `events:PutRule`\n - `lambda:CreateEventSourceMapping`\n:::\n\nLambda can listen to various types of CloudWatch events. One of the simplest types of events is CloudWatch Scheduled Event (similar to Cron job).\n\nJust create a `serverless.yml` with\n```yaml\nservice: cloudwatch-event-handler\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n\nfunctions:\n  signInCloudWatchEvent:\n    handler: handler.signInCloudWatchEvent\n    events:\n      - cloudwatchEvent:\n        event:\n          source:\n            - aws.events\n```\nand `handler.js` with\n```js\nmodule.exports.signInCloudWatchEvent = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event)),\n  callback(null);\n}\n```\n\n&nbsp;\n\nAfter deploying this stack, you can attach this lambda to CloudWatch Event. For example, you can create a new Rule with Schedule of a fixed rate 1 minute in AWS Console. In Targets section set `cloudwatch-event-handler-dev-signInCloudWatchEvent` as listening lambda function. After that you should start receiving events on this lambda:\n\n```json\n{\n    \"version\": \"0\",\n    \"id\": \"397c14ce-20b1-cc14-dbca-9deca327fca9\",\n    \"detail-type\": \"Scheduled Event\",\n    \"source\": \"aws.events\",\n    \"account\": \"189075651281\",\n    \"time\": \"2018-06-05T10:48:38Z\",\n    \"region\": \"eu-west-1\",\n    \"resources\": [\n        \"arn:aws:events:eu-west-1:189075651281:rule/test_rule\"\n    ],\n    \"detail\": {}\n}\n```\n\nNow, you can listen to a Scheduler Event from using cron-like CloudWatch functionality. Every time the event is fired, your lambda will be invoked.\n\n![CloudWatch rules](/assets/listening-to-cloudwatch_1.png)\n\n::: links\nFurther reading:\n\n* [Create CloudWatch Event Rules](https://docs.aws.amazon.com/AmazonCloudWatch/latest/events/Create-CloudWatch-Events-Rule.html)\n* [Serverless CloudWatch](https://serverless.com/framework/docs/providers/aws/events/cloudwatch-event/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"ListeningtoCloudWatchevents\"><a name=\"ListeningtoCloudWatchevents\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to CloudWatch events</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/cloudwatch-event-handler\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<div class=\"info\">\n<p>You will require the following AWS permissions:</p>\n<ul>\n<li><code>events:PutRule</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p>Lambda can listen to various types of CloudWatch events. One of the simplest types of events is CloudWatch Scheduled Event (similar to Cron job).</p>\n<p>Just create a <code>serverless.yml</code> with</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> cloudwatch<span class=\"token punctuation\">-</span>event<span class=\"token punctuation\">-</span>handler\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">signInCloudWatchEvent</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.signInCloudWatchEvent\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">cloudwatchEvent</span><span class=\"token punctuation\">:</span>\n        <span class=\"token key atrule\">event</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">source</span><span class=\"token punctuation\">:</span>\n            <span class=\"token punctuation\">-</span> aws.events\n</code></pre>\n<p>and <code>handler.js</code> with</p>\n<pre class=\"language-js\"><code class=\"language-js\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">signInCloudWatchEvent</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>After deploying this stack, you can attach this lambda to CloudWatch Event. For example, you can create a new Rule with Schedule of a fixed rate 1 minute in AWS Console. In Targets section set <code>cloudwatch-event-handler-dev-signInCloudWatchEvent</code> as listening lambda function. After that you should start receiving events on this lambda:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"version\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"0\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"397c14ce-20b1-cc14-dbca-9deca327fca9\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"detail-type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Scheduled Event\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"source\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws.events\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"account\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"189075651281\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"time\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2018-06-05T10:48:38Z\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"region\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"eu-west-1\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"resources\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token string\">\"arn:aws:events:eu-west-1:189075651281:rule/test_rule\"</span>\n    <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"detail\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>Now, you can listen to a Scheduler Event from using cron-like CloudWatch functionality. Every time the event is fired, your lambda will be invoked.</p>\n<p><img src=\"/assets/listening-to-cloudwatch_1.png\" alt=\"CloudWatch rules\"></p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://docs.aws.amazon.com/AmazonCloudWatch/latest/events/Create-CloudWatch-Events-Rule.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Create CloudWatch Event Rules</a></li>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/events/cloudwatch-event/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless CloudWatch</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLWR5bmFtb2RiLWV2ZW50cy5tZA","filename":"/content/pages/learn/listening-to-dynamodb-events.md","suffix":"","attributes":{"title":"Listening to DynamoDB events","sort":6,"hidden":true},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to DynamoDB events'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 6","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to DynamoDB events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/dynamodb-event-handler"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can execute functions off of the back of data changes in a DynamoDB table.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"dynamodb:CreateTable","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To start, let's create a Serverless music collection table ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ServerlessTestMusicCollection","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on DynamoDB","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There are two ways to do this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"1. Using AWSCLI via the command line.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws dynamodb create-table --table-name ServerlessTestMusicCollection --attribute-definitions AttributeName=Artist,AttributeType=S AttributeName=SongTitle,AttributeType=S --key-schema AttributeName=Artist,KeyType=HASH AttributeName=SongTitle,KeyType=RANGE --provisioned-throughput ReadCapacityUnits=5,WriteCapacityUnits=5 --stream-specification StreamEnabled=true,StreamViewType=NEW_AND_OLD_IMAGES","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The AWS API should respond with ARN for this table similar to the below:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"TableDescription\": { \"TableArn\": \"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection\", ... } ... \"LatestStreamArn\": \"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection/stream/2017-07-21T11:19:36.118\" } Now you can use `LatestStreamArn` to construct an api.","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"2. Using the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file by adding the following function to your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: dynamo-db-event-handler provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev environment: DYNAMODB_TABLE: ${self:service}-${opt:stage, self:provider.stage}-ServerlessTestMusicCollection iamRoleStatements: - Effect: Allow Action: - dynamodb:* Resource: \"arn:aws:dynamodb:${opt:region, self:provider.region}:*:table/${self:provider.environment.DYNAMODB_TABLE}\" functions: dynamoDBEvent: handler: handler.dynamoDBEvent events: - stream: type: dynamodb arn: Fn::GetAtt: - DynamoDBTable - StreamArn resources: Resources: DynamoDBTable: Type: 'AWS::DynamoDB::Table' DeletionPolicy: Delete Properties: AttributeDefinitions: - AttributeName: id AttributeType: S KeySchema: - AttributeName: id KeyType: HASH ProvisionedThroughput: ReadCapacityUnits: 1 WriteCapacityUnits: 1 StreamSpecification: StreamViewType: NEW_IMAGE TableName: ${self:provider.environment.DYNAMODB_TABLE}","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"And a corresponding export in your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.dynamoDBEvent = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)), callback(null); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Deploy your function:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once deployed, if you add anything to your DynamoDB Table, the Lambda will be notified.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Add something to your table using the following command:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws dynamodb put-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --item '{ \"id\": {\"S\": \"1\" }, \"Artist\": { \"S\": \"Tailor Swift\"}, \"SongTitle\": { \"S\": \"Shake It Off\"}, \"AlbumTitle\": { \"S\": \"1989\"}}'","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Check the logs in ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/where-are-my-logs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"CloudWatch","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" or using ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/dumptruck/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" for the log statement from the lambda.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"It should look similar to the below:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Records\": [ { \"eventID\": \"0d2fa79c11e010c6c7d80d2b087d363a\", \"eventName\": \"INSERT\", \"eventVersion\": \"1.1\", \"eventSource\": \"aws:dynamodb\", \"awsRegion\": \"eu-west-1\", \"dynamodb\": { \"ApproximateCreationDateTime\": 1528193160, \"Keys\": { \"id\": { \"S\": \"1\" } }, \"NewImage\": { \"Artist\": { \"S\": \"Tailor Swift\" }, \"SongTitle\": { \"S\": \"Shake It Off\" }, \"AlbumTitle\": { \"S\": \"1989\" }, \"id\": { \"S\": \"1\" } }, \"SequenceNumber\": \"100000000044902851105\", \"SizeBytes\": 59, \"StreamViewType\": \"NEW_IMAGE\" }, \"eventSourceARN\": \"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\" } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To delete the row:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws dynamodb delete-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --key '{ \"id\": {\"S\": \"1\" } }'","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The response will look like something like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Records\": [ { \"eventID\": \"fd107cb379f5c97898e7b03ed0d4c8f3\", \"eventName\": \"REMOVE\", \"eventVersion\": \"1.1\", \"eventSource\": \"aws:dynamodb\", \"awsRegion\": \"eu-west-1\", \"dynamodb\": { \"ApproximateCreationDateTime\": 1528193460, \"Keys\": { \"id\": { \"S\": \"1\" } }, \"SequenceNumber\": \"400000000044903307939\", \"SizeBytes\": 3, \"StreamViewType\": \"NEW_IMAGE\" }, \"eventSourceARN\": \"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\" } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The same method described here can be used to process Kinesis events as well.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/streams/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless Streams","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to DynamoDB events'\nsort: 6\nhidden: true\n---\n::: icons\n\n# Listening to DynamoDB events\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/dynamodb-event-handler)\n:::\n\nYou can execute functions off of the back of data changes in a DynamoDB table.\n\n::: info\nYou will require the following AWS permissions: \n - `dynamodb:CreateTable`\n - `lambda:CreateEventSourceMapping`\n:::\n\n&nbsp;\n\nTo start, let's create a Serverless music collection table `ServerlessTestMusicCollection` on DynamoDB\nThere are two ways to do this:\n\n1. Using AWSCLI via the command line.\n```bash\naws dynamodb create-table --table-name ServerlessTestMusicCollection --attribute-definitions AttributeName=Artist,AttributeType=S AttributeName=SongTitle,AttributeType=S --key-schema AttributeName=Artist,KeyType=HASH AttributeName=SongTitle,KeyType=RANGE --provisioned-throughput ReadCapacityUnits=5,WriteCapacityUnits=5 --stream-specification StreamEnabled=true,StreamViewType=NEW_AND_OLD_IMAGES\n```\n\nThe AWS API should respond with ARN for this table similar to the below:\n```json\n{\n    \"TableDescription\": {\n        \"TableArn\": \"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection\",\n        ...\n    }\n    ...\n    \"LatestStreamArn\": \"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection/stream/2017-07-21T11:19:36.118\"\n}\nNow you can use `LatestStreamArn` to construct an api. \n```\n\n&nbsp;\n\n2. Using the `serverless.yml` file by adding the following function to your `serverless.yml`:\n```yaml\nservice: dynamo-db-event-handler\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n  environment:\n      DYNAMODB_TABLE:  ${self:service}-${opt:stage, self:provider.stage}-ServerlessTestMusicCollection\n  iamRoleStatements:\n    - Effect: Allow\n      Action:\n        - dynamodb:*\n      Resource: \"arn:aws:dynamodb:${opt:region, self:provider.region}:*:table/${self:provider.environment.DYNAMODB_TABLE}\"\n\nfunctions:\n  dynamoDBEvent:\n    handler: handler.dynamoDBEvent\n    events:\n      - stream:\n          type: dynamodb\n          arn:\n            Fn::GetAtt:\n              - DynamoDBTable\n              - StreamArn\n\nresources:\n  Resources:\n    DynamoDBTable:\n      Type: 'AWS::DynamoDB::Table'\n      DeletionPolicy: Delete\n      Properties:\n        AttributeDefinitions:\n          -\n            AttributeName: id\n            AttributeType: S\n        KeySchema:\n          -\n            AttributeName: id\n            KeyType: HASH\n        ProvisionedThroughput:\n          ReadCapacityUnits: 1\n          WriteCapacityUnits: 1\n        StreamSpecification:\n          StreamViewType: NEW_IMAGE\n        TableName: ${self:provider.environment.DYNAMODB_TABLE}\n```\n\nAnd a corresponding export in your `handler.js`:\n```javascript\nmodule.exports.dynamoDBEvent = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event)),\n  callback(null);\n}\n```\n\n&nbsp;\n\nDeploy your function:\n```bash\n  serverless deploy\n```\n\nOnce deployed, if you add anything to your DynamoDB Table, the Lambda will be notified. \nAdd something to your table using the following command:\n\n```bash\n  aws dynamodb put-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --item '{ \"id\": {\"S\": \"1\" }, \"Artist\": { \"S\": \"Tailor Swift\"}, \"SongTitle\": { \"S\": \"Shake It Off\"}, \"AlbumTitle\": { \"S\": \"1989\"}}'\n```\n\nCheck the logs in [CloudWatch](/pages/learn/where-are-my-logs/) or using [Dumptruck](/pages/build/dumptruck/) for the log statement from the lambda.\n\nIt should look similar to the below:\n\n```json\n{\n    \"Records\": [\n        {\n            \"eventID\": \"0d2fa79c11e010c6c7d80d2b087d363a\",\n            \"eventName\": \"INSERT\",\n            \"eventVersion\": \"1.1\",\n            \"eventSource\": \"aws:dynamodb\",\n            \"awsRegion\": \"eu-west-1\",\n            \"dynamodb\": {\n                \"ApproximateCreationDateTime\": 1528193160,\n                \"Keys\": {\n                    \"id\": {\n                        \"S\": \"1\"\n                    }\n                },\n                \"NewImage\": {\n                    \"Artist\": {\n                        \"S\": \"Tailor Swift\"\n                    },\n                    \"SongTitle\": {\n                        \"S\": \"Shake It Off\"\n                    },\n                    \"AlbumTitle\": {\n                        \"S\": \"1989\"\n                    },\n                    \"id\": {\n                        \"S\": \"1\"\n                    }\n                },\n                \"SequenceNumber\": \"100000000044902851105\",\n                \"SizeBytes\": 59,\n                \"StreamViewType\": \"NEW_IMAGE\"\n            },\n            \"eventSourceARN\": \"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\"\n        }\n    ]\n}\n```\n\nTo delete the row:\n\n```bash\n    aws dynamodb delete-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --key '{ \"id\": {\"S\": \"1\" } }'\n```\n\nThe response will look like something like this:\n```json\n{\n    \"Records\": [\n        {\n            \"eventID\": \"fd107cb379f5c97898e7b03ed0d4c8f3\",\n            \"eventName\": \"REMOVE\",\n            \"eventVersion\": \"1.1\",\n            \"eventSource\": \"aws:dynamodb\",\n            \"awsRegion\": \"eu-west-1\",\n            \"dynamodb\": {\n                \"ApproximateCreationDateTime\": 1528193460,\n                \"Keys\": {\n                    \"id\": {\n                        \"S\": \"1\"\n                    }\n                },\n                \"SequenceNumber\": \"400000000044903307939\",\n                \"SizeBytes\": 3,\n                \"StreamViewType\": \"NEW_IMAGE\"\n            },\n            \"eventSourceARN\": \"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\"\n        }\n    ]\n}\n```\n\n::: info\nThe same method described here can be used to process Kinesis events as well.\n::::\n\n::: links\nFurther reading:\n\n* [Serverless Streams](https://serverless.com/framework/docs/providers/aws/events/streams/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"ListeningtoDynamoDBevents\"><a name=\"ListeningtoDynamoDBevents\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to DynamoDB events</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/dynamodb-event-handler\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>You can execute functions off of the back of data changes in a DynamoDB table.</p>\n<div class=\"info\">\n<p>You will require the following AWS permissions:</p>\n<ul>\n<li><code>dynamodb:CreateTable</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p> </p>\n<p>To start, let's create a Serverless music collection table <code>ServerlessTestMusicCollection</code> on DynamoDB\nThere are two ways to do this:</p>\n<ol>\n<li>Using AWSCLI via the command line.</li>\n</ol>\n<pre class=\"language-bash\"><code class=\"language-bash\">aws dynamodb create-table --table-name ServerlessTestMusicCollection --attribute-definitions AttributeName<span class=\"token operator\">=</span>Artist,AttributeType<span class=\"token operator\">=</span>S AttributeName<span class=\"token operator\">=</span>SongTitle,AttributeType<span class=\"token operator\">=</span>S --key-schema AttributeName<span class=\"token operator\">=</span>Artist,KeyType<span class=\"token operator\">=</span>HASH AttributeName<span class=\"token operator\">=</span>SongTitle,KeyType<span class=\"token operator\">=</span>RANGE --provisioned-throughput ReadCapacityUnits<span class=\"token operator\">=</span>5,WriteCapacityUnits<span class=\"token operator\">=</span>5 --stream-specification StreamEnabled<span class=\"token operator\">=</span>true,StreamViewType<span class=\"token operator\">=</span>NEW_AND_OLD_IMAGES\n</code></pre>\n<p>The AWS API should respond with ARN for this table similar to the below:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"TableDescription\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"TableArn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection\"</span><span class=\"token punctuation\">,</span>\n        ...\n    <span class=\"token punctuation\">}</span>\n    ...\n    <span class=\"token property\">\"LatestStreamArn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:dynamodb:us-east-1:xxxxxxxxxxx:table/ServerlessTestMusicCollection/stream/2017-07-21T11:19:36.118\"</span>\n<span class=\"token punctuation\">}</span>\nNow you can use `LatestStreamArn` to construct an api. \n</code></pre>\n<p> </p>\n<ol start=\"2\">\n<li>Using the <code>serverless.yml</code> file by adding the following function to your <code>serverless.yml</code>:</li>\n</ol>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> dynamo<span class=\"token punctuation\">-</span>db<span class=\"token punctuation\">-</span>event<span class=\"token punctuation\">-</span>handler\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n  <span class=\"token key atrule\">environment</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">DYNAMODB_TABLE</span><span class=\"token punctuation\">:</span>  $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>$<span class=\"token punctuation\">{</span>opt<span class=\"token punctuation\">:</span>stage<span class=\"token punctuation\">,</span> self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>ServerlessTestMusicCollection\n  <span class=\"token key atrule\">iamRoleStatements</span><span class=\"token punctuation\">:</span>\n    <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Effect</span><span class=\"token punctuation\">:</span> Allow\n      <span class=\"token key atrule\">Action</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> dynamodb<span class=\"token punctuation\">:</span>*\n      <span class=\"token key atrule\">Resource</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"arn:aws:dynamodb:${opt:region, self:provider.region}:*:table/${self:provider.environment.DYNAMODB_TABLE}\"</span>\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">dynamoDBEvent</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.dynamoDBEvent\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">stream</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">type</span><span class=\"token punctuation\">:</span> dynamodb\n          <span class=\"token key atrule\">arn</span><span class=\"token punctuation\">:</span>\n            <span class=\"token key atrule\">Fn::GetAtt</span><span class=\"token punctuation\">:</span>\n              <span class=\"token punctuation\">-</span> DynamoDBTable\n              <span class=\"token punctuation\">-</span> StreamArn\n\n<span class=\"token key atrule\">resources</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">Resources</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">DynamoDBTable</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">Type</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'AWS::DynamoDB::Table'</span>\n      <span class=\"token key atrule\">DeletionPolicy</span><span class=\"token punctuation\">:</span> Delete\n      <span class=\"token key atrule\">Properties</span><span class=\"token punctuation\">:</span>\n        <span class=\"token key atrule\">AttributeDefinitions</span><span class=\"token punctuation\">:</span>\n          <span class=\"token punctuation\">-</span>\n            <span class=\"token key atrule\">AttributeName</span><span class=\"token punctuation\">:</span> id\n            <span class=\"token key atrule\">AttributeType</span><span class=\"token punctuation\">:</span> S\n        <span class=\"token key atrule\">KeySchema</span><span class=\"token punctuation\">:</span>\n          <span class=\"token punctuation\">-</span>\n            <span class=\"token key atrule\">AttributeName</span><span class=\"token punctuation\">:</span> id\n            <span class=\"token key atrule\">KeyType</span><span class=\"token punctuation\">:</span> HASH\n        <span class=\"token key atrule\">ProvisionedThroughput</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">ReadCapacityUnits</span><span class=\"token punctuation\">:</span> <span class=\"token number\">1</span>\n          <span class=\"token key atrule\">WriteCapacityUnits</span><span class=\"token punctuation\">:</span> <span class=\"token number\">1</span>\n        <span class=\"token key atrule\">StreamSpecification</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">StreamViewType</span><span class=\"token punctuation\">:</span> NEW_IMAGE\n        <span class=\"token key atrule\">TableName</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>provider.environment.DYNAMODB_TABLE<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>And a corresponding export in your <code>handler.js</code>:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">dynamoDBEvent</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>Deploy your function:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">  serverless deploy\n</code></pre>\n<p>Once deployed, if you add anything to your DynamoDB Table, the Lambda will be notified.\nAdd something to your table using the following command:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">  aws dynamodb put-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --item <span class=\"token string\">'{ \"id\": {\"S\": \"1\" }, \"Artist\": { \"S\": \"Tailor Swift\"}, \"SongTitle\": { \"S\": \"Shake It Off\"}, \"AlbumTitle\": { \"S\": \"1989\"}}'</span>\n</code></pre>\n<p>Check the logs in <a href=\"/pages/learn/where-are-my-logs/\" class=\"absolute-link\">CloudWatch</a> or using <a href=\"/pages/build/dumptruck/\" class=\"absolute-link\">Dumptruck</a> for the log statement from the lambda.</p>\n<p>It should look similar to the below:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"Records\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"eventID\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"0d2fa79c11e010c6c7d80d2b087d363a\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventName\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"INSERT\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.1\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventSource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws:dynamodb\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"awsRegion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"eu-west-1\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"dynamodb\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                <span class=\"token property\">\"ApproximateCreationDateTime\"</span><span class=\"token operator\">:</span> <span class=\"token number\">1528193160</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Keys\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                    <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1\"</span>\n                    <span class=\"token punctuation\">}</span>\n                <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"NewImage\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                    <span class=\"token property\">\"Artist\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Tailor Swift\"</span>\n                    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                    <span class=\"token property\">\"SongTitle\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Shake It Off\"</span>\n                    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                    <span class=\"token property\">\"AlbumTitle\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1989\"</span>\n                    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                    <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1\"</span>\n                    <span class=\"token punctuation\">}</span>\n                <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SequenceNumber\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"100000000044902851105\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SizeBytes\"</span><span class=\"token operator\">:</span> <span class=\"token number\">59</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"StreamViewType\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"NEW_IMAGE\"</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventSourceARN\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\"</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>To delete the row:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">    aws dynamodb delete-item --table-name dynamo-db-event-handler-dev-ServerlessTestMusicCollection --key <span class=\"token string\">'{ \"id\": {\"S\": \"1\" } }'</span>\n</code></pre>\n<p>The response will look like something like this:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"Records\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"eventID\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"fd107cb379f5c97898e7b03ed0d4c8f3\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventName\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"REMOVE\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.1\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventSource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws:dynamodb\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"awsRegion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"eu-west-1\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"dynamodb\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                <span class=\"token property\">\"ApproximateCreationDateTime\"</span><span class=\"token operator\">:</span> <span class=\"token number\">1528193460</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Keys\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                    <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                        <span class=\"token property\">\"S\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1\"</span>\n                    <span class=\"token punctuation\">}</span>\n                <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SequenceNumber\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"400000000044903307939\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SizeBytes\"</span><span class=\"token operator\">:</span> <span class=\"token number\">3</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"StreamViewType\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"NEW_IMAGE\"</span>\n            <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"eventSourceARN\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:dynamodb:eu-west-1:189075651281:table/dynamo-db-event-handler-dev-ServerlessTestMusicCollection/stream/2018-06-05T10:00:55.153\"</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<div class=\"info\">\n<p>The same method described here can be used to process Kinesis events as well.</p>\n</div>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/events/streams/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless Streams</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLW90aGVyLWV2ZW50cy1ub24taHR0cC5tZA","filename":"/content/pages/learn/listening-to-other-events-non-http.md","suffix":"","attributes":{"title":"Listening to other events (non-http)","sort":5,"description":"Listening to S3, DynamoDB, SNS, SES and other events with serverless"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to other events (non-http)'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 5","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Listening to S3, DynamoDB, SNS, SES and other events with serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to other events (non-http)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Serverless is not just about http API's. There are a whole range of events in AWS that can trigger a lambda function.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This article will go through the basics of a a few possibilities.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This is by no means exhaustive and meant to be a starting point for further investigation.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This assumes you have a basic understanding of Serverless and can edit and deploy a Serverless application.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If not or if you need a refresher head over to the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/first-serverless-project/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"first Serverless project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" article first.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-s3-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to S3 events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-dynamodb-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to DynamoDB events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-cloudwatch-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to CloudWatch events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-sns-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to SNS events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-ses-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to SES events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless Lamdba Events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to other events (non-http)'\nsort: 5\ndescription: 'Listening to S3, DynamoDB, SNS, SES and other events with serverless'\n---\n# Listening to other events (non-http)\n\nServerless is not just about http API's. There are a whole range of events in AWS that can trigger a lambda function.\nThis article will go through the basics of a a few possibilities. \nThis is by no means exhaustive and meant to be a starting point for further investigation.\n\nThis assumes you have a basic understanding of Serverless and can edit and deploy a Serverless application.\nIf not or if you need a refresher head over to the [first Serverless project](/pages/learn/first-serverless-project/) article first.\n\n&nbsp;\n\n* [Listening to S3 events](/pages/learn/listening-to-s3-events/)\n* [Listening to DynamoDB events](/pages/learn/listening-to-dynamodb-events/)\n* [Listening to CloudWatch events](/pages/learn/listening-to-cloudwatch-events/)\n* [Listening to SNS events](/pages/learn/listening-to-sns-events/)\n* [Listening to SES events](/pages/learn/listening-to-ses-events/)\n\n::: links\nFurther reading:\n\n* [Serverless Lamdba Events](https://serverless.com/framework/docs/providers/aws/events/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Listeningtootherevents(non-http)\"><a name=\"Listeningtootherevents(non-http)\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to other events (non-http)</h1>\n<p>Serverless is not just about http API's. There are a whole range of events in AWS that can trigger a lambda function.\nThis article will go through the basics of a a few possibilities.\nThis is by no means exhaustive and meant to be a starting point for further investigation.</p>\n<p>This assumes you have a basic understanding of Serverless and can edit and deploy a Serverless application.\nIf not or if you need a refresher head over to the <a href=\"/pages/learn/first-serverless-project/\" class=\"absolute-link\">first Serverless project</a> article first.</p>\n<p> </p>\n<ul>\n<li><a href=\"/pages/learn/listening-to-s3-events/\" class=\"absolute-link\">Listening to S3 events</a></li>\n<li><a href=\"/pages/learn/listening-to-dynamodb-events/\" class=\"absolute-link\">Listening to DynamoDB events</a></li>\n<li><a href=\"/pages/learn/listening-to-cloudwatch-events/\" class=\"absolute-link\">Listening to CloudWatch events</a></li>\n<li><a href=\"/pages/learn/listening-to-sns-events/\" class=\"absolute-link\">Listening to SNS events</a></li>\n<li><a href=\"/pages/learn/listening-to-ses-events/\" class=\"absolute-link\">Listening to SES events</a></li>\n</ul>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/events/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless Lamdba Events</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLXMzLWV2ZW50cy5tZA","filename":"/content/pages/learn/listening-to-s3-events.md","suffix":"","attributes":{"title":"Listening to S3 events","sort":5,"hidden":true,"description":"Listening to AWS S3 storage events using serverless"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to S3 events'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 5","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Listening to AWS S3 storage events using serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to S3 events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/s3-event-handler"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Lambda functions can listen to S3 events e.g. when something is added or deleted from a bucket.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"s3:CreateBucket","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There are two ways to create the s3 bucket:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- Manually.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash aws s3api create-bucket --bucket my-bucket","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- Using the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file by adding the following function to your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: s3-event-handler provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev environment: BUCKET_NAME: ${self:service}-${opt:stage, self:provider.stage}-s3bucket iamRoleStatements: - Effect: Allow Action: - s3:* Resource: \"arn:aws:s3:::${self:provider.environment.BUCKET_NAME}*\" functions: fileAdded: handler: handler.fileAdded events: - s3: ${self:provider.environment.BUCKET_NAME}","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"And a corresponding export in your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.fileAdded = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)), callback(null); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Deploy your function.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now if you , you can go to AWS Console S3 and upload some file to our ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"s3bucket","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Your lambda function will get the following event after the file has been uploaded:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Records\": [ { \"eventVersion\": \"2.0\", \"eventSource\": \"aws:s3\", \"awsRegion\": \"us-east-1\", \"eventTime\": \"2017-07-21T10:39:24.388Z\", \"eventName\": \"ObjectCreated:Put\", \"userIdentity\": { \"principalId\": \"AWS:XXXXXXXXXXXXXXXX\" }, \"requestParameters\": { \"sourceIPAddress\": \"xxx.xxx.xxx.xxx\" }, \"responseElements\": { \"x-amz-request-id\": \"55AXXXXXXXXX0E31\", \"x-amz-id-2\": \"PsFUX/J79BSyvY9iYCRi6mOIfQKvhwhDo9X1/s/Dn1HlC/2echsarVantmB7+o/HMNvWmUfTxSc=\" }, \"s3\": { \"s3SchemaVersion\": \"1.0\", \"configurationId\": \"xxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx\", \"bucket\": { \"name\": \"s3bucket\", \"ownerIdentity\": { \"principalId\": \"XXXXXXXXXXXX\" }, \"arn\": \"arn:aws:s3:::serverless-file-bucket\" }, \"object\": { \"key\": \"README.me\", \"size\": 240, \"eTag\": \"xxxxxxxxxxxxxxxx\", \"sequencer\": \"23XXX4324XX324XXXXX\" } } } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Records[i].s3.object","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"  will contains original filenames and sizes of uploaded files.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can also set a filter for the events to filter, for example filtering new JPG images in uploads folder.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: fileAdded: handler: handler.fileAdded events: - s3: bucket: serverless-file-bucket event: s3:ObjectCreated:* rules: - prefix: uploads/ - suffix: .jpg","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/s3/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless S3 Events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to S3 events'\nsort: 5\nhidden: true\ndescription: 'Listening to AWS S3 storage events using serverless'\n---\n::: icons\n\n# Listening to S3 events\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/s3-event-handler)\n:::\n\nLambda functions can listen to S3 events e.g. when something is added or deleted from a bucket.\n\n::: info\n You will require the following AWS permissions: \n * `s3:CreateBucket`\n * `lambda:CreateEventSourceMapping`\n:::\n\nThere are two ways to create the s3 bucket:\n\n- Manually.\n\n```bash\naws s3api create-bucket --bucket my-bucket\n```\n\n- Using the `serverless.yml` file by adding the following function to your `serverless.yml`:\n\n```yaml\nservice: s3-event-handler\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n  environment:\n    BUCKET_NAME:  ${self:service}-${opt:stage, self:provider.stage}-s3bucket\n  iamRoleStatements:\n    - Effect: Allow\n      Action:\n        - s3:*\n      Resource: \"arn:aws:s3:::${self:provider.environment.BUCKET_NAME}*\"\n\nfunctions:\n  fileAdded:\n    handler: handler.fileAdded\n    events:\n      - s3: ${self:provider.environment.BUCKET_NAME}\n```\n\nAnd a corresponding export in your `handler.js`:\n\n```javascript\nmodule.exports.fileAdded = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event)),\n  callback(null);\n}\n```\n\nDeploy your function.\n\n```bash\n  serverless deploy\n```\n\nNow if you , you can go to AWS Console S3 and upload some file to our `s3bucket`.\nYour lambda function will get the following event after the file has been uploaded:\n\n```json\n{\n  \"Records\": [\n    {\n      \"eventVersion\": \"2.0\",\n      \"eventSource\": \"aws:s3\",\n      \"awsRegion\": \"us-east-1\",\n      \"eventTime\": \"2017-07-21T10:39:24.388Z\",\n      \"eventName\": \"ObjectCreated:Put\",\n      \"userIdentity\": {\n        \"principalId\": \"AWS:XXXXXXXXXXXXXXXX\"\n      },\n      \"requestParameters\": {\n        \"sourceIPAddress\": \"xxx.xxx.xxx.xxx\"\n      },\n      \"responseElements\": {\n        \"x-amz-request-id\": \"55AXXXXXXXXX0E31\",\n        \"x-amz-id-2\": \"PsFUX/J79BSyvY9iYCRi6mOIfQKvhwhDo9X1/s/Dn1HlC/2echsarVantmB7+o/HMNvWmUfTxSc=\"\n      },\n      \"s3\": {\n        \"s3SchemaVersion\": \"1.0\",\n        \"configurationId\": \"xxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx\",\n        \"bucket\": {\n          \"name\": \"s3bucket\",\n          \"ownerIdentity\": {\n            \"principalId\": \"XXXXXXXXXXXX\"\n          },\n          \"arn\": \"arn:aws:s3:::serverless-file-bucket\"\n        },\n        \"object\": {\n          \"key\": \"README.me\",\n          \"size\": 240,\n          \"eTag\": \"xxxxxxxxxxxxxxxx\",\n          \"sequencer\": \"23XXX4324XX324XXXXX\"\n        }\n      }\n    }\n  ]\n}\n```\n\n`Records[i].s3.object`  will contains original filenames and sizes of uploaded files.\n\nYou can also set a filter for the events to filter, for example filtering new JPG images in uploads folder.\n\n```yaml\nfunctions:\n  fileAdded:\n    handler: handler.fileAdded\n    events:\n      - s3:\n          bucket: serverless-file-bucket\n          event: s3:ObjectCreated:*\n          rules:\n            - prefix: uploads/\n            - suffix: .jpg\n```\n\n::: links\nFurther reading:\n\n* [Serverless S3 Events](https://serverless.com/framework/docs/providers/aws/events/s3/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"ListeningtoS3events\"><a name=\"ListeningtoS3events\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to S3 events</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/s3-event-handler\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>Lambda functions can listen to S3 events e.g. when something is added or deleted from a bucket.</p>\n<div class=\"info\">\n<p>You will require the following AWS permissions:</p>\n<ul>\n<li><code>s3:CreateBucket</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p>There are two ways to create the s3 bucket:</p>\n<ul>\n<li>Manually.</li>\n</ul>\n<pre class=\"language-bash\"><code class=\"language-bash\">aws s3api create-bucket --bucket my-bucket\n</code></pre>\n<ul>\n<li>Using the <code>serverless.yml</code> file by adding the following function to your <code>serverless.yml</code>:</li>\n</ul>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> s3<span class=\"token punctuation\">-</span>event<span class=\"token punctuation\">-</span>handler\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n  <span class=\"token key atrule\">environment</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">BUCKET_NAME</span><span class=\"token punctuation\">:</span>  $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>$<span class=\"token punctuation\">{</span>opt<span class=\"token punctuation\">:</span>stage<span class=\"token punctuation\">,</span> self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>s3bucket\n  <span class=\"token key atrule\">iamRoleStatements</span><span class=\"token punctuation\">:</span>\n    <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Effect</span><span class=\"token punctuation\">:</span> Allow\n      <span class=\"token key atrule\">Action</span><span class=\"token punctuation\">:</span>\n        <span class=\"token punctuation\">-</span> s3<span class=\"token punctuation\">:</span>*\n      <span class=\"token key atrule\">Resource</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"arn:aws:s3:::${self:provider.environment.BUCKET_NAME}*\"</span>\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">fileAdded</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.fileAdded\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">s3</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>provider.environment.BUCKET_NAME<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>And a corresponding export in your <code>handler.js</code>:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">fileAdded</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>Deploy your function.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">  serverless deploy\n</code></pre>\n<p>Now if you , you can go to AWS Console S3 and upload some file to our <code>s3bucket</code>.\nYour lambda function will get the following event after the file has been uploaded:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"Records\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n    <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"eventVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2.0\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"eventSource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws:s3\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"awsRegion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"us-east-1\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"eventTime\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-07-21T10:39:24.388Z\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"eventName\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"ObjectCreated:Put\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"userIdentity\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"principalId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"AWS:XXXXXXXXXXXXXXXX\"</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"requestParameters\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"sourceIPAddress\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxx.xxx.xxx.xxx\"</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"responseElements\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"x-amz-request-id\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"55AXXXXXXXXX0E31\"</span><span class=\"token punctuation\">,</span>\n        <span class=\"token property\">\"x-amz-id-2\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"PsFUX/J79BSyvY9iYCRi6mOIfQKvhwhDo9X1/s/Dn1HlC/2echsarVantmB7+o/HMNvWmUfTxSc=\"</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"s3\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"s3SchemaVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.0\"</span><span class=\"token punctuation\">,</span>\n        <span class=\"token property\">\"configurationId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n        <span class=\"token property\">\"bucket\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n          <span class=\"token property\">\"name\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"s3bucket\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"ownerIdentity\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"principalId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"XXXXXXXXXXXX\"</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"arn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:s3:::serverless-file-bucket\"</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n        <span class=\"token property\">\"object\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n          <span class=\"token property\">\"key\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"README.me\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"size\"</span><span class=\"token operator\">:</span> <span class=\"token number\">240</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"eTag\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"sequencer\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"23XXX4324XX324XXXXX\"</span>\n        <span class=\"token punctuation\">}</span>\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p><code>Records[i].s3.object</code>  will contains original filenames and sizes of uploaded files.</p>\n<p>You can also set a filter for the events to filter, for example filtering new JPG images in uploads folder.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">fileAdded</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.fileAdded\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">s3</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">bucket</span><span class=\"token punctuation\">:</span> serverless<span class=\"token punctuation\">-</span>file<span class=\"token punctuation\">-</span>bucket\n          <span class=\"token key atrule\">event</span><span class=\"token punctuation\">:</span> s3<span class=\"token punctuation\">:</span>ObjectCreated<span class=\"token punctuation\">:</span>*\n          <span class=\"token key atrule\">rules</span><span class=\"token punctuation\">:</span>\n            <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">prefix</span><span class=\"token punctuation\">:</span> uploads/\n            <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">suffix</span><span class=\"token punctuation\">:</span> .jpg\n</code></pre>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/events/s3/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless S3 Events</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLXNlcy1ldmVudHMubWQ","filename":"/content/pages/learn/listening-to-ses-events.md","suffix":"","attributes":{"title":"Listening to SES events","sort":5,"hidden":true},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to SES events'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 5","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to SES events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/listen-to-ses-events"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:AddPermission","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"s3:CreateBucket","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Step 1: Create new lambda function","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First, create a lambda function that will receive notifications about received emails, ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.emailReceived = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)); callback(null); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: emailReceived: handler: handler.emailReceived","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, we need to set up AWS SES service to save the emails we receive on particular domain. Note, that you need to own a domain name or subdomain and set your ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://en.wikipedia.org/wiki/MX_record"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"MX records","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to AWS. If you don't know what are MX records, check ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://en.wikipedia.org/wiki/MX_record"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Wikipedia article","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://stackoverflow.com/questions/385193/why-have-mx-records"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"stackoverflow answer","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Step 2: Verify the new domain","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Head to AWS SES service and verify a new domain if you haven't verified it yet. Amazon will walk you through what records are needed to be added for your domain in Route 53.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events_5_1.png"],["alt",""],["title","new domain"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"new domain","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"new domain","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Step 3: Create a new rule set","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In the Rule Set section in AWS SES, Create a new Rule. Specify an email, for example test-email@your-domain.com","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events_5_2.png"],["alt",""],["title","new rule"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"new rule","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"new rule","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, create two actions. One action should save all the new emails to S3 email bucket. You can create a new bucket for that. Second rule should invoke our newly created lambda - ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"emaiReceived","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/assets/listening-to-other-events_5_3.png"],["alt",""],["title","new action"]],"map":null,"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"new action","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"new action","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In order to test that the lambda is actually invoked, you can use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/dumptruck/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Launch it and send some dummy email to newly created email listener. Here is the sample output of what you'll see in dumptruck:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Records\": [ { \"eventSource\": \"aws:ses\", \"eventVersion\": \"1.0\", \"ses\": { \"mail\": { \"timestamp\": \"2017-07-25T14:27:30.615Z\", \"source\": \"your-personal-email@gmail.com\", \"messageId\": \"xxxxxxxxxxxxxxxxxxxxxxxxx\", \"destination\": [ \"test-email@your-domain.com\" ], \"headersTruncated\": false, \"headers\": [ // email headers here ], }, \"receipt\": { \"timestamp\": \"2017-07-25T14:27:30.615Z\", \"processingTimeMillis\": 766, \"recipients\": [ \"test-email@your-domain.com\" ], \"spamVerdict\": { \"status\": \"PASS\" }, \"virusVerdict\": { \"status\": \"PASS\" }, \"spfVerdict\": { \"status\": \"PASS\" }, \"dkimVerdict\": { \"status\": \"GRAY\" }, \"action\": { \"type\": \"Lambda\", \"functionArn\": \"arn:aws:lambda:us-east-1:xxxxxxxxxxxx:function:serverless-hello-world-dev-emailReceived\", \"invocationType\": \"Event\" } } } } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note, that in Lambda function, you'll not find the email content itself. However, you can find the email topic in headers and also you can use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ses.mail.messageId","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to retrieve the email file from emails folder. The link to the email file will be ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"https://s3.amazonaws.com/YOUR_NEWLY_CREATED_BUCKET_NAME/emails/{Records[0].ses.mail.messageId}","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":">Amazon SES provides you the raw, unmodified email, which is typically in Multipurpose Internet Mail Extensions (MIME) format.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you need to get attachments from the file, you need to parse it yourself with your lambda. The specification of this format can be found ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://tools.ietf.org/html/rfc2045"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"here.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to SES events'\nsort: 5\nhidden: true\n---\n::: icons\n\n# Listening to SES events\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/listen-to-ses-events)\n:::\n\n::: info\nYou will require the following AWS permissions: \n * `lambda:AddPermission`\n * `s3:CreateBucket`\n * `lambda:CreateEventSourceMapping`\n:::\n\n&nbsp;\n\n## Step 1: Create new lambda function\n\nFirst, create a lambda function that will receive notifications about received emails, `handler.js`:\n```javascript\nmodule.exports.emailReceived = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event));\n  callback(null);\n}\n```\nand `serverless.yml`:\n```yaml\nfunctions:\n  emailReceived:\n    handler: handler.emailReceived\n```\n\nNow, we need to set up AWS SES service to save the emails we receive on particular domain. Note, that you need to own a domain name or subdomain and set your [MX records](https://en.wikipedia.org/wiki/MX_record) to AWS. If you don't know what are MX records, check [Wikipedia article](https://en.wikipedia.org/wiki/MX_record) and [stackoverflow answer](https://stackoverflow.com/questions/385193/why-have-mx-records).\n\n&nbsp;\n\n## Step 2: Verify the new domain\nHead to AWS SES service and verify a new domain if you haven't verified it yet. Amazon will walk you through what records are needed to be added for your domain in Route 53.\n![new domain](/assets/listening-to-other-events_5_1.png \"new domain\")\n\n## Step 3: Create a new rule set\nIn the Rule Set section in AWS SES, Create a new Rule. Specify an email, for example test-email@your-domain.com\n![new rule](/assets/listening-to-other-events_5_2.png \"new rule\")\n\nNow, create two actions. One action should save all the new emails to S3 email bucket. You can create a new bucket for that. Second rule should invoke our newly created lambda - `emaiReceived`.\n\n![new action](/assets/listening-to-other-events_5_3.png \"new action\")\n\nIn order to test that the lambda is actually invoked, you can use [Dumptruck](/pages/build/dumptruck/).\n\nLaunch it and send some dummy email to newly created email listener. Here is the sample output of what you'll see in dumptruck:\n```json\n{\n  \"Records\": [\n    {\n      \"eventSource\": \"aws:ses\",\n      \"eventVersion\": \"1.0\",\n      \"ses\": {\n        \"mail\": {\n          \"timestamp\": \"2017-07-25T14:27:30.615Z\",\n          \"source\": \"your-personal-email@gmail.com\",\n          \"messageId\": \"xxxxxxxxxxxxxxxxxxxxxxxxx\",\n          \"destination\": [\n            \"test-email@your-domain.com\"\n          ],\n          \"headersTruncated\": false,\n          \"headers\": [\n            // email headers here\n          ],\n        },\n        \"receipt\": {\n          \"timestamp\": \"2017-07-25T14:27:30.615Z\",\n          \"processingTimeMillis\": 766,\n          \"recipients\": [\n            \"test-email@your-domain.com\"\n          ],\n          \"spamVerdict\": {\n            \"status\": \"PASS\"\n          },\n          \"virusVerdict\": {\n            \"status\": \"PASS\"\n          },\n          \"spfVerdict\": {\n            \"status\": \"PASS\"\n          },\n          \"dkimVerdict\": {\n            \"status\": \"GRAY\"\n          },\n          \"action\": {\n            \"type\": \"Lambda\",\n            \"functionArn\": \"arn:aws:lambda:us-east-1:xxxxxxxxxxxx:function:serverless-hello-world-dev-emailReceived\",\n            \"invocationType\": \"Event\"\n          }\n        }\n      }\n    }\n  ]\n}\n\n```\n Note, that in Lambda function, you'll not find the email content itself. However, you can find the email topic in headers and also you can use `ses.mail.messageId` to retrieve the email file from emails folder. The link to the email file will be `https://s3.amazonaws.com/YOUR_NEWLY_CREATED_BUCKET_NAME/emails/{Records[0].ses.mail.messageId}`\n\n >Amazon SES provides you the raw, unmodified email, which is typically in Multipurpose Internet Mail Extensions (MIME) format.\n\nIf you need to get attachments from the file, you need to parse it yourself with your lambda. The specification of this format can be found [here.](https://tools.ietf.org/html/rfc2045)\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"ListeningtoSESevents\"><a name=\"ListeningtoSESevents\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to SES events</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/listen-to-ses-events\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<div class=\"info\">\n<p>You will require the following AWS permissions:</p>\n<ul>\n<li><code>lambda:AddPermission</code></li>\n<li><code>s3:CreateBucket</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p> </p>\n<h2 id=\"Step1%3ACreatenewlambdafunction\"><a name=\"Step1%3ACreatenewlambdafunction\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 1: Create new lambda function</h2>\n<p>First, create a lambda function that will receive notifications about received emails, <code>handler.js</code>:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">emailReceived</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p>and <code>serverless.yml</code>:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">emailReceived</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.emailReceived\n</code></pre>\n<p>Now, we need to set up AWS SES service to save the emails we receive on particular domain. Note, that you need to own a domain name or subdomain and set your <a href=\"https://en.wikipedia.org/wiki/MX_record\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">MX records</a> to AWS. If you don't know what are MX records, check <a href=\"https://en.wikipedia.org/wiki/MX_record\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Wikipedia article</a> and <a href=\"https://stackoverflow.com/questions/385193/why-have-mx-records\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">stackoverflow answer</a>.</p>\n<p> </p>\n<h2 id=\"Step2%3AVerifythenewdomain\"><a name=\"Step2%3AVerifythenewdomain\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 2: Verify the new domain</h2>\n<p>Head to AWS SES service and verify a new domain if you haven't verified it yet. Amazon will walk you through what records are needed to be added for your domain in Route 53.\n<img src=\"/assets/listening-to-other-events_5_1.png\" alt=\"new domain\" title=\"new domain\"></p>\n<h2 id=\"Step3%3ACreateanewruleset\"><a name=\"Step3%3ACreateanewruleset\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Step 3: Create a new rule set</h2>\n<p>In the Rule Set section in AWS SES, Create a new Rule. Specify an email, for example test-email@your-domain.com\n<img src=\"/assets/listening-to-other-events_5_2.png\" alt=\"new rule\" title=\"new rule\"></p>\n<p>Now, create two actions. One action should save all the new emails to S3 email bucket. You can create a new bucket for that. Second rule should invoke our newly created lambda - <code>emaiReceived</code>.</p>\n<p><img src=\"/assets/listening-to-other-events_5_3.png\" alt=\"new action\" title=\"new action\"></p>\n<p>In order to test that the lambda is actually invoked, you can use <a href=\"/pages/build/dumptruck/\" class=\"absolute-link\">Dumptruck</a>.</p>\n<p>Launch it and send some dummy email to newly created email listener. Here is the sample output of what you'll see in dumptruck:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"Records\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n    <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"eventSource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws:ses\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"eventVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.0\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"ses\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"mail\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n          <span class=\"token property\">\"timestamp\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-07-25T14:27:30.615Z\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"source\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"your-personal-email@gmail.com\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"messageId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxxxxxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"destination\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n            <span class=\"token string\">\"test-email@your-domain.com\"</span>\n          <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"headersTruncated\"</span><span class=\"token operator\">:</span> <span class=\"token boolean\">false</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"headers\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n            // email headers here\n          <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n        <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n        <span class=\"token property\">\"receipt\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n          <span class=\"token property\">\"timestamp\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-07-25T14:27:30.615Z\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"processingTimeMillis\"</span><span class=\"token operator\">:</span> <span class=\"token number\">766</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"recipients\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n            <span class=\"token string\">\"test-email@your-domain.com\"</span>\n          <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"spamVerdict\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"status\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"PASS\"</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"virusVerdict\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"status\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"PASS\"</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"spfVerdict\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"status\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"PASS\"</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"dkimVerdict\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"status\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"GRAY\"</span>\n          <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"action\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Lambda\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"functionArn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:lambda:us-east-1:xxxxxxxxxxxx:function:serverless-hello-world-dev-emailReceived\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"invocationType\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Event\"</span>\n          <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">}</span>\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n\n</code></pre>\n<p>Note, that in Lambda function, you'll not find the email content itself. However, you can find the email topic in headers and also you can use <code>ses.mail.messageId</code> to retrieve the email file from emails folder. The link to the email file will be <code>https://s3.amazonaws.com/YOUR_NEWLY_CREATED_BUCKET_NAME/emails/{Records[0].ses.mail.messageId}</code></p>\n<blockquote>\n<p>Amazon SES provides you the raw, unmodified email, which is typically in Multipurpose Internet Mail Extensions (MIME) format.</p>\n</blockquote>\n<p>If you need to get attachments from the file, you need to parse it yourself with your lambda. The specification of this format can be found <a href=\"https://tools.ietf.org/html/rfc2045\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">here.</a></p>\n"}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vbGlzdGVuaW5nLXRvLXNucy1ldmVudHMubWQ","filename":"/content/pages/learn/listening-to-sns-events.md","suffix":"","attributes":{"title":"Listening to SNS events","sort":5,"hidden":true,"description":"Listening to AWS SNS Message events using serverless"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Listening to SNS events'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 5","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"hidden: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Listening to AWS SNS Message events using serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Listening to SNS events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/sls-zone-examples"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-npm-small.png"],["alt",""],["title","npm"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You will require the following AWS permissions:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sns:Publish","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sns:CreateTopic","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sns:sns:SetTopicAttributes","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"lambda:CreateEventSourceMapping","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Create a lambda function configuration that will listen to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"customSNSTopic","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: customSnsListener: handler: handler.customSnsListener events: - sns: customSNSTopic","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's create a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.customSnsListener = (event, context, callback) => { console.log('EVENT', JSON.stringify(event)), callback(null); }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"After deploying, you can retrieve the SNS Topic ARN that was generated. The output of ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless deploy -v","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" will contain the string","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"CustomSnsListenerLambdaFunctionQualifiedArn: arn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:sns-event-handler-dev-customSnsListener:1","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"where ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"xxxxxxxxxxxx","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" - is aws account id. Just use it to generate the SNS topic id: ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSNSTopic","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you can publish something to this topic using aws cli:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"shell aws sns publish --topic-arn arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener --subject test --message \"this is a string message\"","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You should get a response, similar to:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"MessageId\": \"xxx\" }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, if you check logs of the lambda function, you'll see that we successfully invoked the event:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"json { \"Records\": [ { \"EventSource\": \"aws:sns\", \"EventVersion\": \"1.0\", \"EventSubscriptionArn\": \"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener:81d84698-6385-4845-9650-39ab67cc2c9f\", \"Sns\": { \"Type\": \"Notification\", \"MessageId\": \"xxxxxxxxxxxx\", \"TopicArn\": \"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener\", \"Subject\": \"test\", \"Message\": \"this is a string message\", \"Timestamp\": \"2018-06-05T11:34:53.797Z\", \"SignatureVersion\": \"1\", \"Signature\": \"xxxxxxxxxxxx\", \"SigningCertUrl\": \"xxxxxxxxxxxx\", \"UnsubscribeUrl\": \"xxxxxxxxxxxx\", \"MessageAttributes\": {} } } ] }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://docs.aws.amazon.com/sns/latest/dg/sns-lambda.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"SNS Lambda","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/events/sns/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless SNS Events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Listening to SNS events'\nsort: 5\nhidden: true\ndescription: 'Listening to AWS SNS Message events using serverless'\n---\n::: icons\n\n# Listening to SNS events\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples)\n[![alt text](/images/logo-npm-small.png \"npm\")](https://www.npmjs.com/package/sls-zone-examples)\n:::\n\n::: info\nYou will require the following AWS permissions: \n * `sns:Publish`\n * `sns:CreateTopic`\n * `sns:sns:SetTopicAttributes`\n * `lambda:CreateEventSourceMapping`\n:::\n\n&nbsp;\n\nCreate a lambda function configuration that will listen to `customSNSTopic`.\n\n```yaml\nfunctions:\n  customSnsListener:\n    handler: handler.customSnsListener\n    events:\n      - sns: customSNSTopic\n```\n\nLet's create a `handler.js` file.\n\n```javascript\nmodule.exports.customSnsListener = (event, context, callback) => {\n  console.log('EVENT', JSON.stringify(event)),\n  callback(null);\n}\n```\n\n&nbsp;\n\nAfter deploying, you can retrieve the SNS Topic ARN that was generated. The output of `serverless deploy -v` will contain the string\n```\nCustomSnsListenerLambdaFunctionQualifiedArn: arn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:sns-event-handler-dev-customSnsListener:1\n```\nwhere `xxxxxxxxxxxx` - is aws account id. Just use it to generate the SNS topic id: `arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSNSTopic`.\n\nNow, you can publish something to this topic using aws cli:\n```shell\naws sns publish --topic-arn arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener --subject test --message \"this is a string message\"\n```\n\nYou should get a response, similar to:\n```json\n{\n    \"MessageId\": \"xxx\"\n}\n```\n\n&nbsp;\n\nNow, if you check logs of the lambda function, you'll see that we successfully invoked the event:\n```json\n{\n    \"Records\": [\n        {\n            \"EventSource\": \"aws:sns\",\n            \"EventVersion\": \"1.0\",\n            \"EventSubscriptionArn\": \"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener:81d84698-6385-4845-9650-39ab67cc2c9f\",\n            \"Sns\": {\n                \"Type\": \"Notification\",\n                \"MessageId\": \"xxxxxxxxxxxx\",\n                \"TopicArn\": \"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener\",\n                \"Subject\": \"test\",\n                \"Message\": \"this is a string message\",\n                \"Timestamp\": \"2018-06-05T11:34:53.797Z\",\n                \"SignatureVersion\": \"1\",\n                \"Signature\": \"xxxxxxxxxxxx\",\n                \"SigningCertUrl\": \"xxxxxxxxxxxx\",\n                \"UnsubscribeUrl\": \"xxxxxxxxxxxx\",\n                \"MessageAttributes\": {}\n            }\n        }\n    ]\n}\n```\n\n::: links\nFurther reading:\n\n* [SNS Lambda](https://docs.aws.amazon.com/sns/latest/dg/sns-lambda.html)\n* [Serverless SNS Events](https://serverless.com/framework/docs/providers/aws/events/sns/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"ListeningtoSNSevents\"><a name=\"ListeningtoSNSevents\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Listening to SNS events</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a>\n<a href=\"https://www.npmjs.com/package/sls-zone-examples\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-npm-small.png\" alt=\"alt text\" title=\"npm\"></a></p>\n</div>\n<div class=\"info\">\n<p>You will require the following AWS permissions:</p>\n<ul>\n<li><code>sns:Publish</code></li>\n<li><code>sns:CreateTopic</code></li>\n<li><code>sns:sns:SetTopicAttributes</code></li>\n<li><code>lambda:CreateEventSourceMapping</code></li>\n</ul>\n</div>\n<p> </p>\n<p>Create a lambda function configuration that will listen to <code>customSNSTopic</code>.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">customSnsListener</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.customSnsListener\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">sns</span><span class=\"token punctuation\">:</span> customSNSTopic\n</code></pre>\n<p>Let's create a <code>handler.js</code> file.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">customSnsListener</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'EVENT'</span><span class=\"token punctuation\">,</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>After deploying, you can retrieve the SNS Topic ARN that was generated. The output of <code>serverless deploy -v</code> will contain the string</p>\n<pre><code>CustomSnsListenerLambdaFunctionQualifiedArn: arn:aws:lambda:eu-west-1:xxxxxxxxxxxx:function:sns-event-handler-dev-customSnsListener:1\n</code></pre>\n<p>where <code>xxxxxxxxxxxx</code> - is aws account id. Just use it to generate the SNS topic id: <code>arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSNSTopic</code>.</p>\n<p>Now, you can publish something to this topic using aws cli:</p>\n<pre class=\"language-shell\"><code class=\"language-shell\">aws sns publish --topic-arn arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener --subject <span class=\"token function\">test</span> --message <span class=\"token string\">\"this is a string message\"</span>\n</code></pre>\n<p>You should get a response, similar to:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"MessageId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxx\"</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>Now, if you check logs of the lambda function, you'll see that we successfully invoked the event:</p>\n<pre class=\"language-json\"><code class=\"language-json\"><span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"Records\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"EventSource\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"aws:sns\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"EventVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1.0\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"EventSubscriptionArn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener:81d84698-6385-4845-9650-39ab67cc2c9f\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"Sns\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                <span class=\"token property\">\"Type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Notification\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"MessageId\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"TopicArn\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"arn:aws:sns:eu-west-1:xxxxxxxxxxxx:customSnsListener\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Subject\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"test\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Message\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"this is a string message\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Timestamp\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2018-06-05T11:34:53.797Z\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SignatureVersion\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"1\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"Signature\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"SigningCertUrl\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"UnsubscribeUrl\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"xxxxxxxxxxxx\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token property\">\"MessageAttributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span>\n            <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://docs.aws.amazon.com/sns/latest/dg/sns-lambda.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">SNS Lambda</a></li>\n<li><a href=\"https://serverless.com/framework/docs/providers/aws/events/sns/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless SNS Events</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vdGVzdGluZy13aXRoLXNlcnZlcmxlc3MubWQ","filename":"/content/pages/learn/testing-with-serverless.md","suffix":"","attributes":{"title":"Testing in serverless","sort":2,"description":"Creating a simplest test case for serverless using mocha"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Testing in serverless'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 2","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Creating a simplest test case for serverless using mocha'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Testing in serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/testing"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Creating a simplest test case for serverless using mocha","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First, create a new project and generate a new ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"package.json","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file for it, running the following commands:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash mkdir testing cd testing npm init","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Install dependencies needed for the project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install -D serverless-offline serverless-mocha-plugin","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Create a function that will multiply two numbers and include it in a file called ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"logic.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.multiplyNumbers = (x, y) => { return x * y; }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Create a handler function that will multiply two numbers and include it in a file called ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"handler.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript const logic = require('./logic'); module.exports.multiplyNumbersForTest = (event, context, callback) => { // event.body will be set in case of post request and event will be set in case of payload passed by other lambda const vars = event.query || event; const response = { statusCode: 200, headers: { 'Access-Control-Allow-Origin': '*', // Required for CORS support to work }, body: JSON.stringify({ result: logic.multiplyNumbers(vars.x, vars.y) || 0, input: event, }), }; callback(null, response); };","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We intentionally separated logic from the actual lambda handler as this allows you to create both unit tests for business logic and integration tests on actual lambda functions.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In this tutorial, we are gonna use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless-mocha-plugin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to create and run serverless tests.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's create a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless.yml","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: testing provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev plugins: - serverless-offline - serverless-mocha-plugin functions: multiplyNumbersForTest: handler: handler.multiplyNumbersForTest events: - http: integration: lambda path: multiply-number-for-test method: get cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, if you run ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" you should see three additional commands available from the serverless-mocha-plugin - ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"create test","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"create function","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"invoke test","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Let's create a test for our ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumbersForTest","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" function. Simply run:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash sls create test --function multiplyNumbersForTest","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will create  ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"multiplyNumbersForTest.js","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" file in ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"test","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" folder.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you can try to run an empty with with ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sls invoke test","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" command. Tests should pass.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, we need to write the actual test. Add this test instead of generated test:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript it('should fail if the result is wrong', () => { const x = 4234; const y = 4334; const result = 18350156; return wrapped.run({ query: { x, y } }).then((response) => { expect(response).to.not.be.empty; expect(response.body).to.not.be.empty; expect(JSON.parse(response.body).result).to.be.eql(result); }); });","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note that we use pre-calculated values to assert if our lambda calculates it correctly. The test we just wrote is an e2e test that tests the \"contract\" between the front-end and our lambda. The object that is passed in ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"wrapper.run","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is essentially our ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"event","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" that we access in lambda. The approach that is taken by ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless-mocha-plugin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is to invoke the exported lambda directly in the code. It doesn't do the actual HTTP request to our lambda. It is reasonable approach as not all lambdas listen to HTTP events. There are many ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-other-events-non-http/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"other events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" the lambda can listen to.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Note the mocha ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"before","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" in the test file. You can connect to database, Redis or any other private datasource there. In case you would like to share the connection between different files, you can use ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"beforeAll","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" handler to open the connection and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"afterAll","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to close the connection.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Best practices","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Above you could see a simple example on how to create the simplest test that will make sure our lambdas work as expected. In real projects, unless you are the God-mode programmer, you have to write hundreds of tests and follow certain best practices for your code to be reliable and maintainable.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In Reason, we try to follow these principles:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_open","tag":"em","attrs":null,"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Write integration end-to-end tests","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_close","tag":"em","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to test the \"contracts\" between front-end and backend. One could argue that integration tests by itself cannot be reliable indicator that the code wouldn't break. We agree with that completely. However, it allows us to be confident that the front-end that relies on lambda APIs or any other components of the cloud ecosystem that use lambdas will not break after new updates to the business logic inside any of the lambdas.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The main problems with integration tests:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- they can be quite time consuming if the piece of logic your are testing is big.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- as e2e tests test the function as a black box, it's hard or impossible to inject mock modules (for example modules accessing database, providing logic from other functions)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Therefore, the next principle:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_open","tag":"em","attrs":null,"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Write unit tests","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"em_close","tag":"em","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"*","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" for whatever cannot be covered with integration tests. You should break your logic into smaller pieces that can be easily tested separately.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In the ideal scenario of unlimited resources one would write both integration and unit test with 100% coverage. For real-world projects under heavy time constraints it might be reasonable to balance between integration and unit tests.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"What makes AWS Lambda special compared to traditional node.js development is that you can't simulate the exact AWS Lambda environment on your local machine. Good thing about Serverless framework is that in most cases you can deploy the copy of your Lambda stack to another account and just launch tests in the cloud.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Discussions","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### HTTP e2e tests versus module.exports invocation tests","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"For some of the projects where most lambdas are HTTP based, instead of using ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless-mocha-plugin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", you can just write tests that invoke lambdas using HTTP protocol (for example with ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"request","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" library). In that case, you can be sure that if you ever decide to migrate logic in your lambdas to an express server on EC2 or to a private to VPS due-to cost reasons or regulators requirements, you can just change the configuration of the endpoint in tests and it will just work. With module.exports invocation testing style like in the example above, you are bound to the lambda stack and will have to rewrite code in case you migrate.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"### Why it is a good idea to abstract the logic from actual lambda handlers","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"First of all, it is easier to unit test separate parts of the logic in that way. Secondly, the logic can be re-used in other services. Third, the service endpoints can be changed at any time using the same logic. Imagine, in version 1.0 of API you had all the endpoint ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"/orderAdd","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"orderEdit","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"orderComplete","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". In case you separate the logic, you can easily migrate to API version 2.0 with ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"order/add","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"order/edit","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"order/complete","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" endpoints.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/blogs/compute/serverless-testing-with-aws-lambda/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless testing with aws lambda","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Testing in serverless'\nsort: 2\ndescription: 'Creating a simplest test case for serverless using mocha'\n---\n::: icons\n\n# Testing in serverless\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/testing)\n:::\n\n## Creating a simplest test case for serverless using mocha\n\nFirst, create a new project and generate a new `package.json` file for it, running the following commands:\n\n```bash\nmkdir testing\ncd testing\nnpm init\n```\n\n&nbsp;\n\n&nbsp;\n\nInstall dependencies needed for the project.\n\n```bash\nnpm install -D serverless-offline serverless-mocha-plugin\n```\n\n&nbsp;\n\nCreate a function that will multiply two numbers and include it in a file called `logic.js`.\n\n\n```javascript\nmodule.exports.multiplyNumbers = (x, y) => {\n  return x * y;\n}\n```\n\n&nbsp;\n\nCreate a handler function that will multiply two numbers and include it in a file called `handler.js`.\n\n```javascript\nconst logic = require('./logic');\n\nmodule.exports.multiplyNumbersForTest = (event, context, callback) => {\n  // event.body will be set in case of post request and event will be set in case of payload passed by other lambda\n  const vars = event.query || event;\n  const response = {\n    statusCode: 200,\n    headers: {\n      'Access-Control-Allow-Origin': '*', // Required for CORS support to work\n    },\n    body: JSON.stringify({\n      result: logic.multiplyNumbers(vars.x, vars.y) || 0,\n      input: event,\n    }),\n  };\n\n  callback(null, response);\n};\n```\n\nWe intentionally separated logic from the actual lambda handler as this allows you to create both unit tests for business logic and integration tests on actual lambda functions.\n\nIn this tutorial, we are gonna use `serverless-mocha-plugin` to create and run serverless tests.\n\n&nbsp;\n\nLet's create a `serverless.yml` file.\n\n```yaml\nservice: testing\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n\nplugins:\n  - serverless-offline\n  - serverless-mocha-plugin\n\nfunctions:\n  multiplyNumbersForTest:\n    handler: handler.multiplyNumbersForTest\n    events:\n      - http:\n          integration: lambda\n          path: multiply-number-for-test\n          method: get\n          cors: true\n```\n\nNow, if you run `serverless` you should see three additional commands available from the serverless-mocha-plugin - `create test`, `create function` and `invoke test`. \n\n&nbsp;\n\nLet's create a test for our `multiplyNumbersForTest` function. Simply run:\n\n```bash\nsls create test --function multiplyNumbersForTest\n```\n\nThis will create  `multiplyNumbersForTest.js` file in `test` folder.\nNow, you can try to run an empty with with `sls invoke test` command. Tests should pass.\n\n&nbsp;\n\nNow, we need to write the actual test. Add this test instead of generated test:\n\n```javascript\nit('should fail if the result is wrong', () => {\n  const x = 4234;\n  const y = 4334;\n  const result = 18350156;\n  return wrapped.run({\n    query: { x, y }\n  }).then((response) => {\n    expect(response).to.not.be.empty;\n    expect(response.body).to.not.be.empty;\n    expect(JSON.parse(response.body).result).to.be.eql(result);\n  });\n});\n```\n\nNote that we use pre-calculated values to assert if our lambda calculates it correctly. The test we just wrote is an e2e test that tests the \"contract\" between the front-end and our lambda. The object that is passed in `wrapper.run` is essentially our `event` that we access in lambda. The approach that is taken by `serverless-mocha-plugin` is to invoke the exported lambda directly in the code. It doesn't do the actual HTTP request to our lambda. It is reasonable approach as not all lambdas listen to HTTP events. There are many [other events](/pages/learn/listening-to-other-events-non-http/) the lambda can listen to.\n\nNote the mocha `before` in the test file. You can connect to database, Redis or any other private datasource there. In case you would like to share the connection between different files, you can use `beforeAll` handler to open the connection and `afterAll` to close the connection.\n\n&nbsp;\n\n## Best practices\n\nAbove you could see a simple example on how to create the simplest test that will make sure our lambdas work as expected. In real projects, unless you are the God-mode programmer, you have to write hundreds of tests and follow certain best practices for your code to be reliable and maintainable.\nIn Reason, we try to follow these principles:\n\n*Write integration end-to-end tests* to test the \"contracts\" between front-end and backend. One could argue that integration tests by itself cannot be reliable indicator that the code wouldn't break. We agree with that completely. However, it allows us to be confident that the front-end that relies on lambda APIs or any other components of the cloud ecosystem that use lambdas will not break after new updates to the business logic inside any of the lambdas.\nThe main problems with integration tests:\n\n- they can be quite time consuming if the piece of logic your are testing is big.\n- as e2e tests test the function as a black box, it's hard or impossible to inject mock modules (for example modules accessing database, providing logic from other functions)\n\n&nbsp;\n\nTherefore, the next principle:\n\n*Write unit tests* for whatever cannot be covered with integration tests. You should break your logic into smaller pieces that can be easily tested separately.\n\n&nbsp;\n\nIn the ideal scenario of unlimited resources one would write both integration and unit test with 100% coverage. For real-world projects under heavy time constraints it might be reasonable to balance between integration and unit tests.\n\nWhat makes AWS Lambda special compared to traditional node.js development is that you can't simulate the exact AWS Lambda environment on your local machine. Good thing about Serverless framework is that in most cases you can deploy the copy of your Lambda stack to another account and just launch tests in the cloud.\n\n&nbsp;\n\n## Discussions\n\n### HTTP e2e tests versus module.exports invocation tests\n\nFor some of the projects where most lambdas are HTTP based, instead of using `serverless-mocha-plugin`, you can just write tests that invoke lambdas using HTTP protocol (for example with `request` library). In that case, you can be sure that if you ever decide to migrate logic in your lambdas to an express server on EC2 or to a private to VPS due-to cost reasons or regulators requirements, you can just change the configuration of the endpoint in tests and it will just work. With module.exports invocation testing style like in the example above, you are bound to the lambda stack and will have to rewrite code in case you migrate.\n\n### Why it is a good idea to abstract the logic from actual lambda handlers\n\nFirst of all, it is easier to unit test separate parts of the logic in that way. Secondly, the logic can be re-used in other services. Third, the service endpoints can be changed at any time using the same logic. Imagine, in version 1.0 of API you had all the endpoint `/orderAdd`, `orderEdit` and `orderComplete`. In case you separate the logic, you can easily migrate to API version 2.0 with `order/add`, `order/edit` and `order/complete` endpoints.\n\n::: links\nFurther reading:\n\n- [Serverless testing with aws lambda](https://aws.amazon.com/blogs/compute/serverless-testing-with-aws-lambda/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"Testinginserverless\"><a name=\"Testinginserverless\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Testing in serverless</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/testing\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<h2 id=\"Creatingasimplesttestcaseforserverlessusingmocha\"><a name=\"Creatingasimplesttestcaseforserverlessusingmocha\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Creating a simplest test case for serverless using mocha</h2>\n<p>First, create a new project and generate a new <code>package.json</code> file for it, running the following commands:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">mkdir</span> testing\n<span class=\"token function\">cd</span> testing\n<span class=\"token function\">npm</span> init\n</code></pre>\n<p> </p>\n<p> </p>\n<p>Install dependencies needed for the project.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> -D serverless-offline serverless-mocha-plugin\n</code></pre>\n<p> </p>\n<p>Create a function that will multiply two numbers and include it in a file called <code>logic.js</code>.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">multiplyNumbers</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>x<span class=\"token punctuation\">,</span> y<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">return</span> x <span class=\"token operator\">*</span> y<span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<p>Create a handler function that will multiply two numbers and include it in a file called <code>handler.js</code>.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token keyword\">const</span> logic <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'./logic'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nmodule<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">multiplyNumbersForTest</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> callback<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token comment\">// event.body will be set in case of post request and event will be set in case of payload passed by other lambda</span>\n  <span class=\"token keyword\">const</span> vars <span class=\"token operator\">=</span> event<span class=\"token punctuation\">.</span>query <span class=\"token operator\">||</span> event<span class=\"token punctuation\">;</span>\n  <span class=\"token keyword\">const</span> response <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    statusCode<span class=\"token punctuation\">:</span> <span class=\"token number\">200</span><span class=\"token punctuation\">,</span>\n    headers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token string\">'Access-Control-Allow-Origin'</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'*'</span><span class=\"token punctuation\">,</span> <span class=\"token comment\">// Required for CORS support to work</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    body<span class=\"token punctuation\">:</span> <span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">stringify</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n      result<span class=\"token punctuation\">:</span> logic<span class=\"token punctuation\">.</span><span class=\"token function\">multiplyNumbers</span><span class=\"token punctuation\">(</span>vars<span class=\"token punctuation\">.</span>x<span class=\"token punctuation\">,</span> vars<span class=\"token punctuation\">.</span>y<span class=\"token punctuation\">)</span> <span class=\"token operator\">||</span> <span class=\"token number\">0</span><span class=\"token punctuation\">,</span>\n      input<span class=\"token punctuation\">:</span> event<span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n\n  <span class=\"token function\">callback</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">,</span> response<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>We intentionally separated logic from the actual lambda handler as this allows you to create both unit tests for business logic and integration tests on actual lambda functions.</p>\n<p>In this tutorial, we are gonna use <code>serverless-mocha-plugin</code> to create and run serverless tests.</p>\n<p> </p>\n<p>Let's create a <code>serverless.yml</code> file.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> testing\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n\n<span class=\"token key atrule\">plugins</span><span class=\"token punctuation\">:</span>\n  <span class=\"token punctuation\">-</span> serverless<span class=\"token punctuation\">-</span>offline\n  <span class=\"token punctuation\">-</span> serverless<span class=\"token punctuation\">-</span>mocha<span class=\"token punctuation\">-</span>plugin\n\n<span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">multiplyNumbersForTest</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.multiplyNumbersForTest\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">integration</span><span class=\"token punctuation\">:</span> lambda\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> multiply<span class=\"token punctuation\">-</span>number<span class=\"token punctuation\">-</span>for<span class=\"token punctuation\">-</span>test\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p>Now, if you run <code>serverless</code> you should see three additional commands available from the serverless-mocha-plugin - <code>create test</code>, <code>create function</code> and <code>invoke test</code>.</p>\n<p> </p>\n<p>Let's create a test for our <code>multiplyNumbersForTest</code> function. Simply run:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">sls create <span class=\"token function\">test</span> --function multiplyNumbersForTest\n</code></pre>\n<p>This will create  <code>multiplyNumbersForTest.js</code> file in <code>test</code> folder.\nNow, you can try to run an empty with with <code>sls invoke test</code> command. Tests should pass.</p>\n<p> </p>\n<p>Now, we need to write the actual test. Add this test instead of generated test:</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\"><span class=\"token function\">it</span><span class=\"token punctuation\">(</span><span class=\"token string\">'should fail if the result is wrong'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> x <span class=\"token operator\">=</span> <span class=\"token number\">4234</span><span class=\"token punctuation\">;</span>\n  <span class=\"token keyword\">const</span> y <span class=\"token operator\">=</span> <span class=\"token number\">4334</span><span class=\"token punctuation\">;</span>\n  <span class=\"token keyword\">const</span> result <span class=\"token operator\">=</span> <span class=\"token number\">18350156</span><span class=\"token punctuation\">;</span>\n  <span class=\"token keyword\">return</span> wrapped<span class=\"token punctuation\">.</span><span class=\"token function\">run</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n    query<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> x<span class=\"token punctuation\">,</span> y <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">then</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n    <span class=\"token function\">expect</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>to<span class=\"token punctuation\">.</span>not<span class=\"token punctuation\">.</span>be<span class=\"token punctuation\">.</span>empty<span class=\"token punctuation\">;</span>\n    <span class=\"token function\">expect</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>to<span class=\"token punctuation\">.</span>not<span class=\"token punctuation\">.</span>be<span class=\"token punctuation\">.</span>empty<span class=\"token punctuation\">;</span>\n    <span class=\"token function\">expect</span><span class=\"token punctuation\">(</span><span class=\"token constant\">JSON</span><span class=\"token punctuation\">.</span><span class=\"token function\">parse</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">.</span>body<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>result<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>to<span class=\"token punctuation\">.</span>be<span class=\"token punctuation\">.</span><span class=\"token function\">eql</span><span class=\"token punctuation\">(</span>result<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n</code></pre>\n<p>Note that we use pre-calculated values to assert if our lambda calculates it correctly. The test we just wrote is an e2e test that tests the &quot;contract&quot; between the front-end and our lambda. The object that is passed in <code>wrapper.run</code> is essentially our <code>event</code> that we access in lambda. The approach that is taken by <code>serverless-mocha-plugin</code> is to invoke the exported lambda directly in the code. It doesn't do the actual HTTP request to our lambda. It is reasonable approach as not all lambdas listen to HTTP events. There are many <a href=\"/pages/learn/listening-to-other-events-non-http/\" class=\"absolute-link\">other events</a> the lambda can listen to.</p>\n<p>Note the mocha <code>before</code> in the test file. You can connect to database, Redis or any other private datasource there. In case you would like to share the connection between different files, you can use <code>beforeAll</code> handler to open the connection and <code>afterAll</code> to close the connection.</p>\n<p> </p>\n<h2 id=\"Bestpractices\"><a name=\"Bestpractices\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Best practices</h2>\n<p>Above you could see a simple example on how to create the simplest test that will make sure our lambdas work as expected. In real projects, unless you are the God-mode programmer, you have to write hundreds of tests and follow certain best practices for your code to be reliable and maintainable.\nIn Reason, we try to follow these principles:</p>\n<p><em>Write integration end-to-end tests</em> to test the &quot;contracts&quot; between front-end and backend. One could argue that integration tests by itself cannot be reliable indicator that the code wouldn't break. We agree with that completely. However, it allows us to be confident that the front-end that relies on lambda APIs or any other components of the cloud ecosystem that use lambdas will not break after new updates to the business logic inside any of the lambdas.\nThe main problems with integration tests:</p>\n<ul>\n<li>they can be quite time consuming if the piece of logic your are testing is big.</li>\n<li>as e2e tests test the function as a black box, it's hard or impossible to inject mock modules (for example modules accessing database, providing logic from other functions)</li>\n</ul>\n<p> </p>\n<p>Therefore, the next principle:</p>\n<p><em>Write unit tests</em> for whatever cannot be covered with integration tests. You should break your logic into smaller pieces that can be easily tested separately.</p>\n<p> </p>\n<p>In the ideal scenario of unlimited resources one would write both integration and unit test with 100% coverage. For real-world projects under heavy time constraints it might be reasonable to balance between integration and unit tests.</p>\n<p>What makes AWS Lambda special compared to traditional node.js development is that you can't simulate the exact AWS Lambda environment on your local machine. Good thing about Serverless framework is that in most cases you can deploy the copy of your Lambda stack to another account and just launch tests in the cloud.</p>\n<p> </p>\n<h2 id=\"Discussions\"><a name=\"Discussions\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Discussions</h2>\n<h3 id=\"HTTPe2etestsversusmodule.exportsinvocationtests\"><a name=\"HTTPe2etestsversusmodule.exportsinvocationtests\" class=\"markdown-it-headinganchor\" href=\"#\"></a>HTTP e2e tests versus module.exports invocation tests</h3>\n<p>For some of the projects where most lambdas are HTTP based, instead of using <code>serverless-mocha-plugin</code>, you can just write tests that invoke lambdas using HTTP protocol (for example with <code>request</code> library). In that case, you can be sure that if you ever decide to migrate logic in your lambdas to an express server on EC2 or to a private to VPS due-to cost reasons or regulators requirements, you can just change the configuration of the endpoint in tests and it will just work. With module.exports invocation testing style like in the example above, you are bound to the lambda stack and will have to rewrite code in case you migrate.</p>\n<h3 id=\"Whyitisagoodideatoabstractthelogicfromactuallambdahandlers\"><a name=\"Whyitisagoodideatoabstractthelogicfromactuallambdahandlers\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Why it is a good idea to abstract the logic from actual lambda handlers</h3>\n<p>First of all, it is easier to unit test separate parts of the logic in that way. Secondly, the logic can be re-used in other services. Third, the service endpoints can be changed at any time using the same logic. Imagine, in version 1.0 of API you had all the endpoint <code>/orderAdd</code>, <code>orderEdit</code> and <code>orderComplete</code>. In case you separate the logic, you can easily migrate to API version 2.0 with <code>order/add</code>, <code>order/edit</code> and <code>order/complete</code> endpoints.</p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://aws.amazon.com/blogs/compute/serverless-testing-with-aws-lambda/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless testing with aws lambda</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbGVhcm4vd2hlcmUtYXJlLW15LWxvZ3MubWQ","filename":"/content/pages/learn/where-are-my-logs.md","suffix":"","attributes":{"title":"Where are my logs?","sort":3,"description":"Where are my logs? There are multiple ways to view the logs for Serverless functions.","video":"LhnTYoz6GiE","timecode":[{"start":6,"end":24,"anchor":"Wherearemylogs%3F"},{"start":24,"end":70,"anchor":"Gettingaprojectsetup"},{"start":70,"end":192,"anchor":"LocalLogging"},{"start":192,"end":235,"anchor":"OnlineLogsviaCloudwatch"},{"start":235,"end":381,"anchor":"UsingDumptruckCLI"},{"start":381,"end":527,"anchor":"UsingServerlessCLItoviewCloudWatchlogs"},{"start":527,"end":720,"anchor":"UsingtheAWSCloudWatchUI"}],"tags":["new"]},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Where are my logs?\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 3","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'Where are my logs? There are multiple ways to view the logs for Serverless functions.'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"video: 'LhnTYoz6GiE'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"timecode:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 6","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 24","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'Wherearemylogs%3F'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 24","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 70","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'Gettingaprojectsetup'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 70","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 192","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'LocalLogging'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 192","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 235","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'OnlineLogsviaCloudwatch'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 235","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 381","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'UsingDumptruckCLI'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 381","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 527","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'UsingServerlessCLItoviewCloudWatchlogs'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"start: 527","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"end: 720","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"anchor: 'UsingtheAWSCloudWatchUI'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"hardbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"tags:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- new","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Where are my logs?","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This Tutorial includes a follow along video, on Desktop you can click \"Play and Follow Video\" to be guided through the article as the video progresses.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"hardbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Getting a project setup","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To start logging, you will need a project to log against, this tutorial will cover","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"logging a ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/slspress-simple-example/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"basic slspress","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" application in an development environment using the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/developing-locally-with-serverless-offline/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"serverless offline","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" plugin.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We will then deploy the application, and view online logs.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"hardbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Local Logging","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you have your serverless project created, and have installed the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/developing-locally-with-serverless-offline/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"serverless offline","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" plugin, you can start your service using the command:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"serverless offline","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once this has launched, you should be presented with a summary of endpoints and shown what port your service is running on (the default is ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"http://localhost:3000","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":").","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you hit your endpoint with the relevant request type, you will be presented with logs that show the request information and a stringified version of your response body.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Online Logs via Cloudwatch","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There are many methods for viewing cloudwatch logs, the ones we have covered here are; using ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/dumptruck/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Dumptruck","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/cli-reference/logs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless CLI","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://aws.amazon.com/cloudwatch"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS Cloudwatch","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" web console.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If it takes a while for events to show in Cloudwatch (or CLI tool) - don't worry, this is normal.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You usually won't see the full event information show up in Cloudwatch until the event completion has been given some time process.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"hardbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"> If you plan on logging any debug payloads, ensure you stringify any JSON payloads otherwise you will see ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"[object object]","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Using Dumptruck CLI","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Dumptruck is one of the utilities we've created for log management.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"For more information, please check the following ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/dumptruck"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"link.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you don't already have it installed you can run ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"npm install -g dumptruck","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to install it.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Dumptruck will scan your AWS CLI config, and any local serverless project to pick the best config for collecting logs, and can be run on any machine with the correct AWS credentials and does not have to in the context of a Serverless project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"To run dumptruck simply invoke it with the following command.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash dumptruck","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will guide you through choosing an AWS profile, Region and then Lambda. These are pre selected by most recently used, and Lambdas are sorted by most recently updated.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once connected it will poll the Cloudwatch log group and bring in the events as they come in.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Once you close the log stream (","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"ctrl+C","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":") you will be given the arguments to allow you to directly invoke the same log tail in the future, e.g:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"dumptruck -p \"default\" -r \"eu-west-1\" -l \"lamdba-name\"","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Using Serverless CLI to view CloudWatch logs","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"When in a serverless project folder, you can use the Serverless CLI to call the logs for your existing project.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless logs -f <func-name>","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Where the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"<func-name>","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" is the name of the Lambda function you are looking for.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Additionally, you can use the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"--tail","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" flag (or ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"-t","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" for short) to stream the logs automatically to your console.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless logs --function <func-name> --tail ## or serverless logs -f <func-name> -t","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"We recommend you doing that on a different terminal window to keep an 'auto-refreshed' log.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Full ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://serverless.com/framework/docs/providers/aws/cli-reference/logs/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"documentation","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" can be found on the serverless website.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"One thing to keep in mind when using the Serverless CLI logging tool, is that you need to be in a serverless project folder to run it.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Using the AWS CloudWatch UI","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"1. In your AWS console, Navigate to CloudWatch -> Logs.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"2. Type the name of your function in the filter box. Useful if you have multiple logs.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"3. Click on the Log Group that matches your function name.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"4. Click on \"Search Log Group\" to view all the logs associated with that group.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"When you open a log stream, these logs are shown in the row view and you may find it easier to read these by clicking on the \"text\" checkbox to show all event data on a single view.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"> If you have a very active log stream, the events may not always populate into the expected log streams seen in step 3 above, so it's always a good idea to use the \"Search Log Group\" option than apply the required filters.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you want bind actions to these Cloudwatch events you trigger a Lambda from Cloudwatch, more information is in our ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-cloudwatch-events/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Listening to CloudWatch events","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" tutorial with examples.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"hardbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Where are my logs?\"\nsort: 3\ndescription: 'Where are my logs? There are multiple ways to view the logs for Serverless functions.'\nvideo: 'LhnTYoz6GiE'\ntimecode:\n  -\n    start: 6\n    end: 24\n    anchor: 'Wherearemylogs%3F'\n  -\n    start: 24\n    end: 70\n    anchor: 'Gettingaprojectsetup'\n  -\n    start: 70\n    end: 192\n    anchor: 'LocalLogging'\n  -\n    start: 192\n    end: 235\n    anchor: 'OnlineLogsviaCloudwatch'\n  -\n    start: 235\n    end: 381\n    anchor: 'UsingDumptruckCLI'\n  -\n    start: 381\n    end: 527\n    anchor: 'UsingServerlessCLItoviewCloudWatchlogs'\n  -\n    start: 527\n    end: 720\n    anchor: 'UsingtheAWSCloudWatchUI'        \n    \ntags:\n    - new\n---\n# Where are my logs?\n\n::: info\nThis Tutorial includes a follow along video, on Desktop you can click \"Play and Follow Video\" to be guided through the article as the video progresses.    \n:::\n\n&nbsp;\n\n## Getting a project setup\n\nTo start logging, you will need a project to log against, this tutorial will cover \nlogging a [basic slspress](/pages/build/slspress-simple-example/) application in an development environment using the [serverless offline](/pages/learn/developing-locally-with-serverless-offline/) plugin.\n\nWe will then deploy the application, and view online logs.    \n\n## Local Logging\n\nOnce you have your serverless project created, and have installed the [serverless offline](/pages/learn/developing-locally-with-serverless-offline/) plugin, you can start your service using the command:\n```\nserverless offline\n``` \nOnce this has launched, you should be presented with a summary of endpoints and shown what port your service is running on (the default is `http://localhost:3000`).\n\nOnce you hit your endpoint with the relevant request type, you will be presented with logs that show the request information and a stringified version of your response body. \n\n# Online Logs via Cloudwatch\n\nThere are many methods for viewing cloudwatch logs, the ones we have covered here are; using [Dumptruck](/pages/build/dumptruck/), [Serverless CLI](https://serverless.com/framework/docs/providers/aws/cli-reference/logs/) and the [AWS Cloudwatch](https://aws.amazon.com/cloudwatch) web console.\n\n::: info\nIf it takes a while for events to show in Cloudwatch (or CLI tool) - don't worry, this is normal.\nYou usually won't see the full event information show up in Cloudwatch until the event completion has been given some time process.    \n:::\n\n> If you plan on logging any debug payloads, ensure you stringify any JSON payloads otherwise you will see `[object object]`\n\n## Using Dumptruck CLI\n\nDumptruck is one of the utilities we've created for log management.\nFor more information, please check the following [link.](/pages/build/dumptruck)\n\nIf you don't already have it installed you can run ` npm install -g dumptruck ` to install it.\n\nDumptruck will scan your AWS CLI config, and any local serverless project to pick the best config for collecting logs, and can be run on any machine with the correct AWS credentials and does not have to in the context of a Serverless project. \n\nTo run dumptruck simply invoke it with the following command.\n```bash\ndumptruck\n```\nThis will guide you through choosing an AWS profile, Region and then Lambda. These are pre selected by most recently used, and Lambdas are sorted by most recently updated.\n\nOnce connected it will poll the Cloudwatch log group and bring in the events as they come in.\n\nOnce you close the log stream (`ctrl+C`) you will be given the arguments to allow you to directly invoke the same log tail in the future, e.g:\n```\ndumptruck -p \"default\" -r \"eu-west-1\" -l \"lamdba-name\"\n```\n  \n\n&nbsp;\n\n## Using Serverless CLI to view CloudWatch logs\n\nWhen in a serverless project folder, you can use the Serverless CLI to call the logs for your existing project.\n\n```bash\nserverless logs -f <func-name>\n```\n\nWhere the `<func-name>` is the name of the Lambda function you are looking for.\n\nAdditionally, you can use the `--tail` flag (or `-t` for short) to stream the logs automatically to your console.\n\n```bash\nserverless logs --function <func-name> --tail\n## or\nserverless logs -f <func-name> -t\n```\n\nWe recommend you doing that on a different terminal window to keep an 'auto-refreshed' log.\nFull [documentation](https://serverless.com/framework/docs/providers/aws/cli-reference/logs/) can be found on the serverless website.\n\nOne thing to keep in mind when using the Serverless CLI logging tool, is that you need to be in a serverless project folder to run it.\n\n## Using the AWS CloudWatch UI\n\n1. In your AWS console, Navigate to CloudWatch -> Logs.\n2. Type the name of your function in the filter box. Useful if you have multiple logs.\n3. Click on the Log Group that matches your function name.\n4. Click on \"Search Log Group\" to view all the logs associated with that group.\n\nWhen you open a log stream, these logs are shown in the row view and you may find it easier to read these by clicking on the \"text\" checkbox to show all event data on a single view.\n\n> If you have a very active log stream, the events may not always populate into the expected log streams seen in step 3 above, so it's always a good idea to use the \"Search Log Group\" option than apply the required filters. \n\nIf you want bind actions to these Cloudwatch events you trigger a Lambda from Cloudwatch, more information is in our [Listening to CloudWatch events](/pages/learn/listening-to-cloudwatch-events/) tutorial with examples.  \n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"Wherearemylogs%3F\"><a name=\"Wherearemylogs%3F\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Where are my logs?</h1>\n<div class=\"info\">\n<p>This Tutorial includes a follow along video, on Desktop you can click &quot;Play and Follow Video&quot; to be guided through the article as the video progresses.</p>\n</div>\n<p> </p>\n<h2 id=\"Gettingaprojectsetup\"><a name=\"Gettingaprojectsetup\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Getting a project setup</h2>\n<p>To start logging, you will need a project to log against, this tutorial will cover\nlogging a <a href=\"/pages/build/slspress-simple-example/\" class=\"absolute-link\">basic slspress</a> application in an development environment using the <a href=\"/pages/learn/developing-locally-with-serverless-offline/\" class=\"absolute-link\">serverless offline</a> plugin.</p>\n<p>We will then deploy the application, and view online logs.</p>\n<h2 id=\"LocalLogging\"><a name=\"LocalLogging\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Local Logging</h2>\n<p>Once you have your serverless project created, and have installed the <a href=\"/pages/learn/developing-locally-with-serverless-offline/\" class=\"absolute-link\">serverless offline</a> plugin, you can start your service using the command:</p>\n<pre><code>serverless offline\n</code></pre>\n<p>Once this has launched, you should be presented with a summary of endpoints and shown what port your service is running on (the default is <code>http://localhost:3000</code>).</p>\n<p>Once you hit your endpoint with the relevant request type, you will be presented with logs that show the request information and a stringified version of your response body.</p>\n<h1 id=\"OnlineLogsviaCloudwatch\"><a name=\"OnlineLogsviaCloudwatch\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Online Logs via Cloudwatch</h1>\n<p>There are many methods for viewing cloudwatch logs, the ones we have covered here are; using <a href=\"/pages/build/dumptruck/\" class=\"absolute-link\">Dumptruck</a>, <a href=\"https://serverless.com/framework/docs/providers/aws/cli-reference/logs/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless CLI</a> and the <a href=\"https://aws.amazon.com/cloudwatch\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS Cloudwatch</a> web console.</p>\n<div class=\"info\">\n<p>If it takes a while for events to show in Cloudwatch (or CLI tool) - don't worry, this is normal.\nYou usually won't see the full event information show up in Cloudwatch until the event completion has been given some time process.</p>\n</div>\n<blockquote>\n<p>If you plan on logging any debug payloads, ensure you stringify any JSON payloads otherwise you will see <code>[object object]</code></p>\n</blockquote>\n<h2 id=\"UsingDumptruckCLI\"><a name=\"UsingDumptruckCLI\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Using Dumptruck CLI</h2>\n<p>Dumptruck is one of the utilities we've created for log management.\nFor more information, please check the following <a href=\"/pages/build/dumptruck\" class=\"absolute-link\">link.</a></p>\n<p>If you don't already have it installed you can run <code>npm install -g dumptruck</code> to install it.</p>\n<p>Dumptruck will scan your AWS CLI config, and any local serverless project to pick the best config for collecting logs, and can be run on any machine with the correct AWS credentials and does not have to in the context of a Serverless project.</p>\n<p>To run dumptruck simply invoke it with the following command.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">dumptruck\n</code></pre>\n<p>This will guide you through choosing an AWS profile, Region and then Lambda. These are pre selected by most recently used, and Lambdas are sorted by most recently updated.</p>\n<p>Once connected it will poll the Cloudwatch log group and bring in the events as they come in.</p>\n<p>Once you close the log stream (<code>ctrl+C</code>) you will be given the arguments to allow you to directly invoke the same log tail in the future, e.g:</p>\n<pre><code>dumptruck -p &quot;default&quot; -r &quot;eu-west-1&quot; -l &quot;lamdba-name&quot;\n</code></pre>\n<p> </p>\n<h2 id=\"UsingServerlessCLItoviewCloudWatchlogs\"><a name=\"UsingServerlessCLItoviewCloudWatchlogs\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Using Serverless CLI to view CloudWatch logs</h2>\n<p>When in a serverless project folder, you can use the Serverless CLI to call the logs for your existing project.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless logs -f <span class=\"token operator\">&lt;</span>func-name<span class=\"token operator\">></span>\n</code></pre>\n<p>Where the <code>&lt;func-name&gt;</code> is the name of the Lambda function you are looking for.</p>\n<p>Additionally, you can use the <code>--tail</code> flag (or <code>-t</code> for short) to stream the logs automatically to your console.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless logs --function <span class=\"token operator\">&lt;</span>func-name<span class=\"token operator\">></span> --tail\n<span class=\"token comment\">## or</span>\nserverless logs -f <span class=\"token operator\">&lt;</span>func-name<span class=\"token operator\">></span> -t\n</code></pre>\n<p>We recommend you doing that on a different terminal window to keep an 'auto-refreshed' log.\nFull <a href=\"https://serverless.com/framework/docs/providers/aws/cli-reference/logs/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">documentation</a> can be found on the serverless website.</p>\n<p>One thing to keep in mind when using the Serverless CLI logging tool, is that you need to be in a serverless project folder to run it.</p>\n<h2 id=\"UsingtheAWSCloudWatchUI\"><a name=\"UsingtheAWSCloudWatchUI\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Using the AWS CloudWatch UI</h2>\n<ol>\n<li>In your AWS console, Navigate to CloudWatch -&gt; Logs.</li>\n<li>Type the name of your function in the filter box. Useful if you have multiple logs.</li>\n<li>Click on the Log Group that matches your function name.</li>\n<li>Click on &quot;Search Log Group&quot; to view all the logs associated with that group.</li>\n</ol>\n<p>When you open a log stream, these logs are shown in the row view and you may find it easier to read these by clicking on the &quot;text&quot; checkbox to show all event data on a single view.</p>\n<blockquote>\n<p>If you have a very active log stream, the events may not always populate into the expected log streams seen in step 3 above, so it's always a good idea to use the &quot;Search Log Group&quot; option than apply the required filters.</p>\n</blockquote>\n<p>If you want bind actions to these Cloudwatch events you trigger a Lambda from Cloudwatch, more information is in our <a href=\"/pages/learn/listening-to-cloudwatch-events/\" class=\"absolute-link\">Listening to CloudWatch events</a> tutorial with examples.</p>\n"}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvbWVldHVwLm1k","filename":"/content/pages/meetup.md","suffix":"","attributes":{"title":"Meetup","sort":5,"description":"SLS Zone Meetup"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Meetup'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 5","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'SLS Zone Meetup'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# SLS Zone Meetup","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Join the next meetup","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The sls.zone meetup crowdsources questions and topics for discussion to make sure you get the most out the evening. By ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.meetup.com/sls-zone-meetup/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"joining the meetup group","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" you can suggest a topic for discussion by leaving a comment (and vote for topics by liking a comment).","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The most popular topics will be discussed in small groups for 20 minute sessions.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Suggest topics, vote for existing topics, and confirm your spot on meetup.com:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"<iframe width=\"225\" height=\"225\" src=\"https://meetu.ps/3jPrsT\" frameborder=\"0\">","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"</iframe>","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"<a class=\"button__button button__button--primary\" href=\"https://www.meetup.com/sls-zone-meetup/events/258353689/\" target=\"_blank\">","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Join Meetup","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"</a>","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## Location","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"<img src=\"https://maps.googleapis.com/maps/api/staticmap?center=85+great+eastern+st+ec2a+3hy&zoom=15&scale=2&size=600x120&maptype=roadmap&key=AIzaSyBhj7D1vbFc_JlLqXICAfemGCdd-n9pSAk&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:R%7C85+great+eastern+st+ec2a+3hy\" style=\"max-width:100%; width:500px\"/>","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Reason, ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://goo.gl/maps/LLg1dAXgrGr"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"85 Great Eastern Street","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", 6:30pm","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Reason is a team of designers, strategists and engineers who share a love of solving problems and making things. We mix an environment of curiosity, learning and fun to create products that people care about.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## What we're about","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The sls.zone meetup crowdsources questions and topics about Serverless, cloud computing and FaaS for discussion to make sure you get the most out the evening.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The most popular topics will be discussed in small groups for 20 minute sessions. You’ll get the chance to talk about 2-3 topics depending on attendance.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"SLS Zone is a collection of tutorials, best practices and open source projects created for the Serverless community to help build Serverless applications the right way. This toolkit has evolved over countless hours by the Reason.co technology team in applying these practices to real world digital products. Our aim is to help grow Serverless adoption, share knowledge and help you produce reliable, scalable and secure digital products at speed.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## See what it looks like","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"<iframe  style=\"border:1px solid #666;max-width:100%\" src=\"https://player.vimeo.com/video/304632686\" width=\"640\" height=\"380\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen>","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"html_inline","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"</iframe>","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Meetup'\nsort: 5\ndescription: 'SLS Zone Meetup'\n---\n\n# SLS Zone Meetup\n\n## Join the next meetup\n\nThe sls.zone meetup crowdsources questions and topics for discussion to make sure you get the most out the evening. By [joining the meetup group](https://www.meetup.com/sls-zone-meetup/) you can suggest a topic for discussion by leaving a comment (and vote for topics by liking a comment).\n \nThe most popular topics will be discussed in small groups for 20 minute sessions. \n\nSuggest topics, vote for existing topics, and confirm your spot on meetup.com: \n\n\n<iframe width=\"225\" height=\"225\" src=\"https://meetu.ps/3jPrsT\" frameborder=\"0\"></iframe>\n \n<a class=\"button__button button__button--primary\" href=\"https://www.meetup.com/sls-zone-meetup/events/258353689/\" target=\"_blank\">Join Meetup</a>\n\n\n\n\n## Location\n\n<img src=\"https://maps.googleapis.com/maps/api/staticmap?center=85+great+eastern+st+ec2a+3hy&zoom=15&scale=2&size=600x120&maptype=roadmap&key=AIzaSyBhj7D1vbFc_JlLqXICAfemGCdd-n9pSAk&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:R%7C85+great+eastern+st+ec2a+3hy\" style=\"max-width:100%; width:500px\"/>\n\nReason, [85 Great Eastern Street](https://goo.gl/maps/LLg1dAXgrGr), 6:30pm\n\nReason is a team of designers, strategists and engineers who share a love of solving problems and making things. We mix an environment of curiosity, learning and fun to create products that people care about.\n\n## What we're about\n\nThe sls.zone meetup crowdsources questions and topics about Serverless, cloud computing and FaaS for discussion to make sure you get the most out the evening.\n\nThe most popular topics will be discussed in small groups for 20 minute sessions. You’ll get the chance to talk about 2-3 topics depending on attendance.\n\nSLS Zone is a collection of tutorials, best practices and open source projects created for the Serverless community to help build Serverless applications the right way. This toolkit has evolved over countless hours by the Reason.co technology team in applying these practices to real world digital products. Our aim is to help grow Serverless adoption, share knowledge and help you produce reliable, scalable and secure digital products at speed.\n\n\n\n\n\n## See what it looks like\n\n<iframe  style=\"border:1px solid #666;max-width:100%\" src=\"https://player.vimeo.com/video/304632686\" width=\"640\" height=\"380\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"SLSZoneMeetup\"><a name=\"SLSZoneMeetup\" class=\"markdown-it-headinganchor\" href=\"#\"></a>SLS Zone Meetup</h1>\n<h2 id=\"Jointhenextmeetup\"><a name=\"Jointhenextmeetup\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Join the next meetup</h2>\n<p>The sls.zone meetup crowdsources questions and topics for discussion to make sure you get the most out the evening. By <a href=\"https://www.meetup.com/sls-zone-meetup/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">joining the meetup group</a> you can suggest a topic for discussion by leaving a comment (and vote for topics by liking a comment).</p>\n<p>The most popular topics will be discussed in small groups for 20 minute sessions.</p>\n<p>Suggest topics, vote for existing topics, and confirm your spot on meetup.com:</p>\n<iframe width=\"225\" height=\"225\" src=\"https://meetu.ps/3jPrsT\" frameborder=\"0\"></iframe>\n<p><a class=\"button__button button__button--primary\" href=\"https://www.meetup.com/sls-zone-meetup/events/258353689/\" target=\"_blank\">Join Meetup</a></p>\n<h2 id=\"Location\"><a name=\"Location\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Location</h2>\n<img src=\"https://maps.googleapis.com/maps/api/staticmap?center=85+great+eastern+st+ec2a+3hy&zoom=15&scale=2&size=600x120&maptype=roadmap&key=AIzaSyBhj7D1vbFc_JlLqXICAfemGCdd-n9pSAk&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:R%7C85+great+eastern+st+ec2a+3hy\" style=\"max-width:100%; width:500px\"/>\n<p>Reason, <a href=\"https://goo.gl/maps/LLg1dAXgrGr\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">85 Great Eastern Street</a>, 6:30pm</p>\n<p>Reason is a team of designers, strategists and engineers who share a love of solving problems and making things. We mix an environment of curiosity, learning and fun to create products that people care about.</p>\n<h2 id=\"Whatwe'reabout\"><a name=\"Whatwe'reabout\" class=\"markdown-it-headinganchor\" href=\"#\"></a>What we're about</h2>\n<p>The sls.zone meetup crowdsources questions and topics about Serverless, cloud computing and FaaS for discussion to make sure you get the most out the evening.</p>\n<p>The most popular topics will be discussed in small groups for 20 minute sessions. You’ll get the chance to talk about 2-3 topics depending on attendance.</p>\n<p>SLS Zone is a collection of tutorials, best practices and open source projects created for the Serverless community to help build Serverless applications the right way. This toolkit has evolved over countless hours by the Reason.co technology team in applying these practices to real world digital products. Our aim is to help grow Serverless adoption, share knowledge and help you produce reliable, scalable and secure digital products at speed.</p>\n<h2 id=\"Seewhatitlookslike\"><a name=\"Seewhatitlookslike\" class=\"markdown-it-headinganchor\" href=\"#\"></a>See what it looks like</h2>\n<iframe  style=\"border:1px solid #666;max-width:100%\" src=\"https://player.vimeo.com/video/304632686\" width=\"640\" height=\"380\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n"}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvb3Blbi1zb3VyY2UubWQ","filename":"/content/pages/open-source.md","suffix":"","attributes":{"title":"Open Source Projects","sort":4,"description":"SLS Zone open source serverless projects and modules"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Open Source Projects'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 4","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'SLS Zone open source serverless projects and modules'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"DO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Open Source Projects'\nsort: 4\ndescription: 'SLS Zone open source serverless projects and modules'\n---\nDO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<p>DO NOT EDIT THIS FILE - its a placeholder so that it appears in the menu structure - See the BuildPage class</p>\n"}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvcnVuL0NPUlMtaW4tZGV2LWFuZC1wcm9kLm1k","filename":"/content/pages/run/CORS-in-dev-and-prod.md","suffix":"","attributes":{"title":"CORS in dev and prod","sort":1,"featured":true,"description":"How to setup cross origin CORS in serverless applications"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'CORS in dev and prod'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 1","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'How to setup cross origin CORS in serverless applications'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# CORS in dev and prod","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you don't know what is CORS - in short, by default, if you are on the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","#easter-egg"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"http://website.com","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" this website can only make requests to that website. In order to make a request to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","#easter-egg"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"http://otherwebsite.com","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", first website has to set CORS headers in the response. More theory can be found ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## How to set up CORS with Serverless","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you are using Serverless the enabling CORS on your endpoints is a straightforward process.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"When editing the yaml file just set ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"cors: true","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" on an http events.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: hello: handler: handler.hello events: - http: path: hello method: get cors: true","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You could do it ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-cors.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"manually","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" but Serverless will save you some time and do it automatically during the deployment.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"There is one more thing that has to be done for CORS to work. In every λ function you have to specify headers. Just set ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Access-Control-Allow-Origin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"'*'","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to accept requests coming from all domains or ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"'your-domain-name.com'","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" for requests coming from one domain.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"javascript module.exports.hello = (event, context, c) => { const response = { statusCode: 200, headers: { 'Access-Control-Allow-Origin': '*', // Required for CORS support to work // try swapping '*' for an environment based variable }, body: 'hello' }; c(null, response) }","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## What does CORS:true do behind the scenes","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Settings cors to true sets the default configuration of Serverless to be:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml functions: hello: handler: handler.hello events: - http: path: hello method: get cors: origin: '*' headers: - Content-Type - X-Amz-Date - Authorization - X-Api-Key - X-Amz-Security-Token - X-Amz-User-Agent allowCredentials: false","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This lets our lambda serverless function to know that we can safely accept requests from any website (","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"'*'","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" - means any). If being precise, the browsers regulate this behaviour for security reasons. If you include an AJAX call from ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"youdomain.com","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to our lambda function which will reside at domain looking something like this:  ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" then before doing ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"GET","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" request to this endpoint, the browser will do so called ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Preflight request","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":". This is a request of HTTP method ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"OPTIONS","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" with three HTTP headers: ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Origin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":",  ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Access-Control-Request-Method","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" and ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Access-Control-Request-Headers","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":".","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"As it is usually handled by the browsers automatically, the developers don't need to handle the logic around it. However, if you are curious, you can do the request to your newly generated lambda endpoint:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"curl OPTIONS https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The header results should look like this:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"shell access-control-allow-credentials: false access-control-allow-headers: Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Amz-User-Agent access-control-allow-methods: OPTIONS,GET access-control-allow-origin: *","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"which means that two methods are allowed on this endpoint - OPTIONS and GET","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"## What to do in production","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"The best practice would be to have the same domain for your lambdas and the website you are querying them with. You don't have to set CORS headers in this case.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If your lambdas and the domain you are calling lambdas from are on the different domains, the recommended approach is to set ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Access-Control-Allow-Origin","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" header to that domain name. ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.w3.org/TR/cors/#access-control-allow-origin-response-header"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"This header supports","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" either one single domain name (can be pattern) or ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"'*'","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" If you are just using one CloudFormation stack for lambdas (one lambda functions group) and you use one domain name there is another approach.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"You can set custom domain name for your API Gateway. Details instruction on how to do it can be found ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-custom-domains.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"here","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.soasta.com/blog/options-web-performance-with-single-page-applications/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Blog article about latency with CORS","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'CORS in dev and prod'\nsort: 1\nfeatured: true\ndescription: 'How to setup cross origin CORS in serverless applications'\n---\n# CORS in dev and prod\n\nIf you don't know what is CORS - in short, by default, if you are on the [http://website.com](#easter-egg) this website can only make requests to that website. In order to make a request to [http://otherwebsite.com](#easter-egg), first website has to set CORS headers in the response. More theory can be found [here](https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS).\n\n## How to set up CORS with Serverless\n\nIf you are using Serverless the enabling CORS on your endpoints is a straightforward process.\nWhen editing the yaml file just set `cors: true` on an http events.\n\n```yaml\nfunctions:\n  hello:\n    handler: handler.hello\n    events:\n      - http:\n          path: hello\n          method: get\n          cors: true\n```\n\n&nbsp;\n\nYou could do it [manually](http://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-cors.html) but Serverless will save you some time and do it automatically during the deployment.\n\nThere is one more thing that has to be done for CORS to work. In every λ function you have to specify headers. Just set `Access-Control-Allow-Origin` to `'*'` to accept requests coming from all domains or `'your-domain-name.com'` for requests coming from one domain.\n\n```javascript\nmodule.exports.hello = (event, context, c) => {\n  const response = {\n    statusCode: 200,\n    headers: {\n      'Access-Control-Allow-Origin': '*', // Required for CORS support to work\n      // try swapping '*' for an environment based variable\n    },\n    body: 'hello'\n  };\n  c(null, response)\n}\n```\n\n&nbsp;\n\n## What does CORS:true do behind the scenes\n\nSettings cors to true sets the default configuration of Serverless to be:\n\n```yaml\nfunctions:\n  hello:\n    handler: handler.hello\n    events:\n      - http:\n          path: hello\n          method: get\n          cors:\n            origin: '*'\n            headers:\n              - Content-Type\n              - X-Amz-Date\n              - Authorization\n              - X-Api-Key\n              - X-Amz-Security-Token\n              - X-Amz-User-Agent\n            allowCredentials: false\n```\n\nThis lets our lambda serverless function to know that we can safely accept requests from any website (`'*'` - means any). If being precise, the browsers regulate this behaviour for security reasons. If you include an AJAX call from `youdomain.com` to our lambda function which will reside at domain looking something like this:  `https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello` then before doing `GET` request to this endpoint, the browser will do so called `Preflight request`. This is a request of HTTP method `OPTIONS` with three HTTP headers: `Origin`,  `Access-Control-Request-Method` and `Access-Control-Request-Headers`.\n\n&nbsp;\n\nAs it is usually handled by the browsers automatically, the developers don't need to handle the logic around it. However, if you are curious, you can do the request to your newly generated lambda endpoint:\n\n```curl\nOPTIONS https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello\n```\n\n&nbsp;\n\nThe header results should look like this:\n\n```shell\naccess-control-allow-credentials: false\naccess-control-allow-headers: Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Amz-User-Agent\naccess-control-allow-methods: OPTIONS,GET\naccess-control-allow-origin: *\n```\n\nwhich means that two methods are allowed on this endpoint - OPTIONS and GET\n\n&nbsp;\n\n## What to do in production\n\nThe best practice would be to have the same domain for your lambdas and the website you are querying them with. You don't have to set CORS headers in this case.\n\n&nbsp;\n\nIf your lambdas and the domain you are calling lambdas from are on the different domains, the recommended approach is to set `Access-Control-Allow-Origin` header to that domain name. [This header supports](https://www.w3.org/TR/cors/#access-control-allow-origin-response-header) either one single domain name (can be pattern) or `'*'` If you are just using one CloudFormation stack for lambdas (one lambda functions group) and you use one domain name there is another approach.\n\n&nbsp;\n\nYou can set custom domain name for your API Gateway. Details instruction on how to do it can be found [here](https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-custom-domains.html)\n\n::: links\nFurther reading:\n\n* [Blog article about latency with CORS](https://www.soasta.com/blog/options-web-performance-with-single-page-applications/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<h1 id=\"CORSindevandprod\"><a name=\"CORSindevandprod\" class=\"markdown-it-headinganchor\" href=\"#\"></a>CORS in dev and prod</h1>\n<p>If you don't know what is CORS - in short, by default, if you are on the <a href=\"#easter-egg\">http://website.com</a> this website can only make requests to that website. In order to make a request to <a href=\"#easter-egg\">http://otherwebsite.com</a>, first website has to set CORS headers in the response. More theory can be found <a href=\"https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">here</a>.</p>\n<h2 id=\"HowtosetupCORSwithServerless\"><a name=\"HowtosetupCORSwithServerless\" class=\"markdown-it-headinganchor\" href=\"#\"></a>How to set up CORS with Serverless</h2>\n<p>If you are using Serverless the enabling CORS on your endpoints is a straightforward process.\nWhen editing the yaml file just set <code>cors: true</code> on an http events.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">hello</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.hello\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> hello\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">true</span>\n</code></pre>\n<p> </p>\n<p>You could do it <a href=\"http://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-cors.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">manually</a> but Serverless will save you some time and do it automatically during the deployment.</p>\n<p>There is one more thing that has to be done for CORS to work. In every λ function you have to specify headers. Just set <code>Access-Control-Allow-Origin</code> to <code>'*'</code> to accept requests coming from all domains or <code>'your-domain-name.com'</code> for requests coming from one domain.</p>\n<pre class=\"language-javascript\"><code class=\"language-javascript\">module<span class=\"token punctuation\">.</span>exports<span class=\"token punctuation\">.</span><span class=\"token function-variable function\">hello</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>event<span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">)</span> <span class=\"token operator\">=></span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">const</span> response <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    statusCode<span class=\"token punctuation\">:</span> <span class=\"token number\">200</span><span class=\"token punctuation\">,</span>\n    headers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token string\">'Access-Control-Allow-Origin'</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'*'</span><span class=\"token punctuation\">,</span> <span class=\"token comment\">// Required for CORS support to work</span>\n      <span class=\"token comment\">// try swapping '*' for an environment based variable</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    body<span class=\"token punctuation\">:</span> <span class=\"token string\">'hello'</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n  <span class=\"token function\">c</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">null</span><span class=\"token punctuation\">,</span> response<span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n<p> </p>\n<h2 id=\"WhatdoesCORS%3Atruedobehindthescenes\"><a name=\"WhatdoesCORS%3Atruedobehindthescenes\" class=\"markdown-it-headinganchor\" href=\"#\"></a>What does CORS:true do behind the scenes</h2>\n<p>Settings cors to true sets the default configuration of Serverless to be:</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">functions</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">hello</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">handler</span><span class=\"token punctuation\">:</span> handler.hello\n    <span class=\"token key atrule\">events</span><span class=\"token punctuation\">:</span>\n      <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">http</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">path</span><span class=\"token punctuation\">:</span> hello\n          <span class=\"token key atrule\">method</span><span class=\"token punctuation\">:</span> get\n          <span class=\"token key atrule\">cors</span><span class=\"token punctuation\">:</span>\n            <span class=\"token key atrule\">origin</span><span class=\"token punctuation\">:</span> <span class=\"token string\">'*'</span>\n            <span class=\"token key atrule\">headers</span><span class=\"token punctuation\">:</span>\n              <span class=\"token punctuation\">-</span> Content<span class=\"token punctuation\">-</span>Type\n              <span class=\"token punctuation\">-</span> X<span class=\"token punctuation\">-</span>Amz<span class=\"token punctuation\">-</span>Date\n              <span class=\"token punctuation\">-</span> Authorization\n              <span class=\"token punctuation\">-</span> X<span class=\"token punctuation\">-</span>Api<span class=\"token punctuation\">-</span>Key\n              <span class=\"token punctuation\">-</span> X<span class=\"token punctuation\">-</span>Amz<span class=\"token punctuation\">-</span>Security<span class=\"token punctuation\">-</span>Token\n              <span class=\"token punctuation\">-</span> X<span class=\"token punctuation\">-</span>Amz<span class=\"token punctuation\">-</span>User<span class=\"token punctuation\">-</span>Agent\n            <span class=\"token key atrule\">allowCredentials</span><span class=\"token punctuation\">:</span> <span class=\"token boolean important\">false</span>\n</code></pre>\n<p>This lets our lambda serverless function to know that we can safely accept requests from any website (<code>'*'</code> - means any). If being precise, the browsers regulate this behaviour for security reasons. If you include an AJAX call from <code>youdomain.com</code> to our lambda function which will reside at domain looking something like this:  <code>https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello</code> then before doing <code>GET</code> request to this endpoint, the browser will do so called <code>Preflight request</code>. This is a request of HTTP method <code>OPTIONS</code> with three HTTP headers: <code>Origin</code>,  <code>Access-Control-Request-Method</code> and <code>Access-Control-Request-Headers</code>.</p>\n<p> </p>\n<p>As it is usually handled by the browsers automatically, the developers don't need to handle the logic around it. However, if you are curious, you can do the request to your newly generated lambda endpoint:</p>\n<pre class=\"language-curl\"><code class=\"language-curl\">OPTIONS https://q3o4tjwe0dgj.execute-api.us-east-1.amazonaws.com/dev/hello\n</code></pre>\n<p> </p>\n<p>The header results should look like this:</p>\n<pre class=\"language-shell\"><code class=\"language-shell\">access-control-allow-credentials: <span class=\"token boolean\">false</span>\naccess-control-allow-headers: Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Amz-User-Agent\naccess-control-allow-methods: OPTIONS,GET\naccess-control-allow-origin: *\n</code></pre>\n<p>which means that two methods are allowed on this endpoint - OPTIONS and GET</p>\n<p> </p>\n<h2 id=\"Whattodoinproduction\"><a name=\"Whattodoinproduction\" class=\"markdown-it-headinganchor\" href=\"#\"></a>What to do in production</h2>\n<p>The best practice would be to have the same domain for your lambdas and the website you are querying them with. You don't have to set CORS headers in this case.</p>\n<p> </p>\n<p>If your lambdas and the domain you are calling lambdas from are on the different domains, the recommended approach is to set <code>Access-Control-Allow-Origin</code> header to that domain name. <a href=\"https://www.w3.org/TR/cors/#access-control-allow-origin-response-header\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">This header supports</a> either one single domain name (can be pattern) or <code>'*'</code> If you are just using one CloudFormation stack for lambdas (one lambda functions group) and you use one domain name there is another approach.</p>\n<p> </p>\n<p>You can set custom domain name for your API Gateway. Details instruction on how to do it can be found <a href=\"https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-custom-domains.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">here</a></p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://www.soasta.com/blog/options-web-performance-with-single-page-applications/\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Blog article about latency with CORS</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvcnVuL2hvc3RpbmctZm9yLWEtc2VydmVybGVzcy1wcm9qZWN0LW9uLXMzLm1k","filename":"/content/pages/run/hosting-for-a-serverless-project-on-s3.md","suffix":"","attributes":{"title":"Static hosting on S3","sort":2,"featured":true,"description":"How to add static hosting to your serverless project"},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: 'Static hosting on S3'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 2","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"featured: true","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"description: 'How to add static hosting to your serverless project'","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: icons","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"# Static hosting on S3","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/withreason/sls-zone-examples/tree/master/static-website"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"image","tag":"img","attrs":[["src","/images/logo-github-small.png"],["alt",""],["title","Git Hub"]],"map":null,"nesting":0,"level":1,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"alt text","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"One solution for hosting the front end part of a project is to use Amazon S3 to store and serve the HTML/JavaScript that will talk to your Serverless API's. This walk through will show you the basics of how to do that.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Fortunately, there is a fancy ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://www.npmjs.com/package/serverless-finch"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"plugin","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" to do all the heavy lifting for you.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you have followed the ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/first-serverless-project/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"first serverless project","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" tutorial you can build on to that directly.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash npm install --save serverless-finch","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"After that you can generate your first HTML page:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash mkdir -p client/dist touch client/dist/index.html","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Here will be the content of index.html. (Be sure to replace {YOUR_API_ID} with the api id you created.)","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"html <html> <head> <title>Static Website</title> </head> <body> <h1>Hello world!</h1> </body> </html>","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"This will send the request to the hello world lambda function.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Add the config to your yaml file replacing {YOUR_BUCKET_NAME} with the name of a bucket that you want to create.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"yaml service: static-website provider: name: aws runtime: nodejs8.10 region: eu-west-1 profile: default memorySize: 256 # optional, in MB, default is 1024 stage: dev plugins: - serverless-finch custom: siteName: static-website.com client: bucketName: ${self:service}-${opt:stage, self:provider.stage}-${self:custom.siteName} # distributionFolder: client/dist resources: Resources: StaticSite: Type: AWS::S3::Bucket Properties: AccessControl: PublicRead BucketName: ${self:custom.client.bucketName} WebsiteConfiguration: IndexDocument: index.html ErrorDocument: error.html # specifying the policies to make sure all files inside the Bucket are avaialble WebAppS3BucketPolicy: Type: AWS::S3::BucketPolicy Properties: Bucket: Ref: StaticSite PolicyDocument: Statement: - Sid: PublicReadGetObject Effect: Allow Principal: \"*\" Action: - s3:GetObject Resource: arn:aws:s3:::${self:custom.client.bucketName}/*","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"In order to deploy this fancy website on S3, just run the command:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"bash serverless client deploy","markup":"```","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":" ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: info","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Keep in mind that the bucket contents will be overridden if they already exist.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Now, you can go to your S3 buckets in the AWS console, find your bucket, press Properties and find Static S3 Hosting URL looking similar to ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"http://{YOUR_BUCKET_NAME}.s3-website-{REGION}.amazonaws.com","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"If you open up the url in a browser, you should see the alert ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"code_inline","tag":"code","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Our lambda is saying hello","markup":"`","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":", which is coming from your api.","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: links","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Further reading:","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","https://github.com/fernando-mc/serverless-finch"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Serverless finch plugin","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","http://docs.aws.amazon.com/AmazonS3/latest/dev/WebsiteHosting.html"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"AWS Static hosting","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"::: steps","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"Next step","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/build/slspress-simple-example/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Create more complicated API's quickly with slspress","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"* ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/pages/learn/listening-to-other-events-non-http/"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Add some static HTML/JavaScript to use your new API","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":":::","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: 'Static hosting on S3'\nsort: 2\nfeatured: true\ndescription: 'How to add static hosting to your serverless project'\n---\n::: icons\n# Static hosting on S3\n\n[![alt text](/images/logo-github-small.png \"Git Hub\")](https://github.com/withreason/sls-zone-examples/tree/master/static-website)\n:::\n\nOne solution for hosting the front end part of a project is to use Amazon S3 to store and serve the HTML/JavaScript that will talk to your Serverless API's. This walk through will show you the basics of how to do that.\n\n&nbsp;\n\nFortunately, there is a fancy [plugin](https://www.npmjs.com/package/serverless-finch) to do all the heavy lifting for you.\n\nIf you have followed the [first serverless project](/pages/learn/first-serverless-project/) tutorial you can build on to that directly.\n\n```bash\nnpm install --save serverless-finch\n```\n\n&nbsp;\n\nAfter that you can generate your first HTML page:\n\n```bash\nmkdir -p client/dist\ntouch client/dist/index.html\n```\n\n&nbsp;\n\nHere will be the content of index.html. (Be sure to replace {YOUR_API_ID} with the api id you created.)\n\n```html\n<html>\n    <head>\n        <title>Static Website</title>\n    </head>\n    <body>\n        <h1>Hello world!</h1>\n    </body>\n</html>\n```\n\nThis will send the request to the hello world lambda function.\n\n&nbsp;\n\nAdd the config to your yaml file replacing {YOUR_BUCKET_NAME} with the name of a bucket that you want to create.\n\n```yaml\nservice: static-website\n\nprovider:\n  name: aws\n  runtime: nodejs8.10\n  region: eu-west-1\n  profile: default\n  memorySize: 256 # optional, in MB, default is 1024\n  stage: dev\n\nplugins:\n  - serverless-finch\n\ncustom:\n  siteName: static-website.com\n  client:\n    bucketName: ${self:service}-${opt:stage, self:provider.stage}-${self:custom.siteName}\n    # distributionFolder: client/dist\n\nresources:\n  Resources:\n  \n    StaticSite:\n      Type: AWS::S3::Bucket\n      Properties:\n        AccessControl: PublicRead\n        BucketName: ${self:custom.client.bucketName}\n        WebsiteConfiguration:\n          IndexDocument: index.html\n          ErrorDocument: error.html\n\n    # specifying the policies to make sure all files inside the Bucket are avaialble\n    WebAppS3BucketPolicy:\n      Type: AWS::S3::BucketPolicy\n      Properties:\n        Bucket:\n          Ref: StaticSite\n        PolicyDocument:\n          Statement:\n            - Sid: PublicReadGetObject\n              Effect: Allow\n              Principal: \"*\"\n              Action:\n              - s3:GetObject\n              Resource: arn:aws:s3:::${self:custom.client.bucketName}/*\n```\n\n&nbsp;\n\nIn order to deploy this fancy website on S3, just run the command:\n\n```bash\nserverless client deploy\n```\n\n&nbsp;\n\n::: info\nKeep in mind that the bucket contents will be overridden if they already exist.\n:::\n\nNow, you can go to your S3 buckets in the AWS console, find your bucket, press Properties and find Static S3 Hosting URL looking similar to `http://{YOUR_BUCKET_NAME}.s3-website-{REGION}.amazonaws.com`\nIf you open up the url in a browser, you should see the alert `Our lambda is saying hello`, which is coming from your api.\n\n::: links\nFurther reading:\n\n* [Serverless finch plugin](https://github.com/fernando-mc/serverless-finch)\n* [AWS Static hosting](http://docs.aws.amazon.com/AmazonS3/latest/dev/WebsiteHosting.html)\n\n:::\n\n::: steps\nNext step\n\n* [Create more complicated API's quickly with slspress](/pages/build/slspress-simple-example/)\n* [Add some static HTML/JavaScript to use your new API](/pages/learn/listening-to-other-events-non-http/)\n\n:::\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<div class=\"icons\">\n<h1 id=\"StatichostingonS3\"><a name=\"StatichostingonS3\" class=\"markdown-it-headinganchor\" href=\"#\"></a>Static hosting on S3</h1>\n<p><a href=\"https://github.com/withreason/sls-zone-examples/tree/master/static-website\" class=\"external-link\" target=\"_blank\" rel=\"noopener\"><img src=\"/images/logo-github-small.png\" alt=\"alt text\" title=\"Git Hub\"></a></p>\n</div>\n<p>One solution for hosting the front end part of a project is to use Amazon S3 to store and serve the HTML/JavaScript that will talk to your Serverless API's. This walk through will show you the basics of how to do that.</p>\n<p> </p>\n<p>Fortunately, there is a fancy <a href=\"https://www.npmjs.com/package/serverless-finch\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">plugin</a> to do all the heavy lifting for you.</p>\n<p>If you have followed the <a href=\"/pages/learn/first-serverless-project/\" class=\"absolute-link\">first serverless project</a> tutorial you can build on to that directly.</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">npm</span> <span class=\"token function\">install</span> --save serverless-finch\n</code></pre>\n<p> </p>\n<p>After that you can generate your first HTML page:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\"><span class=\"token function\">mkdir</span> -p client/dist\n<span class=\"token function\">touch</span> client/dist/index.html\n</code></pre>\n<p> </p>\n<p>Here will be the content of index.html. (Be sure to replace {YOUR_API_ID} with the api id you created.)</p>\n<pre class=\"language-html\"><code class=\"language-html\"><span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>html</span><span class=\"token punctuation\">></span></span>\n    <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>head</span><span class=\"token punctuation\">></span></span>\n        <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>title</span><span class=\"token punctuation\">></span></span>Static Website<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>title</span><span class=\"token punctuation\">></span></span>\n    <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>head</span><span class=\"token punctuation\">></span></span>\n    <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>body</span><span class=\"token punctuation\">></span></span>\n        <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>h1</span><span class=\"token punctuation\">></span></span>Hello world!<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>h1</span><span class=\"token punctuation\">></span></span>\n    <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>body</span><span class=\"token punctuation\">></span></span>\n<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>html</span><span class=\"token punctuation\">></span></span>\n</code></pre>\n<p>This will send the request to the hello world lambda function.</p>\n<p> </p>\n<p>Add the config to your yaml file replacing {YOUR_BUCKET_NAME} with the name of a bucket that you want to create.</p>\n<pre class=\"language-yaml\"><code class=\"language-yaml\"><span class=\"token key atrule\">service</span><span class=\"token punctuation\">:</span> static<span class=\"token punctuation\">-</span>website\n\n<span class=\"token key atrule\">provider</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">name</span><span class=\"token punctuation\">:</span> aws\n  <span class=\"token key atrule\">runtime</span><span class=\"token punctuation\">:</span> nodejs8.10\n  <span class=\"token key atrule\">region</span><span class=\"token punctuation\">:</span> eu<span class=\"token punctuation\">-</span>west<span class=\"token punctuation\">-</span><span class=\"token number\">1</span>\n  <span class=\"token key atrule\">profile</span><span class=\"token punctuation\">:</span> default\n  <span class=\"token key atrule\">memorySize</span><span class=\"token punctuation\">:</span> <span class=\"token number\">256 </span><span class=\"token comment\"># optional, in MB, default is 1024</span>\n  <span class=\"token key atrule\">stage</span><span class=\"token punctuation\">:</span> dev\n\n<span class=\"token key atrule\">plugins</span><span class=\"token punctuation\">:</span>\n  <span class=\"token punctuation\">-</span> serverless<span class=\"token punctuation\">-</span>finch\n\n<span class=\"token key atrule\">custom</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">siteName</span><span class=\"token punctuation\">:</span> static<span class=\"token punctuation\">-</span>website.com\n  <span class=\"token key atrule\">client</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">bucketName</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>service<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>$<span class=\"token punctuation\">{</span>opt<span class=\"token punctuation\">:</span>stage<span class=\"token punctuation\">,</span> self<span class=\"token punctuation\">:</span>provider.stage<span class=\"token punctuation\">}</span><span class=\"token punctuation\">-</span>$<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>custom.siteName<span class=\"token punctuation\">}</span>\n    <span class=\"token comment\"># distributionFolder: client/dist</span>\n\n<span class=\"token key atrule\">resources</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">Resources</span><span class=\"token punctuation\">:</span>\n  \n    <span class=\"token key atrule\">StaticSite</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">Type</span><span class=\"token punctuation\">:</span> AWS<span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span>S3<span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span>Bucket\n      <span class=\"token key atrule\">Properties</span><span class=\"token punctuation\">:</span>\n        <span class=\"token key atrule\">AccessControl</span><span class=\"token punctuation\">:</span> PublicRead\n        <span class=\"token key atrule\">BucketName</span><span class=\"token punctuation\">:</span> $<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>custom.client.bucketName<span class=\"token punctuation\">}</span>\n        <span class=\"token key atrule\">WebsiteConfiguration</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">IndexDocument</span><span class=\"token punctuation\">:</span> index.html\n          <span class=\"token key atrule\">ErrorDocument</span><span class=\"token punctuation\">:</span> error.html\n\n    <span class=\"token comment\"># specifying the policies to make sure all files inside the Bucket are avaialble</span>\n    <span class=\"token key atrule\">WebAppS3BucketPolicy</span><span class=\"token punctuation\">:</span>\n      <span class=\"token key atrule\">Type</span><span class=\"token punctuation\">:</span> AWS<span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span>S3<span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span>BucketPolicy\n      <span class=\"token key atrule\">Properties</span><span class=\"token punctuation\">:</span>\n        <span class=\"token key atrule\">Bucket</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">Ref</span><span class=\"token punctuation\">:</span> StaticSite\n        <span class=\"token key atrule\">PolicyDocument</span><span class=\"token punctuation\">:</span>\n          <span class=\"token key atrule\">Statement</span><span class=\"token punctuation\">:</span>\n            <span class=\"token punctuation\">-</span> <span class=\"token key atrule\">Sid</span><span class=\"token punctuation\">:</span> PublicReadGetObject\n              <span class=\"token key atrule\">Effect</span><span class=\"token punctuation\">:</span> Allow\n              <span class=\"token key atrule\">Principal</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"*\"</span>\n              <span class=\"token key atrule\">Action</span><span class=\"token punctuation\">:</span>\n              <span class=\"token punctuation\">-</span> s3<span class=\"token punctuation\">:</span>GetObject\n              <span class=\"token key atrule\">Resource</span><span class=\"token punctuation\">:</span> arn<span class=\"token punctuation\">:</span>aws<span class=\"token punctuation\">:</span>s3<span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span><span class=\"token punctuation\">:</span>$<span class=\"token punctuation\">{</span>self<span class=\"token punctuation\">:</span>custom.client.bucketName<span class=\"token punctuation\">}</span>/*\n</code></pre>\n<p> </p>\n<p>In order to deploy this fancy website on S3, just run the command:</p>\n<pre class=\"language-bash\"><code class=\"language-bash\">serverless client deploy\n</code></pre>\n<p> </p>\n<div class=\"info\">\n<p>Keep in mind that the bucket contents will be overridden if they already exist.</p>\n</div>\n<p>Now, you can go to your S3 buckets in the AWS console, find your bucket, press Properties and find Static S3 Hosting URL looking similar to <code>http://{YOUR_BUCKET_NAME}.s3-website-{REGION}.amazonaws.com</code>\nIf you open up the url in a browser, you should see the alert <code>Our lambda is saying hello</code>, which is coming from your api.</p>\n<div class=\"links\">\n<p>Further reading:</p>\n<ul>\n<li><a href=\"https://github.com/fernando-mc/serverless-finch\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">Serverless finch plugin</a></li>\n<li><a href=\"http://docs.aws.amazon.com/AmazonS3/latest/dev/WebsiteHosting.html\" class=\"external-link\" target=\"_blank\" rel=\"noopener\">AWS Static hosting</a></li>\n</ul>\n</div>\n<div class=\"steps\">\n<p>Next step</p>\n<ul>\n<li><a href=\"/pages/build/slspress-simple-example/\" class=\"absolute-link\">Create more complicated API's quickly with slspress</a></li>\n<li><a href=\"/pages/learn/listening-to-other-events-non-http/\" class=\"absolute-link\">Add some static HTML/JavaScript to use your new API</a></li>\n</ul>\n</div>\n"}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = {"search_id":"L2NvbnRlbnQvcGFnZXMvcnVuL2luZGV4Lm1k","filename":"/content/pages/run/index.md","suffix":"","attributes":{"title":"Run","sort":3},"content":[{"type":"inline","tag":"","attrs":null,"map":[0,1],"nesting":0,"level":0,"children":[{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"title: \"Run\"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"sort: 3","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"---","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/page/getting_started"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Getting Started","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/learn/index"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Learn","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/build/index"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Build","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"- ","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_open","tag":"a","attrs":[["href","/run/index"]],"map":null,"nesting":1,"level":1,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"text","tag":"","attrs":null,"map":null,"nesting":0,"level":1,"children":null,"content":"Run","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"link_close","tag":"a","attrs":null,"map":null,"nesting":-1,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false},{"type":"softbreak","tag":"br","attrs":null,"map":null,"nesting":0,"level":0,"children":null,"content":"","markup":"","info":"","meta":null,"block":false,"hidden":false}],"content":"---\ntitle: \"Run\"\nsort: 3\n---\n- [Getting Started](/page/getting_started)\n- [Learn](/learn/index)\n- [Build](/build/index)\n- [Run](/run/index)\n","markup":"","info":"","meta":null,"block":false,"hidden":false}],"html":"\n<ul>\n<li><a href=\"/page/getting_started\" class=\"absolute-link\">Getting Started</a></li>\n<li><a href=\"/learn/index\" class=\"absolute-link\">Learn</a></li>\n<li><a href=\"/build/index\" class=\"absolute-link\">Build</a></li>\n<li><a href=\"/run/index\" class=\"absolute-link\">Run</a></li>\n</ul>\n"}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(246), __esModule: true };

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(234);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 149 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(250);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);
var document = __webpack_require__(22).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(27) && !__webpack_require__(35)(function () {
  return Object.defineProperty(__webpack_require__(151)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(149);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(160);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(80);
var $iterCreate = __webpack_require__(256);
var setToStringTag = __webpack_require__(83);
var getPrototypeOf = __webpack_require__(157);
var ITERATOR = __webpack_require__(39)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(57);
var createDesc = __webpack_require__(58);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(87);
var has = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(152);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(158);
var hiddenKeys = __webpack_require__(79).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(29);
var toObject = __webpack_require__(59);
var IE_PROTO = __webpack_require__(84)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(29);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(252)(false);
var IE_PROTO = __webpack_require__(84)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(28);
var core = __webpack_require__(14);
var fails = __webpack_require__(35);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var emptyObject = __webpack_require__(61);
var _invariant = __webpack_require__(2);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(16);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(320);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(32);

var invariant = __webpack_require__(2);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstrumentation = __webpack_require__(15);

var quoteAttributeValueForBrowser = __webpack_require__(385);
var warning = __webpack_require__(4);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var LinkedValueUtils = __webpack_require__(96);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(17);

var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(345);

var containsNode = __webpack_require__(303);
var focusNode = __webpack_require__(163);
var getActiveElement = __webpack_require__(164);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(40);
var DOMProperty = __webpack_require__(41);
var React = __webpack_require__(46);
var ReactBrowserEventEmitter = __webpack_require__(63);
var ReactCurrentOwner = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMContainerInfo = __webpack_require__(339);
var ReactDOMFeatureFlags = __webpack_require__(341);
var ReactFeatureFlags = __webpack_require__(173);
var ReactInstanceMap = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(15);
var ReactMarkupChecksum = __webpack_require__(355);
var ReactReconciler = __webpack_require__(42);
var ReactUpdateQueue = __webpack_require__(99);
var ReactUpdates = __webpack_require__(17);

var emptyObject = __webpack_require__(61);
var instantiateReactComponent = __webpack_require__(184);
var invariant = __webpack_require__(2);
var setInnerHTML = __webpack_require__(67);
var shouldUpdateReactComponent = __webpack_require__(105);
var warning = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var React = __webpack_require__(46);

var invariant = __webpack_require__(2);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(177);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(7);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var ReactCompositeComponent = __webpack_require__(336);
var ReactEmptyComponent = __webpack_require__(172);
var ReactHostComponent = __webpack_require__(174);

var getNextDebugID = __webpack_require__(479);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var escapeTextContentForBrowser = __webpack_require__(66);
var setInnerHTML = __webpack_require__(67);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(20);
var REACT_ELEMENT_TYPE = __webpack_require__(351);

var getIteratorFn = __webpack_require__(382);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(95);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewportSizeType = exports.ColumnSizeType = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnSizeType = exports.ColumnSizeType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]);
var ViewportSizeType = exports.ViewportSizeType = _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(54);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(198);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(417);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(117);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(321);

var _runTransitionHook = __webpack_require__(117);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(45);

var _PathUtils = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInternetExplorerBefore;
/*
 * This detection method identifies Internet Explorers up until version 11.
 *
 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
 */
function isInternetExplorerBefore(version) {
  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);

  return iematch ? +iematch[1] < version : false;
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(55),
    _assign = __webpack_require__(5);

var ReactNoopUpdateQueue = __webpack_require__(206);

var canDefineProperty = __webpack_require__(207);
var emptyObject = __webpack_require__(61);
var invariant = __webpack_require__(2);
var lowPriorityWarning = __webpack_require__(480);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(55);

var ReactCurrentOwner = __webpack_require__(20);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(323);var _reactRouter=__webpack_require__(33);var _routes=__webpack_require__(212);var _routes2=_interopRequireDefault(_routes);__webpack_require__(487);__webpack_require__(300);var _ga=__webpack_require__(211);var _ga2=_interopRequireDefault(_ga);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// Import your routes so that you can pass them to the <Router /> component
(0,_ga2.default)(_reactRouter.browserHistory);(0,_reactDom.render)(_react2.default.createElement(_reactRouter.Router,{routes:_routes2.default,history:_reactRouter.browserHistory}),document.getElementById('root'));

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./pages/build/dumptruck.md": 118,
	"./pages/build/index.md": 119,
	"./pages/build/slspress-authentication-with-auth0.md": 120,
	"./pages/build/slspress-image-cdn.md": 121,
	"./pages/build/slspress-simple-example.md": 122,
	"./pages/community-support.md": 123,
	"./pages/getting-started.md": 124,
	"./pages/learn/adding-a-custom-url-for-your-api.md": 125,
	"./pages/learn/calling-other-lambdas.md": 126,
	"./pages/learn/developing-for-alexa.md": 127,
	"./pages/learn/developing-locally-with-serverless-offline.md": 128,
	"./pages/learn/finding-api-gateway-urls.md": 129,
	"./pages/learn/first-serverless-project.md": 130,
	"./pages/learn/how-to-use-private-dependencies.md": 131,
	"./pages/learn/index.md": 132,
	"./pages/learn/listening-to-cloudwatch-events.md": 133,
	"./pages/learn/listening-to-dynamodb-events.md": 134,
	"./pages/learn/listening-to-other-events-non-http.md": 135,
	"./pages/learn/listening-to-s3-events.md": 136,
	"./pages/learn/listening-to-ses-events.md": 137,
	"./pages/learn/listening-to-sns-events.md": 138,
	"./pages/learn/testing-with-serverless.md": 139,
	"./pages/learn/where-are-my-logs.md": 140,
	"./pages/meetup.md": 141,
	"./pages/open-source.md": 142,
	"./pages/run/CORS-in-dev-and-prod.md": 143,
	"./pages/run/hosting-for-a-serverless-project-on-s3.md": 144,
	"./pages/run/index.md": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.trackPageView=exports.default=undefined;var _reactGa=__webpack_require__(391);var _reactGa2=_interopRequireDefault(_reactGa);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var debug="production"==='development';var trackPageView=function trackPageView(location){_reactGa2.default.set({page:location.pathname});_reactGa2.default.pageview(location.pathname);};var initGa=function initGa(history){_reactGa2.default.initialize(__webpack_require__.i({"NODE_ENV":"production"}).REACT_APP_GA_IDENTIFIER||'UA-29349818-3',{debug:debug});if(debug){_reactGa2.default.ga('set','sendHitTask',null);}var currentPath=history.getCurrentLocation();trackPageView(currentPath);history.listen(trackPageView);};exports.default=initGa;exports.trackPageView=trackPageView;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.routes=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactRouter=__webpack_require__(33);var _page=__webpack_require__(219);var _Layout=__webpack_require__(213);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultRoutes=[{path:'/',title:'Home',component:_page.LandingPage},{path:'/pages/open-source/',title:'Build',component:_page.BuildPage},{path:'/pages/community-support/',title:'Community & Support',component:_page.CommunityPage},{path:'/search/',title:'Search',component:_page.SearchPage}];var requireAll=function requireAll(requireContext){return requireContext.keys().map(requireContext);};var mods=requireAll(__webpack_require__(210));var routesMap=mods.map(function(obj){return{path:obj.filename.replace('/content/','').replace('.md','/'),suffix:obj.suffix,title:obj.attributes.title||'SLS Zone',component:_page.DefaultPage,attributes:obj.attributes,content:obj.content,html:obj.html};});var routes=exports.routes=_react2.default.createElement(_reactRouter.Route,{path:'/',component:_Layout.Layout},_react2.default.createElement(_reactRouter.IndexRoute,{title:'SLS Zone',component:_page.LandingPage}),defaultRoutes.concat(routesMap).map(function(r,k){return _react2.default.createElement(_reactRouter.Route,_extends({key:k},r));}),_react2.default.createElement(_reactRouter.Redirect,{from:'/pages/meetup',to:'/pages/meetup/'}),_react2.default.createElement(_reactRouter.Redirect,{from:'/meetup',to:'/pages/meetup/'}),_react2.default.createElement(_reactRouter.Route,{path:'*',title:'SLS Zone',component:_page.LandingPage}));exports.default=routes;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Layout=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _ui=__webpack_require__(21);var _genericHelper=__webpack_require__(34);__webpack_require__(290);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Layout=exports.Layout=function(_Component){_inherits(Layout,_Component);function Layout(){_classCallCheck(this,Layout);var _this=_possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).call(this));_this.prism=window.Prism;_this.menuChanged=_this.menuChanged.bind(_this);if(_this.prism)_this.initiatePrism();_this.state={menuShow:false};return _this;}_createClass(Layout,[{key:'componentDidMount',value:function componentDidMount(){if(this.prism)this.initiatePrism();}},{key:'onRouteChanged',value:function onRouteChanged(){var _this2=this;// close menu and scroll back up on mobile when we change route
if(window.innerWidth<=768){// on next tick, make sure menu is closed if open
setTimeout(function(){_this2.setState({menuShow:false});},1);}window.scrollTo(0,0);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.prism)this.initiatePrism();if(this.props.location!==prevProps.location){this.onRouteChanged();}}},{key:'initiatePrism',value:function initiatePrism(){var _this3=this;var codeBlocks=Array.prototype.slice.call(document.getElementsByTagName('code'));codeBlocks.forEach(function(codeBlock){_this3.prism.highlightElement(codeBlock);});}},{key:'menuChanged',value:function menuChanged(evt,value){this.setState({menuShow:value!==undefined?value:!this.state.menuShow});}},{key:'render',value:function render(){var _this4=this;var _props=this.props,routes=_props.routes,children=_props.children;var pageRouteStruct=(0,_genericHelper.routeStructBuilder)({routes:routes,type:'pages'});var _ref=this.context.router.getCurrentLocation()||{},pathname=_ref.pathname;return _react2.default.createElement(_ui.Page,null,_react2.default.Children.map(children,function(child){return _react2.default.cloneElement(child,{curMenuState:_this4.state.menuShow,onMenuChange:_this4.menuChanged,routeStruct:pageRouteStruct});}),_react2.default.createElement(_ui.Sidebar,{isOpen:this.state.menuShow,currentPath:pathname,routeStruct:pageRouteStruct,curMenuState:this.state.menuShow,onMenuChange:this.menuChanged,className:pathname==='/'&&'landing'}));}}]);return Layout;}(_react.Component);Layout.propTypes={children:_propTypes.PropTypes.node,routes:_propTypes.PropTypes.array};Layout.contextTypes={router:_propTypes.PropTypes.object.isRequired};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactFlexboxGrid=__webpack_require__(68);var _ui=__webpack_require__(21);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _genericHelper=__webpack_require__(34);__webpack_require__(285);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DefaultPage=function(_React$Component){_inherits(DefaultPage,_React$Component);function DefaultPage(){_classCallCheck(this,DefaultPage);return _possibleConstructorReturn(this,(DefaultPage.__proto__||Object.getPrototypeOf(DefaultPage)).apply(this,arguments));}_createClass(DefaultPage,[{key:'componentWillMount',value:function componentWillMount(){!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);}},{key:'componentWillUpdate',value:function componentWillUpdate(){!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);}},{key:'render',value:function render(){var _props=this.props,curMenuState=_props.curMenuState,onMenuChange=_props.onMenuChange,route=_props.route;var title=route.title;var isError=(0,_genericHelper.checkIsError)(this.props);if(isError)this.context.router.push('/404');var bemmer=(0,_bem2.default)('buildpage');return _react2.default.createElement(_ui.PageWrapper,{isSidebarOpen:this.props.curMenuState},_react2.default.createElement(_ui.HtmlHead,{title:title}),_react2.default.createElement(_ui.PageContent,null,_react2.default.createElement(_ui.BurgerMenu,{curMenuState:curMenuState,onMenuChange:onMenuChange}),_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{md:8},_react2.default.createElement('h1',null,'Build'),_react2.default.createElement('p',null,'SLS Zone open source projects which are available for you to use as part of a larger project. You are welcome to submit pull requests, leave feature suggestions on the issues tracker, or just use within your own project to save you the development time.'),_react2.default.createElement('p',null,'All projects here are used daily the by Reason development team, are maintained, and battle tested through production implementation. But new use cases always come up, so feel free to let us know where they can improve.'),_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{md:6,sm:6},_react2.default.createElement('div',{className:bemmer.element('tile')},_react2.default.createElement('h3',{className:bemmer.element('tile-heading-2')},'slspress'),_react2.default.createElement('div',{className:bemmer.element('tile-content')},_react2.default.createElement('p',null,'A clean and clear way to structure your API endpoints, and Serverless architecture regardless of nano, micro or monolith. Based on express, introduces middleware and components into the serverless domain. No dependencies, lean and functional.'),_react2.default.createElement('div',{className:'icons'},_react2.default.createElement('a',{href:'https://github.com/withreason/slspress'},_react2.default.createElement('img',{alt:'Git Hub',src:'/images/logo-github-small.png'})))))),_react2.default.createElement(_reactFlexboxGrid.Col,{md:6,sm:6},_react2.default.createElement('div',{className:bemmer.element('tile')},_react2.default.createElement('h3',{className:bemmer.element('tile-heading-1')},'dumptruck'),_react2.default.createElement('div',{className:bemmer.element('tile-content')},_react2.default.createElement('p',null,'Very practical and useful AWS log streaming tool. You will find this invaluable when working with remotely deployed lambda\u2019s, and needing to view AWS Cloud Watch at runtime.'),_react2.default.createElement('div',{className:'icons'},_react2.default.createElement('a',{href:'https://github.com/withreason/dumptruck'},_react2.default.createElement('img',{alt:'Git Hub',src:'/images/logo-github-small.png'}))))))),_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{md:6,sm:6},_react2.default.createElement('div',{className:bemmer.element('tile')},_react2.default.createElement('h3',{className:bemmer.element('tile-heading-3')},'sls-notify'),_react2.default.createElement('div',{className:bemmer.element('tile-content')},_react2.default.createElement('p',null,'Managing your notification from 10 to >10,000,000. Sls-notify is built to make your communication layer easy to implement and grow to new devices as you project expands. Supports Email, SMS, APNS, GCM, and MPNS. Build on top of AWS Elastic Search, SES, & SNS.'),_react2.default.createElement('div',{className:'icons'},_react2.default.createElement('a',{href:'https://github.com/withreason/sls-notify'},_react2.default.createElement('img',{alt:'Git Hub',src:'/images/logo-github-small.png'})))))),_react2.default.createElement(_reactFlexboxGrid.Col,{md:6,sm:6},_react2.default.createElement('div',{className:bemmer.element('tile')},_react2.default.createElement('h3',{className:bemmer.element('tile-heading-4')},'sls-image-cdn'),_react2.default.createElement('div',{className:bemmer.element('tile-content')},_react2.default.createElement('p',null,'Add CDN functionality to your Serverless application. sls-cdn will help you create signed uploads, and provide on-demand image transformations and file tagging. Built on top of S3 and Cloudfront.'),_react2.default.createElement('div',{className:'icons'},_react2.default.createElement('a',{href:'https://github.com/withreason/sls-image-cdn'},_react2.default.createElement('img',{alt:'Git Hub',src:'/images/logo-github-small.png'})))))))))),_react2.default.createElement(_ui.Footer,null));}}]);return DefaultPage;}(_react2.default.Component);DefaultPage.defaultProps={onMenuChange:function onMenuChange(){},curMenuState:false};DefaultPage.propTypes={route:_propTypes.PropTypes.object,curMenuState:_propTypes.PropTypes.bool,onMenuChange:_propTypes.PropTypes.func};DefaultPage.contextTypes={router:_propTypes.PropTypes.object.isRequired};exports.default=DefaultPage;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _ui=__webpack_require__(21);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _genericHelper=__webpack_require__(34);__webpack_require__(286);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DefaultPage=function(_React$Component){_inherits(DefaultPage,_React$Component);function DefaultPage(){_classCallCheck(this,DefaultPage);return _possibleConstructorReturn(this,(DefaultPage.__proto__||Object.getPrototypeOf(DefaultPage)).apply(this,arguments));}_createClass(DefaultPage,[{key:'componentWillMount',value:function componentWillMount(){!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);}},{key:'componentWillUpdate',value:function componentWillUpdate(){!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);}},{key:'render',value:function render(){var _props=this.props,curMenuState=_props.curMenuState,onMenuChange=_props.onMenuChange,route=_props.route;var html=route.html,title=route.title;var isError=(0,_genericHelper.checkIsError)(this.props);var bemmer=(0,_bem2.default)('communitypage');if(isError)this.context.router.push('/404');return _react2.default.createElement(_ui.PageWrapper,{isSidebarOpen:this.props.curMenuState},_react2.default.createElement(_ui.HtmlHead,{title:title}),_react2.default.createElement(_ui.PageContent,{className:(0,_bem2.default)('defaultpage').element('content')},_react2.default.createElement(_ui.BurgerMenu,{curMenuState:curMenuState,onMenuChange:onMenuChange}),_react2.default.createElement('div',null,_react2.default.createElement('h1',null,'Community & Support'),_react2.default.createElement('p',null,'We\u2019re here point you to the right direction for online groups and forums you find useful in your Serverless journey. These are external communities from SLS Zone but if you have questions for the developers who are making the SLS Zone content, you can speak to any one of us.'),_react2.default.createElement('div',{className:bemmer.element('serverless')},_react2.default.createElement('a',{className:bemmer.element('logo-serverless'),href:'https://serverless.com'},_react2.default.createElement('img',{src:'/images/logo-serverless.png'})),_react2.default.createElement('ul',null,_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://forum.serverless.com/'},'Serverless forum')),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://gitter.im/serverless/serverless'},'Serverless gitter')),_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'https://www.reddit.com/r/serverless/'},'Serverless Sub-reddit')))))),_react2.default.createElement(_ui.Footer,null));}}]);return DefaultPage;}(_react2.default.Component);DefaultPage.defaultProps={onMenuChange:function onMenuChange(){},curMenuState:false};DefaultPage.propTypes={route:_propTypes.PropTypes.object,curMenuState:_propTypes.PropTypes.bool,onMenuChange:_propTypes.PropTypes.func};DefaultPage.contextTypes={router:_propTypes.PropTypes.object.isRequired};exports.default=DefaultPage;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactFlexboxGrid=__webpack_require__(68);var _ui=__webpack_require__(21);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _genericHelper=__webpack_require__(34);var _SharePanel=__webpack_require__(230);var _SharePanel2=_interopRequireDefault(_SharePanel);__webpack_require__(287);var _reactStickyBox=__webpack_require__(470);var _reactStickyBox2=_interopRequireDefault(_reactStickyBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DefaultPage=function(_React$Component){_inherits(DefaultPage,_React$Component);function DefaultPage(){_classCallCheck(this,DefaultPage);return _possibleConstructorReturn(this,(DefaultPage.__proto__||Object.getPrototypeOf(DefaultPage)).apply(this,arguments));}_createClass(DefaultPage,[{key:'componentWillMount',value:function componentWillMount(){//!this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){var nextPath=newProps.location.pathname;var currPath=this.props.location.pathname;if(nextPath!==currPath)this.loadVideoPlayer();!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);}},{key:'loadVideoPlayer',value:function loadVideoPlayer(){window.videoplayer=null;setTimeout(function(){try{onYouTubeIframeAPIReady();}catch(e){console.error(e);}},100);}},{key:'componentDidMount',value:function componentDidMount(){this.loadVideoPlayer();}},{key:'renderVideo',value:function renderVideo(){var route=this.props.route;var attributes=route.attributes;if(!attributes.video)return;var videoScript=JSON.stringify({'source':attributes.video,'timecode':attributes.timecode});return _react2.default.createElement('div',{className:"video__wrapper"},_react2.default.createElement('script',{id:'video_data',type:'application/json',dangerouslySetInnerHTML:{__html:videoScript}}),_react2.default.createElement('div',{id:'player',className:'player'},' '),_react2.default.createElement('div',{className:"video__over",id:'video__over'},_react2.default.createElement('div',{className:"video__inner"},!!attributes.timecode&&_react2.default.createElement('button',{className:'button__button button__button--primary',id:"playVid"},'Play and Follow Video'),_react2.default.createElement('button',{className:'button__button',id:"playVidOnly"},'Play Video'))));}},{key:'render',value:function render(){var _props=this.props,curMenuState=_props.curMenuState,onMenuChange=_props.onMenuChange,route=_props.route;var html=route.html,title=route.title,content=route.content,attributes=route.attributes,path=route.path;var isError=(0,_genericHelper.checkIsError)(this.props);if(isError)this.context.router.push('/404');var wideSide=false;if(!!attributes.video){wideSide=true;}return _react2.default.createElement(_ui.PageWrapper,{isSidebarOpen:this.props.curMenuState},_react2.default.createElement(_ui.HtmlHead,{title:title}),_react2.default.createElement(_reactFlexboxGrid.Grid,{fluid:true},_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{sm:wideSide?7:9,xs:12},_react2.default.createElement(_ui.PageContent,{className:(0,_bem2.default)('defaultpage').element('content')},_react2.default.createElement(_ui.BurgerMenu,{curMenuState:curMenuState,onMenuChange:onMenuChange}),_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:html}})),_react2.default.createElement(_SharePanel2.default,{loc:path,title:title})),_react2.default.createElement(_reactFlexboxGrid.Col,{sm:wideSide?5:3,xs:12},_react2.default.createElement(_reactStickyBox2.default,{bottom:false},this.renderVideo(),_react2.default.createElement(_ui.SidePanel,{content:content}))))),_react2.default.createElement(_ui.Footer,null));}}]);return DefaultPage;}(_react2.default.Component);DefaultPage.defaultProps={onMenuChange:function onMenuChange(){},curMenuState:false};DefaultPage.propTypes={route:_propTypes.PropTypes.object,curMenuState:_propTypes.PropTypes.bool,onMenuChange:_propTypes.PropTypes.func};DefaultPage.contextTypes={router:_propTypes.PropTypes.object.isRequired};exports.default=DefaultPage;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactFlexboxGrid=__webpack_require__(68);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _ui=__webpack_require__(21);__webpack_require__(288);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LandingPage=function(_Component){_inherits(LandingPage,_Component);function LandingPage(){_classCallCheck(this,LandingPage);return _possibleConstructorReturn(this,(LandingPage.__proto__||Object.getPrototypeOf(LandingPage)).apply(this,arguments));}_createClass(LandingPage,[{key:'_mountLinkList',value:function _mountLinkList(routeStruct){var children=Object.keys(routeStruct.children).map(function(k){return routeStruct.children[k];}).sort(function(a,b){return a.sort-b.sort;}).filter(function(child){return child.featured;});return _react2.default.createElement('ul',{className:'link-list'},children.map(function(child){return _react2.default.createElement('li',{key:child.url},_react2.default.createElement('a',{href:child.url},child.title));}));}},{key:'render',value:function render(){var _props=this.props,title=_props.title,routeStruct=_props.routeStruct,curMenuState=_props.curMenuState,onMenuChange=_props.onMenuChange;var bemmer=(0,_bem2.default)('landingpage');return _react2.default.createElement(_ui.PageWrapper,{isSidebarOpen:this.props.curMenuState},_react2.default.createElement(_ui.HtmlHead,{title:title}),_react2.default.createElement('div',{className:'notif'},'Looking for the London Meetup? Get more info ',_react2.default.createElement('a',{href:'/pages/meetup/'},'here'),'.'),_react2.default.createElement(_ui.PageContent,{isRaw:true,className:bemmer.element('container')},_react2.default.createElement(_ui.BurgerMenu,{curMenuState:curMenuState,onMenuChange:onMenuChange,className:'landing'}),_react2.default.createElement(_ui.PageSection,{type:'primary'},_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{md:10,mdOffset:1},_react2.default.createElement('div',{className:bemmer.element('hero')},_react2.default.createElement('img',{src:'/images/slszone_logo_tall.svg'}),_react2.default.createElement('h1',null,'SLS Zone: Learn, Build and Run Serverless applications'),_react2.default.createElement('p',null,'SLS Zone is a collection of tutorials, best practices and open source projects created for the Serverless community to help build Serverless applications the right way.'),_react2.default.createElement('p',{style:{marginBottom:'40px'}},'This toolkit has evolved over countless hours by the Reason technology team in applying these practices to real world digital products. Our aim is to help grow Serverless adoption, share knowledge and help you produce reliable, scalable and secure digital products at speed.'),_react2.default.createElement(_ui.Button,{to:'/pages/getting-started/',type:'primary'},'Get Started'))))),_react2.default.createElement(_ui.PageSection,null,_react2.default.createElement('div',{className:bemmer.element('col-table')},_react2.default.createElement('div',{className:'col-3 landing-col'},_react2.default.createElement('img',{src:'/images/icon-learn.svg'}),_react2.default.createElement('h3',null,'Learn'),_react2.default.createElement('p',null,'Guides, video tutorials, and code snippets to help you get up and running on various Serverless development topics.'),routeStruct.learn&&this._mountLinkList(routeStruct.learn)),_react2.default.createElement('div',{className:'col-3 landing-col'},_react2.default.createElement('img',{src:'/images/icon-build.png',className:bemmer.element('img-png')}),_react2.default.createElement('h3',null,'Build'),_react2.default.createElement('p',null,'Explore our open source projects to help you streamline your delivery or learn by example.'),routeStruct.build&&this._mountLinkList(routeStruct.build)),_react2.default.createElement('div',{className:'col-3 landing-col'},_react2.default.createElement('img',{src:'/images/icon-run.svg'}),_react2.default.createElement('h3',null,'Run'),_react2.default.createElement('p',null,'Run your product in a production environment. Follow some of the practices we use in production products.'),routeStruct.run&&this._mountLinkList(routeStruct.run)))),_react2.default.createElement(_ui.PageSection,{type:'secondary'},_react2.default.createElement(_reactFlexboxGrid.Grid,null,_react2.default.createElement(_reactFlexboxGrid.Row,null,_react2.default.createElement(_reactFlexboxGrid.Col,{md:8,mdOffset:2},_react2.default.createElement('div',{className:bemmer.element('hero')},_react2.default.createElement('img',{src:'/images/icon-open-source-projects.svg'}),_react2.default.createElement('h2',null,'Open source projects to prevent you from re-inventing the wheel.'),_react2.default.createElement('p',null,'Some of our default goto libraries are open for use and contribution. These libraries are staple for many of our projects, are proven and tested. We are continually evolving them to meet further needs, but feel free to suggest features or fork the projects for your own purposes.'),_react2.default.createElement(_ui.Button,{to:'/pages/open-source/',type:'secondary'},'View projects')))))),_react2.default.createElement(_ui.PageSection,null,_react2.default.createElement('div',{className:bemmer.element('hero')},_react2.default.createElement('img',{src:'/images/logo-sls-zone.svg'}),_react2.default.createElement('h2',null,'Join the online community'),_react2.default.createElement('p',null,'There\u2019s no point going Hans Solo when we can all use the force\u2026'),_react2.default.createElement(_ui.Button,{to:'/pages/community-support/',type:'tertiary'},'View channels')))),_react2.default.createElement(_ui.Footer,null));}}]);return LandingPage;}(_react.Component);LandingPage.defaultProps={title:'SLS Zone'};LandingPage.propTypes={curMenuState:_propTypes.PropTypes.bool,onMenuChange:_propTypes.PropTypes.func,title:_propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string,_propTypes.PropTypes.element]),currentPath:_propTypes.PropTypes.string};exports.default=LandingPage;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactRouter=__webpack_require__(33);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _ui=__webpack_require__(21);__webpack_require__(486);__webpack_require__(289);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(){_classCallCheck(this,SearchPage);var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this));_this._sendQuery=_this._sendQuery.bind(_this);_this._queryStatus=_this._queryStatus.bind(_this);_this._queryParse=_this._queryParse.bind(_this);_this._querySuccess=_this._querySuccess.bind(_this);_this._queryError=_this._queryError.bind(_this);return _this;}_createClass(SearchPage,[{key:'componentWillMount',value:function componentWillMount(){!this.props.curMenuState&&this.props.onMenuChange&&this.props.onMenuChange(null,true);this.setState({queryData:[],queryError:null});var location=this.props.location;if(location.query.q){this._sendQuery(location.query);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(nextProps.location.query!==this.props.location.query){this._sendQuery(nextProps.location.query);}}},{key:'_sendQuery',value:function _sendQuery(query){var _this2=this;fetch(SLS_ES_PATH+'?q='+query.q,{method:'GET',mode:'cors',headers:new Headers({'Content-Type':'application/json'})}).then(function(response){return _this2._queryStatus(response);}).then(function(response){return _this2._queryParse(response);}).then(function(response){return _this2._querySuccess(response);}).catch(function(err){return _this2._queryError(err);});}},{key:'_queryStatus',value:function _queryStatus(response){if(response.status>=200&&response.status<300&&response.status!==204){return response;}else{var error=new Error(response.statusText);error.response=response;error.status=response.status;throw error;}}},{key:'_queryParse',value:function _queryParse(response){return response.json();}},{key:'_querySuccess',value:function _querySuccess(response){this.setState({queryData:response.results.hits.hits||[],queryError:null});}},{key:'_queryError',value:function _queryError(err){this.setState({queryData:[],queryError:err});}},{key:'_displayFound',value:function _displayFound(_ref){var bemmer=_ref.bemmer;var _state=this.state,queryData=_state.queryData,queryError=_state.queryError;return!queryData||queryData.length<=0?_react2.default.createElement('section',{className:bemmer.element('notfound')},_react2.default.createElement('h2',null,'Results:'),_react2.default.createElement('h4',null,queryError&&queryError.message?queryError.message:'Error.')):_react2.default.createElement('section',{className:bemmer.element('found')},_react2.default.createElement('h2',null,'Results:'),_react2.default.createElement('section',{className:bemmer.element('list')},this.state.queryData.map(function(record){var lastUpdated=record._source?new Date(record._source.last_updated):null;var description=record._source.description?record._source.description:'';return _react2.default.createElement('article',{key:'list-item_'+record._source.title,className:bemmer.element('list-item')},_react2.default.createElement(_reactRouter.Link,{to:record._source.filename.replace('/content','').replace('.md','')},_react2.default.createElement('h4',null,record._source.title)),_react2.default.createElement('h6',null,'last updated: ',lastUpdated?''+lastUpdated.toLocaleDateString("en-GB"):null),_react2.default.createElement('p',{className:'description'},description.replace('#','')));})));}},{key:'render',value:function render(){var _props=this.props,location=_props.location,curMenuState=_props.curMenuState;var bemmer=(0,_bem2.default)('searchpage');return _react2.default.createElement(_ui.PageWrapper,{isSidebarOpen:curMenuState},_react2.default.createElement(_ui.HtmlHead,{title:'Search'}),_react2.default.createElement(_ui.PageContent,{className:bemmer.element('content')},_react2.default.createElement(_ui.PageSection,null,_react2.default.createElement(_ui.Searchbar,{location:location}),this._displayFound({bemmer:bemmer}))),_react2.default.createElement(_ui.Footer,null));}}]);return SearchPage;}(_react.Component);SearchPage.defaultProps={curMenuState:false};SearchPage.propTypes={curMenuState:_propTypes.PropTypes.bool,headerRouteStruct:_propTypes.PropTypes.object,route:_propTypes.PropTypes.object,currentPath:_propTypes.PropTypes.string,onMenuClick:_propTypes.PropTypes.func};SearchPage.contextTypes={router:_propTypes.PropTypes.object.isRequired};exports.default=SearchPage;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _LandingPage=__webpack_require__(217);Object.defineProperty(exports,'LandingPage',{enumerable:true,get:function get(){return _interopRequireDefault(_LandingPage).default;}});var _DefaultPage=__webpack_require__(216);Object.defineProperty(exports,'DefaultPage',{enumerable:true,get:function get(){return _interopRequireDefault(_DefaultPage).default;}});var _BuildPage=__webpack_require__(214);Object.defineProperty(exports,'BuildPage',{enumerable:true,get:function get(){return _interopRequireDefault(_BuildPage).default;}});var _SearchPage=__webpack_require__(218);Object.defineProperty(exports,'SearchPage',{enumerable:true,get:function get(){return _interopRequireDefault(_SearchPage).default;}});var _CommunityPage=__webpack_require__(215);Object.defineProperty(exports,'CommunityPage',{enumerable:true,get:function get(){return _interopRequireDefault(_CommunityPage).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);__webpack_require__(291);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LandingPage=function(_Component){_inherits(LandingPage,_Component);function LandingPage(props){_classCallCheck(this,LandingPage);var _this=_possibleConstructorReturn(this,(LandingPage.__proto__||Object.getPrototypeOf(LandingPage)).call(this,props));_this._onBurgerClick=_this._onBurgerClick.bind(_this);return _this;}_createClass(LandingPage,[{key:'_onBurgerClick',value:function _onBurgerClick(evt){this.props.onMenuChange&&this.props.onMenuChange(evt,!this.props.curMenuState);}},{key:'render',value:function render(){return _react2.default.createElement('a',{className:'burger-menu '+this.props.className,onClick:this._onBurgerClick});}}]);return LandingPage;}(_react.Component);LandingPage.propTypes={curMenuState:_propTypes.PropTypes.bool,onMenuChange:_propTypes.PropTypes.func};exports.default=LandingPage;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _genericHelper=__webpack_require__(34);var _reactRouter=__webpack_require__(33);__webpack_require__(292);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_Component){_inherits(Button,_Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:'render',value:function render(){var bemmer=(0,_bem2.default)('button');var _props=this.props,children=_props.children,className=_props.className,to=_props.to;var btnBemmer=bemmer.element('button').modifier(this.props.type);return typeof to==='string'&&(0,_genericHelper.isUrlExternal)(to)?_react2.default.createElement('a',{className:btnBemmer+' '+className,href:to,target:'_blank'},children):_react2.default.createElement(_reactRouter.Link,{className:btnBemmer+' '+className,to:to},children);}}]);return Button;}(_react.Component);exports.default=Button;Button.defaultProps={className:'',type:null,to:undefined};Button.propTypes={type:_react2.default.PropTypes.oneOf(['primary','secondary','tertiary'])};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactRouter=__webpack_require__(33);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _genericHelper=__webpack_require__(34);__webpack_require__(293);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this));}_createClass(Footer,[{key:'renderLinks',value:function renderLinks(_ref){var bemmer=_ref.bemmer;var _props=this.props,links=_props.links,defaultFooter=_props.defaultFooter;var combinedLinks=links.concat(defaultFooter);return _react2.default.createElement('ul',{className:bemmer.element('links')},combinedLinks.map(function(content){return _react2.default.createElement('li',{key:'footer_'+content.name},(0,_genericHelper.isUrlExternal)(content.url)?_react2.default.createElement('a',{href:content.url,target:'blank'},content.name):_react2.default.createElement(_reactRouter.Link,{to:content.url?content.url:'/'},content.name));}));}},{key:'render',value:function render(){var bemmer=(0,_bem2.default)('footer');return _react2.default.createElement('footer',{className:bemmer.element('container')},_react2.default.createElement('a',{className:bemmer.element('logo-reason'),href:'https://reason.co'},_react2.default.createElement('span',null,'Made by the team at'),_react2.default.createElement('img',{src:'/images/logo-reason.png',srcSet:'/images/logo-reason.png 1x, /images/logo-reason@2x.png 2x, /images/logo-reason@3x.png 3x'})),this.renderLinks({bemmer:bemmer}),_react2.default.createElement('a',{className:bemmer.element('logo-serverless'),href:'https://serverless.com'},_react2.default.createElement('img',{src:'/images/logo-serverless.png',srcSet:'/images/logo-serverless.png 1x, /images/logo-serverless@2x.png 2x, /images/logo-serverless@3x.png 3x'})));}}]);return Footer;}(_react.Component);exports.default=Footer;Footer.propTypes={};Footer.defaultProps={links:[],defaultFooter:[{name:'Github',url:'https://github.com/withreason'},{name:'Twitter',url:'https://twitter.com/slszone'}]};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=HtmlHead;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(399);var _reactHelmet2=_interopRequireDefault(_reactHelmet);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function HtmlHead(props){var title=props.title;return _react2.default.createElement(_reactHelmet2.default,null,_react2.default.createElement('html',{lang:'en'}),' ',_react2.default.createElement('title',null,title+' | Reason SLS'),_react2.default.createElement('meta',{charSet:'utf-8'}),_react2.default.createElement('meta',{name:'viewport',content:'width=device-width, initial-scale=1'}));}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);__webpack_require__(294);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputText=function(_Component){_inherits(InputText,_Component);function InputText(){_classCallCheck(this,InputText);return _possibleConstructorReturn(this,(InputText.__proto__||Object.getPrototypeOf(InputText)).call(this));}_createClass(InputText,[{key:'render',value:function render(){var _props=this.props,className=_props.className,placeholder=_props.placeholder,defaultValue=_props.defaultValue,isSearch=_props.isSearch,onChange=_props.onChange;var bemmer=(0,_bem2.default)('inputtext');var outerBemmer=bemmer.element('container');outerBemmer=isSearch?outerBemmer.modifier('with-search'):outerBemmer;return _react2.default.createElement('div',{className:outerBemmer.withClass(className)},_react2.default.createElement('input',{onChange:onChange?onChange.bind(this):null,className:bemmer.element('input'),defaultValue:defaultValue,placeholder:placeholder}));}}]);return InputText;}(_react.Component);exports.default=InputText;InputText.defaultProps={className:'',isSearch:false};InputText.propTypes={defaultValue:_propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string,_propTypes.PropTypes.number]),placeholder:_propTypes.PropTypes.string,onChange:_propTypes.PropTypes.func};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);__webpack_require__(295);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=function(_Component){_inherits(Page,_Component);function Page(){_classCallCheck(this,Page);return _possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).call(this));}_createClass(Page,[{key:'render',value:function render(){var _props=this.props,className=_props.className,children=_props.children;return _react2.default.createElement('section',{className:(0,_bem2.default)('page').element('container')+' '+className},children);}}]);return Page;}(_react.Component);exports.default=Page;Page.defaultProps={className:''};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactFlexboxGrid=__webpack_require__(68);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageContent=function(_Component){_inherits(PageContent,_Component);function PageContent(){_classCallCheck(this,PageContent);return _possibleConstructorReturn(this,(PageContent.__proto__||Object.getPrototypeOf(PageContent)).call(this));}_createClass(PageContent,[{key:'render',value:function render(){var bemmer=(0,_bem2.default)('pagecontent');var _props=this.props,children=_props.children,className=_props.className,isRaw=_props.isRaw;var outerBemmer=!isRaw?bemmer.element('container'):bemmer.element('raw-container');outerBemmer=className?outerBemmer.withClass(className):outerBemmer;return _react2.default.createElement('section',{className:outerBemmer},children);}}]);return PageContent;}(_react.Component);exports.default=PageContent;PageContent.propTypes={className:_propTypes.PropTypes.oneOfType([_propTypes.PropTypes.object,_propTypes.PropTypes.string])};PageContent.defaultProps={isRaw:false};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageSection=function(_Component){_inherits(PageSection,_Component);function PageSection(){_classCallCheck(this,PageSection);return _possibleConstructorReturn(this,(PageSection.__proto__||Object.getPrototypeOf(PageSection)).call(this));}_createClass(PageSection,[{key:'render',value:function render(){var bemmer=(0,_bem2.default)('pagesection');var _props=this.props,children=_props.children,type=_props.type,defaultStyle=_props.defaultStyle,bgImg=_props.bgImg,className=_props.className;var bgImgStyle=bgImg?{backgroundImage:'url('+bgImg+')'}:{};var style=Object.assign(defaultStyle,bgImgStyle);return _react2.default.createElement('section',{style:style,className:bemmer.element('container').modifier(type)+' '+className},children);}}]);return PageSection;}(_react.Component);exports.default=PageSection;PageSection.defaultProps={className:'',type:null,defaultStyle:{backgroundImage:null,backgroundSize:'cover',backgroundPosition:'center'}};PageSection.propTypes={bgImg:_propTypes.PropTypes.string,type:_react2.default.PropTypes.oneOf(['primary','secondary',null])};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageWrapper=function(_Component){_inherits(PageWrapper,_Component);function PageWrapper(){_classCallCheck(this,PageWrapper);return _possibleConstructorReturn(this,(PageWrapper.__proto__||Object.getPrototypeOf(PageWrapper)).call(this));}_createClass(PageWrapper,[{key:'render',value:function render(){var className='pagewrapper';var _props=this.props,children=_props.children,isSidebarOpen=_props.isSidebarOpen;return _react2.default.createElement('div',{className:(0,_bem2.default)(className).element('container').modifier(isSidebarOpen?'sidebar-active':'sidebar-inactive')},children);}}]);return PageWrapper;}(_react.Component);exports.default=PageWrapper;PageWrapper.defaultProps={isSidebarOpen:false};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);var _ui=__webpack_require__(21);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Searchbar=function(_Component){_inherits(Searchbar,_Component);function Searchbar(){_classCallCheck(this,Searchbar);var _this=_possibleConstructorReturn(this,(Searchbar.__proto__||Object.getPrototypeOf(Searchbar)).call(this));_this._inputChange=_this._inputChange.bind(_this);_this._formSubmit=_this._formSubmit.bind(_this);return _this;}_createClass(Searchbar,[{key:'componentWillMount',value:function componentWillMount(){this.setState({q:this.props.q});}},{key:'_inputChange',value:function _inputChange(evt){this.setState({q:evt.target.value});}},{key:'_formSubmit',value:function _formSubmit(evt){evt.preventDefault();var router=this.context.router;router.push({pathname:'/search',query:{q:this.state.q}});}},{key:'render',value:function render(){var _this2=this;var bemmer=(0,_bem2.default)('searchbar');var location=this.props.location;var _ref=location||{},pathname=_ref.pathname,query=_ref.query;return _react2.default.createElement('form',{className:bemmer.element('form'),ref:function ref(component){return _this2.form;},onSubmit:this._formSubmit},_react2.default.createElement(_ui.InputText,{isSearch:true,defaultValue:pathname==='/search'?query.q:null,onChange:this._inputChange,placeholder:'search...',ref:function ref(component){return _this2.input=component;}}));}}]);return Searchbar;}(_react.Component);Searchbar.defaultProps={q:null};Searchbar.propTypes={q:_propTypes.PropTypes.string,location:_propTypes.PropTypes.object.isRequired};Searchbar.contextTypes={router:_propTypes.PropTypes.object.isRequired};exports.default=Searchbar;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactRouter=__webpack_require__(33);var _propTypes=__webpack_require__(0);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);__webpack_require__(296);var _reactShare=__webpack_require__(468);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import './Footer.scss'
var SharePanel=function(_Component){_inherits(SharePanel,_Component);function SharePanel(){_classCallCheck(this,SharePanel);return _possibleConstructorReturn(this,(SharePanel.__proto__||Object.getPrototypeOf(SharePanel)).apply(this,arguments));}_createClass(SharePanel,[{key:'render',value:function render(){if(!this.props.loc){return _react2.default.createElement('div',null);}var urlPath='https://sls.zone/'+this.props.loc;var title=this.props.title||'Serverless Tutorials';var shareProps={url:urlPath,title:'sls.zone - '+title,body:'Saw this on https://sls.zone and thought it might be useful '+urlPath,round:'round'};var icoP={size:32,round:'round'};return _react2.default.createElement('div',{className:"social__wrapper"},_react2.default.createElement('h4',null,'Has this been helpful? Why not share the knowledge:'),_react2.default.createElement('div',{className:"social__buttons"},_react2.default.createElement(_reactShare.FacebookShareButton,shareProps,_react2.default.createElement(_reactShare.FacebookIcon,icoP)),_react2.default.createElement(_reactShare.LinkedinShareButton,shareProps,_react2.default.createElement(_reactShare.LinkedinIcon,icoP)),_react2.default.createElement(_reactShare.TwitterShareButton,shareProps,_react2.default.createElement(_reactShare.TwitterIcon,icoP)),_react2.default.createElement(_reactShare.WhatsappShareButton,shareProps,_react2.default.createElement(_reactShare.WhatsappIcon,icoP)),_react2.default.createElement(_reactShare.RedditShareButton,shareProps,_react2.default.createElement(_reactShare.RedditIcon,icoP)),_react2.default.createElement(_reactShare.EmailShareButton,shareProps,_react2.default.createElement(_reactShare.EmailIcon,icoP))));}}]);return SharePanel;}(_react.Component);exports.default=SharePanel;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(297);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidePanel=function(_Component){_inherits(SidePanel,_Component);function SidePanel(){_classCallCheck(this,SidePanel);var _this=_possibleConstructorReturn(this,(SidePanel.__proto__||Object.getPrototypeOf(SidePanel)).call(this));_this.formatHeading=function(heading){var out=heading.split('#').join('').split('##').join('').split('###').join('');return out;};_this.getAllHeadings=function(content){var headings=[];// if no content provided
if(content.length===0)return headings;// loop and find all headings
content[0].children.map(function(child){// consider only text elements
if(child.type==='text'){// consider only headings
if(child.content.indexOf('##')>-1){headings.push(_this.formatHeading(child.content));}}});return headings;};_this.renderTitles=function(titles){return titles.map(function(title,k){return _react2.default.createElement('div',{className:'side__panel__option',key:k},_react2.default.createElement('a',{href:'#'+title.split(' ').join('')},title));});};return _this;}_createClass(SidePanel,[{key:'render',value:function render(){var content=this.props.content;var titles=this.getAllHeadings(content);return _react2.default.createElement('div',{className:'side__panel'},_react2.default.createElement('div',{className:'side__panel__options'},this.renderTitles(titles)));}}]);return SidePanel;}(_react.Component);exports.default=SidePanel;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(0);var _reactCollapsible=__webpack_require__(322);var _reactCollapsible2=_interopRequireDefault(_reactCollapsible);var _reactRouter=__webpack_require__(33);var _=__webpack_require__(21);var _bem=__webpack_require__(11);var _bem2=_interopRequireDefault(_bem);__webpack_require__(298);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sidebar=function(_Component){_inherits(Sidebar,_Component);function Sidebar(){_classCallCheck(this,Sidebar);return _possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).apply(this,arguments));}_createClass(Sidebar,[{key:'componentWillMount',value:function componentWillMount(){this.collapsible=[];}},{key:'componentWillUpdate',value:function componentWillUpdate(){this.collapsible=[];}},{key:'_genRanKey',value:function _genRanKey(type,title){return type+'_'+title+'_'+Math.round(Math.random()*1000);}},{key:'_navNormal',value:function _navNormal(_ref){var bemmer=_ref.bemmer,url=_ref.url,_ref$title=_ref.title,title=_ref$title===undefined?'Name':_ref$title,currentPath=_ref.currentPath;var childUrl=url;var currentPage=childUrl===currentPath;var newBemmer=currentPage?bemmer.element('no-collapse-link').modifier('current-page'):bemmer.element('no-collapse-link');return _react2.default.createElement(_reactRouter.Link,{key:this._genRanKey('sidebar_normal',title),className:newBemmer,to:childUrl},title);}},{key:'_navCollapsable',value:function _navCollapsable(_ref2){var _this2=this;var bemmer=_ref2.bemmer,id=_ref2.id,_ref2$title=_ref2.title,title=_ref2$title===undefined?'Name':_ref2$title,_ref2$children=_ref2.children,children=_ref2$children===undefined?[]:_ref2$children,currentPath=_ref2.currentPath;var colBemmer=bemmer.element('collapsible');var outerBemmer=bemmer.element('collapsible-outer');var innerBemmer=bemmer.element('collapsible-inner');var stayOpen=false;// SORT IT
var keys=Object.keys(children).sort(function(a,b){return children[a].sort>children[b].sort;});var innerContent=keys.map(function(index){var linkBemmer=bemmer.element('collapsible-inner-link');var childUrl=children[index].url;var currentPage=childUrl===currentPath;if(currentPage)stayOpen=true;return _react2.default.createElement(_reactRouter.Link,{className:linkBemmer.modifier(currentPage?'current-page':null),key:_this2._genRanKey('sidebar_link',children[index].title),to:childUrl},children[index].title,children[index].tags&&children[index].tags.indexOf('new')>=0?_react2.default.createElement('span',{className:bemmer.element('badge')},_react2.default.createElement('img',{className:bemmer.element('badge__image'),src:'/images/tag-new-content.png'})):'');});return _react2.default.createElement(_reactCollapsible2.default,{ref:function ref(component){return _this2.collapsible.push(component);},open:stayOpen,key:this._genRanKey('sidebar_collapse',title),className:colBemmer.toString(),openedClassName:colBemmer.modifier('opened').toString(),triggerClassName:outerBemmer.toString(),triggerOpenedClassName:outerBemmer.modifier('opened').toString(),contentInnerClassName:innerBemmer.toString(),transitionTime:200,trigger:_react2.default.createElement('span',null,title,_react2.default.createElement('i',{className:'arrow-icon'}))},innerContent);}},{key:'renderInnerNavs',value:function renderInnerNavs(_ref3){var _this3=this;var bemmer=_ref3.bemmer,routeStruct=_ref3.routeStruct,currentPath=_ref3.currentPath;var keys=Object.keys(routeStruct).sort(function(a,b){return routeStruct[a].sort>routeStruct[b].sort;});return keys.map(function(index){if(routeStruct[index].children)return _this3._navCollapsable(_extends({bemmer:bemmer},routeStruct[index],{currentPath:currentPath}));return _this3._navNormal(_extends({bemmer:bemmer},routeStruct[index],{currentPath:currentPath}));});}},{key:'render',value:function render(){var bemmer=(0,_bem2.default)('sidebar');var _props=this.props,isOpen=_props.isOpen,headerChildren=_props.headerChildren,footerChildren=_props.footerChildren,routeStruct=_props.routeStruct,currentPath=_props.currentPath,curMenuState=_props.curMenuState,onMenuChange=_props.onMenuChange,className=_props.className;return _react2.default.createElement('nav',{className:bemmer.element('container').modifier(isOpen?'active':'inactive')+' '+className},_react2.default.createElement('header',{className:bemmer.element('header')},_react2.default.createElement(_reactRouter.Link,{to:'/'},_react2.default.createElement('h1',{className:'sls-zone-hero'},'SLS Zone')),_react2.default.createElement(_.BurgerMenu,{curMenuState:curMenuState,onMenuChange:onMenuChange}),headerChildren),!routeStruct?_react2.default.createElement('div',null):this.renderInnerNavs({bemmer:bemmer,routeStruct:routeStruct,currentPath:currentPath}),_react2.default.createElement('footer',null,footerChildren));}}]);return Sidebar;}(_react.Component);Sidebar.defaultProps={isOpen:false,currentPath:null};Sidebar.propTypes={routeStruct:_propTypes.PropTypes.object,headerRouteStruct:_propTypes.PropTypes.object,headerChildren:_propTypes.PropTypes.oneOfType([_propTypes.PropTypes.element,_propTypes.PropTypes.string]),footerChildren:_propTypes.PropTypes.oneOfType([_propTypes.PropTypes.element,_propTypes.PropTypes.string])};exports.default=Sidebar;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(242), __esModule: true };

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(243), __esModule: true };

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(247), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(248), __esModule: true };

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(249), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(14);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(267);
module.exports = __webpack_require__(14).Object.assign;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(268);
var $Object = __webpack_require__(14).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(269);
var $Object = __webpack_require__(14).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(270);
module.exports = __webpack_require__(14).Object.getPrototypeOf;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271);
module.exports = __webpack_require__(14).Object.keys;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
module.exports = __webpack_require__(14).Object.setPrototypeOf;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(275);
__webpack_require__(273);
__webpack_require__(276);
__webpack_require__(277);
module.exports = __webpack_require__(14).Symbol;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(278);
module.exports = __webpack_require__(89).f('iterator');


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(265);
var toAbsoluteIndex = __webpack_require__(264);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(49);
var gOPS = __webpack_require__(82);
var pIE = __webpack_require__(57);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(22).document;
module.exports = document && document.documentElement;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(149);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(81);
var descriptor = __webpack_require__(58);
var setToStringTag = __webpack_require__(83);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(36)(IteratorPrototype, __webpack_require__(39)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(60)('meta');
var isObject = __webpack_require__(37);
var has = __webpack_require__(29);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(35)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(49);
var gOPS = __webpack_require__(82);
var pIE = __webpack_require__(57);
var toObject = __webpack_require__(59);
var IObject = __webpack_require__(153);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(35)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var anObject = __webpack_require__(48);
var getKeys = __webpack_require__(49);

module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(156).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(37);
var anObject = __webpack_require__(48);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(150)(Function.call, __webpack_require__(155).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(86);
var defined = __webpack_require__(78);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(86);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(86);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(251);
var step = __webpack_require__(257);
var Iterators = __webpack_require__(80);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(154)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(28);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(259) });


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(81) });


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(59);
var $getPrototypeOf = __webpack_require__(157);

__webpack_require__(159)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(59);
var $keys = __webpack_require__(49);

__webpack_require__(159)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(28);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(262).set });


/***/ }),
/* 273 */
/***/ (function(module, exports) {



/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(263)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(154)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(22);
var has = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(27);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(160);
var META = __webpack_require__(258).KEY;
var $fails = __webpack_require__(35);
var shared = __webpack_require__(85);
var setToStringTag = __webpack_require__(83);
var uid = __webpack_require__(60);
var wks = __webpack_require__(39);
var wksExt = __webpack_require__(89);
var wksDefine = __webpack_require__(88);
var enumKeys = __webpack_require__(253);
var isArray = __webpack_require__(255);
var anObject = __webpack_require__(48);
var isObject = __webpack_require__(37);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(87);
var createDesc = __webpack_require__(58);
var _create = __webpack_require__(81);
var gOPNExt = __webpack_require__(261);
var $GOPD = __webpack_require__(155);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(49);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(156).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(57).f = $propertyIsEnumerable;
  __webpack_require__(82).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('asyncIterator');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('observable');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(266);
var global = __webpack_require__(22);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(80);
var TO_STRING_TAG = __webpack_require__(39)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(280);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(315);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(283);
var isArguments = __webpack_require__(282);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 282 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(301);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(311);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(2);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(12);

var createArrayFromMixed = __webpack_require__(304);
var getMarkupWrap = __webpack_require__(306);
var invariant = __webpack_require__(2);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(12);

var invariant = __webpack_require__(2);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(308);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(310);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(316);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(314);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(166);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(402);
var assign = __webpack_require__(5);

var ReactPropTypesSecret = __webpack_require__(166);
var checkPropTypes = __webpack_require__(318);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(485);
var objectAssign = __webpack_require__(5);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapsible = _react2.default.createClass({
  displayName: 'Collapsible',


  //Set validation for prop types
  propTypes: {
    transitionTime: _react2.default.PropTypes.number,
    easing: _react2.default.PropTypes.string,
    open: _react2.default.PropTypes.bool,
    classParentString: _react2.default.PropTypes.string,
    openedClassName: _react2.default.PropTypes.string,
    triggerClassName: _react2.default.PropTypes.string,
    triggerOpenedClassName: _react2.default.PropTypes.string,
    contentOuterClassName: _react2.default.PropTypes.string,
    contentInnerClassName: _react2.default.PropTypes.string,
    accordionPosition: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
    handleTriggerClick: _react2.default.PropTypes.func,
    onOpen: _react2.default.PropTypes.func,
    onClose: _react2.default.PropTypes.func,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
    triggerWhenOpen: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
    triggerDisabled: _react2.default.PropTypes.bool,
    lazyRender: _react2.default.PropTypes.bool,
    overflowWhenOpen: _react2.default.PropTypes.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
    triggerSibling: _react2.default.PropTypes.element
  },

  //If no transition time or easing is passed then default to this
  getDefaultProps: function getDefaultProps() {
    return {
      transitionTime: 400,
      easing: 'linear',
      open: false,
      classParentString: 'Collapsible',
      triggerDisabled: false,
      lazyRender: false,
      overflowWhenOpen: 'hidden',
      openedClassName: '',
      triggerClassName: '',
      triggerOpenedClassName: '',
      contentOuterClassName: '',
      contentInnerClassName: '',
      className: '',
      triggerSibling: null,
      onOpen: function onOpen() {},
      onClose: function onClose() {}
    };
  },

  //Defaults the dropdown to be closed
  getInitialState: function getInitialState() {

    if (this.props.open) {
      return {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: this.props.overflowWhenOpen
      };
    } else {
      return {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
        hasBeenOpened: false,
        overflow: 'hidden'
      };
    }
  },

  // Taken from https://github.com/EvandroLG/transitionEnd/
  // Determines which prefixed event to listen for
  whichTransitionEnd: function whichTransitionEnd(element) {
    var transitions = {
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'oTransitionEnd otransitionend',
      'transition': 'transitionend'
    };

    for (var t in transitions) {
      if (element.style[t] !== undefined) {
        return transitions[t];
      }
    }
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    //Set up event listener to listen to transitionend so we can switch the height from fixed pixel to auto for much responsiveness;
    //TODO:  Once Synthetic transitionend events have been exposed in the next release of React move this funciton to a function handed to the onTransitionEnd prop

    this.refs.outer.addEventListener(this.whichTransitionEnd(this.refs.outer), function (event) {
      if (_this.state.isClosed === false) {
        _this.setState({
          shouldSwitchAutoOnNextCycle: true
        });
      }
    });
  },

  componentDidUpdate: function componentDidUpdate(prevProps) {

    if (this.state.shouldSwitchAutoOnNextCycle === true && this.state.isClosed === false) {
      //Set the height to auto to make compoenent re-render with the height set to auto.
      //This way the dropdown will be responsive and also change height if there is another dropdown within it.
      this.makeResponsive();
    }

    if (this.state.shouldSwitchAutoOnNextCycle === true && this.state.isClosed === true) {
      this.prepareToOpen();
    }

    //If there has been a change in the open prop (controlled by accordion)
    if (prevProps.open != this.props.open) {
      if (this.props.open === true) {
        this.openCollapsible();
      } else {
        this.closeCollapsible();
      }
    }
  },

  handleTriggerClick: function handleTriggerClick(event) {

    event.preventDefault();

    if (this.props.triggerDisabled) {
      return;
    }

    if (this.props.handleTriggerClick) {
      this.props.handleTriggerClick(this.props.accordionPosition);
    } else {

      if (this.state.isClosed === true) {
        this.openCollapsible();
      } else {
        this.closeCollapsible();
      }
    }
  },

  closeCollapsible: function closeCollapsible() {
    this.setState({
      isClosed: true,
      shouldSwitchAutoOnNextCycle: true,
      height: this.refs.inner.offsetHeight,
      overflow: 'hidden'
    }, this.props.onClose);
  },

  openCollapsible: function openCollapsible() {
    this.setState({
      height: this.refs.inner.offsetHeight,
      transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
      isClosed: false,
      hasBeenOpened: true
    }, this.props.onOpen);
  },

  makeResponsive: function makeResponsive() {
    this.setState({
      height: 'auto',
      transition: 'none',
      shouldSwitchAutoOnNextCycle: false,
      overflow: this.props.overflowWhenOpen
    });
  },

  prepareToOpen: function prepareToOpen() {
    var _this2 = this;

    //The height has been changes back to fixed pixel, we set a small timeout to force the CSS transition back to 0 on the next tick.
    window.setTimeout(function () {
      _this2.setState({
        height: 0,
        shouldSwitchAutoOnNextCycle: false,
        transition: 'height ' + _this2.props.transitionTime + 'ms ' + _this2.props.easing
      });
    }, 50);
  },

  renderNonClickableTriggerElement: function renderNonClickableTriggerElement() {
    if (this.props.triggerSibling) {
      return _react2.default.createElement(
        'span',
        { className: this.props.classParentString + "__trigger-sibling" },
        this.props.triggerSibling
      );
    }

    return null;
  },

  render: function render() {

    var dropdownStyle = {
      height: this.state.height,
      WebkitTransition: this.state.transition,
      msTransition: this.state.transition,
      transition: this.state.transition,
      overflow: this.state.overflow
    };

    var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
    var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';

    //If user wants different text when tray is open
    var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;

    // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
    var children = this.props.children;
    if (this.props.lazyRender) if (!this.state.hasBeenOpened) children = null;

    var triggerClassName = this.props.classParentString + "__trigger" + ' ' + openClass + ' ' + disabledClass;

    if (this.state.isClosed) {
      triggerClassName = triggerClassName + ' ' + this.props.triggerClassName;
    } else {
      triggerClassName = triggerClassName + ' ' + this.props.triggerOpenedClassName;
    }

    return _react2.default.createElement(
      'div',
      { className: this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName) },
      _react2.default.createElement(
        'span',
        { className: triggerClassName.trim(), onClick: this.handleTriggerClick },
        trigger
      ),
      this.renderNonClickableTriggerElement(),
      _react2.default.createElement(
        'div',
        { className: this.props.classParentString + "__contentOuter" + ' ' + this.props.contentOuterClassName, ref: 'outer', style: dropdownStyle },
        _react2.default.createElement(
          'div',
          { className: this.props.classParentString + "__contentInner" + ' ' + this.props.contentInnerClassName, ref: 'inner' },
          children
        )
      )
    );
  }
});

exports.default = Collapsible;



/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(337);


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(7);

var focusNode = __webpack_require__(163);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(51);
var ExecutionEnvironment = __webpack_require__(12);
var FallbackCompositionState = __webpack_require__(332);
var SyntheticCompositionEvent = __webpack_require__(369);
var SyntheticInputEvent = __webpack_require__(372);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(167);
var ExecutionEnvironment = __webpack_require__(12);
var ReactInstrumentation = __webpack_require__(15);

var camelizeStyleName = __webpack_require__(302);
var dangerousStyleValue = __webpack_require__(378);
var hyphenateStyleName = __webpack_require__(309);
var memoizeStringOnly = __webpack_require__(312);
var warning = __webpack_require__(4);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(50);
var EventPropagators = __webpack_require__(51);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(17);
var SyntheticEvent = __webpack_require__(19);

var inputValueTracking = __webpack_require__(183);
var getEventTarget = __webpack_require__(103);
var isEventSupported = __webpack_require__(104);
var isTextInputElement = __webpack_require__(185);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(40);
var ExecutionEnvironment = __webpack_require__(12);

var createNodesFromMarkup = __webpack_require__(305);
var emptyFunction = __webpack_require__(16);
var invariant = __webpack_require__(2);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(51);
var ReactDOMComponentTree = __webpack_require__(7);
var SyntheticMouseEvent = __webpack_require__(64);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var PooledClass = __webpack_require__(32);

var getTextContentAccessor = __webpack_require__(182);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(41);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(42);

var instantiateReactComponent = __webpack_require__(184);
var KeyEscapeUtils = __webpack_require__(95);
var shouldUpdateReactComponent = __webpack_require__(105);
var traverseAllChildren = __webpack_require__(187);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(204);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(91);
var ReactDOMIDOperations = __webpack_require__(342);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var React = __webpack_require__(46);
var ReactComponentEnvironment = __webpack_require__(97);
var ReactCurrentOwner = __webpack_require__(20);
var ReactErrorUtils = __webpack_require__(98);
var ReactInstanceMap = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(15);
var ReactNodeTypes = __webpack_require__(177);
var ReactReconciler = __webpack_require__(42);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(61);
var invariant = __webpack_require__(2);
var shallowEqual = __webpack_require__(90);
var shouldUpdateReactComponent = __webpack_require__(105);
var warning = __webpack_require__(4);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(7);
var ReactDefaultInjection = __webpack_require__(350);
var ReactMount = __webpack_require__(176);
var ReactReconciler = __webpack_require__(42);
var ReactUpdates = __webpack_require__(17);
var ReactVersion = __webpack_require__(363);

var findDOMNode = __webpack_require__(379);
var getHostComponentFromComposite = __webpack_require__(181);
var renderSubtreeIntoContainer = __webpack_require__(386);
var warning = __webpack_require__(4);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var AutoFocusUtils = __webpack_require__(325);
var CSSPropertyOperations = __webpack_require__(327);
var DOMLazyTree = __webpack_require__(40);
var DOMNamespaces = __webpack_require__(92);
var DOMProperty = __webpack_require__(41);
var DOMPropertyOperations = __webpack_require__(169);
var EventPluginHub = __webpack_require__(50);
var EventPluginRegistry = __webpack_require__(93);
var ReactBrowserEventEmitter = __webpack_require__(63);
var ReactDOMComponentFlags = __webpack_require__(170);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMInput = __webpack_require__(343);
var ReactDOMOption = __webpack_require__(344);
var ReactDOMSelect = __webpack_require__(171);
var ReactDOMTextarea = __webpack_require__(347);
var ReactInstrumentation = __webpack_require__(15);
var ReactMultiChild = __webpack_require__(356);
var ReactServerRenderingTransaction = __webpack_require__(361);

var emptyFunction = __webpack_require__(16);
var escapeTextContentForBrowser = __webpack_require__(66);
var invariant = __webpack_require__(2);
var isEventSupported = __webpack_require__(104);
var shallowEqual = __webpack_require__(90);
var inputValueTracking = __webpack_require__(183);
var validateDOMNesting = __webpack_require__(106);
var warning = __webpack_require__(4);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(106);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(7);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(7);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var DOMPropertyOperations = __webpack_require__(169);
var LinkedValueUtils = __webpack_require__(96);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var React = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMSelect = __webpack_require__(171);

var warning = __webpack_require__(4);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var getNodeForCharacterOffset = __webpack_require__(383);
var getTextContentAccessor = __webpack_require__(182);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var DOMChildrenOperations = __webpack_require__(91);
var DOMLazyTree = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(7);

var escapeTextContentForBrowser = __webpack_require__(66);
var invariant = __webpack_require__(2);
var validateDOMNesting = __webpack_require__(106);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3),
    _assign = __webpack_require__(5);

var LinkedValueUtils = __webpack_require__(96);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var ReactUpdates = __webpack_require__(17);
var Transaction = __webpack_require__(65);

var emptyFunction = __webpack_require__(16);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(324);
var BeforeInputEventPlugin = __webpack_require__(326);
var ChangeEventPlugin = __webpack_require__(328);
var DefaultEventPluginOrder = __webpack_require__(330);
var EnterLeaveEventPlugin = __webpack_require__(331);
var HTMLDOMPropertyConfig = __webpack_require__(333);
var ReactComponentBrowserEnvironment = __webpack_require__(335);
var ReactDOMComponent = __webpack_require__(338);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMEmptyComponent = __webpack_require__(340);
var ReactDOMTreeTraversal = __webpack_require__(348);
var ReactDOMTextComponent = __webpack_require__(346);
var ReactDefaultBatchingStrategy = __webpack_require__(349);
var ReactEventListener = __webpack_require__(353);
var ReactInjection = __webpack_require__(354);
var ReactReconcileTransaction = __webpack_require__(359);
var SVGDOMPropertyConfig = __webpack_require__(364);
var SelectEventPlugin = __webpack_require__(365);
var SimpleEventPlugin = __webpack_require__(366);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(50);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var EventListener = __webpack_require__(162);
var ExecutionEnvironment = __webpack_require__(12);
var PooledClass = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(17);

var getEventTarget = __webpack_require__(103);
var getUnboundedScrollPosition = __webpack_require__(307);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(41);
var EventPluginHub = __webpack_require__(50);
var EventPluginUtils = __webpack_require__(94);
var ReactComponentEnvironment = __webpack_require__(97);
var ReactEmptyComponent = __webpack_require__(172);
var ReactBrowserEventEmitter = __webpack_require__(63);
var ReactHostComponent = __webpack_require__(174);
var ReactUpdates = __webpack_require__(17);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(377);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactComponentEnvironment = __webpack_require__(97);
var ReactInstanceMap = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(20);
var ReactReconciler = __webpack_require__(42);
var ReactChildReconciler = __webpack_require__(334);

var emptyFunction = __webpack_require__(16);
var flattenChildren = __webpack_require__(380);
var invariant = __webpack_require__(2);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var invariant = __webpack_require__(2);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var CallbackQueue = __webpack_require__(168);
var PooledClass = __webpack_require__(32);
var ReactBrowserEventEmitter = __webpack_require__(63);
var ReactInputSelection = __webpack_require__(175);
var ReactInstrumentation = __webpack_require__(15);
var Transaction = __webpack_require__(65);
var ReactUpdateQueue = __webpack_require__(99);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(357);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(5);

var PooledClass = __webpack_require__(32);
var Transaction = __webpack_require__(65);
var ReactInstrumentation = __webpack_require__(15);
var ReactServerUpdateQueue = __webpack_require__(362);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(99);

var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(51);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInputSelection = __webpack_require__(175);
var SyntheticEvent = __webpack_require__(19);

var getActiveElement = __webpack_require__(164);
var isTextInputElement = __webpack_require__(185);
var shallowEqual = __webpack_require__(90);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(3);

var EventListener = __webpack_require__(162);
var EventPropagators = __webpack_require__(51);
var ReactDOMComponentTree = __webpack_require__(7);
var SyntheticAnimationEvent = __webpack_require__(367);
var SyntheticClipboardEvent = __webpack_require__(368);
var SyntheticEvent = __webpack_require__(19);
var SyntheticFocusEvent = __webpack_require__(371);
var SyntheticKeyboardEvent = __webpack_require__(373);
var SyntheticMouseEvent = __webpack_require__(64);
var SyntheticDragEvent = __webpack_require__(370);
var SyntheticTouchEvent = __webpack_require__(374);
var SyntheticTransitionEvent = __webpack_require__(375);
var SyntheticUIEvent = __webpack_require__(53);
var SyntheticWheelEvent = __webpack_require__(376);

var emptyFunction = __webpack_require__(16);
var getEventCharCode = __webpack_require__(101);
var invariant = __webpack_require__(2);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(64);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(53);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(53);

var getEventCharCode = __webpack_require__(101);
var getEventKey = __webpack_require__(381);
var getEventModifierState = __webpack_require__(102);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(53);

var getEventModifierState = __webpack_require__(102);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(64);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(167);
var warning = __webpack_require__(4);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstanceMap = __webpack_require__(52);

var getHostComponentFromComposite = __webpack_require__(181);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(95);
var traverseAllChildren = __webpack_require__(187);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(204);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(101);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(66);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(176);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = getColumnProps;
exports.default = Col;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(108);

var _createProps2 = _interopRequireDefault(_createProps);

var _classNames = __webpack_require__(107);

var _classNames2 = _interopRequireDefault(_classNames);

var _types = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  xs: _types.ColumnSizeType,
  sm: _types.ColumnSizeType,
  md: _types.ColumnSizeType,
  lg: _types.ColumnSizeType,
  xl: _types.ColumnSizeType,
  xsOffset: _propTypes2.default.number,
  smOffset: _propTypes2.default.number,
  mdOffset: _propTypes2.default.number,
  lgOffset: _propTypes2.default.number,
  xlOffset: _propTypes2.default.number,
  first: _types.ViewportSizeType,
  last: _types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var classMap = {
  xs: 'col-xs',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xl: 'col-xl',
  xsOffset: 'col-xs-offset',
  smOffset: 'col-sm-offset',
  mdOffset: 'col-md-offset',
  lgOffset: 'col-lg-offset',
  xlOffset: 'col-xl-offset'
};

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function getColClassNames(props) {
  var extraClasses = [];

  if (props.className) {
    extraClasses.push(props.className);
  }

  if (props.first) {
    extraClasses.push((0, _classNames2.default)('first-' + props.first));
  }

  if (props.last) {
    extraClasses.push((0, _classNames2.default)('last-' + props.last));
  }

  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    return (0, _classNames2.default)(isInteger(props[key]) ? classMap[key] + '-' + props[key] : classMap[key]);
  }).concat(extraClasses);
}

function getColumnProps(props) {
  return (0, _createProps2.default)(propTypes, props, getColClassNames(props));
}

function Col(props) {
  var tagName = props.tagName,
      columnProps = _objectWithoutProperties(props, ['tagName']);

  return _react2.default.createElement(tagName || 'div', getColumnProps(columnProps));
}

Col.propTypes = propTypes;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grid;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(108);

var _createProps2 = _interopRequireDefault(_createProps);

var _classNames = __webpack_require__(107);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fluid: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function Grid(props) {
  var containerClass = (0, _classNames2.default)(props.fluid ? 'container-fluid' : 'container');
  var classNames = [props.className, containerClass];

  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(propTypes, props, classNames));
}

Grid.propTypes = propTypes;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowProps = getRowProps;
exports.default = Row;

var _classNames = __webpack_require__(107);

var _classNames2 = _interopRequireDefault(_classNames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(108);

var _createProps2 = _interopRequireDefault(_createProps);

var _types = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

var propTypes = {
  reverse: _propTypes2.default.bool,
  start: _types.ViewportSizeType,
  center: _types.ViewportSizeType,
  end: _types.ViewportSizeType,
  top: _types.ViewportSizeType,
  middle: _types.ViewportSizeType,
  bottom: _types.ViewportSizeType,
  around: _types.ViewportSizeType,
  between: _types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function getRowClassNames(props) {
  var modificators = [props.className, (0, _classNames2.default)('row')];

  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];
    if (value) {
      modificators.push((0, _classNames2.default)(key + '-' + value));
    }
  }

  if (props.reverse) {
    modificators.push((0, _classNames2.default)('reverse'));
  }

  return modificators;
}

function getRowProps(props) {
  return (0, _createProps2.default)(propTypes, props, getRowClassNames(props));
}

function Row(props) {
  return _react2.default.createElement(props.tagName || 'div', getRowProps(props));
}

Row.propTypes = propTypes;

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(109);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null
});



/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OutboundLink", function() { return OutboundLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__ = __webpack_require__(390);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (typeof window === 'undefined') return false;
  if (!window.ga) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    if (!options || options.standardImplementation !== true) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      } // Optional Fields


      if (options) {
        if (_typeof(options) !== 'object') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga('require', name);

        if (_debug) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
__WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].trackLink = outboundLink;
var OutboundLink = __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(109);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return /[^@]+@[^@]+/.test(s);
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push(args.concat());
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(189);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(469);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(281);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(400);

var _HelmetConstants = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(5);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.3
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(401);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(191);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(54);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(54);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(54);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(44);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(110);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(44);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(196);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(192);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(196);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(194);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(112);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(114);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(45);

var _DOMUtils = __webpack_require__(70);

var _DOMStateStorage = __webpack_require__(199);

var _PathUtils = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(114);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(45);

var _PathUtils = __webpack_require__(24);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(115);

var _BrowserProtocol = __webpack_require__(114);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(421);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(70);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(115);

var _DOMUtils = __webpack_require__(70);

var _HashProtocol = __webpack_require__(420);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(45);

var _PathUtils = __webpack_require__(24);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var EmailIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('email', {
  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
  color: '#7f7f7f'
});

/* harmony default export */ __webpack_exports__["a"] = (EmailIcon);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(8);





function emailLink(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body;

  return 'mailto:' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ subject: subject, body: body || url });
}

var EmailShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('email', emailLink, function (props) {
  return {
    subject: props.subject,
    body: props.body
  };
}, {
  subject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EmailShareButton);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var FacebookIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function facebookLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var FacebookShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('facebook', facebookLink, function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookShareButton);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(25);




function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getFacebookShareCount));

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var GooglePlusIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('google', {
  icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
  mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
  color: '#dd4b39'
});

/* harmony default export */ __webpack_exports__["a"] = (GooglePlusIcon);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(8);





function googlePlusLink(url) {
  __WEBPACK_IMPORTED_MODULE_0_assert___default()(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ url: url });
}

var GooglePlusShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('googlePlus', googlePlusLink, undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (GooglePlusShareButton);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);




function getGooglePlusShareCount(shareUrl, callback) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__["a" /* default */])(11)) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getGooglePlusShareCount));

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var LineIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('line', {
  icon: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
  mask: '',
  color: '#00b800'
});

/* harmony default export */ __webpack_exports__["a"] = (LineIcon);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__(6);







function lineLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'line.url');

  return 'https://social-plugins.line.me/lineit/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var LineShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('line', lineLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* harmony default export */ __webpack_exports__["a"] = (LineShareButton);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var LinkedinIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('linkedin', {
  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
  color: '#007fb1'
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinIcon);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function linkedinLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    summary: description
  });
}

var LinkedinShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('linkedin', linkedinLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 750,
  windowHeight: 600
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinShareButton);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);





function getLinkedinShareCount(shareUrl, callback) {
  var url = 'https://www.linkedin.com/countserv/count/share';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl,
    format: 'jsonp'
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getLinkedinShareCount));

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var LivejournalIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('livejournal', {
  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#21A5D8'
});

/* harmony default export */ __webpack_exports__["a"] = (LivejournalIcon);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function livejournalLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'livejournal.url');

  return 'https://www.livejournal.com/update.bml' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    subject: title,
    event: description
  });
}

var LivejournalShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('livejournal', livejournalLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (LivejournalShareButton);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var MailruIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('mailru', {
  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#168DE2'
});

/* harmony default export */ __webpack_exports__["a"] = (MailruIcon);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function mailruLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'mailru.url');

  return 'https://connect.mail.ru/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageurl: image
  });
}

var MailruShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('mailru', mailruLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (MailruShareButton);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var OKIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('ok', {
  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
  color: '#f2720c'
});

/* harmony default export */ __webpack_exports__["a"] = (OKIcon);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function okLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

var OKShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('ok', okLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (OKShareButton);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);





function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + (0, __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getOKShareCount));

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var PinterestIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pinterest', {
  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#cb2128'
});

/* harmony default export */ __webpack_exports__["a"] = (PinterestIcon);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function pinterestLink(url, _ref) {
  var media = _ref.media,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pinterest.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    media: media,
    description: description
  });
}

var PinterestShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('pinterest', pinterestLink, function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

/* harmony default export */ __webpack_exports__["a"] = (PinterestShareButton);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);





function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getPinterestShareCount));

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var RedditIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('reddit', {
  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
  color: '#5f99cf'
});

/* harmony default export */ __webpack_exports__["a"] = (RedditIcon);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function redditLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var RedditShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('reddit', redditLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (RedditShareButton);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(25);




function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getRedditShareCount));

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var TelegramIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('telegram', {
  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#37aee2'
});

/* harmony default export */ __webpack_exports__["a"] = (TelegramIcon);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function telegramLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'telegram.url');

  return 'https://telegram.me/share/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var TelegramShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('telegram', telegramLink, function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (TelegramShareButton);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var TumblrIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('tumblr', {
  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#2c4762'
});

/* harmony default export */ __webpack_exports__["a"] = (TumblrIcon);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  posttype: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (TumblrShareButton);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);





function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'https://api.tumblr.com/v2/share/stats';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getTumblrShareCount));

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var TwitterIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('twitter', {
  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
  color: '#00aced'
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterIcon);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function twitterLink(url, _ref) {
  var title = _ref.title,
      via = _ref.via,
      _ref$hashtags = _ref.hashtags,
      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'twitter.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

var TwitterShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('twitter', twitterLink, function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterShareButton);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var VKIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('vk', {
  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  color: '#45668e'
});

/* harmony default export */ __webpack_exports__["a"] = (VKIcon);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function vkLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'vk.url');

  return 'https://vk.com/share.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

var VKShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('vk', vkLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (VKShareButton);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(25);





function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count) {
          return window.VK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getVKShareCount));

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var ViberIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('viber', {
  icon: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
  mask: '',
  color: '#7C529E'
});

/* harmony default export */ __webpack_exports__["a"] = (ViberIcon);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function viberLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'viber.url');
  return 'viber://forward' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: (title || '') + ' ' + url
  });
}

var ViberShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('viber', viberLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (ViberShareButton);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function weiboLink(url, _ref) {
  var title = _ref.title,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'weibo.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(image, 'weibo.image');

  return 'http://service.weibo.com/share/share.php?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    pic: image
  });
}

var WeiboShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('weibo', weiboLink, function (props) {
  return {
    title: props.title,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (WeiboShareButton);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var WhatsappIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('whatsapp', {
  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#2cb742'
});

/* harmony default export */ __webpack_exports__["a"] = (WhatsappIcon);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function whatsappLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'whatsapp.url');
  return 'https://api.whatsapp.com/send' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var WhatsappShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('whatsapp', whatsappLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (WhatsappShareButton);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(10);


var WorkplaceIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('workplace', {
  icon: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
  color: '#3b3d4a'
});

/* harmony default export */ __webpack_exports__["a"] = (WorkplaceIcon);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(8);







function workplaceLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'workplace.url');

  return 'https://work.facebook.com/sharer.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var WorkplaceShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('workplace', workplaceLink, function (props) {
  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (WorkplaceShareButton);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookShareCount", function() { return __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlusShareCount__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GooglePlusShareCount", function() { return __WEBPACK_IMPORTED_MODULE_1__GooglePlusShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkedinShareCount__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedinShareCount", function() { return __WEBPACK_IMPORTED_MODULE_2__LinkedinShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PinterestShareCount__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PinterestShareCount", function() { return __WEBPACK_IMPORTED_MODULE_3__PinterestShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VKShareCount__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VKShareCount", function() { return __WEBPACK_IMPORTED_MODULE_4__VKShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OKShareCount__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OKShareCount", function() { return __WEBPACK_IMPORTED_MODULE_5__OKShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RedditShareCount__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RedditShareCount", function() { return __WEBPACK_IMPORTED_MODULE_6__RedditShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TumblrShareCount__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TumblrShareCount", function() { return __WEBPACK_IMPORTED_MODULE_7__TumblrShareCount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookShareButton", function() { return __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GooglePlusShareButton__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GooglePlusShareButton", function() { return __WEBPACK_IMPORTED_MODULE_9__GooglePlusShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedinShareButton", function() { return __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TwitterShareButton", function() { return __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PinterestShareButton__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PinterestShareButton", function() { return __WEBPACK_IMPORTED_MODULE_12__PinterestShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VKShareButton__ = __webpack_require__(459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VKShareButton", function() { return __WEBPACK_IMPORTED_MODULE_13__VKShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OKShareButton__ = __webpack_require__(443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OKShareButton", function() { return __WEBPACK_IMPORTED_MODULE_14__OKShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TelegramShareButton__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TelegramShareButton", function() { return __WEBPACK_IMPORTED_MODULE_15__TelegramShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WhatsappShareButton", function() { return __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RedditShareButton", function() { return __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmailShareButton", function() { return __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TumblrShareButton__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TumblrShareButton", function() { return __WEBPACK_IMPORTED_MODULE_19__TumblrShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LivejournalShareButton__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LivejournalShareButton", function() { return __WEBPACK_IMPORTED_MODULE_20__LivejournalShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MailruShareButton__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MailruShareButton", function() { return __WEBPACK_IMPORTED_MODULE_21__MailruShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViberShareButton__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ViberShareButton", function() { return __WEBPACK_IMPORTED_MODULE_22__ViberShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__WorkplaceShareButton__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WorkplaceShareButton", function() { return __WEBPACK_IMPORTED_MODULE_23__WorkplaceShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LineShareButton__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineShareButton", function() { return __WEBPACK_IMPORTED_MODULE_24__LineShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__WeiboShareButton__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WeiboShareButton", function() { return __WEBPACK_IMPORTED_MODULE_25__WeiboShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookIcon", function() { return __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__ = __webpack_require__(456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TwitterIcon", function() { return __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__GooglePlusIcon__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GooglePlusIcon", function() { return __WEBPACK_IMPORTED_MODULE_28__GooglePlusIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedinIcon", function() { return __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PinterestIcon__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PinterestIcon", function() { return __WEBPACK_IMPORTED_MODULE_30__PinterestIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__VKIcon__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VKIcon", function() { return __WEBPACK_IMPORTED_MODULE_31__VKIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__OKIcon__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OKIcon", function() { return __WEBPACK_IMPORTED_MODULE_32__OKIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__TelegramIcon__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TelegramIcon", function() { return __WEBPACK_IMPORTED_MODULE_33__TelegramIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__WhatsappIcon__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WhatsappIcon", function() { return __WEBPACK_IMPORTED_MODULE_34__WhatsappIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__RedditIcon__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RedditIcon", function() { return __WEBPACK_IMPORTED_MODULE_35__RedditIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__TumblrIcon__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TumblrIcon", function() { return __WEBPACK_IMPORTED_MODULE_36__TumblrIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__MailruIcon__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MailruIcon", function() { return __WEBPACK_IMPORTED_MODULE_37__MailruIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__EmailIcon__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmailIcon", function() { return __WEBPACK_IMPORTED_MODULE_38__EmailIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__LivejournalIcon__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LivejournalIcon", function() { return __WEBPACK_IMPORTED_MODULE_39__LivejournalIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ViberIcon__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ViberIcon", function() { return __WEBPACK_IMPORTED_MODULE_40__ViberIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__WorkplaceIcon__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WorkplaceIcon", function() { return __WEBPACK_IMPORTED_MODULE_41__WorkplaceIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__LineIcon__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineIcon", function() { return __WEBPACK_IMPORTED_MODULE_42__LineIcon__["a"]; });














































/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(1);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(284));
var shallowEqual = _interopDefault(__webpack_require__(484));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_resize_observer_polyfill__ = __webpack_require__(483);









var getScrollParent = function getScrollParent(node) {
  var offsetParent = node;
  while (offsetParent = offsetParent.offsetParent) {
    var overflowYVal = getComputedStyle(offsetParent, null).getPropertyValue("overflow-y");
    if (overflowYVal === "auto" || overflowYVal === "scroll") return offsetParent;
  }
  return window;
};

var offsetTill = function offsetTill(node, target) {
  var current = node;
  var offset = 0;
  do {
    offset += current.offsetTop;
    current = current.offsetParent;
  } while (current && current !== target);
  return offset;
};

var stickyProp = null;
if (typeof CSS !== "undefined" && CSS.supports) {
  if (CSS.supports("position", "sticky")) stickyProp = "sticky";else if (CSS.supports("position", "-webkit-sticky")) stickyProp = "-webkit-sticky";
}

var StickyBox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StickyBox, _React$Component);

  function StickyBox() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StickyBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StickyBox.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StickyBox)).call.apply(_ref, [this].concat(args))), _this), _this.registerContainerRef = function (n) {
      if (!stickyProp) return;
      _this.node = n;
      if (n) {
        _this.scrollPane = getScrollParent(_this.node);
        _this.latestScrollY = _this.scrollPane === window ? window.scrollY : _this.scrollPane.scrollTop;
        _this.scrollPane.addEventListener("scroll", _this.handleScroll);
        _this.scrollPane.addEventListener("mousewheel", _this.handleScroll);
        if (_this.scrollPane === window) {
          window.addEventListener("resize", _this.updateViewport);
          _this.updateViewport();
        } else {
          _this.rosp = new __WEBPACK_IMPORTED_MODULE_7_resize_observer_polyfill__["a" /* default */](_this.updateScrollPane);
          _this.rosp.observe(_this.scrollPane);
          _this.updateScrollPane();
        }
        _this.ropn = new __WEBPACK_IMPORTED_MODULE_7_resize_observer_polyfill__["a" /* default */](_this.updateParentNode);
        _this.ropn.observe(_this.node.parentNode);
        _this.updateParentNode();

        _this.ron = new __WEBPACK_IMPORTED_MODULE_7_resize_observer_polyfill__["a" /* default */](_this.updateNode);
        _this.ron.observe(_this.node);
        _this.updateNode();

        _this.initial();
      } else {
        _this.scrollPane.removeEventListener("mousewheel", _this.handleScroll);
        _this.scrollPane.removeEventListener("scroll", _this.handleScroll);
        if (_this.scrollPane === window) {
          window.removeEventListener("resize", _this.getMeasurements);
        } else {
          _this.rosp.disconnect();
        }
        _this.ropn.disconnect();
        _this.ron.disconnect();
        _this.scrollPane = null;
      }
    }, _this.updateViewport = function () {
      _this.viewPortHeight = window.innerHeight;
      _this.scrollPaneOffset = 0;
    }, _this.updateScrollPane = function () {
      _this.viewPortHeight = _this.scrollPane.offsetHeight;
      _this.scrollPaneOffset = _this.scrollPane.getBoundingClientRect().top;
    }, _this.updateParentNode = function () {
      var parentNode = _this.node.parentNode;
      var computedParentStyle = getComputedStyle(parentNode, null);
      var parentPaddingTop = parseInt(computedParentStyle.getPropertyValue("padding-top"), 10);
      var parentPaddingBottom = parseInt(computedParentStyle.getPropertyValue("padding-bottom"), 10);
      var verticalParentPadding = parentPaddingTop + parentPaddingBottom;
      _this.naturalTop = offsetTill(parentNode, _this.scrollPane) + parentPaddingTop + _this.scrollPaneOffset;
      _this.parentHeight = parentNode.getBoundingClientRect().height - verticalParentPadding;
    }, _this.updateNode = function () {
      _this.nodeHeight = _this.node.getBoundingClientRect().height;
    }, _this.handleScroll = function () {
      var offset = _this.props.offset;

      var scrollY = _this.scrollPane === window ? window.scrollY : _this.scrollPane.scrollTop;
      if (scrollY === _this.latestScrollY) return;
      if (_this.nodeHeight + offset <= _this.viewPortHeight) {
        // Just make it sticky if node smaller than viewport
        _this.initial();
        return;
      }
      var scrollDelta = scrollY - _this.latestScrollY;
      if (scrollDelta > 0) {
        // scroll down
        if (_this.mode === "stickyTop") {
          if (scrollY + _this.scrollPaneOffset + offset > _this.naturalTop) {
            _this.props.onChangeMode(_this.mode, "relative");
            _this.mode = "relative";
            _this.node.style.position = "relative";
            _this.offset = Math.max(0, _this.scrollPaneOffset + _this.latestScrollY - _this.naturalTop + offset);
            _this.node.style.top = _this.offset + "px";
          }
        } else if (_this.mode === "relative") {
          if (scrollY + _this.scrollPaneOffset + _this.viewPortHeight > _this.naturalTop + _this.nodeHeight + _this.offset) {
            _this.props.onChangeMode(_this.mode, "stickyBottom");
            _this.mode = "stickyBottom";
            _this.node.style.position = stickyProp;
            _this.node.style.top = _this.viewPortHeight - _this.nodeHeight + "px";
          }
        }
      } else {
        // scroll up
        if (_this.mode === "stickyBottom") {
          if (_this.scrollPaneOffset + scrollY + _this.viewPortHeight + offset < _this.naturalTop + _this.parentHeight) {
            _this.props.onChangeMode(_this.mode, "relative");
            _this.mode = "relative";
            _this.node.style.position = "relative";
            _this.offset = _this.scrollPaneOffset + _this.latestScrollY + _this.viewPortHeight - (_this.naturalTop + _this.nodeHeight);
            _this.node.style.top = _this.offset + "px";
          }
        } else if (_this.mode === "relative") {
          if (_this.scrollPaneOffset + scrollY + offset < _this.naturalTop + _this.offset) {
            _this.props.onChangeMode(_this.mode, "stickyTop");
            _this.mode = "stickyTop";
            _this.node.style.position = stickyProp;
            _this.node.style.top = offset + "px";
          }
        }
      }

      _this.latestScrollY = scrollY;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StickyBox, [{
    key: "initial",
    value: function initial() {
      var _props = this.props,
          bottom = _props.bottom,
          offset = _props.offset;

      if (bottom) {
        if (this.mode !== "stickyBottom") {
          this.props.onChangeMode(this.mode, "stickyBottom");
          this.mode = "stickyBottom";
          this.node.style.position = stickyProp;
          this.node.style.top = this.viewPortHeight - this.nodeHeight + "px";
        }
      } else {
        if (this.mode !== "stickyTop") {
          this.props.onChangeMode(this.mode, "stickyTop");
          this.mode = "stickyTop";
          this.node.style.position = stickyProp;
          this.node.style.top = offset + "px";
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          style = _props2.style;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: className, style: style, ref: this.registerContainerRef },
        children
      );
    }
  }]);

  return StickyBox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

StickyBox.defaultProps = {
  onChangeMode: function onChangeMode() {},
  offset: 0
};

 false ? StickyBox.propTypes = {
  onChangeMode: PropTypes.func,
  offset: PropTypes.number,
  bottom: PropTypes.bool
} : void 0;

/* harmony default export */ __webpack_exports__["default"] = (StickyBox);


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(55);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(472);
var ReactElement = __webpack_require__(47);

var emptyFunction = __webpack_require__(16);
var traverseAllChildren = __webpack_require__(482);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(47);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(47),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(165);

module.exports = factory(isValidElement);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(203),
    Component = _require.Component;

var _require2 = __webpack_require__(47),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(206);
var factory = __webpack_require__(161);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(55);

var ReactElement = __webpack_require__(47);

var invariant = __webpack_require__(2);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(55);

var ReactCurrentOwner = __webpack_require__(20);
var REACT_ELEMENT_TYPE = __webpack_require__(205);

var getIteratorFn = __webpack_require__(478);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(471);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 484 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/* PrismJS 1.8.4
http://prismjs.com/download.html?themes=prism&languages=markup+css+clike+javascript+bash+coffeescript+json+sql+typescript+yaml&plugins=toolbar+copy-to-clipboard */
var _self="undefined"!=typeof window?window:"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope?self:{},Prism=function(){var e=/\blang(?:uage)?-(\w+)\b/i,t=0,n=_self.Prism={manual:_self.Prism&&_self.Prism.manual,disableWorkerMessageHandler:_self.Prism&&_self.Prism.disableWorkerMessageHandler,util:{encode:function(e){return e instanceof r?new r(e.type,n.util.encode(e.content),e.alias):"Array"===n.util.type(e)?e.map(n.util.encode):e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\u00a0/g," ")},type:function(e){return Object.prototype.toString.call(e).match(/\[object (\w+)\]/)[1]},objId:function(e){return e.__id||Object.defineProperty(e,"__id",{value:++t}),e.__id},clone:function(e){var t=n.util.type(e);switch(t){case"Object":var r={};for(var a in e)e.hasOwnProperty(a)&&(r[a]=n.util.clone(e[a]));return r;case"Array":return e.map(function(e){return n.util.clone(e)})}return e}},languages:{extend:function(e,t){var r=n.util.clone(n.languages[e]);for(var a in t)r[a]=t[a];return r},insertBefore:function(e,t,r,a){a=a||n.languages;var l=a[e];if(2==arguments.length){r=arguments[1];for(var i in r)r.hasOwnProperty(i)&&(l[i]=r[i]);return l}var o={};for(var s in l)if(l.hasOwnProperty(s)){if(s==t)for(var i in r)r.hasOwnProperty(i)&&(o[i]=r[i]);o[s]=l[s]}return n.languages.DFS(n.languages,function(t,n){n===a[e]&&t!=e&&(this[t]=o)}),a[e]=o},DFS:function(e,t,r,a){a=a||{};for(var l in e)e.hasOwnProperty(l)&&(t.call(e,l,e[l],r||l),"Object"!==n.util.type(e[l])||a[n.util.objId(e[l])]?"Array"!==n.util.type(e[l])||a[n.util.objId(e[l])]||(a[n.util.objId(e[l])]=!0,n.languages.DFS(e[l],t,l,a)):(a[n.util.objId(e[l])]=!0,n.languages.DFS(e[l],t,null,a)))}},plugins:{},highlightAll:function(e,t){n.highlightAllUnder(document,e,t)},highlightAllUnder:function(e,t,r){var a={callback:r,selector:'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'};n.hooks.run("before-highlightall",a);for(var l,i=a.elements||e.querySelectorAll(a.selector),o=0;l=i[o++];)n.highlightElement(l,t===!0,a.callback)},highlightElement:function(t,r,a){for(var l,i,o=t;o&&!e.test(o.className);)o=o.parentNode;o&&(l=(o.className.match(e)||[,""])[1].toLowerCase(),i=n.languages[l]),t.className=t.className.replace(e,"").replace(/\s+/g," ")+" language-"+l,t.parentNode&&(o=t.parentNode,/pre/i.test(o.nodeName)&&(o.className=o.className.replace(e,"").replace(/\s+/g," ")+" language-"+l));var s=t.textContent,g={element:t,language:l,grammar:i,code:s};if(n.hooks.run("before-sanity-check",g),!g.code||!g.grammar)return g.code&&(n.hooks.run("before-highlight",g),g.element.textContent=g.code,n.hooks.run("after-highlight",g)),n.hooks.run("complete",g),void 0;if(n.hooks.run("before-highlight",g),r&&_self.Worker){var u=new Worker(n.filename);u.onmessage=function(e){g.highlightedCode=e.data,n.hooks.run("before-insert",g),g.element.innerHTML=g.highlightedCode,a&&a.call(g.element),n.hooks.run("after-highlight",g),n.hooks.run("complete",g)},u.postMessage(JSON.stringify({language:g.language,code:g.code,immediateClose:!0}))}else g.highlightedCode=n.highlight(g.code,g.grammar,g.language),n.hooks.run("before-insert",g),g.element.innerHTML=g.highlightedCode,a&&a.call(t),n.hooks.run("after-highlight",g),n.hooks.run("complete",g)},highlight:function(e,t,a){var l=n.tokenize(e,t);return r.stringify(n.util.encode(l),a)},matchGrammar:function(e,t,r,a,l,i,o){var s=n.Token;for(var g in r)if(r.hasOwnProperty(g)&&r[g]){if(g==o)return;var u=r[g];u="Array"===n.util.type(u)?u:[u];for(var c=0;c<u.length;++c){var h=u[c],f=h.inside,d=!!h.lookbehind,m=!!h.greedy,p=0,y=h.alias;if(m&&!h.pattern.global){var v=h.pattern.toString().match(/[imuy]*$/)[0];h.pattern=RegExp(h.pattern.source,v+"g")}h=h.pattern||h;for(var b=a,k=l;b<t.length;k+=t[b].length,++b){var w=t[b];if(t.length>e.length)return;if(!(w instanceof s)){h.lastIndex=0;var _=h.exec(w),P=1;if(!_&&m&&b!=t.length-1){if(h.lastIndex=k,_=h.exec(e),!_)break;for(var A=_.index+(d?_[1].length:0),j=_.index+_[0].length,x=b,O=k,N=t.length;N>x&&(j>O||!t[x].type&&!t[x-1].greedy);++x)O+=t[x].length,A>=O&&(++b,k=O);if(t[b]instanceof s||t[x-1].greedy)continue;P=x-b,w=e.slice(k,O),_.index-=k}if(_){d&&(p=_[1].length);var A=_.index+p,_=_[0].slice(p),j=A+_.length,S=w.slice(0,A),C=w.slice(j),M=[b,P];S&&(++b,k+=S.length,M.push(S));var E=new s(g,f?n.tokenize(_,f):_,y,_,m);if(M.push(E),C&&M.push(C),Array.prototype.splice.apply(t,M),1!=P&&n.matchGrammar(e,t,r,b,k,!0,g),i)break}else if(i)break}}}}},tokenize:function(e,t){var r=[e],a=t.rest;if(a){for(var l in a)t[l]=a[l];delete t.rest}return n.matchGrammar(e,r,t,0,0,!1),r},hooks:{all:{},add:function(e,t){var r=n.hooks.all;r[e]=r[e]||[],r[e].push(t)},run:function(e,t){var r=n.hooks.all[e];if(r&&r.length)for(var a,l=0;a=r[l++];)a(t)}}},r=n.Token=function(e,t,n,r,a){this.type=e,this.content=t,this.alias=n,this.length=0|(r||"").length,this.greedy=!!a};if(r.stringify=function(e,t,a){if("string"==typeof e)return e;if("Array"===n.util.type(e))return e.map(function(n){return r.stringify(n,t,e)}).join("");var l={type:e.type,content:r.stringify(e.content,t,a),tag:"span",classes:["token",e.type],attributes:{},language:t,parent:a};if(e.alias){var i="Array"===n.util.type(e.alias)?e.alias:[e.alias];Array.prototype.push.apply(l.classes,i)}n.hooks.run("wrap",l);var o=Object.keys(l.attributes).map(function(e){return e+'="'+(l.attributes[e]||"").replace(/"/g,"&quot;")+'"'}).join(" ");return"<"+l.tag+' class="'+l.classes.join(" ")+'"'+(o?" "+o:"")+">"+l.content+"</"+l.tag+">"},!_self.document)return _self.addEventListener?(n.disableWorkerMessageHandler||_self.addEventListener("message",function(e){var t=JSON.parse(e.data),r=t.language,a=t.code,l=t.immediateClose;_self.postMessage(n.highlight(a,n.languages[r],r)),l&&_self.close()},!1),_self.Prism):_self.Prism;var a=document.currentScript||[].slice.call(document.getElementsByTagName("script")).pop();return a&&(n.filename=a.src,n.manual||a.hasAttribute("data-manual")||("loading"!==document.readyState?window.requestAnimationFrame?window.requestAnimationFrame(n.highlightAll):window.setTimeout(n.highlightAll,16):document.addEventListener("DOMContentLoaded",n.highlightAll))),_self.Prism}();"undefined"!=typeof module&&module.exports&&(module.exports=Prism),"undefined"!=typeof global&&(global.Prism=Prism);
Prism.languages.markup={comment:/<!--[\s\S]*?-->/,prolog:/<\?[\s\S]+?\?>/,doctype:/<!DOCTYPE[\s\S]+?>/i,cdata:/<!\[CDATA\[[\s\S]*?]]>/i,tag:{pattern:/<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,inside:{tag:{pattern:/^<\/?[^\s>\/]+/i,inside:{punctuation:/^<\/?/,namespace:/^[^\s>\/:]+:/}},"attr-value":{pattern:/=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,inside:{punctuation:[/^=/,{pattern:/(^|[^\\])["']/,lookbehind:!0}]}},punctuation:/\/?>/,"attr-name":{pattern:/[^\s>\/]+/,inside:{namespace:/^[^\s>\/:]+:/}}}},entity:/&#?[\da-z]{1,8};/i},Prism.languages.markup.tag.inside["attr-value"].inside.entity=Prism.languages.markup.entity,Prism.hooks.add("wrap",function(a){"entity"===a.type&&(a.attributes.title=a.content.replace(/&amp;/,"&"))}),Prism.languages.xml=Prism.languages.markup,Prism.languages.html=Prism.languages.markup,Prism.languages.mathml=Prism.languages.markup,Prism.languages.svg=Prism.languages.markup;
Prism.languages.css={comment:/\/\*[\s\S]*?\*\//,atrule:{pattern:/@[\w-]+?.*?(?:;|(?=\s*\{))/i,inside:{rule:/@[\w-]+/}},url:/url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,selector:/[^{}\s][^{};]*?(?=\s*\{)/,string:{pattern:/("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,greedy:!0},property:/[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,important:/\B!important\b/i,"function":/[-a-z0-9]+(?=\()/i,punctuation:/[(){};:]/},Prism.languages.css.atrule.inside.rest=Prism.util.clone(Prism.languages.css),Prism.languages.markup&&(Prism.languages.insertBefore("markup","tag",{style:{pattern:/(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,lookbehind:!0,inside:Prism.languages.css,alias:"language-css",greedy:!0}}),Prism.languages.insertBefore("inside","attr-value",{"style-attr":{pattern:/\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,inside:{"attr-name":{pattern:/^\s*style/i,inside:Prism.languages.markup.tag.inside},punctuation:/^\s*=\s*['"]|['"]\s*$/,"attr-value":{pattern:/.+/i,inside:Prism.languages.css}},alias:"language-css"}},Prism.languages.markup.tag));
Prism.languages.clike={comment:[{pattern:/(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,lookbehind:!0},{pattern:/(^|[^\\:])\/\/.*/,lookbehind:!0}],string:{pattern:/(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,greedy:!0},"class-name":{pattern:/((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,lookbehind:!0,inside:{punctuation:/[.\\]/}},keyword:/\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,"boolean":/\b(?:true|false)\b/,"function":/[a-z0-9_]+(?=\()/i,number:/\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,operator:/--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,punctuation:/[{}[\];(),.:]/};
Prism.languages.javascript=Prism.languages.extend("clike",{keyword:/\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,number:/\b-?(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|\d*\.?\d+(?:[Ee][+-]?\d+)?|NaN|Infinity)\b/,"function":/[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,operator:/-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/}),Prism.languages.insertBefore("javascript","keyword",{regex:{pattern:/(^|[^\/])\/(?!\/)(\[[^\]\r\n]+]|\\.|[^\/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,lookbehind:!0,greedy:!0},"function-variable":{pattern:/[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,alias:"function"}}),Prism.languages.insertBefore("javascript","string",{"template-string":{pattern:/`(?:\\[\s\S]|[^\\`])*`/,greedy:!0,inside:{interpolation:{pattern:/\$\{[^}]+\}/,inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/,alias:"punctuation"},rest:Prism.languages.javascript}},string:/[\s\S]+/}}}),Prism.languages.markup&&Prism.languages.insertBefore("markup","tag",{script:{pattern:/(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,lookbehind:!0,inside:Prism.languages.javascript,alias:"language-javascript",greedy:!0}}),Prism.languages.js=Prism.languages.javascript;
!function(e){var t={variable:[{pattern:/\$?\(\([\s\S]+?\)\)/,inside:{variable:[{pattern:/(^\$\(\([\s\S]+)\)\)/,lookbehind:!0},/^\$\(\(/],number:/\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee]-?\d+)?)\b/,operator:/--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,punctuation:/\(\(?|\)\)?|,|;/}},{pattern:/\$\([^)]+\)|`[^`]+`/,inside:{variable:/^\$\(|^`|\)$|`$/}},/\$(?:[\w#?*!@]+|\{[^}]+\})/i]};e.languages.bash={shebang:{pattern:/^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,alias:"important"},comment:{pattern:/(^|[^"{\\])#.*/,lookbehind:!0},string:[{pattern:/((?:^|[^<])<<\s*)["']?(\w+?)["']?\s*\r?\n(?:[\s\S])*?\r?\n\2/,lookbehind:!0,greedy:!0,inside:t},{pattern:/(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,greedy:!0,inside:t}],variable:t.variable,"function":{pattern:/(^|[\s;|&])(?:alias|apropos|apt-get|aptitude|aspell|awk|basename|bash|bc|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chmod|chown|chroot|chkconfig|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|cut|date|dc|dd|ddrescue|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|grep|groupadd|groupdel|groupmod|groups|gzip|hash|head|help|hg|history|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|jobs|join|kill|killall|less|link|ln|locate|logname|logout|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|make|man|mkdir|mkfifo|mkisofs|mknod|more|most|mount|mtools|mtr|mv|mmv|nano|netstat|nice|nl|nohup|notify-send|npm|nslookup|open|op|passwd|paste|pathchk|ping|pkill|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|rename|renice|remsync|rev|rm|rmdir|rsync|screen|scp|sdiff|sed|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|sync|tail|tar|tee|test|time|timeout|times|touch|top|traceroute|trap|tr|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|uptime|useradd|userdel|usermod|users|uuencode|uudecode|v|vdir|vi|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yes|zip)(?=$|[\s;|&])/,lookbehind:!0},keyword:{pattern:/(^|[\s;|&])(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|[\s;|&])/,lookbehind:!0},"boolean":{pattern:/(^|[\s;|&])(?:true|false)(?=$|[\s;|&])/,lookbehind:!0},operator:/&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,punctuation:/\$?\(\(?|\)\)?|\.\.|[{}[\];]/};var a=t.variable[1].inside;a["function"]=e.languages.bash["function"],a.keyword=e.languages.bash.keyword,a.boolean=e.languages.bash.boolean,a.operator=e.languages.bash.operator,a.punctuation=e.languages.bash.punctuation}(Prism);
!function(e){var t=/#(?!\{).+/,n={pattern:/#\{[^}]+\}/,alias:"variable"};e.languages.coffeescript=e.languages.extend("javascript",{comment:t,string:[{pattern:/'(?:\\[\s\S]|[^\\'])*'/,greedy:!0},{pattern:/"(?:\\[\s\S]|[^\\"])*"/,greedy:!0,inside:{interpolation:n}}],keyword:/\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,"class-member":{pattern:/@(?!\d)\w+/,alias:"variable"}}),e.languages.insertBefore("coffeescript","comment",{"multiline-comment":{pattern:/###[\s\S]+?###/,alias:"comment"},"block-regex":{pattern:/\/{3}[\s\S]*?\/{3}/,alias:"regex",inside:{comment:t,interpolation:n}}}),e.languages.insertBefore("coffeescript","string",{"inline-javascript":{pattern:/`(?:\\[\s\S]|[^\\`])*`/,inside:{delimiter:{pattern:/^`|`$/,alias:"punctuation"},rest:e.languages.javascript}},"multiline-string":[{pattern:/'''[\s\S]*?'''/,greedy:!0,alias:"string"},{pattern:/"""[\s\S]*?"""/,greedy:!0,alias:"string",inside:{interpolation:n}}]}),e.languages.insertBefore("coffeescript","keyword",{property:/(?!\d)\w+(?=\s*:(?!:))/}),delete e.languages.coffeescript["template-string"]}(Prism);
Prism.languages.json={property:/"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,string:{pattern:/"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,greedy:!0},number:/\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee][+-]?\d+)?)\b/,punctuation:/[{}[\]);,]/,operator:/:/g,"boolean":/\b(?:true|false)\b/i,"null":/\bnull\b/i},Prism.languages.jsonp=Prism.languages.json;
Prism.languages.sql={comment:{pattern:/(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,lookbehind:!0},string:{pattern:/(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\])*\2/,greedy:!0,lookbehind:!0},variable:/@[\w.$]+|@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,"function":/\b(?:COUNT|SUM|AVG|MIN|MAX|FIRST|LAST|UCASE|LCASE|MID|LEN|ROUND|NOW|FORMAT)(?=\s*\()/i,keyword:/\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR VARYING|CHARACTER (?:SET|VARYING)|CHARSET|CHECK|CHECKPOINT|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMN|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS|CONTAINSTABLE|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|DATA(?:BASES?)?|DATE(?:TIME)?|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITER(?:S)?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE(?: PRECISION)?|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE KEY|ELSE|ENABLE|ENCLOSED BY|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPE(?:D BY)?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTO|INVOKER|ISOLATION LEVEL|JOIN|KEYS?|KILL|LANGUAGE SQL|LAST|LEFT|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MODIFIES SQL DATA|MODIFY|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL(?: CHAR VARYING| CHARACTER(?: VARYING)?| VARCHAR)?|NATURAL|NCHAR(?: VARCHAR)?|NEXT|NO(?: SQL|CHECK|CYCLE)?|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READ(?:S SQL DATA|TEXT)?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEATABLE|REPLICATION|REQUIRE|RESTORE|RESTRICT|RETURNS?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE MODE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|START(?:ING BY)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED BY|TEXT(?:SIZE)?|THEN|TIMESTAMP|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNPIVOT|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?)\b/i,"boolean":/\b(?:TRUE|FALSE|NULL)\b/i,number:/\b-?(?:0x)?\d*\.?[\da-f]+\b/,operator:/[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|IN|LIKE|NOT|OR|IS|DIV|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,punctuation:/[;[\]()`,.]/};
Prism.languages.typescript=Prism.languages.extend("javascript",{keyword:/\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield|false|true|module|declare|constructor|string|Function|any|number|boolean|Array|symbol|namespace|abstract|require|type)\b/}),Prism.languages.ts=Prism.languages.typescript;
Prism.languages.yaml={scalar:{pattern:/([\-:]\s*(?:![^\s]+)?[ \t]*[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)[^\r\n]+(?:\2[^\r\n]+)*)/,lookbehind:!0,alias:"string"},comment:/#.*/,key:{pattern:/(\s*(?:^|[:\-,[{\r\n?])[ \t]*(?:![^\s]+)?[ \t]*)[^\r\n{[\]},#\s]+?(?=\s*:\s)/,lookbehind:!0,alias:"atrule"},directive:{pattern:/(^[ \t]*)%.+/m,lookbehind:!0,alias:"important"},datetime:{pattern:/([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?)?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?)(?=[ \t]*(?:$|,|]|}))/m,lookbehind:!0,alias:"number"},"boolean":{pattern:/([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:true|false)[ \t]*(?=$|,|]|})/im,lookbehind:!0,alias:"important"},"null":{pattern:/([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:null|~)[ \t]*(?=$|,|]|})/im,lookbehind:!0,alias:"important"},string:{pattern:/([:\-,[{]\s*(?:![^\s]+)?[ \t]*)("|')(?:(?!\2)[^\\\r\n]|\\.)*\2(?=[ \t]*(?:$|,|]|}))/m,lookbehind:!0,greedy:!0},number:{pattern:/([:\-,[{]\s*(?:![^\s]+)?[ \t]*)[+\-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+\.?\d*|\.?\d+)(?:e[+-]?\d+)?|\.inf|\.nan)[ \t]*(?=$|,|]|})/im,lookbehind:!0},tag:/![^\s]+/,important:/[&*][\w]+/,punctuation:/---|[:[\]{}\-,|>?]|\.\.\./};
!function(){if("undefined"!=typeof self&&self.Prism&&self.document){var t=[],e={},n=function(){};Prism.plugins.toolbar={};var a=Prism.plugins.toolbar.registerButton=function(n,a){var o;o="function"==typeof a?a:function(t){var e;return"function"==typeof a.onClick?(e=document.createElement("button"),e.type="button",e.addEventListener("click",function(){a.onClick.call(this,t)})):"string"==typeof a.url?(e=document.createElement("a"),e.href=a.url):e=document.createElement("span"),e.textContent=a.text,e},t.push(e[n]=o)},o=Prism.plugins.toolbar.hook=function(a){var o=a.element.parentNode;if(o&&/pre/i.test(o.nodeName)&&!o.classList.contains("code-toolbar")){o.classList.add("code-toolbar");var r=document.createElement("div");r.classList.add("toolbar"),document.body.hasAttribute("data-toolbar-order")&&(t=document.body.getAttribute("data-toolbar-order").split(",").map(function(t){return e[t]||n})),t.forEach(function(t){var e=t(a);if(e){var n=document.createElement("div");n.classList.add("toolbar-item"),n.appendChild(e),r.appendChild(n)}}),o.appendChild(r)}};a("label",function(t){var e=t.element.parentNode;if(e&&/pre/i.test(e.nodeName)&&e.hasAttribute("data-label")){var n,a,o=e.getAttribute("data-label");try{a=document.querySelector("template#"+o)}catch(r){}return a?n=a.content:(e.hasAttribute("data-url")?(n=document.createElement("a"),n.href=e.getAttribute("data-url")):n=document.createElement("span"),n.textContent=o),n}}),Prism.hooks.add("complete",o)}}();
!function(){if("undefined"!=typeof self&&self.Prism&&self.document){if(!Prism.plugins.toolbar)return console.warn("Copy to Clipboard plugin loaded before Toolbar plugin."),void 0;var o=window.Clipboard||void 0;o&&/(native code)/.test(o.toString())&&(o=void 0),o||"function"!="function"||(o=__webpack_require__(240));var t=[];if(!o){var e=document.createElement("script"),n=document.querySelector("head");e.onload=function(){if(o=window.Clipboard)for(;t.length;)t.pop()()},e.src="https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/1.7.1/clipboard.min.js",n.appendChild(e)}Prism.plugins.toolbar.registerButton("copy-to-clipboard",function(e){function n(){var t=new o(i,{text:function(){return e.code}});t.on("success",function(){i.textContent="Copied!",r()}),t.on("error",function(){i.textContent="Press Ctrl+C to copy",r()})}function r(){setTimeout(function(){i.textContent="Copy"},5e3)}var i=document.createElement("a");return i.textContent="Copy",o?n():t.push(n),i})}}();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(209);
__webpack_require__(208);
__webpack_require__(118);
__webpack_require__(119);
__webpack_require__(120);
__webpack_require__(121);
__webpack_require__(122);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(128);
__webpack_require__(129);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(132);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(138);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(144);
module.exports = __webpack_require__(145);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.e500a705747ef1d1c9f0.js